import React, { Component } from "react";

export default class FullStackImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
	 width="100%" viewBox="0 0 1080 1080" enable-background="new 0 0 1080 1080" xmlspace="preserve">
<path fill="#EDF9FE" opacity="1.000000" stroke="none" 
	d="
M1.000000,411.000000 
	C1.000000,274.015747 1.000000,137.531509 1.000000,1.023627 
	C360.942719,1.023627 720.885437,1.023627 1080.914062,1.023627 
	C1080.914062,360.901154 1080.914062,720.802307 1080.914062,1080.851807 
	C721.000061,1080.851807 361.000031,1080.851807 1.000000,1080.851807 
	C1.000000,857.780762 1.000000,634.640381 1.000000,411.000000 
M278.631836,248.684372 
	C278.631836,248.684372 278.582550,248.858887 278.164978,249.969467 
	C278.067627,250.352783 277.970276,250.736099 277.212585,251.491440 
	C275.776306,251.670074 274.330719,252.058319 272.905212,251.994888 
	C258.832092,251.368500 244.758469,250.039581 230.692444,250.125885 
	C206.119202,250.276611 181.548126,251.200256 156.986816,252.093216 
	C155.016022,252.164871 153.127533,254.500183 150.569550,256.090546 
	C150.083710,259.325867 149.160095,262.565002 149.188049,265.795868 
	C149.307144,279.560089 149.675034,293.322693 150.037857,307.083649 
	C150.098007,309.365051 150.584610,311.635223 150.878616,314.675323 
	C151.901718,320.551636 156.121262,321.727966 162.070114,321.848633 
	C205.194763,321.899139 248.319397,321.968262 291.444061,321.986877 
	C301.926086,321.991394 312.408173,321.829651 323.631073,321.769501 
	C329.191559,320.655487 333.440247,318.217224 333.921875,310.896606 
	C333.954437,300.576294 333.987030,290.255951 334.954468,279.940002 
	C343.905182,279.974396 352.855865,280.008789 361.969025,280.963318 
	C362.036774,290.914490 362.104523,300.865692 362.083008,311.627014 
	C364.023590,312.436371 365.958954,313.935272 367.905518,313.949921 
	C391.064880,314.124268 414.225983,314.099030 437.386383,314.040955 
	C438.937836,314.037018 440.487549,313.345978 442.488190,312.786896 
	C442.757385,312.563934 442.896393,312.277740 442.985443,311.003815 
	C442.929199,295.413025 442.872986,279.822235 442.509552,263.618378 
	C440.002045,263.799072 437.494537,263.979767 434.059021,264.088623 
	C429.372070,264.075745 424.685089,264.062836 419.552032,263.408997 
	C419.028839,262.118256 418.120453,260.849548 418.045013,259.533142 
	C417.556244,251.006195 417.248962,242.468826 417.258850,233.382141 
	C418.460236,232.926010 419.661591,232.469894 421.517029,232.568390 
	C434.995911,232.692200 448.474762,232.815994 462.618164,232.910812 
	C463.714905,231.919846 464.811676,230.928879 465.977875,229.015930 
	C465.955292,217.693588 465.932709,206.371246 465.931519,194.504440 
	C465.907715,194.324371 465.883911,194.144318 466.053436,193.262924 
	C466.886292,193.073120 467.715118,192.739014 468.552612,192.715576 
	C478.041138,192.450195 487.531006,192.232361 497.754822,192.027878 
	C498.861481,193.047531 499.968140,194.067184 501.050415,196.006622 
	C501.025452,210.985474 500.964691,225.964478 501.024811,240.942993 
	C501.031647,242.648727 501.716705,244.351730 502.479279,246.062729 
	C502.479279,246.062729 502.869232,246.022202 503.089203,246.821182 
	C504.263977,247.219971 505.438507,247.965317 506.613586,247.966232 
	C529.034912,247.983948 551.456238,247.914047 574.590027,247.617294 
	C575.392639,245.753586 576.825073,243.910873 576.888062,242.022537 
	C577.148682,234.198410 577.238647,226.349915 576.898621,218.531799 
	C576.708069,214.151077 577.990845,212.852341 582.462891,212.893890 
	C606.625977,213.118408 630.792297,213.007782 655.214417,213.484970 
	C655.457458,213.750320 655.700562,214.015671 655.968872,214.863815 
	C655.989075,215.252182 656.009338,215.640549 656.021423,216.959579 
	C656.045471,227.667648 656.069458,238.375717 655.635071,249.734741 
	C653.776611,250.118637 651.934814,250.656128 650.056763,250.858994 
	C643.110901,251.609238 636.153076,252.249008 628.497009,253.024902 
	C628.334167,255.020432 628.171326,257.015961 627.715942,259.639923 
	C627.411804,261.882416 627.107666,264.124939 626.803528,266.367432 
	C627.473145,266.492706 628.142761,266.617981 628.812439,266.743256 
	C629.488708,264.908539 630.164978,263.073822 630.944519,260.958893 
	C633.491028,260.958893 635.956055,261.063293 638.409119,260.936310 
	C642.951050,260.701172 647.485901,260.330658 652.502991,260.021881 
	C652.502991,260.021881 652.982117,260.007843 653.799377,260.038086 
	C655.588806,260.325012 657.376343,260.845917 659.168030,260.861023 
	C671.064087,260.961365 682.961182,260.993896 694.857605,260.952393 
	C697.866028,260.941895 699.158020,262.263458 698.930603,265.182526 
	C698.764893,267.310486 698.309998,269.445160 698.400574,271.558960 
	C698.868042,282.466400 699.616882,293.363586 699.950989,304.274048 
	C700.081604,308.536957 699.385742,312.825195 699.071899,318.003387 
	C699.068848,321.636536 699.065857,325.269684 698.903503,329.717682 
	C698.880066,331.039520 698.856628,332.361328 698.504883,334.391144 
	C696.273010,335.017639 694.041199,335.644104 690.899170,336.202759 
	C676.452942,335.982452 662.002625,335.890686 647.563660,335.437805 
	C644.527527,335.342560 641.533020,333.920868 638.297424,332.864105 
	C638.297424,332.864105 638.578552,332.721222 638.578552,332.721222 
	C638.578552,332.721222 638.503357,333.132721 638.104736,333.729980 
	C636.429565,334.544250 634.754456,335.358551 632.311218,336.045624 
	C631.550476,335.899475 630.789795,335.753357 630.020691,334.742767 
	C629.468323,331.329956 631.458679,327.400818 627.834473,323.907288 
	C626.002808,329.482758 624.437561,334.368378 628.369324,339.827393 
	C630.262878,340.184204 632.156372,340.541016 634.928589,340.918579 
	C655.602722,340.914062 676.276794,340.909546 697.635437,341.083405 
	C698.350281,340.414124 699.065125,339.744843 700.512390,338.710602 
	C700.997986,336.870636 701.884277,335.034973 701.904114,333.190002 
	C702.031433,321.367676 701.968689,309.543304 701.968262,297.719604 
	C701.967896,287.857941 701.967712,287.857086 711.573059,286.233643 
	C711.724731,286.208008 711.896362,286.300262 712.479187,286.434021 
	C712.657471,287.527588 712.862061,288.782654 713.016357,290.846039 
	C713.070740,291.929382 713.125122,293.012726 713.123047,295.019226 
	C713.061890,310.040222 712.973450,325.061279 712.985779,340.082214 
	C712.986938,341.445526 713.635681,342.808350 714.092407,344.804413 
	C714.770569,345.168762 715.448792,345.533142 717.041687,345.938690 
	C726.208008,345.939880 735.374817,345.880219 744.540527,345.958099 
	C755.357361,346.050049 766.173157,346.260925 777.050293,347.071808 
	C777.092896,347.723877 777.135498,348.375916 776.987732,349.949829 
	C777.074280,359.927734 777.160889,369.905640 777.186523,380.495056 
	C777.840027,381.193420 778.493530,381.891815 780.014648,382.909607 
	C781.512024,382.961884 783.009460,383.060333 784.506836,383.059845 
	C845.839172,383.039612 907.171570,383.015900 968.503906,382.973206 
	C973.991028,382.969360 979.478027,382.834625 985.498535,382.671478 
	C985.738708,382.210388 985.978943,381.749329 986.774658,380.611969 
	C986.804504,365.948303 986.843689,351.284637 986.828857,336.621002 
	C986.828247,336.054474 986.307983,335.488464 986.029236,334.994385 
	C986.029236,334.994385 986.092651,334.959961 985.875488,334.290771 
	C984.923950,334.105682 983.971619,333.754761 983.021057,333.759583 
	C954.822327,333.902374 926.623779,334.086975 898.424988,334.234619 
	C896.959534,334.242279 895.492554,333.983032 894.038513,332.929779 
	C894.018494,288.287842 894.016907,243.645874 893.928162,199.004074 
	C893.923340,196.581482 893.189819,194.160355 892.810791,191.045822 
	C892.773560,190.122620 892.736389,189.199432 892.804443,187.564636 
	C892.792297,187.325165 892.780090,187.085693 892.426086,186.199371 
	C890.665527,185.897903 888.905273,185.334595 887.144409,185.332977 
	C831.239014,185.281448 775.333557,185.276733 719.428101,185.314392 
	C717.667236,185.315582 715.906677,185.838593 713.488159,186.603271 
	C713.384705,189.481094 713.281189,192.358932 713.138916,196.131042 
	C713.087585,222.538895 713.055908,248.946838 712.949951,275.354462 
	C712.940796,277.626495 712.439453,279.896545 711.264099,282.099854 
	C708.355164,282.099854 705.446228,282.099854 702.025452,282.099854 
	C702.025452,273.884003 702.117126,265.504333 701.950195,257.129822 
	C701.915649,255.396927 700.919922,253.683212 699.702942,251.357285 
	C694.753601,251.304825 689.804199,251.252350 684.105896,251.020981 
	C676.845886,250.428802 669.585815,249.836609 661.680359,248.741867 
	C661.115967,241.496262 660.551575,234.250641 660.002502,226.069397 
	C659.614258,220.700104 659.226074,215.330811 658.300781,209.365005 
	C656.820801,209.266769 655.340942,209.084167 653.860901,209.082901 
	C629.607361,209.062103 605.353821,209.064194 580.244019,209.021103 
	C576.540649,209.289551 576.991272,206.667297 576.987061,204.350906 
	C576.962769,191.007095 576.967285,177.662949 576.825500,164.320358 
	C576.817200,163.537781 575.618347,162.767853 574.936401,161.430389 
	C574.597839,161.039566 574.259277,160.648758 573.005432,160.106140 
	C550.605286,160.076904 528.204956,160.009552 505.805298,160.100021 
	C504.231812,160.106369 502.663055,161.279129 501.028412,162.856216 
	C501.030334,170.879959 501.032227,178.903717 500.331116,187.421738 
	C490.577118,187.653000 480.823120,187.884247 470.240479,188.034561 
	C468.010162,187.374603 465.779846,186.714661 463.427765,185.554657 
	C463.466431,185.387527 463.505127,185.220383 464.411011,184.923569 
	C464.867432,184.498062 465.713715,184.079849 465.721863,183.645920 
	C465.845062,177.066757 465.911530,170.484741 465.814026,163.906021 
	C465.804474,163.259521 464.630737,162.630295 463.879547,161.169662 
	C462.724121,160.779037 461.569000,160.049301 460.413208,160.048233 
	C440.298645,160.029678 420.183990,160.100510 399.377228,160.395706 
	C398.698883,162.701904 398.020569,165.008102 397.170013,168.190216 
	C397.149323,183.115555 397.128662,198.040878 397.005920,213.901459 
	C397.010345,216.227081 397.018158,218.552719 397.018616,220.878342 
	C397.020874,232.412216 395.438568,233.564011 408.662415,232.940689 
	C412.302246,232.769119 413.176392,234.223465 413.097961,237.579987 
	C412.900116,246.048096 413.010193,254.523422 412.143097,262.995483 
	C407.181458,263.576660 402.170197,265.578369 397.369263,262.171356 
	C396.744781,261.728210 395.454315,262.185730 394.477936,262.282562 
	C388.777954,262.847687 383.090027,263.595520 377.377441,263.952698 
	C372.921570,264.231293 368.435791,264.031281 363.514496,263.610718 
	C363.045471,265.852051 362.185974,268.095367 362.197174,270.334290 
	C362.214813,273.867310 361.172821,275.257385 357.348602,275.106812 
	C349.954102,274.815674 342.537506,275.085876 334.555206,275.039612 
	C334.361847,275.028381 334.168518,275.017151 333.321655,274.469543 
	C333.236145,270.666412 333.074585,266.863159 333.081390,263.060181 
	C333.094513,255.729202 331.363190,253.658447 324.081177,251.847733 
	C323.709534,247.248062 323.108826,242.651871 323.039307,238.047638 
	C322.984558,234.422562 323.876526,232.350311 328.901978,232.690781 
	C340.296997,233.462769 351.775574,232.991821 363.220062,233.046860 
	C367.465424,233.067291 368.581665,230.194199 368.568542,226.824829 
	C368.541534,219.882324 368.201477,212.941040 368.019257,205.062424 
	C368.010742,194.708282 368.002228,184.354141 368.021667,173.063004 
	C368.022644,161.099548 368.033051,149.136093 368.015839,137.172668 
	C368.012756,135.026428 368.405182,132.479401 363.945312,133.174393 
	C359.856018,132.736160 355.770355,131.957306 351.676849,131.913834 
	C320.576660,131.583542 289.475067,131.299728 258.373566,131.258682 
	C252.990463,131.251587 247.605759,132.462723 241.373657,132.964142 
	C237.131927,132.526566 237.008179,135.238907 237.008881,138.374466 
	C237.015335,167.652023 236.950058,196.929596 236.911652,226.207153 
	C236.902832,232.921448 237.045807,233.076599 244.035309,233.076736 
	C267.081726,233.077164 290.128174,233.055756 313.174591,233.042984 
	C314.946411,233.042007 316.718201,233.042862 318.846527,233.042862 
	C318.846527,239.733948 318.846527,245.762344 318.203491,252.003998 
	C317.988007,252.071548 317.772552,252.139084 316.701996,252.143524 
	C307.299591,252.179977 297.897156,252.216431 287.719574,251.901535 
	C287.098877,250.318695 286.305023,248.779480 285.892883,247.144073 
	C284.985046,243.541382 284.269775,239.890167 283.475922,236.258743 
	C282.606354,236.290771 281.736816,236.322815 280.867249,236.354843 
	C280.449951,239.535400 280.032684,242.715958 279.447296,246.184647 
	C279.355865,246.640335 279.264435,247.096024 278.754791,248.059631 
	C278.686371,248.268005 278.617981,248.476379 278.631836,248.684372 
M663.024719,288.003204 
	C663.024719,288.003204 663.084229,288.090271 663.807556,287.983032 
	C665.365295,287.321564 666.922974,286.660095 667.378052,286.466858 
	C666.771790,286.494995 664.871399,286.583191 662.099487,286.566010 
	C658.853821,286.566010 655.608215,286.566010 652.362549,286.566010 
	C652.376587,285.948944 652.390625,285.331879 652.404663,284.714813 
	C657.881226,284.714813 663.357727,284.714813 668.834290,284.714813 
	C668.838562,284.483856 668.842834,284.252899 668.847107,284.021942 
	C666.354187,283.460724 663.861267,282.899536 661.368347,282.338318 
	C661.589294,282.097198 661.810242,281.856049 662.031250,281.614929 
	C661.025635,280.723633 660.020020,279.832306 659.200684,278.164062 
	C661.610596,277.751434 664.110474,277.606293 666.400330,276.836456 
	C668.053467,276.280670 669.427307,274.894196 671.071106,273.266205 
	C670.969971,272.872192 670.868774,272.478210 671.357971,271.638916 
	C671.465149,266.407318 667.678955,269.860809 664.979919,269.086243 
	C656.000305,269.086243 647.020691,269.086243 638.041077,269.086243 
	C638.003235,269.371460 637.965332,269.656647 637.927490,269.941864 
	C640.804626,270.205109 643.681763,270.468384 646.558899,270.731628 
	C646.557373,271.028351 646.555908,271.325073 646.554382,271.621796 
	C644.688538,271.842987 642.822693,272.064148 641.636475,272.204773 
	C641.636475,273.573547 641.688416,274.805756 641.627136,276.032318 
	C641.409546,280.386627 641.153442,284.739014 641.042114,289.797760 
	C644.881409,292.220825 645.382141,295.960571 644.752380,300.564301 
	C642.494568,302.047333 642.250183,304.809509 643.609070,306.109436 
	C646.733398,309.098175 644.619934,312.392914 643.159607,313.465210 
	C638.625305,316.794861 639.563660,321.993530 637.815918,326.183990 
	C637.384277,327.218933 639.273254,329.221802 640.095459,330.779755 
	C642.091064,329.517731 644.086609,328.255707 646.809143,326.964966 
	C647.291992,326.917786 647.774841,326.870636 648.765564,326.812012 
	C649.104187,326.814636 649.442810,326.817261 650.544250,327.205383 
	C653.705261,327.442383 656.866272,327.679413 660.674927,327.966522 
	C661.107056,327.947784 661.539185,327.929047 662.780823,327.939789 
	C663.860291,327.922638 664.939697,327.905457 666.452209,327.733978 
	C666.722412,327.559296 666.903931,327.317871 667.000488,327.002075 
	C667.000488,327.002075 667.009766,327.000000 667.646179,326.937378 
	C668.222778,326.554321 668.799377,326.171234 668.631226,326.282990 
	C666.654175,324.453766 664.856750,322.790802 663.885864,321.073547 
	C668.278870,321.847595 670.259338,319.396332 671.415405,315.412140 
	C669.167053,315.578400 667.119385,315.729797 664.997986,315.191772 
	C664.513550,313.984955 664.029114,312.778137 663.738342,312.053833 
	C666.695984,311.673920 669.342773,311.333954 672.688171,311.296204 
	C678.514099,313.878540 684.288940,313.665710 690.093201,311.458008 
	C690.373108,311.716766 690.653015,311.975555 690.932922,312.234344 
	C691.044006,311.969696 691.155029,311.705078 691.266113,311.440430 
	C690.837280,311.300049 690.408386,311.159637 689.454834,310.406372 
	C687.704163,310.302246 685.821472,310.557922 684.244812,309.979462 
	C682.996216,309.521301 682.123108,308.039825 681.602844,306.650604 
	C682.410339,305.728668 683.217834,304.806732 684.200256,303.685120 
	C680.506653,300.479004 675.974792,302.342194 670.983521,301.991882 
	C668.098083,301.507080 665.212646,301.022308 662.327271,300.537506 
	C662.290527,300.328888 662.253845,300.120270 662.217163,299.911652 
	C663.890503,299.636353 665.563843,299.361084 667.237183,299.085785 
	C667.256104,298.888672 667.275024,298.691528 667.293945,298.494385 
	C660.656128,298.205383 654.018311,297.916351 647.184387,297.010681 
	C649.863525,294.585358 649.661682,291.755402 649.269348,288.604095 
	C650.504639,288.602051 651.739929,288.600037 653.579346,288.707733 
	C654.166748,288.562012 654.754211,288.416290 656.138611,288.358826 
	C658.009827,288.304199 659.881104,288.249542 662.066345,288.428314 
	C662.402527,288.315491 662.738647,288.202698 663.024719,288.003204 
M181.869263,706.035217 
	C183.224442,706.046021 184.579620,706.056824 186.163513,706.832703 
	C190.469681,707.473633 194.768478,708.591003 199.083511,708.657776 
	C208.441666,708.802429 217.808899,708.241211 227.170990,708.283508 
	C236.947861,708.327698 246.722534,708.769775 256.499725,708.954956 
	C257.624573,708.976196 258.759491,708.466125 259.889740,708.202393 
	C259.921478,707.742310 259.953186,707.282227 259.984924,706.822144 
	C258.240662,706.227905 256.492798,705.117310 254.752777,705.129517 
	C247.471954,705.180542 240.194931,705.682922 232.913452,705.773071 
	C230.220062,705.806519 227.518295,705.160950 224.847595,703.910645 
	C225.226822,683.604858 225.607483,663.299133 225.984772,642.993347 
	C226.256454,628.371521 226.594955,613.750427 226.773163,599.127441 
	C226.959656,583.823669 226.954132,568.517456 227.138779,553.213623 
	C227.159637,551.485168 227.868759,549.765015 229.069763,548.027954 
	C235.459915,548.346619 241.847351,548.754395 248.241287,548.949097 
	C251.832703,549.058533 252.990433,546.835999 253.053375,543.497864 
	C253.118500,540.044739 251.615784,538.629944 248.269852,538.967163 
	C244.852951,539.311584 241.435944,539.654968 237.800980,539.382629 
	C238.983795,538.037354 239.912994,536.226562 241.390244,535.421692 
	C251.505661,529.910217 251.231277,518.828369 243.886795,513.578918 
	C240.888931,511.436188 237.963501,509.192169 234.827805,506.640930 
	C234.539001,506.752777 234.250198,506.864655 233.224731,506.988647 
	C232.489182,507.025452 231.753647,507.062256 230.080002,507.026703 
	C224.026520,507.043762 217.973038,507.060791 211.134781,507.215027 
	C210.765625,508.723145 210.103912,510.226013 210.076797,511.740265 
	C209.942810,519.222473 209.821182,526.711731 210.017654,534.190002 
	C210.114426,537.873230 208.849564,539.517578 204.286301,539.049683 
	C199.188965,539.368896 194.091629,539.688110 189.109955,539.188538 
	C190.789215,532.803711 189.361786,527.075317 186.579330,521.117615 
	C184.146393,515.908264 180.243317,513.356873 175.422729,511.345917 
	C173.112961,510.382355 170.864594,509.271637 168.924271,508.381622 
	C165.882507,508.871796 162.630692,510.185699 159.677185,509.696930 
	C154.530380,508.845184 149.542358,506.961212 144.532806,505.368286 
	C135.384949,502.459503 126.269989,499.447357 117.631363,496.408813 
	C109.551880,492.217194 102.226494,494.720276 94.713898,499.512909 
	C84.266762,506.910217 79.079262,516.978394 78.860863,529.808411 
	C78.809235,532.841370 77.572922,535.854126 75.965599,538.896729 
	C69.826706,538.916626 63.685043,538.834656 57.550129,539.001160 
	C54.666271,539.079407 51.795395,539.635986 48.177483,540.162354 
	C46.575787,543.300171 45.112526,546.403687 50.956352,548.005432 
	C55.076847,548.056458 59.201778,548.245178 63.316357,548.112549 
	C66.316696,548.015869 67.140060,549.443542 66.890587,552.083496 
	C66.625771,554.885681 66.167191,557.694031 66.196724,560.495544 
	C66.413765,581.091187 66.855049,601.685120 66.986717,622.281067 
	C67.147247,647.392029 67.050568,672.504517 67.139641,697.616150 
	C67.148384,700.079895 67.677902,702.541748 67.533646,705.288513 
	C67.657326,705.860901 67.781006,706.433289 67.933014,707.918579 
	C67.622108,722.166687 67.308784,736.414673 67.004845,750.662964 
	C66.980072,751.824463 66.747971,753.080688 67.106560,754.122864 
	C67.455887,755.138123 68.440147,755.934998 69.145660,756.827698 
	C69.756294,756.009399 70.672592,755.268127 70.903191,754.354004 
	C71.219307,753.100952 71.030609,751.716614 71.031380,750.388550 
	C71.039368,736.608093 71.041962,722.827576 71.977112,709.013306 
	C87.710167,709.010803 103.443336,708.980225 119.176147,709.041504 
	C121.128204,709.049072 123.070847,709.641479 125.030998,709.793518 
	C129.031815,710.103882 129.203568,712.404968 128.722702,715.706299 
	C128.335358,718.365601 128.835770,721.154236 128.923126,724.785583 
	C128.378998,735.046387 126.545868,745.373169 129.453476,755.457153 
	C130.216278,755.457703 130.979095,755.458252 131.741898,755.458740 
	C131.741898,745.026489 131.741898,734.594238 131.782181,723.318909 
	C131.519012,720.524414 131.404861,717.705994 130.960068,714.940735 
	C130.161026,709.973083 133.031250,708.373901 137.155563,708.042053 
	C142.760269,707.591003 148.380768,707.336365 154.557892,707.269165 
	C155.710953,707.500244 156.864014,707.731323 158.786591,708.065308 
	C161.976425,708.616028 163.571808,710.265381 163.069763,713.722595 
	C162.817413,715.460388 163.042206,717.267395 163.015518,719.974426 
	C163.015518,732.108337 163.015518,744.242310 163.015518,756.376221 
	C164.809341,755.941833 165.855682,755.273682 165.861481,754.596619 
	C165.963089,742.747192 165.937378,730.896729 165.989990,718.206055 
	C166.354050,715.163757 166.718109,712.121460 167.927322,709.020142 
	C171.659363,708.655151 175.403671,708.376709 179.112808,707.850342 
	C179.831177,707.748413 180.412216,706.678772 181.869263,706.035217 
M115.281853,368.808868 
	C114.575668,369.537323 113.869484,370.265778 112.401627,371.014587 
	C109.885109,373.812866 107.368591,376.611115 104.219688,379.377380 
	C97.275574,388.494568 96.716454,398.582397 99.299622,409.874298 
	C100.724518,417.766327 104.355835,424.447083 110.469177,429.657074 
	C119.902473,437.696472 130.485947,441.339081 142.694824,437.080505 
	C154.347717,433.015869 162.931992,425.878601 165.737076,412.474304 
	C166.488525,406.485138 167.879425,400.493408 167.855515,394.507355 
	C167.808762,382.798767 155.488205,368.338074 143.862457,365.311432 
	C141.029465,364.609802 138.200546,363.339539 135.362671,363.319183 
	C128.419067,363.269348 121.304451,363.234314 115.999390,368.998779 
	C115.999390,368.998779 115.969452,368.961761 115.281853,368.808868 
M619.195618,370.752106 
	C619.420898,371.793488 619.646179,372.834869 619.640076,374.706543 
	C619.732849,381.175659 619.892151,387.644653 619.905334,394.113922 
	C619.939392,410.864075 619.893433,427.614410 619.911560,444.364624 
	C619.919739,451.948547 620.003906,459.532410 619.278809,467.064117 
	C618.503235,467.089935 617.727722,467.115753 616.414856,467.285736 
	C615.913635,467.536041 615.412354,467.786346 614.311829,467.704926 
	C611.557739,463.176636 608.803711,458.648346 606.038208,453.247406 
	C605.697510,449.960876 605.081421,446.676056 605.061035,443.387543 
	C604.932068,422.602112 604.935059,401.815887 604.970093,380.091614 
	C604.958801,347.413025 604.947571,314.734467 604.963013,281.291443 
	C605.005066,277.331329 602.583618,275.292847 598.565430,273.413849 
	C597.755066,273.278046 596.944763,273.023712 596.134338,273.023407 
	C551.443237,273.006134 506.752106,273.001160 462.061035,273.052826 
	C460.652435,273.054474 459.244568,273.661865 457.158203,274.062103 
	C455.765778,275.987457 454.373322,277.912811 452.401733,280.480408 
	C452.267426,282.454956 452.017090,284.429413 452.015839,286.404022 
	C451.986542,331.944427 451.984344,377.484863 451.656586,423.615234 
	C448.100372,427.066833 444.544189,430.518433 440.261047,433.957703 
	C438.443390,432.664429 436.625702,431.371185 434.843109,429.231903 
	C434.595337,426.929993 434.134674,424.628235 434.132629,422.326111 
	C434.111542,398.547028 434.190979,374.767822 434.150299,350.988800 
	C434.146759,348.922455 433.487396,346.857269 432.982574,344.328888 
	C432.774658,344.041504 432.493439,343.903137 431.564819,343.343567 
	C425.383850,342.880127 419.202911,342.416656 412.262817,341.613342 
	C410.276245,341.458252 408.292145,341.222229 406.302704,341.161499 
	C395.181946,340.822052 384.059967,340.525024 372.626099,339.923859 
	C372.088165,339.959229 371.550201,339.994598 370.094116,339.804993 
	C361.675690,339.842621 352.966675,341.257294 344.914825,339.558014 
	C335.533478,337.578125 326.466431,336.786987 316.288696,337.898163 
	C312.234161,337.816376 309.036713,339.245300 307.038391,343.973358 
	C307.017487,348.789581 306.976196,353.605774 306.978943,358.421997 
	C307.003479,401.275269 307.035797,444.128540 307.118744,487.711761 
	C307.778503,490.890839 309.713379,492.374481 313.205475,492.491943 
	C313.416443,492.729218 313.679718,492.865356 314.789856,492.927063 
	C315.848114,492.910706 316.906372,492.894348 318.903778,492.949554 
	C326.696747,492.960480 334.492340,493.099640 342.281891,492.941895 
	C348.542694,492.815125 354.796234,492.328888 361.078400,492.928284 
	C361.049225,496.953003 361.020050,500.977692 360.458282,505.575012 
	C359.969086,510.712280 359.479889,515.849548 358.214294,521.338684 
	C356.794708,521.649170 355.375671,522.227844 353.955475,522.230591 
	C324.809875,522.287354 295.664093,522.282227 266.518372,522.276917 
	C263.652466,522.276367 260.841858,521.759338 260.756592,526.293396 
	C260.669373,530.929565 263.546967,530.831421 266.638428,530.952881 
	C274.118958,531.246521 281.598907,531.554932 289.243439,532.802979 
	C289.169006,534.298462 289.029480,535.793884 289.029633,537.289368 
	C289.034393,589.927734 289.040985,642.566162 289.078094,695.204529 
	C289.085236,705.368042 289.719940,705.881775 300.927063,705.153503 
	C318.623169,705.227234 336.319275,705.300964 354.682098,705.807312 
	C357.325378,706.002747 359.972626,706.155457 362.611298,706.400635 
	C378.731506,707.898071 394.822235,709.999512 410.976532,710.763855 
	C427.071777,711.525452 443.230865,710.886780 459.360016,711.052368 
	C461.276245,711.071960 463.180206,712.289490 465.050842,713.759888 
	C466.636047,716.782043 464.408325,722.060608 470.697540,722.858032 
	C470.088226,719.342957 469.537872,716.168091 469.487091,712.444702 
	C470.975250,712.316223 472.463409,712.187744 473.914856,712.728699 
	C473.482666,714.066650 473.050476,715.404663 472.644989,716.659912 
	C480.331604,720.818542 484.270691,719.256531 485.769531,711.698486 
	C492.455566,711.466858 499.140961,711.095337 505.827881,711.066345 
	C508.870667,711.053162 511.916412,711.717468 514.990356,712.873108 
	C516.009460,714.868408 517.028625,716.863647 518.047729,718.858948 
	C519.979736,717.655396 522.042542,716.610352 523.783081,715.174622 
	C524.538574,714.551514 524.630920,713.124573 525.762268,711.658264 
	C531.882568,711.431824 538.005066,710.985352 544.122498,711.045715 
	C549.400208,711.097778 554.672180,711.726685 559.995422,712.848022 
	C561.085999,714.203918 562.176514,715.559753 563.267090,716.915649 
	C564.189697,715.306824 565.129028,713.707092 566.017822,712.079773 
	C566.158569,711.822205 566.071167,711.440063 567.013550,711.051819 
	C571.178833,711.030029 575.344177,710.977051 579.509277,710.997314 
	C582.335266,711.010986 585.739624,710.215454 587.785522,711.514282 
	C589.180237,712.399780 588.434875,716.343689 589.112976,718.790833 
	C589.503662,720.200745 590.823181,721.353333 591.724609,722.621704 
	C592.806519,721.366943 594.019836,720.196960 594.909241,718.817993 
	C595.294922,718.219971 595.118469,717.178894 595.017761,716.361145 
	C594.504395,712.190491 596.349915,710.946594 600.453247,710.872559 
	C627.550049,710.384277 654.641541,709.609375 681.736938,709.031799 
	C702.697998,708.584900 723.663147,708.336731 744.624390,707.898560 
	C751.260681,707.759766 757.894653,707.360046 764.518738,706.917114 
	C765.729309,706.836243 766.887268,705.969177 768.832397,705.187561 
	C769.641296,702.803162 771.150513,700.420532 771.156433,698.034119 
	C771.293762,642.781250 771.267822,587.528015 771.918823,531.983032 
	C779.322205,531.706421 786.724060,531.367554 794.129700,531.182190 
	C797.314453,531.102539 799.695679,530.490540 799.692810,526.567627 
	C799.689941,522.591492 797.327332,522.106018 794.098083,522.117493 
	C773.174866,522.191833 752.251282,522.171265 731.327820,522.168579 
	C726.529846,522.167969 721.731934,522.115417 716.952759,521.258179 
	C715.949158,516.499390 714.945618,511.740662 713.985962,506.169312 
	C713.422363,501.457672 712.858704,496.746002 713.147583,492.002075 
	C722.774719,491.662354 732.401855,491.322632 742.891113,491.018097 
	C744.820801,491.246094 746.765076,491.389099 748.677490,491.717621 
	C755.027466,492.808594 757.831177,490.728058 759.034668,483.054016 
	C759.018433,447.368225 759.002197,411.682404 759.025085,375.112640 
	C758.714111,372.309662 758.132263,369.505859 758.140625,366.703827 
	C758.171326,356.378235 753.813660,356.416809 745.734558,357.273010 
	C735.270569,357.057556 724.805969,356.632233 714.342773,356.666412 
	C684.119934,356.765106 653.895935,356.923126 623.676270,357.341125 
	C615.272278,357.457367 613.897705,360.682343 618.370789,368.483215 
	C618.642029,368.971558 618.913208,369.459930 619.195618,370.752106 
M908.909973,503.959229 
	C909.393433,496.769623 909.876953,489.580017 910.360413,482.390442 
	C909.860596,482.159180 909.360779,481.927917 908.860901,481.696655 
	C907.921814,482.688416 906.190613,483.666046 906.172607,484.674286 
	C906.058533,491.050781 906.323975,497.434052 906.112732,504.623352 
	C905.906982,508.830353 905.701294,513.037354 905.298828,518.037292 
	C904.927917,523.715149 904.557068,529.392944 903.894714,535.809387 
	C903.894714,543.925659 903.894714,552.041931 903.894714,560.158203 
	C903.451782,560.189941 903.008911,560.221619 902.565979,560.253296 
	C901.734192,559.165039 900.902405,558.076721 899.983093,556.293457 
	C895.906128,549.344238 890.732910,544.115173 881.824463,544.882019 
	C878.164124,545.197083 874.500549,545.526917 870.861145,546.018616 
	C866.662842,546.585938 865.554260,548.452271 868.369507,551.636292 
	C872.916626,556.779114 877.841187,561.760376 883.317932,565.859131 
	C888.399353,569.661987 894.429260,569.845154 900.945557,566.288025 
	C901.705200,567.190247 902.911316,567.992615 903.139465,569.013550 
	C903.785706,571.906006 904.031799,574.887817 904.342224,578.688843 
	C905.102966,590.799011 905.913330,602.906494 906.581726,615.021790 
	C906.711670,617.377197 906.288818,619.763184 905.255798,622.049438 
	C903.808655,622.084167 902.361572,622.118958 900.055298,622.061584 
	C892.916870,622.087646 885.776794,622.049072 878.642029,622.224609 
	C877.783508,622.245728 876.953613,623.426636 875.967407,624.985352 
	C876.014709,651.299500 876.062012,677.613647 876.123291,704.671326 
	C877.456360,708.484070 880.091797,708.198975 883.378113,707.424988 
	C888.001648,706.336121 892.774475,705.115906 897.460022,705.203857 
	C909.855713,705.436462 922.242615,706.278198 934.625366,707.007141 
	C940.891479,707.376038 943.360718,705.455017 942.849426,700.342590 
	C942.471375,696.562561 942.281860,692.763672 942.039612,688.039551 
	C942.346497,668.453979 942.680298,648.868835 942.945435,629.282715 
	C943.035706,622.614258 939.968323,620.209656 933.308350,621.143250 
	C927.805359,621.914734 922.256287,622.356812 916.214844,622.452576 
	C914.635559,621.630615 911.827026,620.985413 911.679199,619.957581 
	C910.808472,613.901245 910.342102,607.761108 910.193726,601.638245 
	C910.126099,598.847107 911.738281,597.108154 915.119141,597.687622 
	C920.607971,598.628479 926.035034,597.851257 930.048767,593.862732 
	C933.892334,590.043213 937.392578,585.713196 940.233032,581.107544 
	C942.108704,578.066162 942.552002,574.141418 943.636597,570.612122 
	C940.105591,570.423462 936.533447,569.799438 933.051208,570.127808 
	C922.638489,571.109680 914.438782,579.162720 912.694092,589.539001 
	C912.306396,591.844727 911.656555,594.106445 911.127441,596.388428 
	C910.592285,596.375061 910.057129,596.361633 909.521973,596.348206 
	C909.281738,594.842773 908.885803,593.343567 908.825378,591.830933 
	C908.195435,576.051392 907.440918,560.273315 907.108582,544.486755 
	C906.958374,537.351196 907.440186,530.175903 908.084534,523.059265 
	C908.525391,518.190613 910.645325,516.823120 915.217896,518.393860 
	C927.983887,522.779236 938.203857,518.691772 946.274048,508.832977 
	C950.454651,503.725708 955.231689,498.459564 953.998047,490.192505 
	C947.381653,488.076141 940.836182,487.829071 934.208191,490.772400 
	C934.208191,490.772400 934.000854,490.938202 933.278076,490.987152 
	C932.395020,491.293762 931.511902,491.600372 929.899719,491.918488 
	C918.810852,495.605255 910.768250,501.860504 910.263123,514.732239 
	C910.230286,515.568787 908.637024,516.344055 907.965332,516.451477 
	C908.231567,512.575500 908.497742,508.699554 908.909973,503.959229 
M243.239899,470.232666 
	C243.433456,463.643097 238.848175,460.964447 233.718536,459.009338 
	C230.329971,457.717896 226.681229,457.121582 223.245743,455.934082 
	C222.018585,455.509949 221.075836,454.262939 220.003281,453.391510 
	C220.948563,452.313599 221.693542,450.857056 222.877670,450.230621 
	C226.085052,448.533966 229.705734,447.550842 232.754349,445.635162 
	C240.551819,440.735352 240.235733,430.568939 232.115158,425.183411 
	C231.862549,426.015167 231.376373,426.795929 231.440506,427.528534 
	C232.328308,437.670105 226.074234,442.037964 217.717911,444.925323 
	C215.585052,445.662262 213.040527,446.662506 211.866150,448.359253 
	C210.315948,450.598907 208.752533,453.965088 209.375656,456.253052 
	C209.995041,458.527222 213.066803,460.581238 215.527740,461.769623 
	C217.635162,462.787231 220.468796,462.164703 222.860718,462.755524 
	C229.469070,464.387878 237.583572,462.777130 241.185669,471.793732 
	C239.182617,472.559418 237.202866,473.903198 235.172241,473.985107 
	C228.402344,474.258209 221.607422,473.918304 214.838715,474.205292 
	C213.444855,474.264404 211.383484,475.768188 210.954346,477.049683 
	C210.415756,478.657928 210.544357,481.522644 211.604507,482.447968 
	C215.457809,485.811279 219.820145,488.591370 223.990540,491.591400 
	C224.376099,491.276520 224.761673,490.961609 225.147247,490.646698 
	C223.597290,488.605469 221.950256,486.628937 220.531570,484.500244 
	C219.587952,483.084290 218.970444,481.451019 218.206970,479.915009 
	C219.831680,479.272614 221.424469,478.195770 223.087402,478.073608 
	C227.213684,477.770477 231.378601,478.033997 235.515610,477.824768 
	C239.768570,477.609741 242.955612,475.981689 243.239899,470.232666 
M924.245911,453.150391 
	C922.929504,454.626404 921.613159,456.102417 920.296753,457.578430 
	C919.774475,457.227325 919.252197,456.876221 918.729919,456.525116 
	C920.018311,452.584656 921.306641,448.644226 922.595032,444.703796 
	C922.081482,444.554199 921.567932,444.404633 921.054382,444.255035 
	C916.283203,451.849365 913.095825,459.996429 912.912537,469.255035 
	C914.722168,467.889435 915.904846,466.091461 917.486877,464.772461 
	C920.256104,462.463562 921.344727,457.865662 926.687439,458.723755 
	C932.616943,463.637970 939.352173,466.170135 947.059082,464.810455 
	C959.878113,462.548859 967.847107,453.628784 974.809204,443.659668 
	C976.785828,440.829132 974.350891,439.255676 971.861755,438.838776 
	C963.887390,437.503113 955.904846,435.793243 947.865417,435.371094 
	C936.700134,434.784912 927.953308,441.813995 924.245911,453.150391 
M900.815308,481.967346 
	C902.412170,481.967346 904.009033,481.967346 905.607605,481.967346 
	C905.877686,480.011627 905.814331,478.617889 906.273010,477.424927 
	C914.011230,457.299530 895.618347,441.268707 880.609192,437.376404 
	C878.212402,436.754852 877.161377,437.642181 876.918823,440.428802 
	C876.069702,450.181610 878.223389,459.202484 883.014404,467.589752 
	C886.891907,474.377808 892.106018,479.788208 900.815308,481.967346 
M224.943787,724.841553 
	C224.431412,722.063293 223.919037,719.285034 223.289612,715.872131 
	C219.835007,721.396729 220.241211,742.156860 223.899338,744.783142 
	C224.263718,738.205322 224.608429,731.982727 224.943787,724.841553 
M662.417969,293.682953 
	C661.470276,293.965240 660.522522,294.247528 659.574829,294.529816 
	C659.640259,294.744629 659.705688,294.959442 659.771179,295.174255 
	C668.204468,295.174255 676.637817,295.174255 685.169678,295.174255 
	C684.991638,293.586548 684.870544,292.506775 684.704041,291.021973 
	C679.297546,291.021973 673.847900,290.836060 668.423767,291.126343 
	C666.611877,291.223297 664.865234,292.537628 662.417969,293.682953 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M354.015381,705.374695 
	C336.319275,705.300964 318.623169,705.227234 300.468201,704.589844 
	C300.012726,686.341980 300.016113,668.657715 300.304108,650.747437 
	C300.971680,649.786377 301.589905,649.085571 301.702972,648.311035 
	C304.135895,631.643433 314.784088,620.010437 326.842773,610.018921 
	C347.275909,593.088562 371.198273,582.376038 396.546478,575.031433 
	C409.885681,571.166443 423.516754,568.308594 437.013794,565.400757 
	C436.799561,566.932434 436.715271,568.101929 436.356262,569.179810 
	C431.721466,583.095215 432.731720,597.044373 436.034271,611.419800 
	C437.170410,616.480042 438.044739,621.217529 439.480011,625.778442 
	C445.727112,645.629822 454.570801,664.362976 464.298553,682.709534 
	C465.447754,684.876892 466.153931,687.279236 466.915771,689.877991 
	C464.559814,695.091431 465.170898,701.640869 458.697479,704.091980 
	C458.686005,704.096252 458.889496,704.668335 458.525269,705.006226 
	C427.847260,705.040955 397.636566,705.031433 367.425873,705.062927 
	C362.955627,705.067566 358.485535,705.265991 354.015381,705.374695 
z"/>
<path fill="#71D8EA" opacity="1.000000" stroke="none" 
	d="
M324.165344,252.652557 
	C331.363190,253.658447 333.094513,255.729202 333.081390,263.060181 
	C333.074585,266.863159 333.236145,270.666412 333.662994,274.985901 
	C334.004333,275.502258 333.952271,275.996796 333.679016,276.188965 
	C333.352356,277.245667 333.298920,278.110260 333.194885,279.443970 
	C333.111359,282.375885 333.002502,284.840393 333.059387,287.301117 
	C333.247925,295.459442 333.496124,303.616425 333.721436,311.773895 
	C333.440247,318.217224 329.191559,320.655487 322.939453,321.516632 
	C321.427063,321.168182 320.606323,320.989044 319.785583,320.988953 
	C268.196442,320.983337 216.607269,320.987488 165.018127,321.028351 
	C163.736893,321.029358 162.455994,321.451904 161.174927,321.677826 
	C156.121262,321.727966 151.901718,320.551636 150.828278,313.836975 
	C150.871262,296.932617 150.878433,280.865173 151.137558,264.801849 
	C151.184082,261.917877 152.270233,259.050690 153.188812,255.962387 
	C156.055740,254.812836 158.545105,253.479080 161.182236,253.046875 
	C164.096283,252.569336 167.145691,252.913498 170.136154,252.907120 
	C204.525879,252.833710 238.915695,252.781647 273.305023,252.623199 
	C274.829956,252.616165 276.350403,251.642731 277.872925,251.119431 
	C277.970276,250.736099 278.067627,250.352783 278.343170,249.410614 
	C278.521362,248.851776 278.549622,248.684738 278.549622,248.684738 
	C278.617981,248.476379 278.686371,248.268005 278.990417,247.637451 
	C279.355804,246.775681 279.485596,246.336090 279.615387,245.896515 
	C280.032684,242.715958 280.449951,239.535400 280.867249,236.354843 
	C281.736816,236.322815 282.606354,236.290771 283.475922,236.258743 
	C284.269775,239.890167 284.985046,243.541382 285.892883,247.144073 
	C286.305023,248.779480 287.098877,250.318695 288.414551,252.256012 
	C298.592041,252.475861 308.074554,252.341248 317.557068,252.206619 
	C317.772552,252.139084 317.988007,252.071548 318.827820,252.157104 
	C321.023224,252.424332 322.594269,252.538437 324.165344,252.652557 
M309.106079,298.298828 
	C309.276031,296.553162 309.445984,294.807465 310.237915,293.184967 
	C310.802765,293.451172 311.367615,293.717377 312.003357,294.796417 
	C312.325806,296.237701 312.431305,297.782166 313.049957,299.082520 
	C313.436768,299.895538 314.596863,300.340698 315.409943,300.950928 
	C315.975647,300.087646 317.018616,299.231934 317.032379,298.359924 
	C317.155792,290.554138 317.123718,282.745209 317.046021,274.938080 
	C317.039551,274.290344 316.363800,273.649231 315.999023,273.005035 
	C315.481384,273.013153 314.963715,273.021301 314.446045,273.029419 
	C314.228851,277.608368 314.011658,282.187317 313.760620,287.479706 
	C312.002350,282.050659 310.491821,277.386658 308.845856,272.119293 
	C307.898468,272.393280 306.951080,272.667236 305.594055,273.620544 
	C305.488892,276.404541 305.383728,279.188568 304.711639,281.751404 
	C304.169861,281.177094 303.628082,280.602783 303.024933,279.389038 
	C302.903625,275.358551 301.571777,272.214874 296.924530,272.127747 
	C292.044220,272.036285 290.889801,275.249847 290.930115,279.391815 
	C290.986511,285.181915 290.880554,290.975220 291.031769,296.762238 
	C291.136841,300.783417 293.073486,302.278412 297.406525,302.136261 
	C302.003296,301.985474 302.039062,298.807343 303.719055,296.124329 
	C304.398651,297.381256 305.078247,298.638184 306.196777,300.456512 
	C307.106201,300.632355 308.015594,300.808197 309.384552,300.741516 
	C309.312958,300.178650 309.241364,299.615784 309.106079,298.298828 
M252.875916,299.635742 
	C255.347641,302.312225 256.700684,301.245758 256.764099,298.189484 
	C256.919006,290.723389 256.884674,283.250275 256.720062,275.784576 
	C256.699860,274.868530 255.420975,273.980225 254.725403,273.079071 
	C254.182358,273.960266 253.221100,274.818390 253.170898,275.726807 
	C252.983978,279.109283 253.096298,282.508270 253.096298,285.901062 
	C251.408875,282.860779 250.798477,279.648224 249.758301,276.581482 
	C249.302567,275.237854 247.969177,274.191864 247.034317,273.010742 
	C246.332764,274.254791 245.059036,275.483307 245.024734,276.745483 
	C244.835464,283.711670 244.911789,290.686523 244.995453,297.657227 
	C245.008835,298.773834 245.518784,299.884491 245.799179,300.997864 
	C246.387207,300.984833 246.975235,300.971771 247.563263,300.958740 
	C247.563263,296.022705 247.563263,291.086700 247.563263,286.150665 
	C248.050583,286.130829 248.537903,286.110992 249.025208,286.091125 
	C250.200058,290.361206 251.374924,294.631256 252.875916,299.635742 
M238.118774,284.515015 
	C238.116547,287.676117 238.307877,290.854889 238.021683,293.990082 
	C237.898376,295.340790 236.786133,296.601227 236.123154,297.902679 
	C235.348587,296.532867 233.971100,295.191345 233.905289,293.788269 
	C233.640503,288.143646 233.906372,282.475067 233.682983,276.826935 
	C233.628143,275.440674 232.464905,274.098236 231.811234,272.735657 
	C231.218933,272.945099 230.626633,273.154510 230.034332,273.363953 
	C230.034332,281.304749 229.676620,289.274384 230.312927,297.163879 
	C230.453140,298.902374 234.050018,301.468048 236.182022,301.599762 
	C237.977570,301.710785 241.447250,298.971222 241.596909,297.267059 
	C242.234924,290.001953 241.974442,282.651764 241.857483,275.335602 
	C241.845230,274.568665 240.616913,273.821167 239.952789,273.064667 
	C239.351700,273.891205 238.310654,274.678101 238.231873,275.551727 
	C237.993698,278.193024 238.128922,280.867981 238.118774,284.515015 
M208.059814,291.335175 
	C208.030487,286.689697 208.138794,282.037842 207.924911,277.400879 
	C207.774796,274.146118 205.557449,272.625061 202.504974,272.986908 
	C200.339722,273.243561 196.463394,274.156433 196.423279,274.934723 
	C195.983139,283.477264 196.147125,292.050934 196.147125,300.486694 
	C206.265717,302.115021 207.962097,300.857361 208.059814,291.335175 
M182.789719,300.718933 
	C186.579269,300.872864 191.887070,302.951752 192.696167,297.384705 
	C193.689789,290.547974 193.419113,283.405182 192.732422,276.490295 
	C192.288788,272.022919 187.860352,272.917542 184.609406,272.905090 
	C181.074051,272.891541 181.893936,275.619080 181.899658,277.600403 
	C181.921249,285.080841 182.069702,292.560974 182.789719,300.718933 
M178.953903,297.413910 
	C177.851334,290.545013 176.849976,283.657013 175.561279,276.823212 
	C175.301819,275.447296 173.952148,274.276947 173.105133,273.011841 
	C172.154480,274.348175 170.648422,275.571442 170.349442,277.040405 
	C169.061905,283.366486 168.053619,289.753693 167.119980,296.144409 
	C166.892105,297.704132 167.332138,299.361420 167.465088,300.973846 
	C170.960037,297.283875 173.627563,294.528992 176.596497,300.602051 
	C177.400269,299.820160 178.204056,299.038300 178.953903,297.413910 
M270.701080,295.881317 
	C269.721924,295.901978 268.688965,295.732178 267.776703,295.989685 
	C266.536743,296.339813 265.389008,297.016571 264.201752,297.553253 
	C263.786530,296.194885 263.071564,294.849243 263.013458,293.475769 
	C262.851868,289.656952 262.830170,285.819855 263.023743,282.003693 
	C263.118561,280.135071 263.813843,278.296967 264.237366,276.445038 
	C265.844757,277.233093 267.442688,278.041901 269.069519,278.787537 
	C269.322144,278.903290 269.707062,278.730408 270.029541,278.680542 
	C270.864166,275.125824 269.637604,272.862305 266.501862,272.170349 
	C262.707733,271.333099 259.483032,273.470428 259.252197,277.696167 
	C258.917114,283.830994 258.726685,290.045624 259.398590,296.124084 
	C259.629974,298.217438 262.315155,301.065277 264.434296,301.691895 
	C267.906189,302.718445 270.347260,300.401398 270.701080,295.881317 
M217.959488,297.192627 
	C218.362366,298.472443 218.765244,299.752258 219.484100,302.035828 
	C223.002792,296.760956 217.643768,289.181488 226.442780,287.937683 
	C218.879532,282.524414 219.124329,280.855927 227.753204,273.717377 
	C224.871384,273.190247 221.872055,272.792328 219.122818,273.446136 
	C218.353424,273.629120 218.045700,276.905182 218.001862,278.773560 
	C217.865219,284.598785 217.956451,290.429321 217.959488,297.192627 
M284.154846,277.754730 
	C284.146790,284.383789 284.031403,291.015930 284.224030,297.639160 
	C284.261200,298.915863 285.505219,300.157410 286.192474,301.415192 
	C286.806854,300.236237 287.925842,299.068695 287.952759,297.876465 
	C288.113708,290.754028 288.105347,283.623901 287.933319,276.501678 
	C287.905457,275.347443 286.776703,274.219818 286.156830,273.079895 
	C285.488129,274.331238 284.819427,275.582611 284.154846,277.754730 
M280.088593,272.910889 
	C277.566833,272.910889 275.045074,272.910889 271.470154,272.910889 
	C279.894684,281.831512 273.061066,292.364410 277.642975,300.973328 
	C278.563538,299.227173 278.784882,297.463715 279.053680,295.707520 
	C280.150726,288.540009 276.409241,280.749146 281.794739,274.103973 
	C281.849396,274.036499 281.230072,273.422882 280.088593,272.910889 
z"/>
<path fill="#FDBA5B" opacity="1.000000" stroke="none" 
	d="
M440.988007,433.970062 
	C444.544189,430.518433 448.100372,427.066833 452.085938,423.301270 
	C452.694183,422.970612 452.873077,422.953888 453.233826,423.130676 
	C456.258453,421.339508 459.101257,419.354828 462.296478,417.241516 
	C465.469635,415.644714 468.290436,414.176575 471.479797,412.709106 
	C478.150299,411.395935 484.452271,410.082153 491.142212,408.836548 
	C493.631866,408.447662 495.733521,407.990570 498.185974,407.435608 
	C499.018707,407.283813 499.500610,407.229919 500.303589,407.428650 
	C514.416138,407.744873 528.207581,407.808472 542.412964,407.922852 
	C552.983765,409.003845 562.514832,411.672882 570.576355,418.349274 
	C571.944641,419.482544 573.574097,420.300446 575.264771,421.518402 
	C582.007019,427.839325 588.567261,433.905945 595.222656,440.294647 
	C598.175598,443.954590 601.033569,447.292419 603.966248,450.985046 
	C604.710571,452.266602 605.380127,453.193329 606.049683,454.120056 
	C608.803711,458.648346 611.557739,463.176636 614.642883,468.139313 
	C615.013672,468.749237 615.053467,468.924805 615.082275,469.466492 
	C617.311340,476.168152 619.502686,482.521667 621.835754,488.822754 
	C622.260376,489.969482 623.264343,490.901733 623.810425,492.272247 
	C623.625854,493.885895 623.670227,495.161499 623.630615,496.434479 
	C623.489014,500.983521 623.318970,505.531647 623.050720,509.768738 
	C622.083130,509.292145 621.191101,508.886841 620.371155,509.000671 
	C615.016113,509.743927 610.004700,509.305969 605.062012,506.622833 
	C596.504395,501.977295 590.312744,494.982971 584.659363,487.363770 
	C581.510620,483.120239 578.427551,478.964111 578.679138,473.081268 
	C578.803467,470.174622 577.325317,467.199463 576.293274,463.164795 
	C574.615723,465.180084 573.818542,466.388428 572.776306,467.323639 
	C571.592896,468.385468 570.190247,469.202850 568.646973,469.832062 
	C565.648254,460.343994 563.338074,450.981659 559.992065,442.005432 
	C556.806396,433.459412 550.073364,428.986877 540.729614,428.971741 
	C528.932129,428.952637 517.095459,429.556274 505.347473,428.790192 
	C491.856964,427.910461 484.383423,435.428070 480.668182,446.640900 
	C478.176483,454.161133 475.633636,461.664398 472.762695,469.099365 
	C468.933014,465.106689 465.454254,461.189819 462.518494,457.884399 
	C460.253693,463.320709 458.448761,468.587128 455.941132,473.494446 
	C448.837524,487.395966 439.854889,499.765839 425.898346,507.668762 
	C420.305817,510.835571 414.606354,512.279907 408.660370,508.244263 
	C407.815826,507.671051 406.331268,508.040894 405.038635,507.525299 
	C404.993195,502.335175 405.052094,497.593994 405.334534,492.582520 
	C408.347168,484.899109 411.136292,477.486023 414.113647,469.940063 
	C414.581482,469.605377 414.687531,469.335480 414.935150,468.830688 
	C415.524353,467.784851 415.798462,466.905731 416.319885,465.912598 
	C416.753784,465.311035 416.940338,464.823547 417.385376,464.131958 
	C418.145538,462.983521 418.647217,462.039185 419.106781,461.055603 
	C419.064697,461.016357 419.100922,461.125610 419.407776,460.976837 
	C421.834595,457.561432 423.954529,454.294800 426.355347,450.893250 
	C427.438599,449.555267 428.240997,448.352234 429.279602,447.036530 
	C429.647858,446.610626 429.779907,446.297424 429.949402,445.979980 
	C429.986877,445.975708 429.970306,445.902161 430.263977,445.793518 
	C431.421478,444.533447 432.285339,443.382019 433.455811,442.102173 
	C436.170959,439.305847 438.579468,436.637939 440.988007,433.970062 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M779.147034,382.590210 
	C778.493530,381.891815 777.840027,381.193420 777.420166,379.843292 
	C777.495300,369.137024 777.336670,359.082489 777.178101,349.027985 
	C777.135498,348.375916 777.092896,347.723877 777.079407,346.399017 
	C777.137451,345.494904 777.166382,345.263550 777.367798,344.888184 
	C777.712524,344.474548 777.755371,344.185638 777.728394,343.632233 
	C777.562927,342.972229 777.337952,342.557526 777.071838,341.708099 
	C777.149536,338.640686 775.893738,335.251404 780.409363,335.007812 
	C786.312866,334.689331 792.218018,334.399963 798.416260,334.375183 
	C800.694946,334.755249 802.679565,334.945496 804.664490,334.948029 
	C830.606323,334.981018 856.548218,334.998871 882.490051,334.984192 
	C885.302429,334.982605 888.114746,334.754333 891.142090,334.604858 
	C891.357117,334.578522 891.784363,334.506348 892.256714,334.607574 
	C923.850281,334.792511 954.971497,334.876251 986.092651,334.959961 
	C986.092651,334.959961 986.029236,334.994385 986.039917,335.432068 
	C986.106812,351.009247 986.162964,366.148743 986.219116,381.288239 
	C985.978943,381.749329 985.738708,382.210388 984.893433,382.487640 
	C983.466003,382.215363 982.643738,382.049622 981.821411,382.049500 
	C915.561523,382.040253 849.301697,382.040833 783.041809,382.069275 
	C781.743469,382.069855 780.445312,382.408997 779.147034,382.590210 
M913.169617,354.573425 
	C915.619690,359.345551 917.993896,364.159546 920.583496,368.854706 
	C921.103210,369.797119 922.441711,370.287994 923.402649,370.987061 
	C923.817627,370.169586 924.599243,369.347809 924.589661,368.535339 
	C924.513855,362.069489 924.328369,355.603638 924.053223,349.143066 
	C924.021301,348.393494 923.236755,347.675964 922.801147,346.943542 
	C922.325195,346.980652 921.849182,347.017792 921.373169,347.054901 
	C921.373169,352.042725 921.373169,357.030579 921.373169,362.018433 
	C920.972229,362.019653 920.571228,362.020905 920.170288,362.022156 
	C918.179871,358.251343 916.189392,354.480530 914.085449,349.955078 
	C912.329224,348.944733 910.572998,347.934418 908.816772,346.924072 
	C907.971191,348.423187 906.523376,349.871185 906.390930,351.430878 
	C905.959534,356.511749 905.944153,361.632721 905.890442,366.739532 
	C905.833618,372.146088 906.321533,372.442871 912.460022,370.866974 
	C912.767395,370.666412 912.879456,370.387390 912.940369,369.102722 
	C912.843079,364.367126 912.745789,359.631500 913.169617,354.573425 
M896.756897,353.376831 
	C896.756897,351.436432 896.756897,349.496063 896.756897,347.676849 
	C892.427063,346.300781 890.483948,347.250671 890.757568,351.579529 
	C890.939148,354.451294 890.365601,357.036316 885.959961,356.120667 
	C885.959961,354.172302 886.327148,352.105408 885.827820,350.274872 
	C885.507874,349.102081 883.950806,347.557709 882.873169,347.496185 
	C881.752869,347.432251 879.561279,348.912994 879.526062,349.786194 
	C879.247192,356.714508 879.370789,363.658997 879.370789,371.066132 
	C881.748779,370.942871 883.619995,370.845856 885.392944,370.753967 
	C885.619202,369.703247 885.693054,369.216705 885.829956,368.748566 
	C886.497253,366.466003 887.377747,362.177612 887.829102,362.221710 
	C892.090637,362.637878 889.124512,366.407379 890.277893,368.409393 
	C890.883301,369.460297 892.249512,370.973969 892.999878,370.832672 
	C894.174744,370.611481 895.911682,369.251190 896.024109,368.221893 
	C896.528381,363.606781 896.542664,358.938080 896.756897,353.376831 
M799.324036,353.125336 
	C802.880676,351.879913 801.914185,350.477600 799.524780,348.897156 
	C794.803894,345.774506 789.562805,346.537628 786.823181,350.810638 
	C784.620178,354.246704 785.762024,357.017975 790.730713,360.479279 
	C791.813843,361.233856 793.074707,361.972321 793.727722,363.039948 
	C794.416382,364.165985 794.475586,365.677063 794.809814,367.019897 
	C793.430054,367.272430 792.012451,367.846527 790.680725,367.690033 
	C789.252258,367.522186 787.904480,366.667419 786.521484,366.112427 
	C787.078552,371.280457 790.378296,372.126770 794.121765,371.846680 
	C797.835999,371.568817 801.605164,370.982971 802.104858,366.105042 
	C802.627197,361.005951 799.900635,358.198883 795.545715,356.131592 
	C794.095825,355.443329 793.306458,353.363831 792.215088,351.920380 
	C794.072754,352.049591 795.932434,352.156982 797.785889,352.330963 
	C798.072998,352.357880 798.331482,352.689850 799.324036,353.125336 
M818.472107,367.103363 
	C815.029480,366.644226 811.586853,366.185059 808.144287,365.725922 
	C808.100281,365.223267 808.056274,364.720612 808.012268,364.217957 
	C809.916504,363.872925 811.868225,363.683472 813.706421,363.122223 
	C814.741455,362.806152 815.589294,361.876923 816.521423,361.223938 
	C815.547363,360.571716 814.642151,359.547882 813.583618,359.351929 
	C811.879333,359.036438 810.073914,359.267242 807.824463,359.267242 
	C807.960205,356.964691 807.727051,354.092468 808.201294,353.970459 
	C811.611755,353.093170 815.165771,352.773834 818.647278,352.281342 
	C819.184326,346.766235 816.202209,345.771088 805.921753,348.131378 
	C805.921753,355.574524 805.921753,363.097351 805.921753,371.046173 
	C809.804321,371.046173 813.128723,371.279633 816.381409,370.899628 
	C817.320679,370.789917 818.053772,368.916534 818.472107,367.103363 
M872.115295,348.182953 
	C868.991821,346.433563 866.307922,347.329651 864.011353,349.701874 
	C859.367798,354.498322 859.632263,364.728058 864.449280,369.393677 
	C868.230591,373.056183 873.176941,372.129211 875.983826,366.536713 
	C874.178772,366.174652 872.576538,365.879578 870.986938,365.526978 
	C869.424683,365.180481 866.631226,364.977264 866.531555,364.362183 
	C866.050354,361.392639 866.057495,358.272644 866.468201,355.285278 
	C866.559082,354.624023 869.001038,354.318817 870.335083,353.786102 
	C871.594482,353.283234 873.300720,352.996857 873.896362,352.043945 
	C874.309631,351.382751 873.174011,349.753387 872.115295,348.182953 
M939.876038,370.521912 
	C941.247314,368.030548 942.618652,365.539215 943.989990,363.047882 
	C943.542969,362.651886 943.095947,362.255920 942.648926,361.859924 
	C939.810791,362.054565 936.972717,362.249207 934.134583,362.443878 
	C934.112000,363.010651 934.089417,363.577423 934.066833,364.144226 
	C935.836792,364.534943 937.606750,364.925690 939.440674,365.330536 
	C936.788635,368.585144 934.432373,368.728790 932.487671,365.862457 
	C930.415344,362.807983 930.252014,355.694916 932.653503,353.034546 
	C933.561890,352.028259 935.594177,351.901428 937.158264,351.663086 
	C938.505249,351.457825 939.914856,351.663635 941.296814,351.687683 
	C940.317444,350.361969 939.515442,348.148590 938.318909,347.909424 
	C936.302612,347.506439 932.945984,347.596710 932.088684,348.827637 
	C929.924377,351.935272 927.680847,355.750458 927.546997,359.359192 
	C927.212708,368.369812 932.269531,372.838684 939.876038,370.521912 
M839.696655,370.343872 
	C836.358948,362.695770 833.021179,355.047668 829.683472,347.399567 
	C829.247314,347.435944 828.811157,347.472351 828.375000,347.508728 
	C826.233337,355.166870 824.091675,362.825043 821.950012,370.483215 
	C822.524536,370.681274 823.099060,370.879333 823.673645,371.077423 
	C824.180176,370.192963 824.945984,369.362640 825.144348,368.413788 
	C825.717224,365.673187 826.784790,364.056946 830.045715,364.015930 
	C833.206787,363.976166 834.945007,364.933167 835.977295,367.977570 
	C836.377441,369.157745 838.059326,369.903351 839.696655,370.343872 
M847.948853,360.521973 
	C851.176514,364.075317 852.986206,368.981415 857.122559,371.667786 
	C857.593018,371.282898 858.063538,370.898041 858.533997,370.513184 
	C855.135498,365.826111 851.737061,361.139008 849.258728,357.720978 
	C851.501221,354.577667 854.966492,351.264313 854.391785,350.257782 
	C851.952332,345.985443 847.433289,347.203949 843.541321,347.604004 
	C843.541321,355.534485 843.541321,363.056824 843.541321,370.579132 
	C843.980103,370.584503 844.418884,370.589844 844.857666,370.595184 
	C844.857666,366.602661 844.857666,362.610168 844.857666,357.662231 
	C846.314880,358.947174 846.895142,359.458862 847.948853,360.521973 
M900.021912,363.401215 
	C900.021912,366.009247 900.021912,368.617249 900.021912,371.225281 
	C900.677063,371.197418 901.332153,371.169556 901.987305,371.141663 
	C901.987305,363.279999 901.987305,355.418304 901.987305,347.556641 
	C901.336548,347.530792 900.685791,347.504974 900.035034,347.479126 
	C900.035034,352.462952 900.035034,357.446808 900.021912,363.401215 
z"/>
<path fill="#EDF8FD" opacity="1.000000" stroke="none" 
	d="
M158.017090,707.962402 
	C156.864014,707.731323 155.710953,707.500244 154.203812,706.759399 
	C151.967224,705.496765 150.086472,704.115356 148.201904,704.110168 
	C142.767517,704.095154 137.331604,704.635071 131.922394,704.512817 
	C132.605637,681.998169 133.460876,659.931458 133.870560,637.856445 
	C134.400940,609.277710 134.560913,580.692200 134.949890,552.110474 
	C134.968643,550.733582 135.656830,549.365784 136.498260,548.007690 
	C144.700272,547.966248 152.437317,547.910889 160.555435,547.892212 
	C161.847931,550.140015 163.219223,552.285095 163.548340,554.579773 
	C163.916656,557.147583 163.201569,559.850586 163.196854,562.495239 
	C163.144913,591.589966 163.164932,620.684814 163.112381,649.779541 
	C163.079132,668.188049 162.956497,686.596436 162.558380,705.155579 
	C160.834244,706.191650 159.425659,707.077026 158.017090,707.962402 
z"/>
<path fill="#EEECD3" opacity="1.000000" stroke="none" 
	d="
M603.891479,450.630249 
	C601.033569,447.292419 598.175598,443.954590 595.216797,439.828247 
	C595.160828,429.711945 595.241577,420.384155 595.244385,411.056366 
	C595.256226,371.241028 595.252014,331.425720 595.226990,291.610382 
	C595.225281,288.920074 596.074280,285.950409 591.327087,285.965088 
	C549.513123,286.094604 507.698486,286.064209 465.884186,285.999603 
	C462.953979,285.995087 461.728180,286.793152 461.737457,289.933319 
	C461.863037,332.412109 461.891541,374.891144 461.944092,417.370148 
	C459.101257,419.354828 456.258453,421.339508 453.220764,422.667999 
	C453.010895,374.620575 452.995880,327.229370 452.980865,279.838135 
	C454.373322,277.912811 455.765778,275.987457 457.984314,274.031006 
	C505.623322,273.988800 552.436218,273.977722 599.249146,273.966644 
	C602.583618,275.292847 605.005066,277.331329 604.670410,281.971375 
	C604.253967,283.631897 604.022278,284.612457 604.022095,285.593079 
	C604.017212,317.406830 604.034668,349.220581 604.038452,381.499512 
	C603.982605,404.853210 603.937012,427.741730 603.891479,450.630249 
z"/>
<path fill="#EEDEBE" opacity="1.000000" stroke="none" 
	d="
M916.727600,622.944824 
	C922.256287,622.356812 927.805359,621.914734 933.308350,621.143250 
	C939.968323,620.209656 943.035706,622.614258 942.945435,629.282715 
	C942.680298,648.868835 942.346497,668.453979 941.647339,688.557129 
	C934.230591,692.374634 926.839539,693.152710 919.428772,691.189392 
	C909.710388,688.614502 902.628601,682.140381 897.083984,674.057495 
	C888.369385,661.353577 883.853027,647.039368 882.041382,631.864624 
	C881.104858,624.020508 881.339966,624.182983 889.445251,623.909729 
	C893.283691,623.780273 897.092285,622.766663 900.914429,622.153687 
	C902.361572,622.118958 903.808655,622.084167 905.968750,622.374878 
	C910.030273,622.781860 913.378967,622.863403 916.727600,622.944824 
z"/>
<path fill="#584345" opacity="1.000000" stroke="none" 
	d="
M463.543823,185.053253 
	C463.505127,185.220383 463.466431,185.387527 463.366882,186.182953 
	C463.357697,189.217606 463.409424,191.623978 463.388794,194.350769 
	C463.367584,195.103241 463.418701,195.535294 463.364807,196.426483 
	C463.259827,207.818588 463.259827,218.751541 463.259827,229.948303 
	C442.067535,229.948303 421.512329,229.948303 400.694458,229.948303 
	C400.694458,209.562408 400.694458,189.393082 400.694458,168.764664 
	C415.046539,168.764664 429.012451,168.764664 443.439819,168.832565 
	C447.961487,168.853821 452.021698,168.807190 456.527954,168.830902 
	C458.894226,168.901260 460.814484,168.901260 463.543823,168.901260 
	C463.543823,174.635483 463.543823,179.844376 463.543823,185.053253 
M415.384064,211.778915 
	C414.048248,212.006699 412.712402,212.234497 411.376587,212.462280 
	C411.368378,212.817902 411.360168,213.173508 411.351959,213.529129 
	C413.059052,213.939667 414.766144,214.350204 417.076813,214.905884 
	C416.717499,213.306717 416.514801,212.404633 417.143005,211.204178 
	C417.437286,211.200333 417.731537,211.196487 418.042725,211.985275 
	C418.892975,215.125656 420.700500,213.025558 422.415253,213.095413 
	C431.505554,213.465683 440.571625,214.407135 449.653961,215.037888 
	C450.406036,215.090118 451.216339,214.303192 451.999573,213.906174 
	C451.980927,213.494720 451.962250,213.083282 451.943573,212.671829 
	C450.007202,212.441132 448.076111,212.104630 446.133057,212.007111 
	C443.818420,211.890915 441.493500,211.979736 439.232910,211.979736 
	C437.736115,207.669083 428.809723,204.611206 421.479523,206.252594 
	C423.350433,207.351776 424.650818,208.115738 425.044525,208.948837 
	C422.481079,208.956116 419.905945,208.842926 417.365570,209.088608 
	C416.939484,209.129822 416.663727,210.725372 415.384064,211.778915 
M432.991791,221.099930 
	C437.192657,221.067322 441.398987,221.136597 445.589569,220.912277 
	C446.385132,220.869720 447.118439,219.663834 447.880463,218.994690 
	C446.966827,218.320038 446.084473,217.119781 445.134064,217.063248 
	C441.356171,216.838501 437.557068,216.970734 433.552063,216.970734 
	C433.125519,217.799957 432.556488,218.906235 431.970734,219.249115 
	C430.658478,218.354965 429.336639,216.693542 428.035706,216.709747 
	C424.051422,216.759323 420.098358,217.853470 416.053711,217.237000 
	C415.890747,217.212143 415.651611,217.686905 414.385284,219.191467 
	C417.660034,220.109619 420.264923,220.999283 422.943268,221.476517 
	C423.595825,221.592804 424.489746,220.354355 424.419189,220.409836 
	C427.386902,220.705475 429.760315,220.941925 432.991791,221.099930 
M436.041229,196.883514 
	C436.985687,196.379440 437.930176,195.875366 438.874664,195.371277 
	C438.710541,195.139618 438.546417,194.907959 438.382324,194.676300 
	C430.627655,194.676300 422.872986,194.676300 415.118317,194.676300 
	C415.092865,195.329895 415.067413,195.983490 415.041962,196.637070 
	C421.711212,197.075684 428.430603,196.884003 436.041229,196.883514 
M419.797333,176.780685 
	C415.418427,176.780685 411.039551,176.780685 406.660645,176.780685 
	C406.669464,177.451050 406.678284,178.121414 406.687103,178.791779 
	C411.160950,178.791779 415.635315,178.814774 420.106781,178.711609 
	C420.294769,178.707275 420.455597,177.528656 419.797333,176.780685 
M445.688843,201.759949 
	C444.236786,201.906281 442.784729,202.052612 441.332672,202.198944 
	C441.390961,202.547653 441.449249,202.896378 441.507568,203.245087 
	C445.568573,203.245087 449.629608,203.245087 453.690613,203.245087 
	C453.699921,202.749741 453.709229,202.254410 453.718536,201.759064 
	C451.346802,201.759064 448.975067,201.759064 445.688843,201.759949 
M417.634399,208.103378 
	C418.617157,207.881393 419.599915,207.659424 420.582642,207.437439 
	C420.560364,207.021515 420.538055,206.605606 420.515747,206.189682 
	C419.043579,206.189682 417.571381,206.189682 416.099213,206.189682 
	C416.360168,206.814713 416.621094,207.439728 417.634399,208.103378 
z"/>
<path fill="#F3EDD2" opacity="1.000000" stroke="none" 
	d="
M624.000854,491.932983 
	C623.264343,490.901733 622.260376,489.969482 621.835754,488.822754 
	C619.502686,482.521667 617.311340,476.168152 615.378052,469.389099 
	C616.107178,468.344238 616.529663,467.742889 616.952148,467.141571 
	C617.727722,467.115753 618.503235,467.089935 619.687012,467.296356 
	C620.095154,467.528595 620.059998,467.943451 619.913452,468.001038 
	C619.862732,468.018188 619.958679,467.977722 620.345459,467.946472 
	C621.019958,467.901031 621.403564,467.846375 621.846130,467.914551 
	C621.905151,468.037354 621.963745,468.301971 622.067993,468.398315 
	C622.172302,468.494629 622.556885,468.580872 622.556885,468.580872 
	C622.556885,468.580872 622.878784,468.341705 623.261597,468.277771 
	C624.158142,468.259674 624.671753,468.305511 625.463074,468.547424 
	C627.761902,468.618744 629.783081,468.494049 632.216919,468.283752 
	C633.749817,468.107391 634.869934,468.016541 636.456177,467.985992 
	C655.277771,468.027588 673.633240,468.008881 692.456055,468.038696 
	C702.014221,468.184601 711.104919,468.282013 720.510498,468.578125 
	C724.151245,468.647949 727.477173,468.519043 731.189331,468.323914 
	C732.093262,468.308777 732.610962,468.359833 733.206116,468.497070 
	C733.283569,468.583221 733.609741,468.620880 733.609741,468.620880 
	C733.609741,468.620880 733.871582,468.408966 734.234741,468.317078 
	C735.338257,468.136536 736.078613,468.047852 737.278442,468.044037 
	C740.830139,468.115753 743.922363,468.102570 747.001709,468.550537 
	C746.992554,472.630249 746.860840,476.255280 747.033936,479.865723 
	C747.255066,484.480133 745.728699,488.191254 742.028992,490.982910 
	C732.401855,491.322632 722.774719,491.662354 712.435913,491.750488 
	C703.691711,491.648285 695.658997,491.911713 687.626831,491.894958 
	C684.054260,491.887512 680.482849,491.315186 676.451172,491.006104 
	C658.661255,491.319580 641.331055,491.626282 624.000854,491.932983 
M674.487122,478.954681 
	C669.872498,478.954681 665.257874,478.954681 660.643250,478.954681 
	C660.658875,479.413849 660.674561,479.873047 660.690186,480.332214 
	C669.209473,480.332214 677.728821,480.332214 686.248108,480.332214 
	C686.259888,479.873108 686.271606,479.414001 686.283386,478.954895 
	C682.680054,478.954895 679.076782,478.954895 674.487122,478.954681 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M117.141312,496.478333 
	C126.269989,499.447357 135.384949,502.459503 144.532806,505.368286 
	C149.542358,506.961212 154.530380,508.845184 159.677185,509.696930 
	C162.630692,510.185699 165.882507,508.871796 168.924271,508.381622 
	C170.864594,509.271637 173.112961,510.382355 175.422729,511.345917 
	C180.243317,513.356873 184.146393,515.908264 186.579330,521.117615 
	C189.361786,527.075317 190.789215,532.803711 188.650146,539.592957 
	C186.779556,539.721680 185.364288,539.190735 183.958847,539.215576 
	C178.621841,539.310059 173.288040,539.584229 167.915680,539.464111 
	C162.219696,533.403625 158.457870,526.945374 158.792694,518.453064 
	C158.849030,517.024475 156.690430,514.769287 155.071518,514.139526 
	C147.344162,511.133789 139.434204,508.601227 131.619385,505.815643 
	C122.741234,502.651031 113.598343,501.332428 104.230629,502.107117 
	C101.556305,502.328278 98.962334,503.520966 96.300995,504.276825 
	C101.031197,506.215790 105.413437,507.229095 108.862915,509.599701 
	C114.838692,513.706421 118.161278,520.129395 119.679291,527.031799 
	C120.695190,531.651062 122.351112,533.514954 127.201500,533.111328 
	C131.768784,532.731201 135.290253,534.705139 135.571350,539.888428 
	C117.884537,539.945374 100.665649,539.945374 82.345276,539.945374 
	C83.522003,543.269287 84.372536,545.671814 85.119019,548.421509 
	C87.834274,555.872253 93.685112,558.312866 100.693291,558.775513 
	C104.335144,559.015930 108.036415,558.619568 111.642090,559.066040 
	C114.837631,559.461792 118.644562,559.850464 118.903450,564.352722 
	C119.176392,569.099365 115.486198,570.037781 111.996651,570.624207 
	C99.508347,572.722778 86.772461,565.146973 82.171951,553.227905 
	C81.445892,551.346802 80.019073,549.736206 79.083916,547.664307 
	C80.418037,544.295288 80.355377,541.641846 76.957390,539.725098 
	C76.909004,539.254150 76.895287,539.065186 76.881577,538.876221 
	C77.572922,535.854126 78.809235,532.841370 78.860863,529.808411 
	C79.079262,516.978394 84.266762,506.910217 95.303749,499.245178 
	C102.976173,498.144409 110.058746,497.311371 117.141312,496.478333 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M747.014526,468.089386 
	C743.922363,468.102570 740.830139,468.115753 737.286499,467.580505 
	C736.835083,433.476074 736.835083,399.920105 736.835083,366.279083 
	C731.267761,366.279083 726.620178,366.279083 721.510986,366.199707 
	C705.681030,366.195618 690.312744,366.270966 674.971069,366.239807 
	C674.997803,366.133301 674.936340,365.922485 674.615906,365.671570 
	C659.646606,365.308899 644.997925,365.179779 630.348877,365.096375 
	C626.143921,365.072418 621.730469,364.301483 618.368469,367.917084 
	C613.897705,360.682343 615.272278,357.457367 623.676270,357.341125 
	C653.895935,356.923126 684.119934,356.765106 714.342773,356.666412 
	C724.805969,356.632233 735.270569,357.057556 745.910278,357.352814 
	C745.633972,357.988220 744.714600,358.638855 744.805115,359.084167 
	C745.436523,362.189056 746.828369,365.230286 746.947205,368.331360 
	C747.300659,377.559570 747.180359,386.805878 747.178772,396.506409 
	C747.079773,420.674927 747.047119,444.382172 747.014526,468.089386 
z"/>
<path fill="#F0D5C1" opacity="1.000000" stroke="none" 
	d="
M354.348755,705.591003 
	C358.485535,705.265991 362.955627,705.067566 367.425873,705.062927 
	C397.636566,705.031433 427.847260,705.040955 458.810364,705.291504 
	C462.720673,705.327576 465.878571,705.109314 469.498535,704.956177 
	C474.107758,705.018250 478.254883,705.016235 482.401978,705.011963 
	C518.589233,704.974854 554.776428,704.937378 591.238525,705.201416 
	C594.681396,705.304810 597.849548,705.106812 601.266663,704.949341 
	C601.675659,704.937805 601.835571,704.885803 602.458740,704.911621 
	C643.145935,705.007141 683.369812,705.041443 723.593750,705.032654 
	C736.055420,705.029907 748.517029,704.909973 761.416443,704.931519 
	C763.925964,705.167847 765.997742,705.316406 768.069519,705.465027 
	C766.887268,705.969177 765.729309,706.836243 764.518738,706.917114 
	C757.894653,707.360046 751.260681,707.759766 744.624390,707.898560 
	C723.663147,708.336731 702.697998,708.584900 681.736938,709.031799 
	C654.641541,709.609375 627.550049,710.384277 600.453247,710.872559 
	C596.349915,710.946594 594.504395,712.190491 595.017761,716.361145 
	C595.118469,717.178894 595.294922,718.219971 594.909241,718.817993 
	C594.019836,720.196960 592.806519,721.366943 591.724609,722.621704 
	C590.823181,721.353333 589.503662,720.200745 589.112976,718.790833 
	C588.434875,716.343689 589.180237,712.399780 587.785522,711.514282 
	C585.739624,710.215454 582.335266,711.010986 579.509277,710.997314 
	C575.344177,710.977051 571.178833,711.030029 566.148438,711.044739 
	C563.504517,711.391968 561.725586,711.746277 559.946716,712.100586 
	C554.672180,711.726685 549.400208,711.097778 544.122498,711.045715 
	C538.005066,710.985352 531.882568,711.431824 525.029297,711.689697 
	C521.184509,711.838867 518.072632,711.956726 514.960815,712.074463 
	C511.916412,711.717468 508.870667,711.053162 505.827881,711.066345 
	C499.140961,711.095337 492.455566,711.466858 485.037689,711.712646 
	C480.854431,711.837585 477.402985,711.948364 473.951569,712.059204 
	C472.463409,712.187744 470.975250,712.316223 468.846436,712.719910 
	C467.167145,712.980652 466.128510,712.966187 465.089844,712.951721 
	C463.180206,712.289490 461.276245,711.071960 459.360016,711.052368 
	C443.230865,710.886780 427.071777,711.525452 410.976532,710.763855 
	C394.822235,709.999512 378.731506,707.898071 362.611298,706.400635 
	C359.972626,706.155457 357.325378,706.002747 354.348755,705.591003 
z"/>
<path fill="#F3EDD2" opacity="1.000000" stroke="none" 
	d="
M413.925385,470.072937 
	C411.136292,477.486023 408.347168,484.899109 404.934204,492.582642 
	C397.829346,492.575775 391.348358,492.298431 384.407043,492.023132 
	C376.315460,492.017487 368.684235,492.009796 361.052979,492.002136 
	C354.796234,492.328888 348.542694,492.815125 342.281891,492.941895 
	C334.492340,493.099640 326.696747,492.960480 318.438324,492.529022 
	C317.315582,488.487579 316.391754,484.889801 316.074982,481.239349 
	C315.749725,477.491058 316.017609,473.691345 316.273987,469.908905 
	C316.522095,469.903687 316.993469,469.748535 317.404022,469.821960 
	C319.201141,469.853943 320.587677,469.812500 322.259796,469.839203 
	C322.738647,469.876556 322.931946,469.845734 323.443420,469.862671 
	C324.189240,469.881012 324.616913,469.851593 325.504700,469.899109 
	C355.285034,470.008331 384.605225,470.040649 413.925385,470.072937 
M373.032654,478.961517 
	C372.207947,479.176514 371.383270,479.391510 370.558563,479.606476 
	C370.605103,479.889252 370.651642,480.171997 370.698151,480.454773 
	C379.226654,480.454773 387.755127,480.454773 396.283630,480.454773 
	C396.294159,479.955139 396.304718,479.455475 396.315247,478.955841 
	C388.851746,478.955841 381.388245,478.955841 373.032654,478.961517 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M900.484863,622.107666 
	C897.092285,622.766663 893.283691,623.780273 889.445251,623.909729 
	C881.339966,624.182983 881.104858,624.020508 882.041382,631.864624 
	C883.853027,647.039368 888.369385,661.353577 897.083984,674.057495 
	C902.628601,682.140381 909.710388,688.614502 919.428772,691.189392 
	C926.839539,693.152710 934.230591,692.374634 941.631714,689.023926 
	C942.281860,692.763672 942.471375,696.562561 942.849426,700.342590 
	C943.360718,705.455017 940.891479,707.376038 934.625366,707.007141 
	C922.242615,706.278198 909.855713,705.436462 897.460022,705.203857 
	C892.774475,705.115906 888.001648,706.336121 883.378113,707.424988 
	C880.091797,708.198975 877.456360,708.484070 876.384888,703.996277 
	C876.758789,702.674438 876.968811,702.027710 876.969360,701.380859 
	C876.990601,676.849854 877.005432,652.318909 876.959351,627.787964 
	C876.957031,626.548096 876.406006,625.309326 876.110474,624.070007 
	C876.953613,623.426636 877.783508,622.245728 878.642029,622.224609 
	C885.776794,622.049072 892.916870,622.087646 900.484863,622.107666 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M916.471191,622.698730 
	C913.378967,622.863403 910.030273,622.781860 906.401245,622.417725 
	C906.288818,619.763184 906.711670,617.377197 906.581726,615.021790 
	C905.913330,602.906494 905.102966,590.799011 904.564941,577.918335 
	C904.813904,572.715820 904.926880,568.282349 904.848816,563.852173 
	C904.679810,554.257446 904.412964,544.664490 904.186218,535.070801 
	C904.557068,529.392944 904.927917,523.715149 905.678589,517.612915 
	C906.628723,517.174988 907.199219,517.161438 907.769653,517.147888 
	C908.637024,516.344055 910.230286,515.568787 910.263123,514.732239 
	C910.768250,501.860504 918.810852,495.605255 930.639771,491.907043 
	C932.253540,491.576477 933.127197,491.257355 934.000854,490.938202 
	C934.000854,490.938202 934.208191,490.772400 934.796631,490.870117 
	C941.712402,490.940796 948.039673,490.913788 954.367004,490.886780 
	C955.231689,498.459564 950.454651,503.725708 946.274048,508.832977 
	C938.203857,518.691772 927.983887,522.779236 915.217896,518.393860 
	C910.645325,516.823120 908.525391,518.190613 908.084534,523.059265 
	C907.440186,530.175903 906.958374,537.351196 907.108582,544.486755 
	C907.440918,560.273315 908.195435,576.051392 908.825378,591.830933 
	C908.885803,593.343567 909.281738,594.842773 909.521973,596.348206 
	C910.057129,596.361633 910.592285,596.375061 911.127441,596.388428 
	C911.656555,594.106445 912.306396,591.844727 912.694092,589.539001 
	C914.438782,579.162720 922.638489,571.109680 933.051208,570.127808 
	C936.533447,569.799438 940.105591,570.423462 943.636597,570.612122 
	C942.552002,574.141418 942.108704,578.066162 940.233032,581.107544 
	C937.392578,585.713196 933.892334,590.043213 930.048767,593.862732 
	C926.035034,597.851257 920.607971,598.628479 915.119141,597.687622 
	C911.738281,597.108154 910.126099,598.847107 910.193726,601.638245 
	C910.342102,607.761108 910.808472,613.901245 911.679199,619.957581 
	C911.827026,620.985413 914.635559,621.630615 916.471191,622.698730 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M300.019470,650.973450 
	C300.016113,668.657715 300.012726,686.341980 300.008728,704.491943 
	C289.719940,705.881775 289.085236,705.368042 289.078094,695.204529 
	C289.040985,642.566162 289.034393,589.927734 289.029633,537.289368 
	C289.029480,535.793884 289.169006,534.298462 289.463745,532.066223 
	C293.143158,531.244934 296.602203,531.160339 300.042938,531.536743 
	C300.022888,571.656372 300.021179,611.314880 300.019470,650.973450 
z"/>
<path fill="#97666E" opacity="1.000000" stroke="none" 
	d="
M716.933960,522.086731 
	C721.731934,522.115417 726.529846,522.167969 731.327820,522.168579 
	C752.251282,522.171265 773.174866,522.191833 794.098083,522.117493 
	C797.327332,522.106018 799.689941,522.591492 799.692810,526.567627 
	C799.695679,530.490540 797.314453,531.102539 794.129700,531.182190 
	C786.724060,531.367554 779.322205,531.706421 771.304016,531.803467 
	C767.434631,531.445312 764.180115,531.266785 760.465454,531.055298 
	C752.672363,531.008850 745.339478,530.988037 738.006531,530.982910 
	C686.009033,530.946838 634.011597,530.914001 581.976196,530.438538 
	C581.975403,522.920654 581.976868,523.014771 588.869568,522.905579 
	C597.632568,522.766785 606.526978,524.027039 615.180298,521.113037 
	C616.456787,521.692871 617.575806,521.986816 618.698059,521.999573 
	C631.127136,522.141174 643.556641,522.268738 655.986328,522.327698 
	C659.006592,522.342041 662.028015,522.091492 665.460449,522.009766 
	C675.892090,522.223755 685.912231,522.390747 696.393433,522.661255 
	C703.547729,522.538818 710.240845,522.312744 716.933960,522.086731 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M760.925537,531.088257 
	C764.180115,531.266785 767.434631,531.445312 770.980713,531.949341 
	C771.267822,587.528015 771.293762,642.781250 771.156433,698.034119 
	C771.150513,700.420532 769.641296,702.803162 768.450928,705.326294 
	C765.997742,705.316406 763.925964,705.167847 761.417480,704.514038 
	C760.657349,701.558899 760.029907,699.105347 760.059021,696.659485 
	C760.288086,677.427429 760.642761,658.196838 760.965576,638.500732 
	C760.956665,602.386536 760.941101,566.737366 760.925537,531.088257 
z"/>
<path fill="#97666E" opacity="1.000000" stroke="none" 
	d="
M300.061279,531.075745 
	C296.602203,531.160339 293.143158,531.244934 289.381592,531.593445 
	C281.598907,531.554932 274.118958,531.246521 266.638428,530.952881 
	C263.546967,530.831421 260.669373,530.929565 260.756592,526.293396 
	C260.841858,521.759338 263.652466,522.276367 266.518372,522.276917 
	C295.664093,522.282227 324.809875,522.287354 353.955475,522.230591 
	C355.375671,522.227844 356.794708,521.649170 358.665405,521.569336 
	C363.766266,522.058228 368.416046,522.316406 373.522034,522.665894 
	C382.701904,522.511475 391.425507,522.265808 400.514404,521.962646 
	C402.940094,521.972839 405.000519,522.040527 407.372314,522.374756 
	C412.858215,522.755920 418.032837,522.870605 423.661194,522.937378 
	C434.740173,522.903809 445.366241,522.996338 455.990051,522.882080 
	C458.960938,522.850159 460.355408,523.790100 460.081879,526.858887 
	C459.964478,528.176147 460.059570,529.512390 459.587158,530.873413 
	C449.587830,531.299744 440.061981,531.806274 430.529602,532.018066 
	C427.561157,532.084045 424.578339,531.073120 421.596283,531.036865 
	C410.994232,530.907837 400.389343,530.944580 389.786438,531.031433 
	C388.188751,531.044495 386.596008,531.658752 384.533447,532.012695 
	C365.099762,531.782410 346.133606,531.534363 326.699127,531.167725 
	C321.075073,531.056213 315.915741,530.961609 310.766388,531.146057 
	C309.565430,531.189148 308.398407,532.180176 306.838013,532.826172 
	C304.327271,532.303406 302.194275,531.689575 300.061279,531.075745 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M324.123260,252.250137 
	C322.594269,252.538437 321.023224,252.424332 319.149353,252.050476 
	C318.846527,245.762344 318.846527,239.733948 318.846527,233.042862 
	C316.718201,233.042862 314.946411,233.042007 313.174591,233.042984 
	C290.128174,233.055756 267.081726,233.077164 244.035309,233.076736 
	C237.045807,233.076599 236.902832,232.921448 236.911652,226.207153 
	C236.950058,196.929596 237.015335,167.652023 237.008881,138.374466 
	C237.008179,135.238907 237.131927,132.526566 242.083481,133.318146 
	C258.898010,133.779114 275.002625,133.904449 291.107452,133.988174 
	C309.378052,134.083145 327.648865,134.140869 345.925964,134.371857 
	C345.932343,134.528946 345.946930,134.842896 345.877258,135.272430 
	C345.868103,137.139984 345.928619,138.577988 345.960968,140.212769 
	C345.932800,140.409546 345.842163,140.796631 345.385620,140.840439 
	C319.237854,140.949356 293.546692,141.014481 267.410034,141.136902 
	C263.811798,141.275391 259.993591,140.244537 257.636444,141.655151 
	C251.597153,145.269318 246.037247,143.101288 240.267181,142.238235 
	C240.267181,171.252029 240.267181,200.637039 240.267181,230.045868 
	C253.674225,230.045868 266.665588,230.093231 279.656067,230.006500 
	C282.301605,229.988861 284.937195,229.324127 287.588623,229.202271 
	C297.639740,228.740372 307.700104,227.989288 317.747986,228.107941 
	C325.269989,228.196762 332.764252,229.726944 340.296600,230.113373 
	C347.442047,230.479950 354.621094,230.214157 361.785095,230.175644 
	C363.045563,230.168869 364.304688,229.911942 366.051971,229.715790 
	C366.051971,221.608261 366.051971,213.805588 366.375061,205.999146 
	C367.128845,205.996674 367.559540,205.997955 367.990234,205.999252 
	C368.201477,212.941040 368.541534,219.882324 368.568542,226.824829 
	C368.581665,230.194199 367.465424,233.067291 363.220062,233.046860 
	C351.775574,232.991821 340.296997,233.462769 328.901978,232.690781 
	C323.876526,232.350311 322.984558,234.422562 323.039307,238.047638 
	C323.108826,242.651871 323.709534,247.248062 324.123260,252.250137 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M924.774658,452.659760 
	C927.953308,441.813995 936.700134,434.784912 947.865417,435.371094 
	C955.904846,435.793243 963.887390,437.503113 971.861755,438.838776 
	C974.350891,439.255676 976.785828,440.829132 974.809204,443.659668 
	C967.847107,453.628784 959.878113,462.548859 947.059082,464.810455 
	C939.352173,466.170135 932.616943,463.637970 926.272583,458.173309 
	C925.496704,455.968506 925.135681,454.314117 924.774658,452.659760 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M321.974243,469.771027 
	C320.587677,469.812500 319.201141,469.853943 317.314331,469.654022 
	C316.649048,469.208130 316.440094,469.070007 316.107544,468.535889 
	C315.960236,437.393066 315.892670,406.712646 315.899109,375.566284 
	C316.345551,362.756836 316.718048,350.413330 317.090515,338.069855 
	C326.466431,336.786987 335.533478,337.578125 344.914825,339.558014 
	C352.966675,341.257294 361.675690,339.842621 370.685181,340.131165 
	C371.830261,340.376068 372.384338,340.294800 372.938385,340.213501 
	C384.059967,340.525024 395.181946,340.822052 406.302704,341.161499 
	C408.292145,341.222229 410.276245,341.458252 412.539581,342.043030 
	C412.548096,342.962067 412.279816,343.451385 411.632568,344.000946 
	C410.490906,344.017975 409.728241,343.974731 408.670807,343.661255 
	C404.928986,343.568817 401.481964,343.746582 397.603088,343.986267 
	C395.419037,344.126587 393.666809,344.205048 391.476807,344.192200 
	C388.341522,344.032318 385.644012,343.963776 382.638428,343.628235 
	C363.453461,343.268280 344.576630,343.167114 325.699646,343.122345 
	C325.140594,343.121033 324.580200,343.712860 323.842438,344.170746 
	C323.436462,344.517151 323.236786,344.745636 322.765991,345.289856 
	C322.634735,350.371826 322.802856,355.162781 323.019836,360.410065 
	C323.036407,363.926361 323.004059,366.986359 322.689819,370.345337 
	C322.281219,371.288055 322.044159,371.931641 322.043610,372.575409 
	C322.022644,397.801880 322.009796,423.028351 322.061340,448.254700 
	C322.063843,449.488312 322.654602,450.720734 323.019592,452.413574 
	C323.035706,456.262878 323.003601,459.652313 322.703033,463.306824 
	C322.281128,465.638275 322.127686,467.704651 321.974243,469.771027 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M747.001709,468.550537 
	C747.047119,444.382172 747.079773,420.674927 747.520874,396.547913 
	C751.264893,397.437286 754.600586,398.746429 757.957397,400.518402 
	C757.985962,426.748016 757.972961,452.514893 758.042236,478.281494 
	C758.047302,480.184021 758.644958,482.084930 758.967163,483.986603 
	C757.831177,490.728058 755.027466,492.808594 748.677490,491.717621 
	C746.765076,491.389099 744.820801,491.246094 742.460083,491.000488 
	C745.728699,488.191254 747.255066,484.480133 747.033936,479.865723 
	C746.860840,476.255280 746.992554,472.630249 747.001709,468.550537 
z"/>
<path fill="#F0D5B6" opacity="1.000000" stroke="none" 
	d="
M104.852074,379.409393 
	C107.368591,376.611115 109.885109,373.812866 113.082321,370.953735 
	C114.498489,370.249146 115.233963,369.605438 115.969444,368.961761 
	C115.969452,368.961761 115.999390,368.998779 116.356949,368.965271 
	C125.513489,364.186859 134.843124,364.381805 144.322021,365.966095 
	C155.488205,368.338074 167.808762,382.798767 167.855515,394.507355 
	C167.879425,400.493408 166.488525,406.485138 165.134399,412.801025 
	C163.941360,413.916779 163.297287,414.671539 162.768723,415.500000 
	C154.740036,428.084137 143.222733,433.872070 128.481644,431.929016 
	C114.768837,430.121460 105.646904,422.037476 100.823883,408.680603 
	C98.558464,398.137360 99.986427,388.533813 104.852074,379.409393 
M134.251846,427.762207 
	C135.216476,427.527130 136.168854,427.195709 137.147583,427.071320 
	C153.877457,424.944611 165.693771,409.776245 161.519516,391.939911 
	C157.726593,375.733093 143.650406,365.918915 125.902382,370.279236 
	C114.830856,372.999237 107.774582,380.572235 104.804482,391.473755 
	C102.064110,401.532104 104.932526,410.481079 111.734383,418.223297 
	C117.473244,424.755585 125.090256,427.140381 134.251846,427.762207 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M67.965698,705.004517 
	C67.677902,702.541748 67.148384,700.079895 67.139641,697.616150 
	C67.050568,672.504517 67.147247,647.392029 66.986717,622.281067 
	C66.855049,601.685120 66.413765,581.091187 66.196724,560.495544 
	C66.167191,557.694031 66.625771,554.885681 66.890587,552.083496 
	C67.140060,549.443542 66.316696,548.015869 63.316357,548.112549 
	C59.201778,548.245178 55.076847,548.056458 50.820190,547.680359 
	C58.759533,547.515442 66.835037,547.675598 74.592941,548.081543 
	C73.873329,550.037842 73.138107,551.745239 73.122543,553.459229 
	C73.007805,566.099365 73.047623,578.740784 73.017799,591.381836 
	C72.970314,611.507080 73.101364,631.635376 72.791199,651.756714 
	C72.517555,669.509277 71.743805,687.254028 70.788116,705.015076 
	C69.578804,705.020081 68.772255,705.012329 67.965698,705.004517 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M315.825134,376.032227 
	C315.892670,406.712646 315.960236,437.393066 316.037140,468.759583 
	C316.046509,469.445679 316.025909,469.914124 316.025909,469.914124 
	C316.017609,473.691345 315.749725,477.491058 316.074982,481.239349 
	C316.391754,484.889801 317.315582,488.487579 317.968750,492.493225 
	C316.906372,492.894348 315.848114,492.910706 314.271118,492.723938 
	C313.542816,492.281921 313.280151,492.144379 312.964355,492.108246 
	C309.713379,492.374481 307.778503,490.890839 307.371521,487.043304 
	C307.748047,484.561646 307.978210,482.748535 307.979889,480.935242 
	C308.013336,444.638214 308.020538,408.341156 308.304016,372.297180 
	C309.147491,377.550934 313.051636,375.614471 315.825134,376.032227 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M900.396118,481.963318 
	C892.106018,479.788208 886.891907,474.377808 883.014404,467.589752 
	C878.223389,459.202484 876.069702,450.181610 876.918823,440.428802 
	C877.161377,437.642181 878.212402,436.754852 880.609192,437.376404 
	C895.618347,441.268707 914.011230,457.299530 906.273010,477.424927 
	C905.814331,478.617889 905.877686,480.011627 905.607605,481.967346 
	C904.009033,481.967346 902.412170,481.967346 900.396118,481.963318 
z"/>
<path fill="#CBBB9F" opacity="1.000000" stroke="none" 
	d="
M228.258728,548.041016 
	C227.868759,549.765015 227.159637,551.485168 227.138779,553.213623 
	C226.954132,568.517456 226.959656,583.823669 226.773163,599.127441 
	C226.594955,613.750427 226.256454,628.371521 225.984772,642.993347 
	C225.607483,663.299133 225.226822,683.604858 224.434906,704.419922 
	C222.662399,704.954956 221.302582,704.980713 220.101730,704.617737 
	C220.497971,702.274597 220.940933,700.320312 220.942062,698.365784 
	C220.963425,661.761353 220.991913,625.156799 220.878571,588.552673 
	C220.841034,576.427734 220.481979,564.301636 220.065811,552.182983 
	C220.015152,550.707825 218.690140,549.276428 217.945770,547.680481 
	C217.935791,547.536255 217.909836,547.248230 218.360626,547.186096 
	C221.960541,547.429688 225.109634,547.735352 228.258728,548.041016 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M228.664246,548.034485 
	C225.109634,547.735352 221.960541,547.429688 217.903839,547.114868 
	C204.084000,547.085266 191.171677,547.036926 178.259705,547.084412 
	C176.857727,547.089539 175.457809,547.648926 173.678833,547.973206 
	C172.544510,547.985718 171.788284,547.976257 170.755035,547.677734 
	C167.986588,547.254639 165.495163,547.120483 162.999405,546.556152 
	C163.004089,544.118652 163.013123,542.111389 163.430389,540.043457 
	C165.210083,539.919006 166.581558,539.855103 167.953033,539.791260 
	C173.288040,539.584229 178.621841,539.310059 183.958847,539.215576 
	C185.364288,539.190735 186.779556,539.721680 188.592316,540.002319 
	C194.091629,539.688110 199.188965,539.368896 204.977448,539.326660 
	C207.476990,539.753235 209.285370,539.902771 211.556183,540.033936 
	C220.685410,540.009888 229.352188,540.004395 238.018982,539.998840 
	C241.435944,539.654968 244.852951,539.311584 248.269852,538.967163 
	C251.615784,538.629944 253.118500,540.044739 253.053375,543.497864 
	C252.990433,546.835999 251.832703,549.058533 248.241287,548.949097 
	C241.847351,548.754395 235.459915,548.346619 228.664246,548.034485 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M442.978363,168.764664 
	C429.012451,168.764664 415.046539,168.764664 400.694458,168.764664 
	C400.694458,189.393082 400.694458,209.562408 400.694458,229.948303 
	C421.512329,229.948303 442.067535,229.948303 463.259827,229.948303 
	C463.259827,218.751541 463.259827,207.818588 463.620605,196.424057 
	C464.321991,195.979874 464.662598,195.997269 465.004669,196.482391 
	C465.004517,205.386734 464.933807,213.824265 465.042969,222.259445 
	C465.076172,224.822235 465.606018,227.378586 465.908417,229.937897 
	C464.811676,230.928879 463.714905,231.919846 461.991119,232.639496 
	C447.863708,232.250046 434.363342,232.131897 420.862976,232.013763 
	C419.661591,232.469894 418.460236,232.926010 416.666870,233.689453 
	C415.377411,235.399460 414.140778,236.778641 414.078308,238.209076 
	C413.842407,243.612976 414.097076,249.036545 413.946075,254.446564 
	C413.866333,257.302917 413.328125,260.146515 412.996887,262.995850 
	C413.010193,254.523422 412.900116,246.048096 413.097961,237.579987 
	C413.176392,234.223465 412.302246,232.769119 408.662415,232.940689 
	C395.438568,233.564011 397.020874,232.412216 397.018616,220.878342 
	C397.018158,218.552719 397.010345,216.227081 397.275513,213.615204 
	C397.917236,213.471466 398.289398,213.613968 398.661560,213.756470 
	C398.712494,213.442383 398.807770,213.128326 398.808014,212.814209 
	C398.819794,198.357407 398.844330,183.900497 398.764496,169.444183 
	C398.760590,168.731628 397.837372,168.024155 397.342224,167.314301 
	C398.020569,165.008102 398.698883,162.701904 399.812164,160.650391 
	C401.928741,161.258850 403.608124,161.906570 405.292389,161.919510 
	C417.848419,162.015884 430.405396,161.986511 442.959412,162.237671 
	C442.956726,162.478745 442.936188,162.960373 442.690491,163.212067 
	C442.614105,164.986023 442.783478,166.508255 442.958954,168.214050 
	C442.965088,168.397598 442.978363,168.764664 442.978363,168.764664 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M656.029541,216.028915 
	C656.009338,215.640549 655.989075,215.252182 656.206299,214.397720 
	C656.482239,213.489166 656.520691,213.046707 656.559082,212.604248 
	C656.025208,212.740402 655.491333,212.876556 654.957458,213.012695 
	C630.792297,213.007782 606.625977,213.118408 582.462891,212.893890 
	C577.990845,212.852341 576.708069,214.151077 576.898621,218.531799 
	C577.238647,226.349915 577.148682,234.198410 576.888062,242.022537 
	C576.825073,243.910873 575.392639,245.753586 574.242676,247.462189 
	C573.612671,246.852737 573.330017,246.398407 573.037842,245.720428 
	C573.028381,245.496750 573.019104,245.047958 573.174805,244.597565 
	C573.365906,223.220032 573.424805,202.292908 573.416382,181.365814 
	C573.414734,177.233688 573.153625,173.101669 572.998535,168.694427 
	C572.961304,168.237076 572.937744,168.054916 573.006653,167.473602 
	C573.045837,165.715302 572.992432,164.356186 573.200195,162.882294 
	C573.965332,162.509048 574.469421,162.250534 574.973511,161.992035 
	C575.618347,162.767853 576.817200,163.537781 576.825500,164.320358 
	C576.967285,177.662949 576.962769,191.007095 576.987061,204.350906 
	C576.991272,206.667297 576.540649,209.289551 580.963318,209.319641 
	C583.493958,209.724976 585.305115,209.922729 587.116577,209.924866 
	C611.023682,209.953156 634.930786,209.953888 658.837891,209.961517 
	C659.226074,215.330811 659.614258,220.700104 659.619568,226.535706 
	C658.485413,227.004791 657.734131,227.007584 656.980591,226.556534 
	C656.661987,222.744766 656.345764,219.386841 656.029541,216.028915 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M501.034149,186.927460 
	C501.032227,178.903717 501.030334,170.879959 501.518616,162.408890 
	C519.007812,161.960556 536.006836,161.959534 553.074646,162.279953 
	C553.196716,162.813980 553.249939,163.026581 553.236328,163.625122 
	C553.302673,165.302231 553.435913,166.593445 553.265076,167.980118 
	C552.632263,168.340637 552.303589,168.605667 551.508789,168.908875 
	C535.497253,168.947052 519.951904,168.947052 504.099396,168.947052 
	C504.099396,194.682205 504.099396,219.737213 504.065826,245.087280 
	C504.015747,245.579605 503.999207,245.776871 503.704559,245.991852 
	C503.240692,246.013763 503.054962,246.017975 502.869232,246.022202 
	C502.869232,246.022202 502.479279,246.062729 502.255981,245.585144 
	C502.023499,230.166550 502.044464,215.225357 501.964294,200.284729 
	C501.954987,198.550568 501.384918,196.819397 501.074829,195.086823 
	C499.968140,194.067184 498.861481,193.047531 497.083618,191.726105 
	C487.115692,191.424332 477.819000,191.424332 468.522308,191.424332 
	C468.500641,190.823761 468.478943,190.223175 468.457245,189.622604 
	C469.340363,189.389206 470.223480,189.155807 471.564880,188.930740 
	C480.934265,188.944275 489.845825,188.989044 498.756012,188.899033 
	C499.745300,188.889038 502.720276,190.350494 501.034149,186.927460 
z"/>
<path fill="#F0D5B6" opacity="1.000000" stroke="none" 
	d="
M237.909973,539.690735 
	C229.352188,540.004395 220.685410,540.009888 211.558533,539.573669 
	C211.147186,536.076111 211.195923,533.020264 211.618286,529.982666 
	C217.683395,532.646606 222.560959,531.795776 226.232681,526.480408 
	C230.262726,520.646362 231.586868,514.094055 231.018097,507.099091 
	C231.753647,507.062256 232.489182,507.025452 233.854095,506.990662 
	C234.657333,506.993195 234.831223,506.993713 235.005096,506.994263 
	C237.963501,509.192169 240.888931,511.436188 243.886795,513.578918 
	C251.231277,518.828369 251.505661,529.910217 241.390244,535.421692 
	C239.912994,536.226562 238.983795,538.037354 237.909973,539.690735 
M237.011322,526.123413 
	C237.081467,527.420593 237.151611,528.717773 237.223038,530.038818 
	C241.959793,530.584106 243.262405,526.963623 243.620239,523.971252 
	C244.047913,520.395020 241.366623,518.202637 237.005280,517.125977 
	C237.005280,520.147400 237.005280,522.702637 237.011322,526.123413 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M698.833191,333.683167 
	C698.856628,332.361328 698.880066,331.039520 699.232544,329.008301 
	C699.396484,324.566559 699.231384,320.834229 699.066284,317.101898 
	C699.385742,312.825195 700.081604,308.536957 699.950989,304.274048 
	C699.616882,293.363586 698.868042,282.466400 698.400574,271.558960 
	C698.309998,269.445160 698.764893,267.310486 698.930603,265.182526 
	C699.158020,262.263458 697.866028,260.941895 694.857605,260.952393 
	C682.961182,260.993896 671.064087,260.961365 659.168030,260.861023 
	C657.376343,260.845917 655.588806,260.325012 653.692139,259.730957 
	C657.684204,259.282532 661.785522,259.182037 665.882507,258.989624 
	C670.923401,258.752869 675.960754,258.439484 681.378296,258.100342 
	C682.777893,257.999329 683.798767,257.957184 685.199707,257.943909 
	C686.086243,257.959900 686.592834,257.947021 687.490967,257.929626 
	C689.278625,257.245880 690.674622,256.566681 692.348816,256.116272 
	C694.393494,257.168365 696.159912,257.991638 697.926392,258.814880 
	C698.499939,257.288452 699.085999,255.766541 699.641785,254.233673 
	C699.912659,253.486542 700.127136,252.718964 700.367126,251.960648 
	C700.919922,253.683212 701.915649,255.396927 701.950195,257.129822 
	C702.117126,265.504333 702.025452,273.884003 702.025452,282.099854 
	C705.446228,282.099854 708.355164,282.099854 711.724243,282.371368 
	C712.798767,282.765747 713.413269,282.888611 714.309021,283.008606 
	C714.965332,283.011902 715.340332,283.018066 715.777283,283.487244 
	C715.793274,289.958466 715.747314,295.966675 715.429321,301.970642 
	C714.794861,301.963074 714.432312,301.959808 714.045410,301.520844 
	C713.993835,298.750610 713.966736,296.416046 713.965393,293.712036 
	C713.682983,292.240967 713.374878,291.139343 713.066711,290.037689 
	C712.862061,288.782654 712.657471,287.527588 712.479187,286.434021 
	C711.896362,286.300262 711.724731,286.208008 711.573059,286.233643 
	C701.967712,287.857086 701.967896,287.857941 701.968262,297.719604 
	C701.968689,309.543304 702.031433,321.367676 701.904114,333.190002 
	C701.884277,335.034973 700.997986,336.870636 699.733032,338.917847 
	C698.153259,339.308990 697.352844,339.492859 696.156738,339.671631 
	C675.323425,339.669708 654.885681,339.672852 634.037231,339.484070 
	C631.866638,339.230560 630.106812,339.169006 628.347046,339.107422 
	C624.437561,334.368378 626.002808,329.482758 627.834473,323.907288 
	C631.458679,327.400818 629.468323,331.329956 629.735229,335.413879 
	C630.736511,336.560394 632.023193,337.035828 633.756958,337.530243 
	C653.064636,337.544037 671.925171,337.538849 691.233337,337.666687 
	C694.262085,337.799713 696.843201,337.799713 700.273010,337.799713 
	C699.649719,336.017700 699.241455,334.850433 698.833191,333.683167 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M900.080627,566.127869 
	C894.429260,569.845154 888.399353,569.661987 883.317932,565.859131 
	C877.841187,561.760376 872.916626,556.779114 868.369507,551.636292 
	C865.554260,548.452271 866.662842,546.585938 870.861145,546.018616 
	C874.500549,545.526917 878.164124,545.197083 881.824463,544.882019 
	C890.732910,544.115173 895.906128,549.344238 900.034729,556.998596 
	C899.914856,560.511658 904.156982,563.322571 900.080627,566.127869 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M716.943359,521.672485 
	C710.240845,522.312744 703.547729,522.538818 696.407776,522.258545 
	C696.527344,518.230469 695.318176,516.720276 691.480347,516.882324 
	C688.003296,517.029297 684.491150,516.343262 681.251587,515.776123 
	C680.692200,511.354340 679.875671,507.180817 679.418701,502.844513 
	C682.858826,502.787354 685.977722,502.621857 689.012512,503.050720 
	C697.341248,504.227631 705.634644,505.654144 713.942017,506.981903 
	C714.945618,511.740662 715.949158,516.499390 716.943359,521.672485 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M241.284698,470.960266 
	C237.583572,462.777130 229.469070,464.387878 222.860718,462.755524 
	C220.468796,462.164703 217.635162,462.787231 215.527740,461.769623 
	C213.066803,460.581238 209.995041,458.527222 209.375656,456.253052 
	C208.752533,453.965088 210.315948,450.598907 211.866150,448.359253 
	C213.040527,446.662506 215.585052,445.662262 217.717911,444.925323 
	C226.074234,442.037964 232.328308,437.670105 231.440506,427.528534 
	C231.376373,426.795929 231.862549,426.015167 232.115158,425.183411 
	C240.235733,430.568939 240.551819,440.735352 232.754349,445.635162 
	C229.705734,447.550842 226.085052,448.533966 222.877670,450.230621 
	C221.693542,450.857056 220.948563,452.313599 220.003265,453.391510 
	C221.075836,454.262939 222.018585,455.509949 223.245743,455.934082 
	C226.681229,457.121582 230.329971,457.717896 233.718536,459.009338 
	C238.848175,460.964447 243.433456,463.643097 242.790314,470.590271 
	C241.988724,470.951996 241.636719,470.956146 241.284698,470.960266 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M412.570007,262.995667 
	C413.328125,260.146515 413.866333,257.302917 413.946075,254.446564 
	C414.097076,249.036545 413.842407,243.612976 414.078308,238.209076 
	C414.140778,236.778641 415.377411,235.399460 416.478577,233.965820 
	C417.248962,242.468826 417.556244,251.006195 418.045013,259.533142 
	C418.120453,260.849548 419.028839,262.118256 419.746063,264.080078 
	C420.301178,266.171021 420.662231,267.590881 420.766327,269.348694 
	C415.831879,270.046997 411.154388,270.407379 405.981781,270.828369 
	C394.258728,270.865814 383.030823,270.842651 371.502625,270.588684 
	C368.631500,270.139160 366.060669,269.920410 363.377747,269.692108 
	C363.594879,267.597656 363.779053,265.820831 363.963257,264.044006 
	C368.435791,264.031281 372.921570,264.231293 377.377441,263.952698 
	C383.090027,263.595520 388.777954,262.847687 394.477936,262.282562 
	C395.454315,262.185730 396.744781,261.728210 397.369263,262.171356 
	C402.170197,265.578369 407.181458,263.576660 412.570007,262.995667 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M757.936218,400.055603 
	C754.600586,398.746429 751.264893,397.437286 747.587158,396.086639 
	C747.180359,386.805878 747.300659,377.559570 746.947205,368.331360 
	C746.828369,365.230286 745.436523,362.189056 744.805115,359.084167 
	C744.714600,358.638855 745.633972,357.988220 746.353027,357.320435 
	C753.813660,356.416809 758.171326,356.378235 758.140625,366.703827 
	C758.132263,369.505859 758.714111,372.309662 758.716980,375.855804 
	C758.251282,384.417847 758.093750,392.236725 757.936218,400.055603 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M652.975220,288.597992 
	C651.739929,288.600037 650.504639,288.602051 648.413025,288.754944 
	C645.341797,288.967926 643.126831,289.030029 640.911926,289.092133 
	C641.153442,284.739014 641.409546,280.386627 641.627136,276.032318 
	C641.688416,274.805756 641.636475,273.573547 641.636475,272.204773 
	C642.822693,272.064148 644.688538,271.842987 646.554382,271.621796 
	C646.555908,271.325073 646.557373,271.028351 646.558899,270.731628 
	C643.681763,270.468384 640.804626,270.205109 637.927490,269.941864 
	C637.965332,269.656647 638.003235,269.371460 638.041077,269.086243 
	C647.020691,269.086243 656.000305,269.086243 665.111450,269.347168 
	C663.836670,270.006256 662.430298,270.404449 661.023926,270.802612 
	C661.088867,271.229828 661.153870,271.657013 661.218872,272.084198 
	C664.401794,272.084198 667.584717,272.084198 670.767639,272.084198 
	C670.868774,272.478210 670.969971,272.872192 670.612061,273.560272 
	C666.092346,273.854340 662.031738,273.854340 658.056274,273.854340 
	C657.438599,275.626007 656.946472,277.037354 656.450806,278.458954 
	C657.438843,278.644714 658.226624,278.792847 659.014465,278.940979 
	C660.020020,279.832306 661.025635,280.723633 662.031250,281.614929 
	C661.810242,281.856049 661.589294,282.097198 661.368347,282.338318 
	C663.861267,282.899536 666.354187,283.460724 668.847107,284.021942 
	C668.842834,284.252899 668.838562,284.483856 668.834290,284.714813 
	C663.357727,284.714813 657.881226,284.714813 652.404663,284.714813 
	C652.390625,285.331879 652.376587,285.948944 652.362549,286.566010 
	C655.608215,286.566010 658.853821,286.566010 662.574402,286.972717 
	C663.060974,287.616364 663.072571,287.853302 663.084229,288.090271 
	C663.084229,288.090271 663.024719,288.003204 662.715088,288.021973 
	C662.187683,288.092133 661.970032,288.143524 661.752319,288.194916 
	C659.881104,288.249542 658.009827,288.304199 655.432129,288.223083 
	C654.142212,288.257568 653.558716,288.427795 652.975220,288.597992 
z"/>
<path fill="#97666E" opacity="1.000000" stroke="none" 
	d="
M100.816208,409.104462 
	C105.646904,422.037476 114.768837,430.121460 128.481644,431.929016 
	C143.222733,433.872070 154.740036,428.084137 162.768723,415.500000 
	C163.297287,414.671539 163.941360,413.916779 164.879700,413.048706 
	C162.931992,425.878601 154.347717,433.015869 142.694824,437.080505 
	C130.485947,441.339081 119.902473,437.696472 110.469177,429.657074 
	C104.355835,424.447083 100.724518,417.766327 99.679321,409.520233 
	C100.308601,409.111053 100.560989,409.090485 100.816208,409.104462 
z"/>
<path fill="#EEDEBE" opacity="1.000000" stroke="none" 
	d="
M230.549042,507.062897 
	C231.586868,514.094055 230.262726,520.646362 226.232681,526.480408 
	C222.560959,531.795776 217.683395,532.646606 211.552429,529.530945 
	C211.087234,525.701538 211.061523,522.341980 211.250427,518.836182 
	C211.318893,518.132812 211.172760,517.575684 211.015167,516.590027 
	C211.308990,513.133606 211.614273,510.105713 211.919556,507.077820 
	C217.973038,507.060791 224.026520,507.043762 230.549042,507.062897 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M713.963989,506.575623 
	C705.634644,505.654144 697.341248,504.227631 689.012512,503.050720 
	C685.977722,502.621857 682.858826,502.787354 679.328003,502.446899 
	C678.222046,498.474457 677.566528,494.736877 676.910950,490.999268 
	C680.482849,491.315186 684.054260,491.887512 687.626831,491.894958 
	C695.658997,491.911713 703.691711,491.648285 712.009644,491.766632 
	C712.858704,496.746002 713.422363,501.457672 713.963989,506.575623 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M680.999634,258.159241 
	C675.960754,258.439484 670.923401,258.752869 665.882507,258.989624 
	C661.785522,259.182037 657.684204,259.282532 653.283447,259.715820 
	C652.982117,260.007843 652.502991,260.021881 651.962402,259.725372 
	C643.617371,259.289734 635.812988,259.150604 628.008545,259.011475 
	C628.171326,257.015961 628.334167,255.020432 629.295776,252.935440 
	C637.710510,252.880112 645.327454,252.854401 652.941956,252.980057 
	C655.695679,253.025482 657.615967,252.571121 656.926697,248.692444 
	C656.979187,241.143295 656.981018,234.076828 656.982910,227.010376 
	C657.734131,227.007584 658.485413,227.004791 659.611938,227.003510 
	C660.551575,234.250641 661.115967,241.496262 661.707642,249.258408 
	C661.190186,250.282745 660.645447,250.790543 660.100708,251.298340 
	C660.926270,251.645996 661.742554,252.268448 662.578979,252.296951 
	C668.224121,252.489319 673.873596,252.555923 679.413940,253.006714 
	C679.308228,253.589127 679.310181,253.828064 679.220093,254.414001 
	C679.138611,255.477249 679.149109,256.193451 679.176758,257.159302 
	C679.368774,257.742859 679.644287,257.899597 680.266235,257.946014 
	C680.674500,258.061615 680.837097,258.110443 680.999634,258.159241 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M649.781433,326.819855 
	C649.442810,326.817261 649.104187,326.814636 648.338867,326.549622 
	C647.302124,326.522705 646.692139,326.758209 646.082153,326.993713 
	C644.086609,328.255707 642.091064,329.517731 640.095459,330.779724 
	C639.273254,329.221802 637.384277,327.218933 637.815918,326.183990 
	C639.563660,321.993530 638.625305,316.794861 643.159607,313.465210 
	C644.619934,312.392914 646.733398,309.098175 643.609070,306.109436 
	C642.250183,304.809509 642.494568,302.047333 645.223877,300.514618 
	C650.180176,303.349365 654.788879,301.565948 659.398499,300.977234 
	C655.947144,299.864838 652.436462,299.505280 648.950317,298.982605 
	C648.372314,298.895935 647.901062,298.097076 647.380493,297.627350 
	C654.018311,297.916351 660.656128,298.205383 667.293945,298.494385 
	C667.275024,298.691528 667.256104,298.888672 667.237183,299.085785 
	C665.563843,299.361084 663.890503,299.636353 662.217163,299.911652 
	C662.253845,300.120270 662.290527,300.328888 662.327271,300.537506 
	C665.212646,301.022308 668.098083,301.507080 671.214966,302.402405 
	C672.557983,303.540466 673.608276,304.395874 674.796021,304.964142 
	C676.397949,305.730652 678.105591,306.276215 679.355835,306.926392 
	C677.608765,307.007507 676.273743,307.078796 674.511169,307.091919 
	C672.070129,307.052521 670.056641,307.071289 667.839478,307.027283 
	C667.635742,306.964508 667.210388,306.933228 667.074585,306.694458 
	C666.619019,306.337280 666.299255,306.218811 665.879944,305.741058 
	C663.511169,304.643097 661.241882,303.904388 658.557739,303.111511 
	C652.380554,302.347870 654.203125,306.665955 653.804321,309.815765 
	C651.312439,310.118622 648.762695,310.428528 646.213013,310.738403 
	C646.251526,311.105743 646.290039,311.473114 646.328552,311.840454 
	C648.345764,312.150909 650.362976,312.461365 652.380188,312.771820 
	C652.322571,313.085022 652.265015,313.398224 652.207397,313.711426 
	C650.228271,313.972168 648.249146,314.232880 646.270020,314.493622 
	C646.276367,314.793976 646.282654,315.094360 646.288940,315.394745 
	C647.847046,315.806396 649.405090,316.218079 651.290527,316.716217 
	C650.265686,317.876251 649.593994,318.636536 648.759399,319.581238 
	C651.450317,319.733368 653.744812,319.863098 657.037842,320.049286 
	C654.254883,322.422852 652.162476,324.207489 649.957886,326.185120 
	C649.845764,326.378113 649.781433,326.819855 649.781433,326.819855 
M646.012878,304.372070 
	C646.195251,304.423798 646.377563,304.475555 646.559937,304.527283 
	C646.492432,304.350983 646.424927,304.174652 646.012878,304.372070 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M67.749672,705.146545 
	C68.772255,705.012329 69.578804,705.020081 71.177223,705.077393 
	C75.072006,705.337463 78.188133,705.841980 81.275383,705.703308 
	C90.679825,705.280884 100.066933,704.351196 109.472908,704.126404 
	C115.901703,703.972778 122.350777,704.667480 129.179840,704.983398 
	C130.344696,704.974976 131.120499,704.966064 131.896286,704.957153 
	C137.331604,704.635071 142.767517,704.095154 148.201904,704.110168 
	C150.086472,704.115356 151.967224,705.496765 153.922119,706.623596 
	C148.380768,707.336365 142.760269,707.591003 137.155563,708.042053 
	C133.031250,708.373901 130.161026,709.973083 130.960068,714.940735 
	C131.404861,717.705994 131.519012,720.524414 131.419083,723.690369 
	C130.351425,724.003052 129.646851,723.944275 128.942291,723.885498 
	C128.835770,721.154236 128.335358,718.365601 128.722702,715.706299 
	C129.203568,712.404968 129.031815,710.103882 125.030998,709.793518 
	C123.070847,709.641479 121.128204,709.049072 119.176147,709.041504 
	C103.443336,708.980225 87.710167,709.010803 71.434723,708.678589 
	C69.896454,707.897827 68.900574,707.451721 67.904686,707.005676 
	C67.781006,706.433289 67.657326,705.860901 67.749672,705.146545 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M373.065796,522.574585 
	C368.416046,522.316406 363.766266,522.058228 359.053589,521.393433 
	C359.479889,515.849548 359.969086,510.712280 361.083954,505.447021 
	C367.562561,504.796875 373.411011,504.205444 379.273224,503.826660 
	C380.161438,503.769257 381.113556,504.700775 382.048462,505.597778 
	C382.068329,509.685822 382.075867,513.350952 381.796631,517.313049 
	C380.062347,517.736206 378.589508,518.096191 377.172150,517.942932 
	C373.483826,517.544250 372.542999,519.355591 373.065796,522.574585 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M714.145996,186.118332 
	C715.906677,185.838593 717.667236,185.315582 719.428101,185.314392 
	C775.333557,185.276733 831.239014,185.281448 887.144409,185.332977 
	C888.905273,185.334595 890.665527,185.897903 892.151978,186.564072 
	C885.571472,187.003387 879.265137,187.078018 872.496338,187.096222 
	C821.873840,187.023911 771.713806,187.011505 721.553833,186.981796 
	C719.059326,186.980316 716.565002,186.828278 714.104126,186.591125 
	C714.137695,186.435883 714.145996,186.118332 714.145996,186.118332 
z"/>
<path fill="#534B4B" opacity="1.000000" stroke="none" 
	d="
M345.919586,134.214783 
	C327.648865,134.140869 309.378052,134.083145 291.107452,133.988174 
	C275.002625,133.904449 258.898010,133.779114 242.507538,133.391663 
	C247.605759,132.462723 252.990463,131.251587 258.373566,131.258682 
	C289.475067,131.299728 320.576660,131.583542 351.676849,131.913834 
	C355.770355,131.957306 359.856018,132.736160 364.476135,133.350937 
	C365.006989,133.527481 364.984039,133.990692 364.523438,133.905945 
	C358.015076,133.952393 351.967316,134.083588 345.919586,134.214783 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M277.542786,251.305435 
	C276.350403,251.642731 274.829956,252.616165 273.305023,252.623199 
	C238.915695,252.781647 204.525879,252.833710 170.136154,252.907120 
	C167.145691,252.913498 164.096283,252.569336 161.182236,253.046875 
	C158.545105,253.479080 156.055740,254.812836 152.771729,255.859589 
	C151.761765,255.907974 151.481277,255.845779 151.200790,255.783569 
	C153.127533,254.500183 155.016022,252.164871 156.986816,252.093216 
	C181.548126,251.200256 206.119202,250.276611 230.692444,250.125885 
	C244.758469,250.039581 258.832092,251.368500 272.905212,251.994888 
	C274.330719,252.058319 275.776306,251.670074 277.542786,251.305435 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M315.899109,375.566284 
	C313.051636,375.614471 309.147491,377.550934 308.292023,371.823700 
	C308.005585,367.627991 308.093262,364.155762 307.978394,360.690277 
	C307.783539,354.810913 307.460968,348.935791 307.192078,343.058868 
	C309.036713,339.245300 312.234161,337.816376 316.689606,337.984009 
	C316.718048,350.413330 316.345551,362.756836 315.899109,375.566284 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M382.036133,505.174866 
	C381.113556,504.700775 380.161438,503.769257 379.273224,503.826660 
	C373.411011,504.205444 367.562561,504.796875 361.350281,505.160736 
	C361.020050,500.977692 361.049225,496.953003 361.065674,492.465210 
	C368.684235,492.009796 376.315460,492.017487 384.276245,492.372345 
	C383.749237,496.871307 382.892700,501.023071 382.036133,505.174866 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M650.070007,325.992126 
	C652.162476,324.207489 654.254883,322.422852 657.037842,320.049286 
	C653.744812,319.863098 651.450317,319.733368 648.759399,319.581238 
	C649.593994,318.636536 650.265686,317.876251 651.290527,316.716217 
	C649.405090,316.218079 647.847046,315.806396 646.288940,315.394745 
	C646.282654,315.094360 646.276367,314.793976 646.270020,314.493622 
	C648.249146,314.232880 650.228271,313.972168 652.207397,313.711426 
	C652.265015,313.398224 652.322571,313.085022 652.380188,312.771820 
	C650.362976,312.461365 648.345764,312.150909 646.328552,311.840454 
	C646.290039,311.473114 646.251526,311.105743 646.213013,310.738403 
	C648.762695,310.428528 651.312439,310.118622 653.804321,309.815765 
	C654.203125,306.665955 652.380554,302.347870 658.591187,303.483887 
	C661.360168,304.939880 663.680847,305.969330 666.021423,307.385620 
	C668.024048,308.846252 670.006775,309.920105 671.989502,310.993988 
	C669.342773,311.333954 666.695984,311.673920 663.738342,312.053833 
	C664.029114,312.778137 664.513550,313.984955 664.686768,315.576508 
	C660.220093,315.571777 662.173950,319.312042 660.658691,320.959717 
	C659.674133,321.455902 659.038574,321.935608 658.403015,322.415283 
	C658.848633,322.816620 659.294312,323.217896 659.739929,323.619202 
	C660.178894,322.743530 660.617859,321.867859 661.391235,321.002075 
	C662.170166,321.050629 662.614807,321.089233 663.059387,321.127838 
	C664.856750,322.790802 666.654175,324.453766 668.631226,326.282990 
	C668.799377,326.171234 668.222778,326.554321 667.025391,326.681793 
	C660.959717,326.281525 655.514893,326.136810 650.070007,325.992126 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M219.942780,705.006470 
	C221.302582,704.980713 222.662399,704.954956 224.421265,704.877075 
	C227.518295,705.160950 230.220062,705.806519 232.913452,705.773071 
	C240.194931,705.682922 247.471954,705.180542 254.752777,705.129517 
	C256.492798,705.117310 258.240662,706.227905 259.984924,706.822144 
	C259.953186,707.282227 259.921478,707.742310 259.889740,708.202393 
	C258.759491,708.466125 257.624573,708.976196 256.499725,708.954956 
	C246.722534,708.769775 236.947861,708.327698 227.170990,708.283508 
	C217.808899,708.241211 208.441666,708.802429 199.083511,708.657776 
	C194.768478,708.591003 190.469681,707.473633 186.475433,706.419983 
	C188.875290,705.662048 190.963211,705.316833 193.513992,704.977295 
	C202.632156,704.990784 211.287476,704.998596 219.942780,705.006470 
z"/>
<path fill="#E9DCC3" opacity="1.000000" stroke="none" 
	d="
M74.910545,547.835693 
	C66.835037,547.675598 58.759533,547.515442 50.389648,547.633667 
	C45.112526,546.403687 46.575787,543.300171 49.025284,540.077515 
	C58.912746,539.997437 67.952408,540.002258 76.992065,540.007141 
	C80.355377,541.641846 80.418037,544.295288 78.685646,547.674438 
	C77.049995,547.959106 75.980270,547.897400 74.910545,547.835693 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M620.059998,467.943451 
	C620.059998,467.943451 620.095154,467.528595 620.074402,467.322449 
	C620.003906,459.532410 619.919739,451.948547 619.911560,444.364624 
	C619.893433,427.614410 619.939392,410.864075 619.905334,394.113922 
	C619.892151,387.644653 619.732849,381.175659 620.009644,374.185272 
	C620.606384,372.785706 620.833679,371.907440 621.287476,371.362610 
	C621.595276,372.185608 621.747559,372.675049 621.747742,373.164581 
	C621.756042,402.590729 621.751038,432.016907 621.750549,461.443054 
	C621.750488,463.559265 621.774353,465.675476 621.787109,467.791687 
	C621.403564,467.846375 621.019958,467.901031 620.317566,467.977020 
	C619.998718,467.998322 620.059998,467.943451 620.059998,467.943451 
z"/>
<path fill="#97666E" opacity="1.000000" stroke="none" 
	d="
M241.235184,471.377014 
	C241.636719,470.956146 241.988724,470.951996 242.604340,470.962524 
	C242.955612,475.981689 239.768570,477.609741 235.515610,477.824768 
	C231.378601,478.033997 227.213684,477.770477 223.087402,478.073608 
	C221.424469,478.195770 219.831680,479.272614 218.206970,479.915009 
	C218.970444,481.451019 219.587952,483.084290 220.531570,484.500244 
	C221.950256,486.628937 223.597290,488.605469 225.147247,490.646698 
	C224.761673,490.961609 224.376099,491.276520 223.990540,491.591400 
	C219.820145,488.591370 215.457809,485.811279 211.604507,482.447968 
	C210.544357,481.522644 210.415756,478.657928 210.954346,477.049683 
	C211.383484,475.768188 213.444855,474.264404 214.838715,474.205292 
	C221.607422,473.918304 228.402344,474.258209 235.172241,473.985107 
	C237.202866,473.903198 239.182617,472.559418 241.235184,471.377014 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M442.038086,312.974487 
	C440.487549,313.345978 438.937836,314.037018 437.386383,314.040955 
	C414.225983,314.099030 391.064880,314.124268 367.905518,313.949921 
	C365.958954,313.935272 364.023590,312.436371 362.356567,310.897095 
	C362.439819,299.816254 362.249451,289.465332 362.048340,278.855591 
	C362.053162,278.424805 362.068787,278.252808 362.384552,278.061401 
	C363.285004,278.011200 363.885284,277.980408 364.632935,278.399475 
	C364.780334,289.752228 364.780334,300.655090 364.780334,311.496948 
	C365.791595,311.786621 366.252289,312.034607 366.712555,312.033783 
	C391.441040,311.990509 416.169495,311.926300 441.020752,312.113464 
	C441.441711,312.566650 441.739899,312.770569 442.038086,312.974487 
z"/>
<path fill="#A15F68" opacity="1.000000" stroke="none" 
	d="
M779.580811,382.749878 
	C780.445312,382.408997 781.743469,382.069855 783.041809,382.069275 
	C849.301697,382.040833 915.561523,382.040253 981.821411,382.049500 
	C982.643738,382.049622 983.466003,382.215363 984.626709,382.532227 
	C979.478027,382.834625 973.991028,382.969360 968.503906,382.973206 
	C907.171570,383.015900 845.839172,383.039612 784.506836,383.059845 
	C783.009460,383.060333 781.512024,382.961884 779.580811,382.749878 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M713.817078,186.360809 
	C714.145996,186.118332 714.137695,186.435883 714.115845,186.997131 
	C714.762024,189.723846 715.429932,191.889282 716.053711,194.294708 
	C716.009460,194.534683 716.084778,195.016846 716.017456,195.480225 
	C715.939026,199.095703 715.925415,202.247772 715.917175,205.399857 
	C715.849304,231.274643 715.782471,257.149445 715.715332,283.024231 
	C715.340332,283.018066 714.965332,283.011902 714.349976,282.540283 
	C714.031555,254.890839 713.966248,227.706818 713.846375,200.523041 
	C713.838562,198.759995 713.410400,196.998810 713.177734,195.236755 
	C713.281189,192.358932 713.384705,189.481094 713.817078,186.360809 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M67.918854,707.462158 
	C68.900574,707.451721 69.896454,707.897827 70.969193,708.695496 
	C71.041962,722.827576 71.039368,736.608093 71.031380,750.388550 
	C71.030609,751.716614 71.219307,753.100952 70.903191,754.354004 
	C70.672592,755.268127 69.756294,756.009399 69.145653,756.827698 
	C68.440147,755.934998 67.455887,755.138123 67.106560,754.122864 
	C66.747971,753.080688 66.980072,751.824463 67.004845,750.662964 
	C67.308784,736.414673 67.622108,722.166687 67.918854,707.462158 
z"/>
<path fill="#59B6CF" opacity="1.000000" stroke="none" 
	d="
M161.622528,321.763245 
	C162.455994,321.451904 163.736893,321.029358 165.018127,321.028351 
	C216.607269,320.987488 268.196442,320.983337 319.785583,320.988953 
	C320.606323,320.989044 321.427063,321.168182 322.569031,321.504059 
	C312.408173,321.829651 301.926086,321.991394 291.444061,321.986877 
	C248.319397,321.968262 205.194763,321.899139 161.622528,321.763245 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M690.785767,337.533661 
	C671.925171,337.538849 653.064636,337.544037 633.728882,337.305603 
	C633.164673,336.771667 633.106506,336.475281 633.079285,336.172821 
	C634.754456,335.358551 636.429565,334.544250 638.302734,333.401062 
	C638.500671,333.072144 638.519287,333.110413 638.519287,333.110413 
	C641.533020,333.920868 644.527527,335.342560 647.563660,335.437805 
	C662.002625,335.890686 676.452942,335.982452 691.222656,336.392944 
	C691.292664,336.899994 691.039185,337.216827 690.785767,337.533661 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M714.069824,301.956512 
	C714.432312,301.959808 714.794861,301.963074 715.514771,302.433929 
	C715.872192,316.414703 715.872192,329.927887 715.872192,343.514008 
	C731.760925,343.514008 746.824890,343.514008 762.350159,343.631104 
	C767.763855,343.791290 772.716370,343.834412 777.668823,343.877533 
	C777.755371,344.185638 777.712524,344.474548 776.879028,344.889709 
	C757.934937,345.040253 739.652039,345.022430 721.369324,345.087250 
	C719.620911,345.093445 717.874390,345.615143 716.126953,345.897522 
	C715.448792,345.533142 714.770569,345.168762 714.053650,344.002075 
	C714.033203,329.452026 714.051514,315.704254 714.069824,301.956512 
z"/>
<path fill="#59B6CF" opacity="1.000000" stroke="none" 
	d="
M433.149170,442.230591 
	C432.285339,443.382019 431.421478,444.533447 430.279633,445.393097 
	C430.667358,439.534973 431.858643,433.973267 431.907745,428.401489 
	C432.120392,404.280182 432.041290,380.155792 431.949310,356.032959 
	C431.936981,352.802399 431.245880,349.574432 430.880554,346.443481 
	C425.142303,345.932404 420.095337,345.482880 414.852173,344.956085 
	C414.397461,344.755249 414.191986,344.572174 414.495850,344.236572 
	C420.681091,344.066956 426.409973,343.990387 432.138885,343.913849 
	C432.493439,343.903137 432.774658,344.041504 433.058899,345.045776 
	C433.162018,374.481354 433.188843,403.199982 433.154388,432.381897 
	C433.111786,435.973633 433.130493,439.102112 433.149170,442.230591 
z"/>
<path fill="#4D2F36" opacity="1.000000" stroke="none" 
	d="
M634.447998,339.675995 
	C654.885681,339.672852 675.323425,339.669708 696.229675,339.877930 
	C696.912415,340.320984 696.996643,340.592865 696.950928,340.904999 
	C676.276794,340.909546 655.602722,340.914062 634.506714,340.690796 
	C634.262024,340.226624 634.383118,339.964264 634.447998,339.675995 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M307.115234,343.516113 
	C307.460968,348.935791 307.783539,354.810913 307.978394,360.690277 
	C308.093262,364.155762 308.005585,367.627991 308.020996,371.570648 
	C308.020538,408.341156 308.013336,444.638214 307.979889,480.935242 
	C307.978210,482.748535 307.748047,484.561646 307.345032,486.678345 
	C307.035797,444.128540 307.003479,401.275269 306.978943,358.421997 
	C306.976196,353.605774 307.017487,348.789581 307.115234,343.516113 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M892.795471,191.738541 
	C893.189819,194.160355 893.923340,196.581482 893.928162,199.004074 
	C894.016907,243.645874 894.018494,288.287842 893.799072,333.498352 
	C893.391174,334.099640 893.222595,334.132294 893.029663,333.681946 
	C893.006775,288.804138 893.025208,244.409363 892.953613,200.014740 
	C892.950378,198.028885 892.127502,196.044342 891.781494,194.107117 
	C891.876648,194.155029 891.745178,194.322693 891.802490,193.887344 
	C891.860107,193.159256 891.860352,192.866531 891.947388,192.369965 
	C892.240295,191.938797 892.494080,191.796265 892.795471,191.738541 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M452.691284,280.159271 
	C452.995880,327.229370 453.010895,374.620575 453.038940,422.474487 
	C452.873077,422.953888 452.694183,422.970612 452.246216,423.006287 
	C451.984344,377.484863 451.986542,331.944427 452.015839,286.404022 
	C452.017090,284.429413 452.267426,282.454956 452.691284,280.159271 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M502.979218,246.421692 
	C503.054962,246.017975 503.240692,246.013763 504.174988,245.999619 
	C527.631470,245.974503 550.339355,245.959290 573.047302,245.944092 
	C573.330017,246.398407 573.612671,246.852737 573.886475,247.584686 
	C551.456238,247.914047 529.034912,247.983948 506.613586,247.966232 
	C505.438507,247.965317 504.263977,247.219971 502.979218,246.421692 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M165.939316,719.046448 
	C165.937378,730.896729 165.963089,742.747192 165.861481,754.596619 
	C165.855682,755.273682 164.809341,755.941833 163.015518,756.376221 
	C163.015518,744.242310 163.015518,732.108337 163.394012,719.496948 
	C164.494766,719.028442 165.217041,719.037415 165.939316,719.046448 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M598.907288,273.690247 
	C552.436218,273.977722 505.623322,273.988800 458.323364,273.993347 
	C459.244568,273.661865 460.652435,273.054474 462.061035,273.052826 
	C506.752106,273.001160 551.443237,273.006134 596.134338,273.023407 
	C596.944763,273.023712 597.755066,273.278046 598.907288,273.690247 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M553.005798,161.958511 
	C536.006836,161.959534 519.007812,161.960556 501.550476,161.935516 
	C502.663055,161.279129 504.231812,160.106369 505.805298,160.100021 
	C528.204956,160.009552 550.605286,160.076904 573.209229,160.426727 
	C570.709900,161.033768 568.012817,161.434555 565.302124,161.580017 
	C561.208374,161.799667 557.105042,161.841248 553.005798,161.958511 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M924.510254,452.905090 
	C925.135681,454.314117 925.496704,455.968506 925.996338,457.935120 
	C921.344727,457.865662 920.256104,462.463562 917.486877,464.772461 
	C915.904846,466.091461 914.722168,467.889435 912.912537,469.255035 
	C913.095825,459.996429 916.283203,451.849365 921.054382,444.255035 
	C921.567932,444.404633 922.081482,444.554199 922.595032,444.703796 
	C921.306641,448.644226 920.018311,452.584656 918.729919,456.525116 
	C919.252197,456.876221 919.774475,457.227325 920.296753,457.578430 
	C921.613159,456.102417 922.929504,454.626404 924.510254,452.905090 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M442.962097,161.996597 
	C430.405396,161.986511 417.848419,162.015884 405.292389,161.919510 
	C403.608124,161.906570 401.928741,161.258850 400.158203,160.528473 
	C420.183990,160.100510 440.298645,160.029678 460.413208,160.048233 
	C461.569000,160.049301 462.724121,160.779037 463.718750,161.687775 
	C463.281433,162.400085 463.089417,162.657318 462.574615,162.970078 
	C460.814148,163.015594 459.460907,163.068649 457.822357,162.802277 
	C452.678711,162.320770 447.820404,162.158676 442.962097,161.996597 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M128.932709,724.335571 
	C129.646851,723.944275 130.351425,724.003052 131.398941,724.111938 
	C131.741898,734.594238 131.741898,745.026489 131.741898,755.458740 
	C130.979095,755.458252 130.216278,755.457703 129.453476,755.457153 
	C126.545868,745.373169 128.378998,735.046387 128.932709,724.335571 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M757.957397,400.518433 
	C758.093750,392.236725 758.251282,384.417847 758.697388,376.297791 
	C759.002197,411.682404 759.018433,447.368225 759.000916,483.520325 
	C758.644958,482.084930 758.047302,480.184021 758.042236,478.281494 
	C757.972961,452.514893 757.985962,426.748016 757.957397,400.518433 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M604.048828,381.034332 
	C604.034668,349.220581 604.017212,317.406830 604.022095,285.593079 
	C604.022278,284.612457 604.253967,283.631897 604.657043,282.353577 
	C604.947571,314.734467 604.958801,347.413025 604.721313,380.555542 
	C604.472473,381.019470 604.048828,381.034332 604.048828,381.034332 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M224.948456,725.300903 
	C224.608429,731.982727 224.263718,738.205322 223.899338,744.783142 
	C220.241211,742.156860 219.835007,721.396729 223.289612,715.872131 
	C223.919037,719.285034 224.431412,722.063293 224.948456,725.300903 
z"/>
<path fill="#A15F68" opacity="1.000000" stroke="none" 
	d="
M893.054077,334.164978 
	C893.222595,334.132294 893.391174,334.099640 893.792969,333.957520 
	C895.492554,333.983032 896.959534,334.242279 898.424988,334.234619 
	C926.623779,334.086975 954.822327,333.902374 983.021057,333.759583 
	C983.971619,333.754761 984.923950,334.105682 985.984070,334.625366 
	C954.971497,334.876251 923.850281,334.792511 892.295776,334.605164 
	C891.862488,334.501526 891.939575,334.498962 892.250427,334.523010 
	C892.725525,334.419708 892.889832,334.292328 893.054077,334.164978 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M900.513062,566.207947 
	C904.156982,563.322571 899.914856,560.511658 900.078491,557.346069 
	C900.902405,558.076721 901.734192,559.165039 902.565979,560.253296 
	C903.008911,560.221619 903.451782,560.189941 903.894714,560.158203 
	C903.894714,552.041931 903.894714,543.925659 904.040466,535.440063 
	C904.412964,544.664490 904.679810,554.257446 904.848816,563.852173 
	C904.926880,568.282349 904.813904,572.715820 904.611572,577.491150 
	C904.031799,574.887817 903.785706,571.906006 903.139465,569.013550 
	C902.911316,567.992615 901.705200,567.190247 900.513062,566.207947 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M397.256104,167.752258 
	C397.837372,168.024155 398.760590,168.731628 398.764496,169.444183 
	C398.844330,183.900497 398.819794,198.357407 398.808014,212.814209 
	C398.807770,213.128326 398.712494,213.442383 398.661560,213.756470 
	C398.289398,213.613968 397.917236,213.471466 397.326538,213.147583 
	C397.128662,198.040878 397.149323,183.115555 397.256104,167.752258 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M662.753357,293.489197 
	C664.865234,292.537628 666.611877,291.223297 668.423767,291.126343 
	C673.847900,290.836060 679.297546,291.021973 684.704041,291.021973 
	C684.870544,292.506775 684.991638,293.586548 685.169678,295.174255 
	C676.637817,295.174255 668.204468,295.174255 659.771179,295.174255 
	C659.705688,294.959442 659.640259,294.744629 659.574829,294.529816 
	C660.522522,294.247528 661.470276,293.965240 662.753357,293.489197 
M678.075012,293.173401 
	C678.172424,293.044128 678.289917,292.924866 678.360901,292.782410 
	C678.417603,292.668762 678.417664,292.526886 678.442810,292.397522 
	C677.184570,292.239258 675.926331,292.080994 674.668091,291.922699 
	C674.647949,292.321503 674.627808,292.720276 674.607666,293.119080 
	C675.508118,293.210785 676.408508,293.302521 678.075012,293.173401 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M713.158325,195.683899 
	C713.410400,196.998810 713.838562,198.759995 713.846375,200.523041 
	C713.966248,227.706818 714.031555,254.890839 714.068604,282.543152 
	C713.413269,282.888611 712.798767,282.765747 712.175537,282.405212 
	C712.439453,279.896545 712.940796,277.626495 712.949951,275.354462 
	C713.055908,248.946838 713.087585,222.538895 713.158325,195.683899 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M433.215698,431.918640 
	C433.188843,403.199982 433.162018,374.481354 433.133911,345.277100 
	C433.487396,346.857269 434.146759,348.922455 434.150299,350.988800 
	C434.190979,374.767822 434.111542,398.547028 434.132629,422.326111 
	C434.134674,424.628235 434.595337,426.929993 434.631317,429.809937 
	C434.018250,430.898224 433.616974,431.408417 433.215698,431.918640 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M647.282471,297.319031 
	C647.901062,298.097076 648.372314,298.895935 648.950317,298.982605 
	C652.436462,299.505280 655.947144,299.864838 659.398499,300.977234 
	C654.788879,301.565948 650.180176,303.349365 645.384399,300.242249 
	C645.382141,295.960571 644.881409,292.220825 640.977051,289.444946 
	C643.126831,289.030029 645.341797,288.967926 647.949341,288.837158 
	C649.661682,291.755402 649.863525,294.585358 647.282471,297.319031 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M471.106598,188.922394 
	C470.223480,189.155807 469.340363,189.389206 468.457245,189.622604 
	C468.478943,190.223175 468.500641,190.823761 468.522308,191.424332 
	C477.819000,191.424332 487.115692,191.424332 496.716431,191.713074 
	C487.531006,192.232361 478.041138,192.450195 468.552612,192.715576 
	C467.715118,192.739014 466.886292,193.073120 465.659668,193.621521 
	C464.664307,193.996872 464.062744,194.013611 463.461121,194.030334 
	C463.409424,191.623978 463.357697,189.217606 463.427734,186.432968 
	C465.779846,186.714661 468.010162,187.374603 470.649292,188.277008 
	C471.058105,188.519455 471.106598,188.922394 471.106598,188.922394 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M364.984039,133.990692 
	C364.984039,133.990692 365.006989,133.527481 364.914337,133.314896 
	C368.405182,132.479401 368.012756,135.026428 368.015839,137.172668 
	C368.033051,149.136093 368.022644,161.099548 367.684601,173.532288 
	C366.916626,174.000015 366.485687,173.998459 365.991089,173.532135 
	C365.900208,162.486969 365.873016,151.906540 365.842468,140.921570 
	C365.820038,140.247925 365.800964,139.978821 365.811798,139.340775 
	C365.569855,137.559189 365.297974,136.146576 365.026642,134.547516 
	C365.027191,134.361084 364.984039,133.990692 364.984039,133.990692 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M672.338867,311.145081 
	C670.006775,309.920105 668.024048,308.846252 666.020630,307.386200 
	C666.000000,307.000000 665.998962,307.000519 666.302612,306.998077 
	C666.807617,306.974823 667.009033,306.954010 667.210388,306.933228 
	C667.210388,306.933228 667.635742,306.964508 668.097778,307.291504 
	C670.686157,307.462341 672.812500,307.306213 674.938782,307.150085 
	C676.273743,307.078796 677.608765,307.007507 679.684448,306.954346 
	C680.644470,306.985901 680.863831,306.999329 681.083252,307.012756 
	C682.123108,308.039825 682.996216,309.521301 684.244812,309.979462 
	C685.821472,310.557922 687.704163,310.302246 689.727417,310.703247 
	C689.999939,311.000092 690.018494,310.979218 690.018494,310.979218 
	C684.288940,313.665710 678.514099,313.878540 672.338867,311.145081 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M473.933228,712.393921 
	C477.402985,711.948364 480.854431,711.837585 484.668732,711.914856 
	C484.270691,719.256531 480.331604,720.818542 472.644989,716.659912 
	C473.050476,715.404663 473.482666,714.066650 473.933228,712.393921 
z"/>
<path fill="#F0D5B6" opacity="1.000000" stroke="none" 
	d="
M421.023315,269.010773 
	C420.662231,267.590881 420.301178,266.171021 419.969116,264.400543 
	C424.685089,264.062836 429.372070,264.075745 434.571106,264.438232 
	C435.117706,264.997650 435.152252,265.207428 435.204041,265.784302 
	C435.391937,267.369659 435.562561,268.587891 435.245483,269.878052 
	C431.110748,269.800720 427.231873,270.993835 424.090057,267.826782 
	C423.780365,267.514557 422.078827,268.583099 421.023315,269.010773 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M876.038940,624.527710 
	C876.406006,625.309326 876.957031,626.548096 876.959351,627.787964 
	C877.005432,652.318909 876.990601,676.849854 876.969360,701.380859 
	C876.968811,702.027710 876.758789,702.674438 876.377930,703.624512 
	C876.062012,677.613647 876.014709,651.299500 876.038940,624.527710 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M658.569336,209.663269 
	C634.930786,209.953888 611.023682,209.953156 587.116577,209.924866 
	C585.305115,209.922729 583.493958,209.724976 581.391479,209.339661 
	C605.353821,209.064194 629.607361,209.062103 653.860901,209.082901 
	C655.340942,209.084167 656.820801,209.266769 658.569336,209.663269 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M700.035034,251.658966 
	C700.127136,252.718964 699.912659,253.486542 699.641785,254.233673 
	C699.085999,255.766541 698.499939,257.288452 697.926392,258.814880 
	C696.159912,257.991638 694.393494,257.168365 692.326050,255.819702 
	C692.023010,254.895935 692.020935,254.497559 691.801697,253.777588 
	C690.051147,253.315735 688.517761,253.175507 686.610718,253.008835 
	C685.740723,253.027954 685.244324,253.073517 684.317505,253.096527 
	C682.435730,252.930099 680.984375,252.786224 679.842407,252.454926 
	C681.719421,251.911636 683.287170,251.555756 684.854858,251.199890 
	C689.804199,251.252350 694.753601,251.304825 700.035034,251.658966 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M462.981873,162.977615 
	C463.089417,162.657318 463.281433,162.400085 463.777649,162.099487 
	C464.630737,162.630295 465.804474,163.259521 465.814026,163.906021 
	C465.911530,170.484741 465.845062,177.066757 465.721863,183.645920 
	C465.713715,184.079849 464.867432,184.498062 463.977417,184.988403 
	C463.543823,179.844376 463.543823,174.635483 463.543823,168.901260 
	C460.814484,168.901260 458.894226,168.901260 456.742950,168.622192 
	C457.087036,168.185013 457.662140,168.026886 458.635254,167.876129 
	C463.228180,168.565125 463.435120,166.037064 462.981873,162.977615 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M150.885162,255.937057 
	C151.481277,255.845779 151.761765,255.907974 152.459320,256.072968 
	C152.270233,259.050690 151.184082,261.917877 151.137558,264.801849 
	C150.878433,280.865173 150.871262,296.932617 150.826019,313.454590 
	C150.584610,311.635223 150.098007,309.365051 150.037857,307.083649 
	C149.675034,293.322693 149.307144,279.560089 149.188049,265.795868 
	C149.160095,262.565002 150.083710,259.325867 150.885162,255.937057 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M604.038513,381.499512 
	C604.048828,381.034332 604.472473,381.019470 604.683472,381.024689 
	C604.935059,401.815887 604.932068,422.602112 605.061035,443.387543 
	C605.081421,446.676056 605.697510,449.960876 606.043945,453.683716 
	C605.380127,453.193329 604.710571,452.266602 603.966248,450.985046 
	C603.937012,427.741730 603.982605,404.853210 604.038513,381.499512 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M553.074646,162.279953 
	C557.105042,161.841248 561.208374,161.799667 565.302124,161.580017 
	C568.012817,161.434555 570.709900,161.033768 573.666870,160.502625 
	C574.259277,160.648758 574.597839,161.039566 574.954956,161.711212 
	C574.469421,162.250534 573.965332,162.509048 572.789612,162.903076 
	C570.784180,163.888779 569.450439,164.738922 568.116699,165.589096 
	C569.715820,166.350327 571.315002,167.111542 572.914124,167.872757 
	C572.937744,168.054916 572.961304,168.237076 572.530029,168.722900 
	C565.375061,168.974625 558.674988,168.922684 551.974915,168.870728 
	C552.303589,168.605667 552.632263,168.340637 553.635620,167.970291 
	C556.217651,167.652084 559.271729,168.812271 558.616516,165.221619 
	C558.445068,164.282120 555.802429,163.772659 554.270447,163.122726 
	C554.011108,163.012726 553.628723,163.193024 553.303162,163.239197 
	C553.249939,163.026581 553.196716,162.813980 553.074646,162.279953 
M561.358948,167.027222 
	C562.842529,166.836136 564.326050,166.645035 565.809631,166.453934 
	C565.229431,165.325287 564.649231,164.196640 564.069031,163.067993 
	C563.077637,164.135406 562.086182,165.202805 561.358948,167.027222 
z"/>
<path fill="#514546" opacity="1.000000" stroke="none" 
	d="
M684.480347,251.110428 
	C683.287170,251.555756 681.719421,251.911636 679.838623,252.477905 
	C679.525452,252.688278 679.521667,252.663239 679.521667,252.663239 
	C673.873596,252.555923 668.224121,252.489319 662.578979,252.296951 
	C661.742554,252.268448 660.926270,251.645996 660.100708,251.298340 
	C660.645447,250.790543 661.190186,250.282745 662.030396,249.509674 
	C669.585815,249.836609 676.845886,250.428802 684.480347,251.110428 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M627.862244,259.325684 
	C635.812988,259.150604 643.617371,259.289734 651.722778,259.722717 
	C647.485901,260.330658 642.951050,260.701172 638.409119,260.936310 
	C635.956055,261.063293 633.491028,260.958893 630.944519,260.958893 
	C630.164978,263.073822 629.488708,264.908539 628.812439,266.743256 
	C628.142761,266.617981 627.473145,266.492706 626.803528,266.367432 
	C627.107666,264.124939 627.411804,261.882416 627.862244,259.325684 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M906.464111,503.815125 
	C906.323975,497.434052 906.058533,491.050781 906.172607,484.674286 
	C906.190613,483.666046 907.921814,482.688416 908.860901,481.696655 
	C909.360779,481.927917 909.860596,482.159180 910.360413,482.390442 
	C909.876953,489.580017 909.393433,496.769623 908.604248,504.293030 
	C907.687012,504.356262 907.075562,504.085693 906.464111,503.815125 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M364.485565,277.949585 
	C363.885284,277.980408 363.285004,278.011200 361.907715,278.037170 
	C353.516266,278.020233 345.899017,278.111206 338.289795,277.905884 
	C336.827820,277.866455 335.397308,276.663177 333.952271,275.996796 
	C333.952271,275.996796 334.004333,275.502258 333.989777,275.254089 
	C334.168518,275.017151 334.361847,275.028381 335.133972,275.357544 
	C345.321716,275.468231 354.930664,275.261017 364.560852,275.416138 
	C364.549896,276.502167 364.517731,277.225891 364.485565,277.949585 
z"/>
<path fill="#F0D5B6" opacity="1.000000" stroke="none" 
	d="
M872.958801,187.152634 
	C879.265137,187.078018 885.571472,187.003387 892.322876,186.887482 
	C892.780090,187.085693 892.792297,187.325165 892.359009,187.911240 
	C888.367737,187.552109 885.697937,187.946167 886.094971,192.734406 
	C885.171875,193.217590 884.591064,193.586411 883.613586,194.040833 
	C882.141357,194.068756 881.065796,194.011093 879.795532,193.698730 
	C878.998413,193.245880 878.395935,193.047729 877.839233,192.445862 
	C878.696472,187.778030 876.110413,187.693069 873.054321,187.895996 
	C873.019348,187.648636 872.958801,187.152634 872.958801,187.152634 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M364.539612,275.053772 
	C354.930664,275.261017 345.321716,275.468231 335.421417,275.399475 
	C342.537506,275.085876 349.954102,274.815674 357.348602,275.106812 
	C361.172821,275.257385 362.214813,273.867310 362.197174,270.334290 
	C362.185974,268.095367 363.045471,265.852051 363.738892,263.827362 
	C363.779053,265.820831 363.594879,267.597656 363.377747,269.692108 
	C366.060669,269.920410 368.631500,270.139160 371.138611,270.616516 
	C369.399506,271.747986 367.724152,272.620789 365.750824,273.705292 
	C365.148438,274.295929 364.844025,274.674866 364.539612,275.053772 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M618.369629,368.200134 
	C621.730469,364.301483 626.143921,365.072418 630.348877,365.096375 
	C644.997925,365.179779 659.646606,365.308899 674.160400,365.740540 
	C658.432617,366.074890 642.838379,365.983673 627.249390,366.229858 
	C625.168335,366.262726 623.114380,368.004578 620.796814,369.041748 
	C620.091980,369.401703 619.638184,369.674988 619.184448,369.948273 
	C618.913208,369.459930 618.642029,368.971558 618.369629,368.200134 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M514.975586,712.473816 
	C518.072632,711.956726 521.184509,711.838867 524.660400,711.891846 
	C524.630920,713.124573 524.538574,714.551514 523.783081,715.174622 
	C522.042542,716.610352 519.979736,717.655396 518.047729,718.858948 
	C517.028625,716.863647 516.009460,714.868408 514.975586,712.473816 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M366.054810,173.996902 
	C366.485687,173.998459 366.916626,174.000015 367.670624,174.000778 
	C368.002228,184.354141 368.010742,194.708282 368.004761,205.530838 
	C367.559540,205.997955 367.128845,205.996674 366.303345,205.534943 
	C365.957275,194.715302 366.006042,184.356110 366.054810,173.996902 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M716.584351,345.918091 
	C717.874390,345.615143 719.620911,345.093445 721.369324,345.087250 
	C739.652039,345.022430 757.934937,345.040253 776.706604,345.033691 
	C777.166382,345.263550 777.137451,345.494904 777.048950,346.073242 
	C766.173157,346.260925 755.357361,346.050049 744.540527,345.958099 
	C735.374817,345.880219 726.208008,345.939880 716.584351,345.918091 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M165.964661,718.626221 
	C165.217041,719.037415 164.494766,719.028442 163.411865,719.031250 
	C163.042206,717.267395 162.817413,715.460388 163.069763,713.722595 
	C163.571808,710.265381 161.976425,708.616028 158.401840,708.013855 
	C159.425659,707.077026 160.834244,706.191650 162.848785,705.171753 
	C163.646210,705.063538 163.837631,705.089905 164.088699,705.446167 
	C165.126297,706.877136 166.104233,707.978149 167.082169,709.079163 
	C166.718109,712.121460 166.354050,715.163757 165.964661,718.626221 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M333.679016,276.188965 
	C335.397308,276.663177 336.827820,277.866455 338.289795,277.905884 
	C345.899017,278.111206 353.516266,278.020233 361.607544,278.056610 
	C362.068787,278.252808 362.053162,278.424805 361.999268,279.091583 
	C361.960999,279.586395 361.806580,280.043182 361.806580,280.043182 
	C352.855865,280.008789 343.905182,279.974396 334.390747,279.751678 
	C333.692871,279.308228 333.499023,279.112061 333.245483,278.974823 
	C333.298920,278.110260 333.352356,277.245667 333.679016,276.188965 
z"/>
<path fill="#E9DCC3" opacity="1.000000" stroke="none" 
	d="
M435.186798,265.417236 
	C435.152252,265.207428 435.117706,264.997650 435.035095,264.474182 
	C437.494537,263.979767 440.002045,263.799072 442.414307,264.224884 
	C442.214569,279.795013 442.097046,294.758636 442.044342,309.722412 
	C442.041748,310.456696 442.605286,311.192963 442.905212,311.928284 
	C442.896393,312.277740 442.757385,312.563934 442.263123,312.880676 
	C441.739899,312.770569 441.441711,312.566650 441.041107,311.654297 
	C440.902222,300.349945 440.865814,289.753998 440.925537,278.696259 
	C440.897766,275.673096 440.773834,273.111755 440.657104,270.151611 
	C440.664337,268.248016 440.664337,266.743256 440.664337,264.845978 
	C438.339783,265.088409 436.763275,265.252808 435.186798,265.417236 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M100.823883,408.680603 
	C100.560989,409.090485 100.308601,409.111053 99.871964,409.186340 
	C96.716454,398.582397 97.275574,388.494568 104.535881,379.393372 
	C99.986427,388.533813 98.558464,398.137360 100.823883,408.680603 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M656.876038,249.175125 
	C657.615967,252.571121 655.695679,253.025482 652.941956,252.980057 
	C645.327454,252.854401 637.710510,252.880112 629.647095,252.888123 
	C636.153076,252.249008 643.110901,251.609238 650.056763,250.858994 
	C651.934814,250.656128 653.776611,250.118637 656.061890,249.412842 
	C656.488708,249.090958 656.876038,249.175125 656.876038,249.175125 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M501.062622,195.546722 
	C501.384918,196.819397 501.954987,198.550568 501.964294,200.284729 
	C502.044464,215.225357 502.023499,230.166550 502.059998,245.581787 
	C501.716705,244.351730 501.031647,242.648727 501.024811,240.942993 
	C500.964691,225.964478 501.025452,210.985474 501.062622,195.546722 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M714.045410,301.520844 
	C714.051514,315.704254 714.033203,329.452026 713.999329,343.685608 
	C713.635681,342.808350 712.986938,341.445526 712.985779,340.082214 
	C712.973450,325.061279 713.061890,310.040222 713.340454,294.544006 
	C713.557861,294.068817 713.939636,294.081482 713.939636,294.081482 
	C713.966736,296.416046 713.993835,298.750610 714.045410,301.520844 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M433.154358,432.381897 
	C433.616974,431.408417 434.018250,430.898224 434.613770,430.232971 
	C436.625702,431.371185 438.443390,432.664429 440.624512,433.963867 
	C438.579468,436.637939 436.170959,439.305847 433.455811,442.102142 
	C433.130493,439.102112 433.111786,435.973633 433.154358,432.381897 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M117.386337,496.443573 
	C110.058746,497.311371 102.976173,498.144409 95.494446,498.962372 
	C102.226494,494.720276 109.551880,492.217194 117.386337,496.443573 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M442.945312,311.466064 
	C442.605286,311.192963 442.041748,310.456696 442.044342,309.722412 
	C442.097046,294.758636 442.214569,279.795013 442.567932,264.531433 
	C442.872986,279.822235 442.929199,295.413025 442.945312,311.466064 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M144.092239,365.638763 
	C134.843124,364.381805 125.513489,364.186859 116.341599,368.945374 
	C121.304451,363.234314 128.419067,363.269348 135.362671,363.319183 
	C138.200546,363.339539 141.029465,364.609802 144.092239,365.638763 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M167.504745,709.049683 
	C166.104233,707.978149 165.126297,706.877136 164.463486,705.423218 
	C165.274445,705.137329 165.770279,705.204407 166.532928,705.487183 
	C170.549149,705.162964 174.298523,704.622986 178.191956,704.364746 
	C179.242905,705.116211 180.149765,705.585876 181.056610,706.055542 
	C180.412216,706.678772 179.831177,707.748413 179.112808,707.850342 
	C175.403671,708.376709 171.659363,708.655151 167.504745,709.049683 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M663.472656,321.100708 
	C662.614807,321.089233 662.170166,321.050629 661.366943,321.001862 
	C661.008301,320.991730 661.007751,320.943237 661.007751,320.943237 
	C662.173950,319.312042 660.220093,315.571777 664.723633,315.921204 
	C667.119385,315.729797 669.167053,315.578400 671.415405,315.412140 
	C670.259338,319.396332 668.278870,321.847595 663.472656,321.100708 
z"/>
<path fill="#A15F68" opacity="1.000000" stroke="none" 
	d="
M986.496826,380.950104 
	C986.162964,366.148743 986.106812,351.009247 986.040283,335.395996 
	C986.307983,335.488464 986.828247,336.054474 986.828857,336.621002 
	C986.843689,351.284637 986.804504,365.948303 986.496826,380.950104 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M906.288452,504.219238 
	C907.075562,504.085693 907.687012,504.356262 908.531189,504.725220 
	C908.497742,508.699554 908.231567,512.575500 907.867493,516.799683 
	C907.199219,517.161438 906.628723,517.174988 905.776917,517.216431 
	C905.701294,513.037354 905.906982,508.830353 906.288452,504.219238 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M211.527161,507.146423 
	C211.614273,510.105713 211.308990,513.133606 211.006012,516.917175 
	C211.017487,518.109375 211.026657,518.545898 211.035828,518.982422 
	C211.061523,522.341980 211.087234,525.701538 211.178802,529.512817 
	C211.195923,533.020264 211.147186,536.076111 211.096100,539.592163 
	C209.285370,539.902771 207.476990,539.753235 205.407867,539.346069 
	C208.849564,539.517578 210.114426,537.873230 210.017654,534.190002 
	C209.821182,526.711731 209.942810,519.222473 210.076797,511.740265 
	C210.103912,510.226013 210.765625,508.723145 211.527161,507.146423 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M659.107544,278.552521 
	C658.226624,278.792847 657.438843,278.644714 656.450806,278.458954 
	C656.946472,277.037354 657.438599,275.626007 658.056274,273.854340 
	C662.031738,273.854340 666.092346,273.854340 670.539307,273.866272 
	C669.427307,274.894196 668.053467,276.280670 666.400330,276.836456 
	C664.110474,277.606293 661.610596,277.751434 659.107544,278.552521 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M681.343018,306.831665 
	C680.863831,306.999329 680.644470,306.985901 680.096497,306.944519 
	C678.105591,306.276215 676.397949,305.730652 674.796021,304.964142 
	C673.608276,304.395874 672.557983,303.540466 671.602173,302.482788 
	C675.974792,302.342194 680.506653,300.479004 684.200256,303.685120 
	C683.217834,304.806732 682.410339,305.728668 681.343018,306.831665 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M421.190002,232.291077 
	C434.363342,232.131897 447.863708,232.250046 461.658875,232.653992 
	C448.474762,232.815994 434.995911,232.692200 421.190002,232.291077 
z"/>
<path fill="#EEECD3" opacity="1.000000" stroke="none" 
	d="
M465.070343,713.355835 
	C466.128510,712.966187 467.167145,712.980652 468.596680,712.994141 
	C469.537872,716.168091 470.088226,719.342957 470.697540,722.858032 
	C464.408325,722.060608 466.636047,716.782043 465.070343,713.355835 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M317.129517,252.175079 
	C308.074554,252.341248 298.592041,252.475861 288.802124,252.431671 
	C297.897156,252.216431 307.299591,252.179977 317.129517,252.175079 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M465.943146,229.476913 
	C465.606018,227.378586 465.076172,224.822235 465.042969,222.259445 
	C464.933807,213.824265 465.004517,205.386734 465.101654,196.274109 
	C465.370575,195.331573 465.608215,195.148514 465.910126,195.048904 
	C465.932709,206.371246 465.955292,217.693588 465.943146,229.476913 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M954.182495,490.539642 
	C948.039673,490.913788 941.712402,490.940796 934.901489,490.951508 
	C940.836182,487.829071 947.381653,488.076141 954.182495,490.539642 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M431.851868,343.628723 
	C426.409973,343.990387 420.681091,344.066956 414.157074,344.167297 
	C412.911835,344.107574 412.461670,344.024139 412.011536,343.940674 
	C412.279816,343.451385 412.548096,342.962067 412.919128,342.212952 
	C419.202911,342.416656 425.383850,342.880127 431.851868,343.628723 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M656.926697,248.692444 
	C656.876038,249.175125 656.488708,249.090958 656.291138,249.087372 
	C656.069458,238.375717 656.045471,227.667648 656.025513,216.494247 
	C656.345764,219.386841 656.661987,222.744766 656.980591,226.556534 
	C656.981018,234.076828 656.979187,241.143295 656.926697,248.692444 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M471.564880,188.930725 
	C471.106598,188.922394 471.058105,188.519455 471.063599,188.317474 
	C480.823120,187.884247 490.577118,187.653000 500.682617,187.174591 
	C502.720276,190.350494 499.745300,188.889038 498.756012,188.899033 
	C489.845825,188.989044 480.934265,188.944275 471.564880,188.930725 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M886.437134,192.620041 
	C885.697937,187.946167 888.367737,187.552109 892.306396,188.267029 
	C892.736389,189.199432 892.773560,190.122620 892.803101,191.392181 
	C892.494080,191.796265 892.240295,191.938797 891.564819,192.476349 
	C889.542664,192.731033 887.989929,192.675537 886.437134,192.620041 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M333.194885,279.443970 
	C333.499023,279.112061 333.692871,279.308228 333.923340,279.749512 
	C333.987030,290.255951 333.954437,300.576294 333.821655,311.335266 
	C333.496124,303.616425 333.247925,295.459442 333.059387,287.301117 
	C333.002502,284.840393 333.111359,282.375885 333.194885,279.443970 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M361.887817,280.503235 
	C361.806580,280.043182 361.960999,279.586395 362.010040,279.350403 
	C362.249451,289.465332 362.439819,299.816254 362.401245,310.492035 
	C362.104523,300.865692 362.036774,290.914490 361.887817,280.503235 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M559.971069,712.474304 
	C561.725586,711.746277 563.504517,711.391968 565.686340,711.076538 
	C566.071167,711.440063 566.158569,711.822205 566.017822,712.079773 
	C565.129028,713.707092 564.189697,715.306824 563.267090,716.915649 
	C562.176514,715.559753 561.085999,714.203918 559.971069,712.474304 
z"/>
<path fill="#684347" opacity="1.000000" stroke="none" 
	d="
M777.082886,349.488892 
	C777.336670,359.082489 777.495300,369.137024 777.450684,379.537537 
	C777.160889,369.905640 777.074280,359.927734 777.082886,349.488892 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M649.957886,326.185120 
	C655.514893,326.136810 660.959717,326.281525 666.707153,326.713104 
	C667.009766,327.000000 667.000488,327.002075 666.792725,327.100403 
	C666.325378,327.370361 666.136780,327.600220 666.019165,327.888306 
	C664.939697,327.905457 663.860291,327.922638 662.226929,327.725433 
	C661.124390,327.646179 660.575867,327.781281 660.027283,327.916412 
	C656.866272,327.679413 653.705261,327.442383 650.162842,327.012634 
	C649.781433,326.819855 649.845764,326.378113 649.957886,326.185120 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M181.462952,706.045410 
	C180.149765,705.585876 179.242905,705.116211 178.651917,704.340088 
	C183.662231,704.346313 188.356674,704.658936 193.051117,704.971619 
	C190.963211,705.316833 188.875290,705.662048 186.361084,706.037476 
	C184.579620,706.056824 183.224442,706.046021 181.462952,706.045410 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M671.062805,271.861572 
	C667.584717,272.084198 664.401794,272.084198 661.218872,272.084198 
	C661.153870,271.657013 661.088867,271.229828 661.023926,270.802612 
	C662.430298,270.404449 663.836670,270.006256 665.505188,269.370392 
	C667.678955,269.860809 671.465149,266.407318 671.062805,271.861572 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M76.957390,539.725098 
	C67.952408,540.002258 58.912746,539.997437 49.395863,539.984253 
	C51.795395,539.635986 54.666271,539.079407 57.550129,539.001160 
	C63.685043,538.834656 69.826706,538.916626 76.423584,538.886475 
	C76.895287,539.065186 76.909004,539.254150 76.957390,539.725098 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M691.233337,337.666687 
	C691.039185,337.216827 691.292664,336.899994 691.677734,336.426880 
	C694.041199,335.644104 696.273010,335.017639 698.669067,334.037170 
	C699.241455,334.850433 699.649719,336.017700 700.273010,337.799713 
	C696.843201,337.799713 694.262085,337.799713 691.233337,337.666687 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M699.069092,317.552643 
	C699.231384,320.834229 699.396484,324.566559 699.312195,328.600861 
	C699.065857,325.269684 699.068848,321.636536 699.069092,317.552643 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M634.037231,339.484070 
	C634.383118,339.964264 634.262024,340.226624 634.067383,340.680420 
	C632.156372,340.541016 630.262878,340.184204 628.358154,339.467407 
	C630.106812,339.169006 631.866638,339.230560 634.037231,339.484070 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M619.190063,370.350189 
	C619.638184,369.674988 620.091980,369.401703 620.829285,369.387024 
	C621.095520,370.106781 621.078247,370.567963 621.060913,371.029144 
	C620.833679,371.907440 620.606384,372.785706 620.125305,373.770142 
	C619.646179,372.834869 619.420898,371.793488 619.190063,370.350189 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M663.445923,288.036652 
	C663.072571,287.853302 663.060974,287.616364 663.010132,287.025391 
	C664.871399,286.583191 666.771790,286.494995 667.378052,286.466858 
	C666.922974,286.660095 665.365295,287.321564 663.445923,288.036652 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M632.695251,336.109222 
	C633.106506,336.475281 633.164673,336.771667 633.281799,337.286621 
	C632.023193,337.035828 630.736511,336.560394 629.739441,335.846069 
	C630.789795,335.753357 631.550476,335.899475 632.695251,336.109222 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M697.293213,340.994202 
	C696.996643,340.592865 696.912415,340.320984 696.625305,339.883057 
	C697.352844,339.492859 698.153259,339.308990 699.366821,339.100342 
	C699.065125,339.744843 698.350281,340.414124 697.293213,340.994202 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M465.920837,194.776672 
	C465.608215,195.148514 465.370575,195.331573 465.100189,195.806366 
	C464.662598,195.997269 464.321991,195.979874 463.725586,195.964905 
	C463.418701,195.535294 463.367584,195.103241 463.388794,194.350769 
	C464.062744,194.013611 464.664307,193.996872 465.562988,193.972198 
	C465.883911,194.144318 465.907715,194.324371 465.920837,194.776672 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M115.625641,368.885315 
	C115.233963,369.605438 114.498489,370.249146 113.463158,370.943542 
	C113.869484,370.265778 114.575668,369.537323 115.625641,368.885315 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M655.085938,213.248840 
	C655.491333,212.876556 656.025208,212.740402 656.559082,212.604248 
	C656.520691,213.046707 656.482239,213.489166 656.193726,214.106323 
	C655.700562,214.015671 655.457458,213.750320 655.085938,213.248840 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M372.782227,340.068665 
	C372.384338,340.294800 371.830261,340.376068 371.144226,340.243652 
	C371.550201,339.994598 372.088165,339.959229 372.782227,340.068665 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M713.965393,293.712036 
	C713.939636,294.081482 713.557861,294.068817 713.368713,294.082458 
	C713.125122,293.012726 713.070740,291.929382 713.041504,290.441864 
	C713.374878,291.139343 713.682983,292.240967 713.965393,293.712036 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M616.683472,467.213654 
	C616.529663,467.742889 616.107178,468.344238 615.388977,469.022980 
	C615.053467,468.924805 615.013672,468.749237 614.942505,468.305176 
	C615.412354,467.786346 615.913635,467.536041 616.683472,467.213654 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M279.531342,246.040588 
	C279.485596,246.336090 279.355804,246.775681 279.199524,247.383484 
	C279.264435,247.096024 279.355865,246.640335 279.531342,246.040588 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M933.639465,490.962677 
	C933.127197,491.257355 932.253540,491.576477 931.004395,491.901306 
	C931.511902,491.600372 932.395020,491.293762 933.639465,490.962677 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M689.989746,311.009644 
	C690.408386,311.159637 690.837280,311.300049 691.266113,311.440430 
	C691.155029,311.705078 691.044006,311.969696 690.932922,312.234344 
	C690.653015,311.975555 690.373108,311.716766 690.055847,311.218628 
	C690.018494,310.979218 689.999939,311.000092 689.989746,311.009644 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M278.590729,248.684555 
	C278.549622,248.684738 278.521362,248.851776 278.551941,248.855331 
	C278.582550,248.858887 278.631836,248.684372 278.590729,248.684555 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M660.351074,327.941467 
	C660.575867,327.781281 661.124390,327.646179 661.822144,327.710693 
	C661.539185,327.929047 661.107056,327.947784 660.351074,327.941467 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M653.277283,288.652863 
	C653.558716,288.427795 654.142212,288.257568 655.033691,288.178955 
	C654.754211,288.416290 654.166748,288.562012 653.277283,288.652863 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M646.445679,326.979340 
	C646.692139,326.758209 647.302124,326.522705 648.084900,326.555328 
	C647.774841,326.870636 647.291992,326.917786 646.445679,326.979340 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M666.235718,327.811157 
	C666.136780,327.600220 666.325378,327.370361 666.790955,327.104248 
	C666.903931,327.317871 666.722412,327.559296 666.235718,327.811157 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M661.909302,288.311615 
	C661.970032,288.143524 662.187683,288.092133 662.740112,288.065308 
	C662.738647,288.202698 662.402527,288.315491 661.909302,288.311615 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M638.408325,332.987244 
	C638.519287,333.110413 638.500671,333.072144 638.502014,333.102417 
	C638.503357,333.132721 638.578552,332.721222 638.578552,332.721222 
	C638.578552,332.721222 638.297424,332.864105 638.408325,332.987244 
z"/>
<path fill="#EEDEBE" opacity="1.000000" stroke="none" 
	d="
M234.916443,506.817596 
	C234.831223,506.993713 234.657333,506.993195 234.222443,506.984619 
	C234.250198,506.864655 234.539001,506.752777 234.916443,506.817596 
z"/>
<path fill="#F3EDD2" opacity="1.000000" stroke="none" 
	d="
M313.084900,492.300110 
	C313.280151,492.144379 313.542816,492.281921 313.873840,492.710571 
	C313.679718,492.865356 313.416443,492.729218 313.084900,492.300110 
z"/>
<path fill="#59363C" opacity="1.000000" stroke="none" 
	d="
M300.042938,531.536743 
	C302.194275,531.689575 304.327271,532.303406 307.285889,532.861206 
	C314.425781,533.132690 320.740021,533.460144 327.515320,533.825012 
	C335.944458,534.472351 343.912598,535.082275 352.023407,535.967285 
	C353.018585,536.780151 353.871033,537.317871 355.106812,538.097412 
	C353.063385,538.872620 351.529999,539.454346 349.617554,540.134155 
	C347.925629,540.451355 346.598511,540.607178 345.302368,540.900024 
	C337.942841,542.562927 337.380493,544.220764 337.891968,551.638550 
	C338.477173,560.125671 340.893402,566.494812 350.181976,568.168518 
	C350.485504,568.223206 350.733673,568.536194 351.031036,568.680542 
	C362.388824,574.192505 374.423706,574.867004 386.433624,572.301086 
	C395.136902,570.441650 403.529968,567.101562 412.018463,564.291992 
	C413.529602,563.791809 415.266846,562.974121 416.151337,561.758545 
	C419.550629,557.086670 421.995209,552.062561 419.903229,545.997925 
	C417.599091,539.318176 412.079559,539.274475 406.460876,539.362488 
	C394.983307,539.542358 383.505554,539.713867 372.018677,539.562744 
	C372.379395,538.025574 372.749329,536.814514 373.541809,535.482910 
	C377.643250,534.239990 381.322113,533.117493 385.000977,531.994995 
	C386.596008,531.658752 388.188751,531.044495 389.786438,531.031433 
	C400.389343,530.944580 410.994232,530.907837 421.596283,531.036865 
	C424.578339,531.073120 427.561157,532.084045 430.529602,532.018066 
	C440.061981,531.806274 449.587830,531.299744 459.741699,531.269653 
	C460.577087,535.753296 460.786957,539.874207 460.746704,543.787476 
	C459.500244,543.053955 458.118439,541.824707 457.573944,542.123169 
	C455.138153,543.458252 452.463745,544.835571 450.748688,546.917114 
	C445.940216,552.753113 441.563232,558.944641 437.016022,564.995911 
	C423.516754,568.308594 409.885681,571.166443 396.546478,575.031433 
	C371.198273,582.376038 347.275909,593.088562 326.842773,610.018921 
	C314.784088,620.010437 304.135895,631.643433 301.702972,648.311035 
	C301.589905,649.085571 300.971680,649.786377 300.304108,650.747437 
	C300.021179,611.314880 300.022888,571.656372 300.042938,531.536743 
z"/>
<path fill="#3E2329" opacity="1.000000" stroke="none" 
	d="
M467.065491,689.572632 
	C466.153931,687.279236 465.447754,684.876892 464.298553,682.709534 
	C454.570801,664.362976 445.727112,645.629822 439.480011,625.778442 
	C438.044739,621.217529 437.170410,616.480042 436.398041,611.410095 
	C437.789886,610.543701 438.966248,610.278076 439.830841,609.609375 
	C448.163696,603.164368 452.450287,594.150574 455.984070,584.539185 
	C460.713470,571.676025 461.515930,558.393372 461.324280,545.070190 
	C462.503662,546.815857 463.384216,548.399292 464.348755,550.369263 
	C464.925781,557.346680 465.120911,563.980835 466.069794,570.505432 
	C466.412903,572.864685 468.562012,574.961304 469.913971,577.152283 
	C469.940948,577.126831 469.919098,577.055847 470.050110,577.346863 
	C470.782471,577.806885 471.383881,577.975952 472.325012,578.375244 
	C487.405945,578.677856 502.147125,578.750122 516.954590,579.291992 
	C517.127441,582.534546 517.234070,585.307495 517.222778,588.394897 
	C515.933777,590.228821 514.762878,591.748230 513.103027,593.126709 
	C500.403809,593.027527 488.193481,593.069153 475.599274,593.056274 
	C473.948120,594.078552 471.698395,595.062744 471.586639,596.248474 
	C471.143463,600.949341 471.072968,605.742676 471.538452,610.434814 
	C471.667542,611.735596 473.956940,613.231567 475.560211,613.860535 
	C477.145294,614.482300 479.115906,614.121338 480.955261,614.589600 
	C482.326965,616.046875 483.530548,617.706360 485.023926,618.030334 
	C487.536224,618.575439 490.232574,618.272156 492.821075,618.678833 
	C489.654968,628.464905 486.472076,637.882507 483.394836,647.334595 
	C478.884491,661.188232 474.449768,675.066589 469.610229,688.977661 
	C468.513580,689.204895 467.789520,689.388794 467.065491,689.572632 
z"/>
<path fill="#4D2F36" opacity="1.000000" stroke="none" 
	d="
M461.025452,544.907959 
	C461.515930,558.393372 460.713470,571.676025 455.984070,584.539185 
	C452.450287,594.150574 448.163696,603.164368 439.830841,609.609375 
	C438.966248,610.278076 437.789886,610.543701 436.394379,611.005981 
	C432.731720,597.044373 431.721466,583.095215 436.356262,569.179810 
	C436.715271,568.101929 436.799561,566.932434 437.013794,565.400757 
	C441.563232,558.944641 445.940216,552.753113 450.748688,546.917114 
	C452.463745,544.835571 455.138153,543.458252 457.573944,542.123169 
	C458.118439,541.824707 459.500244,543.053955 460.765198,544.015381 
	C461.033875,544.450867 461.025452,544.907959 461.025452,544.907959 
z"/>
<path fill="#CBBB9F" opacity="1.000000" stroke="none" 
	d="
M466.915741,689.877991 
	C467.789520,689.388794 468.513580,689.204895 469.895477,689.251221 
	C473.930359,695.000122 472.051544,700.001465 469.036438,704.890991 
	C465.878571,705.109314 462.720673,705.327576 459.277710,705.260559 
	C458.889496,704.668335 458.686005,704.096252 458.697479,704.091980 
	C465.170898,701.640869 464.559814,695.091431 466.915741,689.877991 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M305.278564,281.972565 
	C305.383728,279.188568 305.488892,276.404541 306.172363,273.268372 
	C307.494202,272.851715 308.237762,272.787170 308.981293,272.722656 
	C310.491821,277.386658 312.002350,282.050659 313.760620,287.479706 
	C314.011658,282.187317 314.228851,277.608368 314.446045,273.029419 
	C314.963715,273.021301 315.481384,273.013153 315.999023,273.005035 
	C316.363800,273.649231 317.039551,274.290344 317.046021,274.938080 
	C317.123718,282.745209 317.155792,290.554138 317.032379,298.359924 
	C317.018616,299.231934 315.975647,300.087646 315.409943,300.950928 
	C314.596863,300.340698 313.436768,299.895538 313.049957,299.082520 
	C312.431305,297.782166 312.325806,296.237701 311.987152,293.995667 
	C311.201324,290.221130 310.431702,287.247314 309.662079,284.273468 
	C309.383179,284.326324 309.104279,284.379211 308.825378,284.432068 
	C309.088898,287.308624 309.352417,290.185211 309.615906,293.061798 
	C309.445984,294.807465 309.276031,296.553162 309.071960,298.993713 
	C309.000244,300.120392 308.962646,300.552216 308.925018,300.984039 
	C308.015594,300.808197 307.106201,300.632355 306.042786,299.735229 
	C305.888794,295.981873 305.888794,292.949829 305.888794,289.917786 
	C305.084351,289.898010 304.279877,289.878235 303.475433,289.858459 
	C303.340515,291.906952 303.205597,293.955414 303.070648,296.003906 
	C302.039062,298.807343 302.003296,301.985474 297.406525,302.136261 
	C293.073486,302.278412 291.136841,300.783417 291.031769,296.762238 
	C290.880554,290.975220 290.986511,285.181915 290.930115,279.391815 
	C290.889801,275.249847 292.044220,272.036285 296.924530,272.127747 
	C301.571777,272.214874 302.903625,275.358551 303.006287,280.131439 
	C303.186920,282.646912 303.386169,284.419952 303.737335,287.544800 
	C305.078400,285.767181 305.720062,285.300415 305.737732,284.811188 
	C305.771637,283.871735 305.451691,282.919495 305.278564,281.972565 
M298.782532,296.914490 
	C298.882965,291.103882 299.103210,285.290710 298.979248,279.484894 
	C298.955444,278.370453 297.578827,277.284943 296.826324,276.186066 
	C296.170105,277.296112 294.995453,278.384186 294.947235,279.520050 
	C294.735870,284.500885 294.843933,289.495514 294.849915,294.485168 
	C294.852600,296.728882 295.160278,298.676208 298.782532,296.914490 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M252.712845,299.268524 
	C251.374924,294.631256 250.200058,290.361206 249.025208,286.091125 
	C248.537903,286.110992 248.050583,286.130829 247.563263,286.150665 
	C247.563263,291.086700 247.563263,296.022705 247.563263,300.958740 
	C246.975235,300.971771 246.387207,300.984833 245.799179,300.997864 
	C245.518784,299.884491 245.008835,298.773834 244.995453,297.657227 
	C244.911789,290.686523 244.835464,283.711670 245.024734,276.745483 
	C245.059036,275.483307 246.332764,274.254791 247.034317,273.010742 
	C247.969177,274.191864 249.302567,275.237854 249.758301,276.581482 
	C250.798477,279.648224 251.408875,282.860779 253.096298,285.901062 
	C253.096298,282.508270 252.983978,279.109283 253.170898,275.726807 
	C253.221100,274.818390 254.182358,273.960266 254.725403,273.079071 
	C255.420975,273.980225 256.699860,274.868530 256.720062,275.784576 
	C256.884674,283.250275 256.919006,290.723389 256.764099,298.189484 
	C256.700684,301.245758 255.347641,302.312225 252.712845,299.268524 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M238.118698,284.022400 
	C238.128922,280.867981 237.993698,278.193024 238.231873,275.551727 
	C238.310654,274.678101 239.351700,273.891205 239.952789,273.064667 
	C240.616913,273.821167 241.845230,274.568665 241.857483,275.335602 
	C241.974442,282.651764 242.234924,290.001953 241.596909,297.267059 
	C241.447250,298.971222 237.977570,301.710785 236.182022,301.599762 
	C234.050018,301.468048 230.453140,298.902374 230.312927,297.163879 
	C229.676620,289.274384 230.034332,281.304749 230.034332,273.363953 
	C230.626633,273.154510 231.218933,272.945099 231.811234,272.735657 
	C232.464905,274.098236 233.628143,275.440674 233.682983,276.826935 
	C233.906372,282.475067 233.640503,288.143646 233.905289,293.788269 
	C233.971100,295.191345 235.348587,296.532867 236.123169,297.902679 
	C236.786133,296.601227 237.898376,295.340790 238.021683,293.990082 
	C238.307877,290.854889 238.116547,287.676117 238.118698,284.022400 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M208.061035,291.808777 
	C207.962097,300.857361 206.265717,302.115021 196.147125,300.486694 
	C196.147125,292.050934 195.983139,283.477264 196.423279,274.934723 
	C196.463394,274.156433 200.339722,273.243561 202.504974,272.986908 
	C205.557449,272.625061 207.774796,274.146118 207.924911,277.400879 
	C208.138794,282.037842 208.030487,286.689697 208.061035,291.808777 
M199.996597,295.913452 
	C201.944519,299.545868 204.159378,297.973083 204.420364,295.393311 
	C204.982941,289.832214 204.698959,284.169434 204.460602,278.561035 
	C204.425842,277.742737 202.738205,276.994690 201.815384,276.214142 
	C201.202011,277.183838 200.091705,278.136719 200.058182,279.126099 
	C199.878738,284.423676 199.967834,289.730347 199.996597,295.913452 
z"/>
<path fill="#EDF8FD" opacity="1.000000" stroke="none" 
	d="
M182.480194,300.380066 
	C182.069702,292.560974 181.921249,285.080841 181.899658,277.600403 
	C181.893936,275.619080 181.074051,272.891541 184.609406,272.905090 
	C187.860352,272.917542 192.288788,272.022919 192.732422,276.490295 
	C193.419113,283.405182 193.689789,290.547974 192.696167,297.384705 
	C191.887070,302.951752 186.579269,300.872864 182.480194,300.380066 
M189.460876,296.605865 
	C189.619873,290.834076 189.935410,285.058533 189.796722,279.293884 
	C189.771088,278.228760 187.909866,277.207764 186.895859,276.166412 
	C186.285400,277.145752 185.177734,278.109894 185.147171,279.106995 
	C184.979767,284.567444 184.949097,290.043060 185.250992,295.492432 
	C185.286987,296.142456 187.629456,296.664703 189.460876,296.605865 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M178.980865,297.835175 
	C178.204056,299.038300 177.400269,299.820160 176.596497,300.602051 
	C173.627563,294.528992 170.960037,297.283875 167.465088,300.973846 
	C167.332138,299.361420 166.892105,297.704132 167.119980,296.144409 
	C168.053619,289.753693 169.061905,283.366486 170.349442,277.040405 
	C170.648422,275.571442 172.154480,274.348175 173.105133,273.011841 
	C173.952148,274.276947 175.301819,275.447296 175.561279,276.823212 
	C176.849976,283.657013 177.851334,290.545013 178.980865,297.835175 
M171.789673,293.636749 
	C172.784866,293.024017 174.663635,292.349426 174.625824,291.808960 
	C174.438797,289.136444 173.744995,286.499451 173.229889,283.849915 
	C172.910080,283.877808 172.590286,283.905701 172.270477,283.933594 
	C171.944687,286.963074 171.618896,289.992584 171.789673,293.636749 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M270.776855,296.243774 
	C270.347260,300.401398 267.906189,302.718445 264.434296,301.691895 
	C262.315155,301.065277 259.629974,298.217438 259.398590,296.124084 
	C258.726685,290.045624 258.917114,283.830994 259.252197,277.696167 
	C259.483032,273.470428 262.707733,271.333099 266.501862,272.170349 
	C269.637604,272.862305 270.864166,275.125824 270.030182,278.685791 
	C269.707062,278.730408 269.322144,278.903290 269.069519,278.787537 
	C267.442688,278.041901 265.844757,277.233093 264.237366,276.445038 
	C263.813843,278.296967 263.118561,280.135071 263.023743,282.003693 
	C262.830170,285.819855 262.851868,289.656952 263.013458,293.475769 
	C263.071564,294.849243 263.786530,296.194885 264.201752,297.553223 
	C265.389008,297.016571 266.536743,296.339813 267.776703,295.989685 
	C268.688965,295.732178 269.721924,295.901978 270.776855,296.243774 
z"/>
<path fill="#EDF8FD" opacity="1.000000" stroke="none" 
	d="
M217.959412,296.725220 
	C217.956451,290.429321 217.865219,284.598785 218.001862,278.773560 
	C218.045700,276.905182 218.353424,273.629120 219.122818,273.446136 
	C221.872055,272.792328 224.871384,273.190247 227.753204,273.717377 
	C219.124329,280.855927 218.879532,282.524414 226.442780,287.937683 
	C217.643768,289.181488 223.002792,296.760956 219.484100,302.035828 
	C218.765244,299.752258 218.362366,298.472443 217.959412,296.725220 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M284.152802,277.294342 
	C284.819427,275.582611 285.488129,274.331238 286.156830,273.079895 
	C286.776703,274.219818 287.905457,275.347443 287.933319,276.501678 
	C288.105347,283.623901 288.113708,290.754028 287.952759,297.876465 
	C287.925842,299.068695 286.806854,300.236237 286.192474,301.415192 
	C285.505219,300.157410 284.261200,298.915863 284.224030,297.639160 
	C284.031403,291.015930 284.146790,284.383789 284.152802,277.294342 
z"/>
<path fill="#E3F9F9" opacity="1.000000" stroke="none" 
	d="
M280.506989,272.987549 
	C281.230072,273.422882 281.849396,274.036499 281.794739,274.103973 
	C276.409241,280.749146 280.150726,288.540009 279.053680,295.707520 
	C278.784882,297.463715 278.563538,299.227173 277.642975,300.973328 
	C273.061066,292.364410 279.894684,281.831512 271.470154,272.910889 
	C275.045074,272.910889 277.566833,272.910889 280.506989,272.987549 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M303.394836,296.064117 
	C303.205597,293.955414 303.340515,291.906952 303.475433,289.858459 
	C304.279877,289.878235 305.084351,289.898010 305.888794,289.917786 
	C305.888794,292.949829 305.888794,295.981873 305.823303,299.454529 
	C305.078247,298.638184 304.398651,297.381256 303.394836,296.064117 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M309.926941,293.123383 
	C309.352417,290.185211 309.088898,287.308624 308.825378,284.432068 
	C309.104279,284.379211 309.383179,284.326324 309.662079,284.273468 
	C310.431702,287.247314 311.201324,290.221130 311.951721,293.589264 
	C311.367615,293.717377 310.802765,293.451172 309.926941,293.123383 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M304.995117,281.862000 
	C305.451691,282.919495 305.771637,283.871735 305.737732,284.811188 
	C305.720062,285.300415 305.078400,285.767181 303.737335,287.544800 
	C303.386169,284.419952 303.186920,282.646912 303.036987,280.451141 
	C303.628082,280.602783 304.169861,281.177094 304.995117,281.862000 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M308.913574,272.420959 
	C308.237762,272.787170 307.494202,272.851715 306.377197,272.928711 
	C306.951080,272.667236 307.898468,272.393280 308.913574,272.420959 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M309.154785,300.862793 
	C308.962646,300.552216 309.000244,300.120392 309.103821,299.370728 
	C309.241364,299.615784 309.312958,300.178650 309.154785,300.862793 
z"/>
<path fill="#514546" opacity="1.000000" stroke="none" 
	d="
M490.754242,408.768341 
	C484.452271,410.082153 478.150299,411.395935 471.460663,412.265137 
	C471.072998,374.611633 471.072998,337.402740 471.072998,300.189880 
	C506.166779,300.189880 540.376160,300.189880 575.082886,300.189880 
	C575.082886,340.785736 575.082886,381.024902 575.082886,421.264069 
	C573.574097,420.300446 571.944641,419.482544 570.576355,418.349274 
	C562.514832,411.672882 552.983765,409.003845 542.234253,407.656036 
	C540.056091,406.569763 538.470581,405.801147 536.820557,404.609924 
	C537.193237,401.831696 537.630493,399.476135 538.526917,397.177246 
	C544.256958,397.255798 549.531311,397.388153 554.796326,397.222809 
	C556.137024,397.180725 557.448059,396.193726 558.772766,395.640869 
	C557.378662,394.986389 556.011536,393.848907 554.585266,393.768982 
	C550.482544,393.539124 546.355896,393.736572 542.145630,393.395142 
	C544.278320,390.070343 544.370850,386.916840 543.343384,383.613098 
	C544.567871,383.593781 545.465149,383.795013 546.176575,383.518280 
	C547.205322,383.118103 548.099426,382.371735 549.051025,381.773071 
	C548.012268,381.138824 547.032349,380.127136 545.921753,379.954224 
	C544.014343,379.657288 542.025391,379.883820 540.051758,379.429993 
	C539.978394,373.615906 539.924072,368.262390 540.343994,362.887634 
	C543.950439,362.861206 547.096741,363.017609 550.205811,362.746704 
	C551.073853,362.671082 551.831909,361.333557 552.640381,360.574890 
	C551.803772,360.030853 550.977051,359.037140 550.128906,359.018494 
	C545.849915,358.924652 541.565369,359.084778 536.963440,358.976135 
	C531.443359,357.171692 526.242554,355.546906 521.015198,353.494385 
	C516.283936,352.559021 511.579285,352.051453 506.874634,351.543854 
	C506.565277,352.151093 506.255951,352.758331 505.946594,353.365601 
	C506.940857,354.275146 507.935120,355.184692 508.732788,356.359375 
	C505.872406,358.392212 503.208649,360.159912 501.689880,361.167755 
	C501.177490,364.232422 500.817932,366.383057 500.458374,368.533691 
	C500.140411,368.475800 499.822449,368.417938 499.504517,368.360077 
	C500.301331,372.177338 501.098145,375.994629 501.595703,380.032288 
	C500.489227,381.317291 499.682007,382.381927 498.932251,382.983765 
	C498.104309,380.152649 492.724182,378.538788 491.485474,380.422638 
	C491.106232,380.999420 492.070892,383.405731 492.635590,383.487579 
	C494.683350,383.784332 496.822571,383.449951 498.998962,383.766998 
	C498.365143,386.868561 494.062042,389.896729 499.681946,391.564819 
	C499.068970,393.633850 498.551117,395.381805 497.832947,397.805878 
	C500.883942,397.805878 502.986908,397.805878 505.098938,398.204163 
	C505.085358,399.133118 505.062714,399.663788 504.617371,400.239563 
	C502.303284,400.284698 500.411835,400.284698 497.826935,400.284698 
	C500.498199,402.047791 502.132477,403.126404 504.223511,404.506500 
	C502.191010,405.785889 501.086761,406.480957 499.982513,407.176056 
	C499.500610,407.229919 499.018707,407.283813 497.790039,407.336792 
	C494.946960,407.813354 492.850586,408.290863 490.754242,408.768341 
M531.162781,347.339569 
	C531.104980,346.894196 531.047180,346.448853 530.989441,345.446777 
	C530.657898,345.364807 530.326294,345.282837 529.064270,345.089691 
	C521.705872,345.129120 514.347534,345.168579 506.066956,345.173889 
	C503.429474,345.129517 500.779388,344.930023 498.162781,345.142731 
	C497.451172,345.200562 496.840576,346.500977 496.183624,347.231110 
	C496.830078,347.807831 497.462402,348.858093 498.125488,348.877869 
	C500.759216,348.956482 503.402588,348.713318 506.931213,348.884613 
	C514.617981,348.853882 522.304749,348.823120 530.540466,348.881134 
	C530.690918,348.586365 530.841370,348.291595 531.162781,347.339569 
M505.738800,335.262695 
	C506.238586,334.180786 506.738373,333.098877 507.568359,331.302155 
	C502.238403,331.302155 497.948212,331.117065 493.694489,331.428986 
	C492.595886,331.509552 491.611725,333.150238 490.574982,334.074280 
	C490.886658,334.486816 491.198364,334.899353 491.510040,335.311890 
	C495.963440,335.311890 500.416840,335.311890 505.738800,335.262695 
M504.118164,311.135498 
	C499.970703,311.132904 495.809479,310.944305 491.684784,311.249512 
	C490.556335,311.333008 489.537567,312.898193 488.468475,313.783447 
	C488.788940,314.141632 489.109406,314.499786 489.429871,314.857971 
	C494.845825,314.857971 500.261749,314.857971 506.471649,314.857971 
	C505.871216,313.346069 505.454102,312.295776 504.118164,311.135498 
M517.417480,321.060669 
	C522.004822,321.263367 526.594971,321.618500 531.177063,321.534821 
	C532.050110,321.518890 532.891541,319.768921 533.747559,318.819000 
	C528.560791,317.812134 524.417603,317.644684 520.304626,317.922943 
	C519.194702,317.998016 518.176270,319.424988 517.417480,321.060669 
M512.826050,321.641327 
	C513.442688,320.862030 514.059387,320.082703 514.676025,319.303406 
	C513.958008,318.811127 513.255249,317.921753 512.519348,317.893372 
	C508.765686,317.748718 505.003510,317.826569 501.244293,317.826569 
	C501.021088,318.416321 500.797913,319.006042 500.574707,319.595795 
	C501.721832,320.289429 502.815704,321.441742 504.026978,321.582275 
	C506.641663,321.885712 509.316620,321.669769 512.826050,321.641327 
M494.367432,321.674744 
	C495.908813,320.990173 497.450165,320.305634 498.991547,319.621094 
	C497.397461,319.017120 495.809204,318.396759 494.203888,317.824127 
	C493.911530,317.719818 493.523346,317.728149 493.224182,317.824097 
	C491.199249,318.473389 489.186310,319.160156 487.169525,319.834808 
	C489.267822,320.447296 491.366119,321.059784 494.367432,321.674744 
M511.778870,311.128326 
	C510.754028,312.024841 509.729187,312.921356 508.704346,313.817871 
	C509.032562,314.127594 509.360748,314.437286 509.688965,314.747009 
	C513.210632,314.747009 516.732300,314.747009 520.253967,314.747009 
	C520.480164,314.375549 520.706421,314.004059 520.932678,313.632599 
	C519.988342,312.799042 519.155457,311.496246 518.074219,311.239594 
	C516.362244,310.833221 514.484009,311.127197 511.778870,311.128326 
M506.318024,325.045959 
	C499.872192,325.051483 499.872192,325.051483 500.722748,329.013031 
	C502.954712,329.013031 505.260925,329.215179 507.504639,328.928436 
	C508.640442,328.783264 509.663391,327.754791 510.737366,327.125641 
	C509.563049,326.432190 508.388702,325.738739 506.318024,325.045959 
M516.615479,328.990967 
	C518.710815,328.990967 520.806091,328.990967 522.901428,328.990967 
	C523.167725,328.484833 523.434021,327.978668 523.700378,327.472534 
	C522.673096,326.672638 521.750000,325.472839 520.592834,325.171387 
	C519.056519,324.771057 517.301208,324.865143 515.710022,325.145081 
	C514.679810,325.326294 513.774841,326.219513 512.813782,326.793671 
	C513.767212,327.524811 514.720703,328.255981 516.615479,328.990967 
M504.153259,338.080841 
	C497.655304,338.017426 497.655304,338.017426 498.430023,341.987488 
	C500.033600,341.987488 501.668762,342.023285 503.301849,341.979797 
	C506.397766,341.897430 506.418182,340.390656 504.153259,338.080841 
M498.080750,352.122864 
	C495.821991,352.122864 493.563202,352.122864 491.304443,352.122864 
	C491.061035,352.633423 490.817657,353.144012 490.574280,353.654572 
	C491.759827,354.413727 492.913544,355.736298 494.138092,355.805511 
	C496.189117,355.921448 499.711792,357.255646 498.080750,352.122864 
z"/>
<path fill="#54BBD7" opacity="1.000000" stroke="none" 
	d="
M575.264771,421.518402 
	C575.082886,381.024902 575.082886,340.785736 575.082886,300.189880 
	C540.376160,300.189880 506.166779,300.189880 471.072998,300.189880 
	C471.072998,337.402740 471.072998,374.611633 471.092102,412.264465 
	C468.290436,414.176575 465.469635,415.644714 462.296448,417.241516 
	C461.891541,374.891144 461.863037,332.412109 461.737457,289.933319 
	C461.728180,286.793152 462.953979,285.995087 465.884186,285.999603 
	C507.698486,286.064209 549.513123,286.094604 591.327087,285.965088 
	C596.074280,285.950409 595.225281,288.920074 595.226990,291.610382 
	C595.252014,331.425720 595.256226,371.241028 595.244385,411.056366 
	C595.241577,420.384155 595.160828,429.711945 595.121704,439.506134 
	C588.567261,433.905945 582.007019,427.839325 575.264771,421.518402 
z"/>
<path fill="#54BBD7" opacity="1.000000" stroke="none" 
	d="
M415.048370,345.033386 
	C420.095337,345.482880 425.142303,345.932404 430.880554,346.443481 
	C431.245880,349.574432 431.936981,352.802399 431.949310,356.032959 
	C432.041290,380.155792 432.120392,404.280182 431.907745,428.401489 
	C431.858643,433.973267 430.667358,439.534973 429.985962,445.501740 
	C429.970306,445.902161 429.986877,445.975708 429.738464,446.117767 
	C429.341125,446.556274 429.192261,446.852753 429.043396,447.149200 
	C428.240997,448.352234 427.438599,449.555267 425.997559,450.916626 
	C423.081726,453.021698 420.804535,454.968445 418.432037,456.996704 
	C418.634918,458.249176 418.867920,459.687378 419.100922,461.125610 
	C419.100922,461.125610 419.064697,461.016357 418.727539,461.081482 
	C417.969208,462.209778 417.548065,463.272888 417.126892,464.336029 
	C416.940338,464.823547 416.753784,465.311035 415.974548,465.933655 
	C414.574371,467.035461 413.766937,468.002197 412.493652,468.986267 
	C401.867218,469.003540 391.706635,469.003540 381.253998,469.003540 
	C381.152771,466.923798 381.082458,465.479309 381.474915,463.964783 
	C389.196350,463.894775 396.455078,463.894775 404.236023,463.894775 
	C404.236023,456.182556 404.215210,449.236023 404.239899,442.289642 
	C404.313660,421.523315 404.405243,400.757050 404.805908,379.861450 
	C405.773376,377.895111 406.537170,376.089294 407.057251,374.215820 
	C409.755219,364.497833 412.390961,354.762604 415.048370,345.033386 
z"/>
<path fill="#FB994A" opacity="1.000000" stroke="none" 
	d="
M461.324280,545.070190 
	C461.025452,544.907959 461.033875,544.450867 461.015381,544.223022 
	C460.786957,539.874207 460.577087,535.753296 460.212646,531.236206 
	C460.059570,529.512390 459.964478,528.176147 460.081879,526.858887 
	C460.355408,523.790100 458.960938,522.850159 455.990051,522.882080 
	C445.366241,522.996338 434.740173,522.903809 423.410767,522.672974 
	C418.874268,520.908630 415.041931,519.360901 410.994751,517.555054 
	C408.900909,514.189392 407.021912,511.081818 405.142914,507.974243 
	C406.331268,508.040894 407.815826,507.671051 408.660370,508.244263 
	C414.606354,512.279907 420.305817,510.835571 425.898346,507.668762 
	C439.854889,499.765839 448.837524,487.395966 455.941132,473.494446 
	C458.448761,468.587128 460.253693,463.320709 462.518494,457.884399 
	C465.454254,461.189819 468.933014,465.106689 472.744537,469.502258 
	C472.990936,470.971252 473.021484,471.988403 472.800995,472.947876 
	C468.421844,492.004425 466.194763,511.299713 465.883759,530.856262 
	C465.782257,537.238708 464.828674,543.607605 464.264832,549.982666 
	C463.384216,548.399292 462.503662,546.815857 461.324280,545.070190 
z"/>
<path fill="#EDF8FD" opacity="1.000000" stroke="none" 
	d="
M676.451172,491.006104 
	C677.566528,494.736877 678.222046,498.474457 678.968384,502.609680 
	C679.875671,507.180817 680.692200,511.354340 680.787292,515.771484 
	C677.908142,516.009766 675.716309,516.247070 673.599548,515.949829 
	C668.759338,515.270081 665.471069,516.499634 665.048950,521.962708 
	C662.028015,522.091492 659.006592,522.342041 655.986328,522.327698 
	C643.556641,522.268738 631.127136,522.141174 618.698059,521.999573 
	C617.575806,521.986816 616.456787,521.692871 615.400085,520.896851 
	C618.029175,516.869446 620.594421,513.474792 623.159668,510.080139 
	C623.318970,505.531647 623.489014,500.983521 623.630615,496.434479 
	C623.670227,495.161499 623.625854,493.885895 623.810425,492.272247 
	C641.331055,491.626282 658.661255,491.319580 676.451172,491.006104 
z"/>
<path fill="#FB994A" opacity="1.000000" stroke="none" 
	d="
M623.050720,509.768738 
	C620.594421,513.474792 618.029175,516.869446 615.244141,520.480347 
	C606.526978,524.027039 597.632568,522.766785 588.869568,522.905579 
	C581.976868,523.014771 581.975403,522.920654 581.878906,530.840454 
	C581.622131,534.124817 581.424744,536.565735 581.122009,539.411011 
	C579.931091,543.895630 578.845581,547.975891 577.526428,551.714111 
	C576.851135,542.783752 576.582092,534.182129 575.921814,525.610657 
	C575.186768,516.068665 574.305115,506.527557 573.098877,497.035370 
	C571.954773,488.032532 570.308411,479.093567 568.882935,470.126526 
	C570.190247,469.202850 571.592896,468.385468 572.776306,467.323639 
	C573.818542,466.388428 574.615723,465.180084 576.293274,463.164795 
	C577.325317,467.199463 578.803467,470.174622 578.679138,473.081268 
	C578.427551,478.964111 581.510620,483.120239 584.659363,487.363770 
	C590.312744,494.982971 596.504395,501.977295 605.062012,506.622833 
	C610.004700,509.305969 615.016113,509.743927 620.371155,509.000671 
	C621.191101,508.886841 622.083130,509.292145 623.050720,509.768738 
z"/>
<path fill="#F5556C" opacity="1.000000" stroke="none" 
	d="
M568.646973,469.832031 
	C570.308411,479.093567 571.954773,488.032532 573.098877,497.035370 
	C574.305115,506.527557 575.186768,516.068665 575.921814,525.610657 
	C576.582092,534.182129 576.851135,542.783752 577.425354,552.107178 
	C577.412720,558.243958 577.267456,563.645752 577.034180,569.414185 
	C575.988831,571.883301 575.031433,573.985596 574.057617,575.660278 
	C574.357544,572.109558 574.982849,568.981079 574.927429,565.864624 
	C574.803772,558.903320 574.438660,551.941772 573.995300,544.991577 
	C573.056763,530.281860 572.444519,515.532593 570.886597,500.885895 
	C569.026062,483.393799 565.239380,466.259460 559.427368,449.574860 
	C556.723450,441.812775 547.961426,434.231049 539.219666,434.811798 
	C527.775391,435.572174 516.242493,434.995087 504.747711,434.996521 
	C493.707672,434.997925 487.727966,438.847382 483.577057,448.934296 
	C475.235229,469.205383 470.914246,490.502289 469.192657,512.195312 
	C467.919250,528.240784 468.140869,544.419250 468.091858,560.539673 
	C468.074982,566.083862 469.254181,571.631592 469.886993,577.177734 
	C468.562012,574.961304 466.412903,572.864685 466.069794,570.505432 
	C465.120911,563.980835 464.925781,557.346680 464.348755,550.369263 
	C464.828674,543.607605 465.782257,537.238708 465.883759,530.856262 
	C466.194763,511.299713 468.421844,492.004425 472.800995,472.947876 
	C473.021484,471.988403 472.990936,470.971252 473.095459,469.578094 
	C475.633636,461.664398 478.176483,454.161133 480.668182,446.640900 
	C484.383423,435.428070 491.856964,427.910461 505.347473,428.790192 
	C517.095459,429.556274 528.932129,428.952637 540.729614,428.971741 
	C550.073364,428.986877 556.806396,433.459412 559.992065,442.005432 
	C563.338074,450.981659 565.648254,460.343994 568.646973,469.832031 
z"/>
<path fill="#EBF6FB" opacity="1.000000" stroke="none" 
	d="
M405.038635,507.525299 
	C407.021912,511.081818 408.900909,514.189392 410.993805,517.947998 
	C409.825439,519.768799 408.443207,520.938538 407.060974,522.108276 
	C405.000519,522.040527 402.940094,521.972839 400.488861,521.735779 
	C400.064758,521.089111 400.031403,520.611877 400.227844,520.004211 
	C400.631256,519.575256 400.804840,519.276672 400.920532,518.615967 
	C399.330658,517.517822 397.074158,515.735901 396.383514,516.214355 
	C391.656921,519.488586 386.822510,516.858032 382.083405,517.016052 
	C382.075867,513.350952 382.068329,509.685822 382.048462,505.597778 
	C382.892700,501.023071 383.749237,496.871307 384.736572,492.370300 
	C391.348358,492.298431 397.829346,492.575775 404.710693,492.852966 
	C405.052094,497.593994 404.993195,502.335175 405.038635,507.525299 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M381.012177,464.034851 
	C381.082458,465.479309 381.152771,466.923798 381.253998,469.003540 
	C391.706635,469.003540 401.867218,469.003540 412.771729,469.004700 
	C413.883789,469.003082 414.251923,469.000244 414.620056,468.997437 
	C414.687531,469.335480 414.581482,469.605377 414.113647,469.940063 
	C384.605225,470.040649 355.285034,470.008331 325.825409,469.654663 
	C329.498077,469.229584 333.318787,468.921417 337.119934,469.080231 
	C340.845642,469.235931 342.363220,467.687073 342.498535,464.005554 
	C355.642639,463.961395 368.327393,463.998108 381.012177,464.034851 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M536.885071,405.032532 
	C538.470581,405.801147 540.056091,406.569763 541.820312,407.605225 
	C528.207581,407.808472 514.416138,407.744873 500.303589,407.428650 
	C501.086761,406.480957 502.191010,405.785889 504.223511,404.506500 
	C502.132477,403.126404 500.498199,402.047791 497.826935,400.284698 
	C500.411835,400.284698 502.303284,400.284698 504.788269,400.555328 
	C505.953857,403.248352 507.085754,404.061340 509.887634,403.724609 
	C514.906738,403.121368 520.020142,403.302704 525.219055,403.347687 
	C525.853027,403.445007 526.362183,403.350739 527.316772,403.194580 
	C528.636963,403.303925 529.511780,403.475189 530.645752,403.792389 
	C532.898315,404.303070 534.891724,404.667816 536.885071,405.032532 
z"/>
<path fill="#59B6CF" opacity="1.000000" stroke="none" 
	d="
M419.407776,460.976837 
	C418.867920,459.687378 418.634918,458.249176 418.432037,456.996704 
	C420.804535,454.968445 423.081726,453.021698 425.716675,451.051544 
	C423.954529,454.294800 421.834595,457.561432 419.407776,460.976837 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M491.142212,408.836548 
	C492.850586,408.290863 494.946960,407.813354 497.439240,407.434692 
	C495.733521,407.990570 493.631866,408.447662 491.142212,408.836548 
z"/>
<path fill="#59B6CF" opacity="1.000000" stroke="none" 
	d="
M414.935150,468.830688 
	C414.251923,469.000244 413.883789,469.003082 413.237579,468.987427 
	C413.766937,468.002197 414.574371,467.035461 415.727173,466.047668 
	C415.798462,466.905731 415.524353,467.784851 414.935150,468.830688 
z"/>
<path fill="#59B6CF" opacity="1.000000" stroke="none" 
	d="
M417.385376,464.131958 
	C417.548065,463.272888 417.969208,462.209778 418.769623,461.120728 
	C418.647217,462.039185 418.145538,462.983521 417.385376,464.131958 
z"/>
<path fill="#59B6CF" opacity="1.000000" stroke="none" 
	d="
M429.279602,447.036530 
	C429.192261,446.852753 429.341125,446.556274 429.700989,446.122009 
	C429.779907,446.297424 429.647858,446.610626 429.279602,447.036530 
z"/>
<path fill="#574043" opacity="1.000000" stroke="none" 
	d="
M879.990173,193.953430 
	C881.065796,194.011093 882.141357,194.068756 884.043945,194.111420 
	C887.162354,194.171844 889.453735,194.247269 891.745178,194.322693 
	C891.745178,194.322693 891.876648,194.155029 891.791626,194.574768 
	C891.723328,215.257446 891.725281,235.520401 891.760559,255.783310 
	C891.806274,282.021881 891.878662,308.260406 891.939575,334.498962 
	C891.939575,334.498962 891.862488,334.501526 891.823425,334.503937 
	C891.784363,334.506348 891.357117,334.578522 890.791992,334.424316 
	C878.830261,334.187958 867.432983,334.151215 856.037903,333.974426 
	C854.335571,333.948029 852.643311,333.263947 851.215332,332.803528 
	C851.856750,332.725403 852.229187,332.727936 853.000183,332.831177 
	C854.199890,332.262543 855.001099,331.593201 855.802307,330.923828 
	C854.656677,330.461731 853.511108,329.999603 851.946777,329.527466 
	C847.377808,329.379974 843.227600,329.242554 838.536133,328.993530 
	C837.331299,329.084778 836.667603,329.287628 835.980835,329.520508 
	C835.957825,329.550568 835.909424,329.387360 835.906128,329.000427 
	C831.537720,327.640198 827.214661,326.344421 822.797668,325.768311 
	C815.968201,324.877563 809.074585,324.478699 802.250122,323.619873 
	C802.459412,322.893829 802.626770,322.419098 802.929077,321.510010 
	C802.154480,320.258606 801.254639,318.743011 800.333923,318.730255 
	C788.526611,318.566681 776.716309,318.648102 764.907043,318.591827 
	C762.234314,318.579102 761.830750,319.921356 761.976196,322.272522 
	C760.700684,322.309143 759.835144,322.165375 759.126221,321.577759 
	C758.251160,320.296173 757.003906,318.587219 756.226990,318.779419 
	C753.593872,319.430786 749.836731,316.224365 748.222412,321.115540 
	C748.339722,321.631683 748.557739,321.893127 749.174438,322.328552 
	C752.463318,322.474579 755.353638,322.446686 757.939941,322.684204 
	C756.570862,324.591949 755.505737,326.234283 754.097839,327.902985 
	C753.526550,327.947205 753.298157,327.965088 752.982056,327.552765 
	C749.074219,326.796661 745.254944,326.455505 741.428040,326.262390 
	C741.356995,326.258789 741.197083,328.014099 741.017517,329.258575 
	C740.937378,329.988770 740.918335,330.409119 740.600830,330.951904 
	C739.699158,331.925415 739.095947,332.776550 738.492737,333.627686 
	C738.648132,334.188690 738.803528,334.749664 738.958862,335.310669 
	C743.934570,334.994110 748.910217,334.677582 754.018921,334.700195 
	C756.962219,334.739502 756.962219,334.739502 757.435791,329.097534 
	C759.200745,329.178070 760.557678,329.300140 761.932373,329.821045 
	C762.580261,333.323395 763.210449,336.426910 763.998840,340.309326 
	C763.690979,340.776917 762.789978,342.145477 761.888916,343.514008 
	C746.824890,343.514008 731.760925,343.514008 715.872192,343.514008 
	C715.872192,329.927887 715.872192,316.414703 715.786743,302.438232 
	C715.747314,295.966675 715.793274,289.958466 715.777283,283.487244 
	C715.782471,257.149445 715.849304,231.274643 715.917175,205.399857 
	C715.925415,202.247772 715.939026,199.095703 716.203613,195.384415 
	C716.705994,194.680099 716.894470,194.478531 717.488037,194.180038 
	C768.300903,194.173279 818.648193,194.207001 869.275696,194.458298 
	C871.369995,194.525253 873.184143,194.374619 875.412598,194.175674 
	C877.214722,194.069382 878.602417,194.011398 879.990173,193.953430 
M781.584473,226.659851 
	C781.498474,226.130295 781.412537,225.600739 781.175537,224.473877 
	C781.130615,224.273483 781.085693,224.073074 781.236328,223.106857 
	C783.192688,222.736084 785.142029,222.321365 787.107239,222.005356 
	C789.717285,221.585678 792.339783,221.242966 795.037598,220.004761 
	C795.411316,217.623993 794.376038,216.767105 792.010559,216.853897 
	C787.391296,217.023407 782.765137,217.005615 777.323242,217.034073 
	C776.504272,217.043793 775.685364,217.053513 773.952698,216.950348 
	C768.726562,216.950348 763.500366,216.950348 757.448242,216.950348 
	C758.196594,218.908661 758.626099,220.032486 759.685852,221.667053 
	C764.399353,221.667053 769.112854,221.667053 773.408508,221.667053 
	C773.547241,223.799622 773.652588,225.418579 774.375854,227.560699 
	C776.662903,227.359177 778.949890,227.157654 781.584473,226.659851 
M745.869812,308.157318 
	C746.841858,308.140991 747.813843,308.124634 749.205811,308.486877 
	C749.879761,308.361725 750.553711,308.236572 752.028809,308.176453 
	C753.350586,308.028351 754.672424,307.880249 756.591553,308.302185 
	C762.392456,308.487427 768.194397,308.792297 773.993225,308.740967 
	C774.967529,308.732361 775.928223,307.183105 776.895203,306.345734 
	C775.863647,305.576019 774.820801,304.130829 773.802429,304.147888 
	C767.859253,304.247406 761.921936,304.689636 755.178345,304.776276 
	C752.060242,304.582001 748.934387,304.160461 745.826660,304.267456 
	C743.465393,304.348694 741.994751,305.501923 744.234985,308.327606 
	C744.537720,308.248657 744.840393,308.169708 745.869812,308.157318 
M753.935242,314.787720 
	C757.409668,315.116425 760.881042,315.593475 764.360718,315.664154 
	C765.177429,315.680756 766.022034,314.323639 766.853821,313.598511 
	C765.952881,312.959991 765.071533,311.809723 764.147522,311.774353 
	C760.721741,311.643097 757.281860,311.879303 753.440369,312.261505 
	C753.525391,312.832581 753.610413,313.403687 753.935242,314.787720 
M807.568787,237.795334 
	C806.976074,237.541626 806.384277,237.069107 805.790466,237.066483 
	C793.491333,237.012314 781.191650,236.978546 768.893005,237.065109 
	C767.947571,237.071777 767.008606,238.001297 766.198792,239.271500 
	C767.347595,240.231171 768.481506,242.003159 769.647522,242.024567 
	C781.076355,242.234467 792.512512,242.038589 803.941895,242.232864 
	C806.853699,242.282364 807.666748,240.960739 807.568787,237.795334 
M850.453979,290.003906 
	C838.853394,289.860992 827.252930,289.673798 815.652161,289.658417 
	C814.714294,289.657227 813.774841,290.835358 812.836182,291.465515 
	C813.814209,292.231384 814.782654,293.648743 815.771667,293.663177 
	C826.565186,293.820709 837.363281,293.830566 848.155334,293.626526 
	C849.061890,293.609375 849.933777,291.754517 850.453979,290.003906 
M772.477844,267.623413 
	C766.389099,267.623413 760.300293,267.623413 754.211548,267.623413 
	C753.935364,268.145233 753.659180,268.667053 753.382996,269.188904 
	C754.514099,270.070618 755.627258,271.688782 756.779175,271.716858 
	C765.565247,271.930939 774.361328,271.931854 783.147034,271.709015 
	C784.214111,271.681976 785.237549,269.929565 786.281189,268.976746 
	C785.973450,268.526611 785.665771,268.076477 785.358032,267.626343 
	C781.393738,267.626343 777.429382,267.626343 772.477844,267.623413 
M800.753723,282.219757 
	C800.091431,282.219635 799.331787,282.009308 798.786377,282.261749 
	C797.529175,282.843658 796.376099,283.650299 795.180725,284.365753 
	C796.419434,285.046631 797.636658,286.264862 798.900513,286.315247 
	C804.355957,286.532837 809.830505,286.537201 815.284973,286.308197 
	C816.489502,286.257629 817.640930,284.939941 818.816772,284.205719 
	C817.578125,283.542786 816.366089,282.374878 815.096069,282.308167 
	C810.637817,282.073944 806.159668,282.218781 800.753723,282.219757 
M841.046814,254.431732 
	C840.536316,253.924194 840.031494,252.980896 839.514526,252.974197 
	C831.246521,252.866776 822.976196,252.829041 814.708923,252.948425 
	C813.961121,252.959229 813.230469,254.157730 812.491882,254.804688 
	C813.364868,255.488724 814.226685,256.749451 815.112671,256.766693 
	C823.048828,256.920868 830.989746,256.894440 838.927551,256.790436 
	C839.641052,256.781128 840.342529,255.853775 841.046814,254.431732 
M760.409668,206.124939 
	C762.853699,206.124939 765.297729,206.124939 767.741760,206.124939 
	C767.979004,205.536392 768.216187,204.947845 768.453430,204.359299 
	C767.332031,203.602737 766.227722,202.222244 765.086548,202.191010 
	C757.761963,201.990494 750.425964,201.977982 743.102539,202.196091 
	C741.955322,202.230255 740.852417,203.754013 739.729004,204.588989 
	C740.002808,205.100677 740.276611,205.612350 740.550415,206.124039 
	C746.845764,206.124039 753.141174,206.124039 760.409668,206.124939 
M807.958008,276.574615 
	C808.517517,277.386169 809.062866,278.892761 809.638733,278.904480 
	C817.620300,279.067078 825.606995,279.077820 833.589294,278.942383 
	C834.312439,278.930084 835.014160,277.654510 835.725769,276.965607 
	C834.974304,276.323853 834.217651,275.119690 833.472107,275.126465 
	C825.041809,275.203278 816.613098,275.465668 807.958008,276.574615 
M787.060303,209.037201 
	C786.497070,210.002151 785.933838,210.967117 785.370605,211.932068 
	C786.362854,212.301804 787.350403,212.976456 788.348022,212.991623 
	C794.679077,213.087860 801.015991,213.149048 807.341492,212.937820 
	C808.520935,212.898438 809.657410,211.572510 810.813721,210.840332 
	C809.693726,210.231659 808.586609,209.125992 807.451538,209.096405 
	C800.956665,208.927200 794.455139,209.013794 787.060303,209.037201 
M755.125061,289.416870 
	C752.821167,292.313293 753.437012,293.873047 757.218933,293.896240 
	C761.882202,293.924835 766.555603,294.070068 771.202515,293.793396 
	C772.431458,293.720276 773.579102,292.281464 774.764038,291.469727 
	C773.506165,290.720337 772.276611,289.387390 770.985413,289.324829 
	C766.001465,289.083191 760.997803,289.247223 755.125061,289.416870 
M768.109558,223.934906 
	C760.049500,223.934906 751.989441,223.934906 743.929382,223.934906 
	C743.665588,224.419022 743.401794,224.903137 743.138000,225.387253 
	C744.190002,226.209427 745.219604,227.707611 746.297546,227.743256 
	C752.923401,227.962311 759.561096,227.789886 766.192993,227.879929 
	C768.782532,227.915085 769.382568,226.725342 768.109558,223.934906 
M790.120056,279.064026 
	C791.292358,278.334412 792.464661,277.604797 793.636902,276.875153 
	C792.853943,276.266479 792.082397,275.147644 791.286133,275.129791 
	C784.872009,274.985840 778.453247,275.049133 772.035889,275.049133 
	C771.785950,275.615692 771.535950,276.182220 771.286011,276.748779 
	C772.444153,277.514465 773.570129,278.876648 774.766113,278.941071 
	C779.567078,279.199860 784.389771,279.056641 790.120056,279.064026 
M794.643921,271.865601 
	C797.467529,271.857880 800.303467,271.994446 803.107239,271.754578 
	C803.949463,271.682556 805.224609,270.644379 805.342346,269.897552 
	C805.450623,269.210724 804.297668,267.654785 803.651367,267.627136 
	C799.176819,267.435669 794.684692,267.445648 790.211487,267.663269 
	C789.555542,267.695190 788.650085,269.111084 788.480042,270.004608 
	C788.388184,270.486908 789.515015,271.544678 790.260864,271.761169 
	C791.335388,272.073029 792.563477,271.855530 794.643921,271.865601 
M796.932007,293.750519 
	C800.410889,293.752258 803.891113,293.695709 807.368347,293.772430 
	C810.732910,293.846619 810.817871,292.244568 809.632874,289.568817 
	C805.087830,289.568817 800.626648,289.462250 796.178040,289.650421 
	C795.176941,289.692780 794.219421,290.764008 793.241882,291.361603 
	C794.179016,292.157135 795.116150,292.952667 796.932007,293.750519 
M773.430298,213.022598 
	C775.868225,213.022598 778.306152,213.022598 780.743713,213.022598 
	C780.693176,208.863800 780.693054,208.853912 764.200806,209.040421 
	C761.907532,209.066360 758.765381,208.282913 760.220642,213.022049 
	C764.263611,213.022049 768.359802,213.022049 773.430298,213.022598 
M747.493774,213.129822 
	C749.986084,213.088867 752.492859,213.182770 754.961060,212.917694 
	C755.627014,212.846176 756.636475,211.693878 756.648132,211.023132 
	C756.659546,210.364883 755.620728,209.128189 755.010620,209.107773 
	C750.031067,208.941132 745.040710,208.910736 740.062866,209.091995 
	C739.360535,209.117538 738.708008,210.510880 738.032471,211.271072 
	C738.704285,211.865417 739.325562,212.886948 740.057312,212.973465 
	C742.190857,213.225662 744.368530,213.104126 747.493774,213.129822 
M781.828125,256.849701 
	C786.292786,256.853973 790.767822,257.025360 795.215149,256.749969 
	C796.388550,256.677307 797.476624,255.225555 798.603943,254.407074 
	C798.333435,253.892441 798.062927,253.377808 797.792419,252.863174 
	C792.537476,252.863174 787.276306,252.709259 782.029724,252.918411 
	C778.647217,253.053238 779.276123,254.883270 781.828125,256.849701 
M786.256470,202.057297 
	C782.602844,202.058228 778.937073,201.894073 775.303284,202.163116 
	C774.246094,202.241394 773.280518,203.557587 772.272949,204.306320 
	C773.247620,204.912476 774.198486,205.990936 775.201233,206.041611 
	C779.176758,206.242523 783.174194,206.237534 787.150391,206.041199 
	C788.172668,205.990707 789.146729,204.962463 790.143005,204.383453 
	C789.161011,203.608154 788.179016,202.832870 786.256470,202.057297 
M792.054199,304.294800 
	C791.591980,305.466278 791.129761,306.637726 790.497375,308.240417 
	C795.798889,308.240417 800.232666,308.240417 804.632629,308.240417 
	C805.761780,305.308533 804.977539,304.027802 801.890564,304.171204 
	C798.916016,304.309357 795.930542,304.211609 792.054199,304.294800 
M773.539185,249.412003 
	C778.325317,249.408951 783.116577,249.522964 787.893677,249.313385 
	C788.971313,249.266083 789.999512,248.091400 791.050476,247.435684 
	C789.950439,246.827911 788.868408,245.736847 787.747375,245.695221 
	C782.638184,245.505463 777.512634,245.483322 772.405640,245.699814 
	C771.137756,245.753540 769.917236,246.923019 768.674988,247.579651 
	C769.963867,248.189529 771.252808,248.799408 773.539185,249.412003 
M789.540955,289.698151 
	C785.774048,289.698151 782.007202,289.698151 778.353760,289.698151 
	C777.045410,293.152618 778.566833,293.713043 781.284973,293.805573 
	C790.110901,294.105988 790.298096,294.116791 790.482666,290.534607 
	C790.489990,290.393188 790.336060,290.243439 789.540955,289.698151 
M755.138611,286.385773 
	C758.102661,286.430145 761.080444,286.649475 764.022705,286.417358 
	C764.963379,286.343170 765.809814,285.073120 766.699402,284.350281 
	C765.838623,283.637268 765.038330,282.421112 764.105469,282.309113 
	C761.668274,282.016510 759.172913,282.220947 756.700989,282.200989 
	C753.778381,282.177429 753.337280,283.644958 755.138611,286.385773 
M786.364441,298.547058 
	C786.491516,299.169769 786.585449,300.326813 786.750488,300.337006 
	C790.784912,300.586700 794.826599,300.761139 798.867676,300.775726 
	C799.192688,300.776917 799.902771,299.424347 799.756470,298.884705 
	C799.558411,298.154785 798.693542,297.052216 798.133484,297.063202 
	C794.273560,297.138885 790.418518,297.462952 786.364441,298.547058 
M764.963379,264.120941 
	C765.479309,263.141296 765.995178,262.161652 766.511047,261.181976 
	C765.703613,260.803833 764.912537,260.148682 764.085571,260.099609 
	C761.623108,259.953430 759.145630,260.086243 756.675598,260.034515 
	C753.174255,259.961304 753.516968,261.745667 754.492310,264.141113 
	C757.826111,264.141113 760.949829,264.141113 764.963379,264.120941 
M762.225464,242.151657 
	C763.142822,241.358459 764.060120,240.565262 764.977417,239.772049 
	C764.136658,239.234268 763.330261,238.310928 762.448669,238.232498 
	C760.006531,238.015320 757.505676,237.935822 755.084656,238.244858 
	C754.019470,238.380814 753.091431,239.590744 752.101135,240.313110 
	C753.032898,240.926788 753.911865,241.939560 754.907471,242.071365 
	C757.004333,242.348969 759.162354,242.164856 762.225464,242.151657 
M761.478088,230.903915 
	C759.194458,230.903915 756.910767,230.903915 754.743225,230.903915 
	C753.178101,235.115829 755.763123,235.435944 758.088806,234.860977 
	C761.080383,234.121353 765.919067,237.603027 767.501099,231.172119 
	C765.320862,231.056305 763.868713,230.979172 761.478088,230.903915 
M762.257324,296.929657 
	C760.450684,296.932312 758.641113,297.001495 756.837952,296.923035 
	C753.596008,296.781982 753.294373,298.271515 754.544067,301.002167 
	C757.544495,301.002167 760.500854,301.175964 763.418091,300.914154 
	C764.539612,300.813477 765.572021,299.720703 766.645081,299.079926 
	C765.484558,298.362366 764.324036,297.644806 762.257324,296.929657 
M782.004639,297.129547 
	C778.846863,297.069489 775.683105,296.883179 772.535461,297.034332 
	C771.703247,297.074280 770.921021,298.154510 770.115845,298.757080 
	C770.940125,299.504883 771.704712,300.799591 772.599976,300.897339 
	C775.232239,301.184784 777.960693,301.267975 780.555298,300.843384 
	C781.422607,300.701447 781.999817,298.786652 782.004639,297.129547 
M747.712341,274.942444 
	C746.462036,275.616272 745.211731,276.290070 743.961426,276.963898 
	C745.176575,277.671021 746.329773,278.803345 747.620483,278.991150 
	C749.868652,279.318329 752.222778,279.237213 754.487549,278.959869 
	C755.308167,278.859375 755.999817,277.705383 756.750305,277.032074 
	C756.012817,276.349548 755.348083,275.207520 754.523132,275.076843 
	C752.600037,274.772247 750.599854,274.954163 747.712341,274.942444 
M774.886108,286.782013 
	C777.005188,286.001587 780.881287,288.739532 780.836060,284.165070 
	C780.828979,283.451385 776.962219,282.763794 774.869995,282.096283 
	C774.568176,282.000000 774.123230,281.955566 773.890137,282.108765 
	C772.817017,282.813934 771.795593,283.597717 770.755615,284.353271 
	C771.856018,285.162445 772.956482,285.971619 774.886108,286.782013 
M779.466675,304.843567 
	C779.939880,306.154755 780.410828,308.588470 780.886658,308.589447 
	C783.406860,308.594452 785.928223,307.987915 788.449219,307.593323 
	C787.827393,306.414459 787.378113,304.392670 786.549805,304.223145 
	C784.503052,303.804291 782.282532,304.234161 779.466675,304.843567 
M779.742310,315.269684 
	C779.646423,307.350494 773.805725,313.907227 771.000122,312.158325 
	C771.471436,313.864838 772.360779,315.330475 773.557739,315.652649 
	C775.244507,316.106598 777.159180,315.713409 779.742310,315.269684 
M806.006653,277.469391 
	C804.297668,272.342072 800.098877,276.051239 797.198364,275.112183 
	C796.773804,274.974731 795.836121,276.422180 795.135864,277.136292 
	C795.912903,277.781250 796.689209,278.971863 797.467041,278.972809 
	C800.227417,278.976135 802.988220,278.573639 806.006653,277.469391 
M738.434448,322.514099 
	C740.213989,322.643158 742.174133,323.271271 743.706360,322.716827 
	C744.647949,322.376099 744.935059,320.226715 745.516113,318.889435 
	C743.460266,318.663849 741.356506,318.108429 739.375183,318.396149 
	C738.705078,318.493408 738.344849,320.724579 738.434448,322.514099 
M781.924927,234.293411 
	C781.462341,233.180939 781.019226,231.123154 780.533936,231.113159 
	C777.869202,231.058273 775.194153,231.504852 772.522644,231.779266 
	C773.122559,232.834045 773.591492,234.669632 774.347107,234.796371 
	C776.564026,235.168213 778.894958,234.860580 781.924927,234.293411 
M755.087585,246.032867 
	C752.133545,245.937607 749.172363,245.690765 746.229126,245.827728 
	C745.171509,245.876953 744.156982,246.850449 743.122742,247.402100 
	C744.087097,248.023911 745.005249,249.072266 746.024963,249.182510 
	C748.467102,249.446594 750.990967,249.502243 753.410095,249.149384 
	C754.305847,249.018723 755.000610,247.509903 755.087585,246.032867 
M745.030640,310.049713 
	C741.467224,311.599976 743.057068,312.965759 745.349060,313.782928 
	C747.164490,314.430206 749.202271,314.453857 751.513977,314.812164 
	C752.995056,308.857483 748.758057,310.223053 745.030640,310.049713 
M764.418091,275.039978 
	C762.969482,275.113525 761.520935,275.187042 760.029724,275.262756 
	C759.026428,280.959534 763.222412,278.708099 765.319275,278.905151 
	C766.466370,279.012970 767.745850,277.712738 768.965637,277.047424 
	C767.754272,276.378906 766.542908,275.710419 764.418091,275.039978 
M785.637451,264.158844 
	C786.136047,264.158630 786.701904,264.312469 787.120728,264.129578 
	C788.430298,263.557587 789.684387,262.858490 790.960022,262.208679 
	C789.615051,261.460449 788.307007,260.629608 786.906860,260.004913 
	C786.353699,259.758118 785.531494,259.796509 784.945374,260.012787 
	C783.976562,260.370300 783.099792,260.977417 782.184265,261.479370 
	C783.040771,262.369720 783.897339,263.260071 785.637451,264.158844 
M784.989502,234.283569 
	C792.547607,236.000351 794.239807,235.398087 793.563843,230.940048 
	C791.502258,230.940048 789.351074,230.686813 787.309692,231.050354 
	C786.337158,231.223572 785.573608,232.570145 784.989502,234.283569 
M772.776855,259.981110 
	C771.974243,261.030029 771.171631,262.078949 770.369019,263.127869 
	C772.723877,263.437164 775.076904,263.901337 777.434998,263.928253 
	C777.920349,263.933807 778.622803,262.347839 778.813721,261.411560 
	C778.881897,261.077179 777.789795,260.226562 777.126465,260.085510 
	C776.012329,259.848602 774.817444,259.991028 772.776855,259.981110 
M808.192810,256.847412 
	C808.804260,255.925873 809.415710,255.004333 810.027161,254.082825 
	C809.239136,253.676956 808.473633,252.984924 807.658752,252.920944 
	C805.544312,252.754913 803.408203,252.865219 800.867981,252.865219 
	C800.644958,258.948761 805.037415,256.099670 808.192810,256.847412 
M826.130432,282.234894 
	C823.790649,282.517822 819.908691,280.890594 821.341125,285.984100 
	C828.148499,286.884613 828.457520,286.679199 826.130432,282.234894 
M784.831909,284.379974 
	C786.214661,285.053986 787.553101,286.084747 788.997314,286.264374 
	C789.825378,286.367340 790.825317,285.088379 791.747925,284.431580 
	C790.905579,283.692139 790.078369,282.367218 789.217529,282.345093 
	C787.784851,282.308228 786.330688,283.106659 784.831909,284.379974 
M803.943665,300.974274 
	C805.430786,300.963318 807.043091,301.292664 808.356506,300.809448 
	C809.103943,300.534424 809.362915,298.931580 809.841858,297.926666 
	C807.836853,297.615662 805.832581,297.176605 803.825989,297.166199 
	C803.592346,297.164978 803.346313,299.534912 803.943665,300.974274 
M771.636841,252.874100 
	C771.113098,253.956085 770.589294,255.038071 770.065491,256.120026 
	C772.116089,256.346375 774.168518,256.721283 776.216003,256.695740 
	C776.734802,256.689301 777.652954,255.391083 777.627319,254.715332 
	C777.603210,254.080856 776.669189,253.150391 775.964661,252.949509 
	C774.897827,252.645309 773.682922,252.860519 771.636841,252.874100 
M755.635010,252.882858 
	C755.118713,253.953918 754.602356,255.024979 754.086060,256.096039 
	C755.942444,256.320160 757.801575,256.691925 759.653320,256.658173 
	C760.082886,256.650299 760.487244,255.259079 760.903198,254.504410 
	C759.445557,253.957504 757.987915,253.410599 755.635010,252.882858 
M750.063904,231.152924 
	C748.604065,231.091736 746.981018,230.623108 745.744263,231.118637 
	C744.973755,231.427338 744.787170,233.193344 744.338501,234.305344 
	C745.909241,234.526291 747.570801,235.140915 749.013794,234.808014 
	C749.776062,234.632141 750.157593,232.805649 750.063904,231.152924 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M802.208130,323.871216 
	C809.074585,324.478699 815.968201,324.877563 822.797668,325.768311 
	C827.214661,326.344421 831.537720,327.640198 835.721741,329.303406 
	C835.578613,330.414978 835.616638,330.836639 835.654663,331.258240 
	C835.911377,331.195831 836.168091,331.133392 836.424805,331.070984 
	C836.284485,330.544159 836.144226,330.017303 836.003906,329.490448 
	C836.667603,329.287628 837.331299,329.084778 838.538818,329.425781 
	C841.381287,330.964996 843.679932,331.960388 845.570801,333.057068 
	C843.055908,333.435577 840.950623,333.936920 838.841553,333.953583 
	C825.269043,334.060852 811.695557,334.062073 798.122437,334.098083 
	C792.218018,334.399963 786.312866,334.689331 780.409363,335.007812 
	C775.893738,335.251404 777.149536,338.640686 776.810547,341.962830 
	C770.625000,344.208954 769.153870,338.862366 765.648010,336.211121 
	C767.282166,334.412964 768.509277,333.062622 770.437439,330.940887 
	C766.926880,330.315338 764.420776,329.868774 761.914612,329.422180 
	C760.557678,329.300140 759.200745,329.178070 757.198364,328.928894 
	C755.848877,328.493378 755.144775,328.184998 754.440674,327.876617 
	C755.505737,326.234283 756.570862,324.591949 758.010864,322.613831 
	C758.563232,322.155731 758.757812,322.070251 758.969543,322.021606 
	C759.835144,322.165375 760.700684,322.309143 762.238159,322.251892 
	C763.260315,322.035339 763.610474,322.019806 764.258789,322.302429 
	C767.025208,322.734924 769.492065,322.918915 771.962158,322.994873 
	C782.043640,323.304962 792.126038,323.582001 802.208130,323.871216 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M896.745300,353.832764 
	C896.542664,358.938080 896.528381,363.606781 896.024109,368.221893 
	C895.911682,369.251190 894.174744,370.611481 892.999878,370.832672 
	C892.249512,370.973969 890.883301,369.460297 890.277893,368.409393 
	C889.124512,366.407379 892.090637,362.637878 887.829102,362.221710 
	C887.377747,362.177612 886.497253,366.466003 885.829956,368.748566 
	C885.693054,369.216705 885.619202,369.703247 885.392944,370.753967 
	C883.619995,370.845856 881.748779,370.942871 879.370789,371.066132 
	C879.370789,363.658997 879.247192,356.714508 879.526062,349.786194 
	C879.561279,348.912994 881.752869,347.432251 882.873169,347.496185 
	C883.950806,347.557709 885.507874,349.102081 885.827820,350.274872 
	C886.327148,352.105408 885.959961,354.172302 885.959961,356.120667 
	C890.365601,357.036316 890.939148,354.451294 890.757568,351.579529 
	C890.483948,347.250671 892.427063,346.300781 896.756897,347.676849 
	C896.756897,349.496063 896.756897,351.436432 896.745300,353.832764 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M798.963623,353.003052 
	C798.331482,352.689850 798.072998,352.357880 797.785889,352.330963 
	C795.932434,352.156982 794.072754,352.049591 792.215088,351.920349 
	C793.306458,353.363831 794.095825,355.443329 795.545715,356.131592 
	C799.900635,358.198883 802.627197,361.005951 802.104858,366.105042 
	C801.605164,370.982971 797.835999,371.568817 794.121765,371.846680 
	C790.378296,372.126770 787.078552,371.280457 786.521484,366.112427 
	C787.904480,366.667419 789.252258,367.522186 790.680725,367.690033 
	C792.012451,367.846527 793.430054,367.272430 794.809814,367.019897 
	C794.475586,365.677063 794.416382,364.165985 793.727722,363.039948 
	C793.074707,361.972321 791.813843,361.233856 790.730713,360.479279 
	C785.762024,357.017975 784.620178,354.246704 786.823181,350.810638 
	C789.562805,346.537628 794.803894,345.774506 799.524780,348.897156 
	C801.914185,350.477600 802.880676,351.879913 798.963623,353.003052 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M818.676758,367.477539 
	C818.053772,368.916534 817.320679,370.789917 816.381409,370.899628 
	C813.128723,371.279633 809.804321,371.046173 805.921753,371.046173 
	C805.921753,363.097351 805.921753,355.574524 805.921753,348.131378 
	C816.202209,345.771088 819.184326,346.766235 818.647278,352.281342 
	C815.165771,352.773834 811.611755,353.093170 808.201294,353.970459 
	C807.727051,354.092468 807.960205,356.964691 807.824463,359.267242 
	C810.073914,359.267242 811.879333,359.036438 813.583618,359.351929 
	C814.642151,359.547882 815.547363,360.571716 816.521423,361.223938 
	C815.589294,361.876923 814.741455,362.806152 813.706421,363.122223 
	C811.868225,363.683472 809.916504,363.872925 808.012268,364.217957 
	C808.056274,364.720612 808.100281,365.223267 808.144287,365.725922 
	C811.586853,366.185059 815.029480,366.644226 818.676758,367.477539 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M872.422852,348.369751 
	C873.174011,349.753387 874.309631,351.382751 873.896362,352.043945 
	C873.300720,352.996857 871.594482,353.283234 870.335083,353.786102 
	C869.001038,354.318817 866.559082,354.624023 866.468201,355.285278 
	C866.057495,358.272644 866.050354,361.392639 866.531555,364.362183 
	C866.631226,364.977264 869.424683,365.180481 870.986938,365.526978 
	C872.576538,365.879578 874.178772,366.174652 875.983826,366.536713 
	C873.176941,372.129211 868.230591,373.056183 864.449280,369.393677 
	C859.632263,364.728058 859.367798,354.498322 864.011353,349.701874 
	C866.307922,347.329651 868.991821,346.433563 872.422852,348.369751 
z"/>
<path fill="#F0D5C1" opacity="1.000000" stroke="none" 
	d="
M939.549805,370.704712 
	C932.269531,372.838684 927.212708,368.369812 927.546997,359.359192 
	C927.680847,355.750458 929.924377,351.935272 932.088684,348.827637 
	C932.945984,347.596710 936.302612,347.506439 938.318909,347.909424 
	C939.515442,348.148590 940.317444,350.361969 941.296814,351.687683 
	C939.914856,351.663635 938.505249,351.457825 937.158264,351.663086 
	C935.594177,351.901428 933.561890,352.028259 932.653503,353.034546 
	C930.252014,355.694916 930.415344,362.807983 932.487671,365.862457 
	C934.432373,368.728790 936.788635,368.585144 939.440674,365.330536 
	C937.606750,364.925690 935.836792,364.534943 934.066833,364.144226 
	C934.089417,363.577423 934.112000,363.010651 934.134583,362.443878 
	C936.972717,362.249207 939.810791,362.054565 942.648926,361.859924 
	C943.095947,362.255920 943.542969,362.651886 943.989990,363.047882 
	C942.618652,365.539215 941.247314,368.030548 939.549805,370.704712 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M911.995972,370.985992 
	C906.321533,372.442871 905.833618,372.146088 905.890442,366.739532 
	C905.944153,361.632721 905.959534,356.511749 906.390930,351.430878 
	C906.523376,349.871185 907.971191,348.423187 908.816772,346.924072 
	C910.572998,347.934418 912.329224,348.944733 913.959473,350.619263 
	C913.438538,352.487579 913.043518,353.691742 912.648438,354.895905 
	C912.745789,359.631500 912.843079,364.367126 912.690674,369.683594 
	C912.225464,370.463501 912.077087,370.704010 911.995972,370.985992 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M839.427002,370.595398 
	C838.059326,369.903351 836.377441,369.157745 835.977295,367.977570 
	C834.945007,364.933167 833.206787,363.976166 830.045715,364.015930 
	C826.784790,364.056946 825.717224,365.673187 825.144348,368.413788 
	C824.945984,369.362640 824.180176,370.192963 823.673645,371.077423 
	C823.099060,370.879333 822.524536,370.681274 821.950012,370.483215 
	C824.091675,362.825043 826.233337,355.166870 828.375000,347.508728 
	C828.811157,347.472351 829.247314,347.435944 829.683472,347.399567 
	C833.021179,355.047668 836.358948,362.695770 839.427002,370.595398 
z"/>
<path fill="#F0D5C1" opacity="1.000000" stroke="none" 
	d="
M847.712158,360.246277 
	C846.895142,359.458862 846.314880,358.947174 844.857666,357.662231 
	C844.857666,362.610168 844.857666,366.602661 844.857666,370.595184 
	C844.418884,370.589844 843.980103,370.584503 843.541321,370.579132 
	C843.541321,363.056824 843.541321,355.534485 843.541321,347.604004 
	C847.433289,347.203949 851.952332,345.985443 854.391785,350.257782 
	C854.966492,351.264313 851.501221,354.577667 849.258728,357.720978 
	C851.737061,361.139008 855.135498,365.826111 858.533997,370.513184 
	C858.063538,370.898041 857.593018,371.282898 857.122559,371.667786 
	C852.986206,368.981415 851.176514,364.075317 847.712158,360.246277 
M848.293274,349.911713 
	C847.211426,350.531769 846.088379,351.098145 845.107239,351.849701 
	C845.001648,351.930573 845.764771,353.673340 846.049988,353.651855 
	C848.056763,353.500458 850.043884,353.088593 852.037292,352.759949 
	C852.010315,352.259521 851.983337,351.759064 851.956360,351.258606 
	C851.006348,350.824768 850.056396,350.390930 848.293274,349.911713 
z"/>
<path fill="#F0D5C1" opacity="1.000000" stroke="none" 
	d="
M912.909058,354.734680 
	C913.043518,353.691742 913.438538,352.487579 914.016235,350.996582 
	C916.189392,354.480530 918.179871,358.251343 920.170288,362.022156 
	C920.571228,362.020905 920.972229,362.019653 921.373169,362.018433 
	C921.373169,357.030579 921.373169,352.042725 921.373169,347.054901 
	C921.849182,347.017792 922.325195,346.980652 922.801147,346.943542 
	C923.236755,347.675964 924.021301,348.393494 924.053223,349.143066 
	C924.328369,355.603638 924.513855,362.069489 924.589661,368.535339 
	C924.599243,369.347809 923.817627,370.169586 923.402649,370.987061 
	C922.441711,370.287994 921.103210,369.797119 920.583496,368.854706 
	C917.993896,364.159546 915.619690,359.345551 912.909058,354.734680 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M798.416260,334.375183 
	C811.695557,334.062073 825.269043,334.060852 838.841553,333.953583 
	C840.950623,333.936920 843.055908,333.435577 845.984009,333.104431 
	C848.185608,332.995056 849.565979,332.939606 850.946411,332.884155 
	C852.643311,333.263947 854.335571,333.948029 856.037903,333.974426 
	C867.432983,334.151215 878.830261,334.187958 890.576904,334.450684 
	C888.114746,334.754333 885.302429,334.982605 882.490051,334.984192 
	C856.548218,334.998871 830.606323,334.981018 804.664490,334.948029 
	C802.679565,334.945496 800.694946,334.755249 798.416260,334.375183 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M761.932373,329.821045 
	C764.420776,329.868774 766.926880,330.315338 770.437439,330.940887 
	C768.509277,333.062622 767.282166,334.412964 765.648010,336.211121 
	C769.153870,338.862366 770.625000,344.208954 776.851685,342.397552 
	C777.337952,342.557526 777.562927,342.972229 777.728394,343.632233 
	C772.716370,343.834412 767.763855,343.791290 762.350159,343.631104 
	C762.789978,342.145477 763.690979,340.776917 763.998840,340.309326 
	C763.210449,336.426910 762.580261,333.323395 761.932373,329.821045 
z"/>
<path fill="#F0D5C1" opacity="1.000000" stroke="none" 
	d="
M900.028442,362.915924 
	C900.035034,357.446808 900.035034,352.462952 900.035034,347.479126 
	C900.685791,347.504974 901.336548,347.530792 901.987305,347.556641 
	C901.987305,355.418304 901.987305,363.279999 901.987305,371.141663 
	C901.332153,371.169556 900.677063,371.197418 900.021912,371.225281 
	C900.021912,368.617249 900.021912,366.009247 900.028442,362.915924 
z"/>
<path fill="#F0D5C1" opacity="1.000000" stroke="none" 
	d="
M912.228027,370.926483 
	C912.077087,370.704010 912.225464,370.463501 912.618591,370.147217 
	C912.879456,370.387390 912.767395,370.666412 912.228027,370.926483 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M131.922394,704.512878 
	C131.120499,704.966064 130.344696,704.974976 129.207184,704.566467 
	C128.590820,701.176392 128.119461,698.204102 128.113937,695.230957 
	C128.027328,648.574890 127.997643,601.918701 127.963676,555.262573 
	C127.958534,548.202271 127.979080,548.202271 120.972519,547.713013 
	C120.970612,547.513855 120.929710,547.117615 121.397858,547.077637 
	C126.588425,547.356323 131.310867,547.675049 136.033295,547.993774 
	C135.656830,549.365784 134.968643,550.733582 134.949890,552.110474 
	C134.560913,580.692200 134.400940,609.277710 133.870560,637.856445 
	C133.460876,659.931458 132.605637,681.998169 131.922394,704.512878 
z"/>
<path fill="#CBBB9F" opacity="1.000000" stroke="none" 
	d="
M166.266083,705.271545 
	C165.770279,705.204407 165.274445,705.137329 164.403824,705.093262 
	C163.837631,705.089905 163.646210,705.063538 163.164368,705.020996 
	C162.956497,686.596436 163.079132,668.188049 163.112381,649.779541 
	C163.164932,620.684814 163.144913,591.589966 163.196854,562.495239 
	C163.201569,559.850586 163.916656,557.147583 163.548340,554.579773 
	C163.219223,552.285095 161.847931,550.140015 160.755066,547.665527 
	C161.383667,547.263489 162.193710,547.124939 163.003754,546.986328 
	C165.495163,547.120483 167.986588,547.254639 170.436874,547.961670 
	C169.950104,553.632080 169.187347,558.724854 169.110336,563.827942 
	C168.613480,596.751648 168.287827,629.677917 167.859604,662.602722 
	C167.691010,675.565491 167.426285,688.527283 167.133209,701.487793 
	C167.104553,702.754944 166.567276,704.010559 166.266083,705.271545 
z"/>
<path fill="#E9DCC3" opacity="1.000000" stroke="none" 
	d="
M162.999420,546.556152 
	C162.193710,547.124939 161.383667,547.263489 160.373993,547.628784 
	C152.437317,547.910889 144.700272,547.966248 136.498260,548.007690 
	C131.310867,547.675049 126.588425,547.356323 120.936661,547.049805 
	C113.575180,547.038757 107.140854,546.906799 100.711731,547.035278 
	C97.169106,547.106079 93.635216,547.614197 89.689072,547.954712 
	C87.928192,548.014282 86.575630,548.044312 85.223076,548.074341 
	C84.372536,545.671814 83.522003,543.269287 82.345276,539.945374 
	C100.665649,539.945374 117.884537,539.945374 136.034424,539.938721 
	C145.650986,539.989441 154.336563,540.046753 163.022156,540.104126 
	C163.013123,542.111389 163.004089,544.118652 162.999420,546.556152 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M425.951172,208.879715 
	C424.650818,208.115738 423.350433,207.351776 421.479523,206.252594 
	C428.809723,204.611206 437.736115,207.669083 439.232910,211.979736 
	C441.493500,211.979736 443.818420,211.890915 446.133057,212.007111 
	C448.076111,212.104630 450.007202,212.441132 451.943573,212.671829 
	C451.962250,213.083282 451.980927,213.494720 451.999573,213.906174 
	C451.216339,214.303192 450.406036,215.090118 449.653961,215.037888 
	C440.571625,214.407135 431.505554,213.465683 422.415253,213.095413 
	C420.700500,213.025558 418.892975,215.125656 418.416260,211.493469 
	C422.126556,211.001648 425.463379,211.001648 428.800171,211.001648 
	C428.825348,210.585083 428.850525,210.168503 428.875702,209.751938 
	C427.900848,209.461197 426.926025,209.170456 425.951172,208.879715 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M458.237213,167.868774 
	C457.662140,168.026886 457.087036,168.185013 456.296936,168.551849 
	C452.021698,168.807190 447.961487,168.853821 443.439819,168.832565 
	C442.978363,168.764664 442.965088,168.397598 443.008698,168.170746 
	C443.052307,167.943878 443.148499,167.853622 443.549011,167.901688 
	C445.591400,167.083115 448.517822,166.367874 448.641083,165.322235 
	C449.056885,161.794220 445.975861,163.112183 444.061523,162.940063 
	C443.742096,162.911346 443.409454,163.029205 443.047119,163.048462 
	C443.011353,163.017609 442.936188,162.960373 442.936188,162.960373 
	C442.936188,162.960373 442.956726,162.478745 442.959412,162.237671 
	C447.820404,162.158676 452.678711,162.320770 457.794983,163.198883 
	C458.114380,165.232880 458.175781,166.550812 458.237213,167.868774 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M435.587891,196.884766 
	C428.430603,196.884003 421.711212,197.075684 415.041962,196.637070 
	C415.067413,195.983490 415.092865,195.329895 415.118317,194.676300 
	C422.872986,194.676300 430.627655,194.676300 438.382324,194.676300 
	C438.546417,194.907959 438.710541,195.139618 438.874664,195.371277 
	C437.930176,195.875366 436.985687,196.379440 435.587891,196.884766 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M431.987457,220.012497 
	C432.556488,218.906235 433.125519,217.799957 433.552063,216.970734 
	C437.557068,216.970734 441.356171,216.838501 445.134064,217.063248 
	C446.084473,217.119781 446.966827,218.320038 447.880463,218.994690 
	C447.118439,219.663834 446.385132,220.869720 445.589569,220.912277 
	C441.398987,221.136597 437.192657,221.067322 432.493866,221.045044 
	C431.995941,220.990143 431.858459,220.801697 431.906250,220.598419 
	C431.954071,220.395142 432.014679,219.981949 432.008423,219.989471 
	C432.002167,219.997009 431.987457,220.012497 431.987457,220.012497 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M432.064850,221.084259 
	C429.760315,220.941925 427.386902,220.705475 424.419189,220.409836 
	C424.489746,220.354355 423.595825,221.592804 422.943268,221.476517 
	C420.264923,220.999283 417.660034,220.109619 414.385284,219.191467 
	C415.651611,217.686905 415.890747,217.212143 416.053711,217.237000 
	C420.098358,217.853470 424.051422,216.759323 428.035706,216.709747 
	C429.336639,216.693542 430.658478,218.354965 431.979095,219.630798 
	C431.987457,220.012497 432.002167,219.997009 431.854309,220.054108 
	C431.706421,220.111206 431.528839,220.495178 431.528839,220.495178 
	C431.528839,220.495178 431.858459,220.801697 431.858459,220.801697 
	C431.858459,220.801697 431.995941,220.990143 432.064850,221.084259 
M428.387909,218.479050 
	C428.387909,218.479050 428.511292,218.396652 428.387909,218.479050 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M420.213196,176.838898 
	C420.455597,177.528656 420.294769,178.707275 420.106781,178.711609 
	C415.635315,178.814774 411.160950,178.791779 406.687103,178.791779 
	C406.678284,178.121414 406.669464,177.451050 406.660645,176.780685 
	C411.039551,176.780685 415.418427,176.780685 420.213196,176.838898 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M425.497864,208.914276 
	C426.926025,209.170456 427.900848,209.461197 428.875702,209.751938 
	C428.850525,210.168503 428.825348,210.585083 428.800171,211.001648 
	C425.463379,211.001648 422.126556,211.001648 418.407776,211.097137 
	C417.731537,211.196487 417.437286,211.200333 416.715942,211.384613 
	C416.288879,211.565048 416.318512,211.602722 416.318512,211.602722 
	C416.663727,210.725372 416.939484,209.129822 417.365570,209.088608 
	C419.905945,208.842926 422.481079,208.956116 425.497864,208.914276 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M446.146088,201.759506 
	C448.975067,201.759064 451.346802,201.759064 453.718536,201.759064 
	C453.709229,202.254410 453.699921,202.749741 453.690613,203.245087 
	C449.629608,203.245087 445.568573,203.245087 441.507568,203.245087 
	C441.449249,202.896378 441.390961,202.547653 441.332672,202.198944 
	C442.784729,202.052612 444.236786,201.906281 446.146088,201.759506 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M415.851288,211.690826 
	C416.318512,211.602722 416.288879,211.565048 416.300476,211.533798 
	C416.514801,212.404633 416.717499,213.306717 417.076813,214.905884 
	C414.766144,214.350204 413.059052,213.939667 411.351959,213.529129 
	C411.360168,213.173508 411.368378,212.817902 411.376587,212.462280 
	C412.712402,212.234497 414.048248,212.006699 415.851288,211.690826 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M417.258240,208.084076 
	C416.621094,207.439728 416.360168,206.814713 416.099213,206.189682 
	C417.571381,206.189682 419.043579,206.189682 420.515747,206.189682 
	C420.538055,206.605606 420.560364,207.021515 420.582642,207.437439 
	C419.599915,207.659424 418.617157,207.881393 417.258240,208.084076 
z"/>
<path fill="#54BBD7" opacity="1.000000" stroke="none" 
	d="
M721.972595,366.279083 
	C726.620178,366.279083 731.267761,366.279083 736.835083,366.279083 
	C736.835083,399.920105 736.835083,433.476074 736.827026,467.495605 
	C736.078613,468.047852 735.338257,468.136536 734.049438,468.246216 
	C733.500916,468.267242 733.128662,468.410919 733.128662,468.410919 
	C732.610962,468.359833 732.093262,468.308777 730.766479,468.211151 
	C726.703552,468.236206 723.449585,468.307800 720.195679,468.379425 
	C711.104919,468.282013 702.014221,468.184601 692.460815,467.634033 
	C692.343201,465.574005 692.581787,463.935394 693.049988,462.365204 
	C697.344238,447.964630 701.678284,433.575928 706.463379,419.110840 
	C714.481079,419.037872 722.036133,419.037872 729.707581,419.037872 
	C729.707581,402.660553 729.707581,387.033142 729.707581,371.180267 
	C726.230652,371.016571 723.119751,370.870087 720.192017,370.464722 
	C720.907776,368.896912 721.440186,367.588013 721.972595,366.279083 
z"/>
<path fill="#54BBD7" opacity="1.000000" stroke="none" 
	d="
M621.287476,371.362610 
	C621.078247,370.567963 621.095520,370.106781 621.080383,369.300323 
	C623.114380,368.004578 625.168335,366.262726 627.249390,366.229858 
	C642.838379,365.983673 658.432617,366.074890 674.480835,365.991455 
	C674.936340,365.922485 674.997803,366.133301 674.984131,366.597656 
	C671.363586,376.828217 667.756653,386.594421 664.092529,396.515320 
	C670.290955,396.999542 675.656189,397.418701 680.553955,397.890381 
	C663.317139,397.942932 646.547729,397.942932 629.604980,397.942932 
	C629.604980,420.199799 629.604980,441.861511 629.604980,463.615753 
	C632.375732,463.784180 634.691589,463.924927 636.967163,464.399475 
	C636.614685,465.797394 636.302429,466.861542 635.990112,467.925720 
	C634.869934,468.016541 633.749817,468.107391 631.817505,468.179779 
	C629.065369,468.224701 627.125366,468.288025 625.185425,468.351349 
	C624.671753,468.305511 624.158142,468.259674 623.036499,468.200287 
	C622.428467,468.186737 621.963745,468.301971 621.963745,468.301971 
	C621.963745,468.301971 621.905151,468.037354 621.846130,467.914520 
	C621.774353,465.675476 621.750488,463.559265 621.750549,461.443054 
	C621.751038,432.016907 621.756042,402.590729 621.747742,373.164581 
	C621.747559,372.675049 621.595276,372.185608 621.287476,371.362610 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M681.021423,397.837860 
	C675.656189,397.418701 670.290955,396.999542 664.092529,396.515320 
	C667.756653,386.594421 671.363586,376.828217 674.957458,366.704163 
	C690.312744,366.270966 705.681030,366.195618 721.510986,366.199707 
	C721.440186,367.588013 720.907776,368.896912 719.725586,370.539276 
	C709.517578,370.872742 699.959229,370.872742 690.381226,370.872742 
	C690.381226,387.339172 690.381226,402.894562 690.381226,419.183777 
	C695.787048,419.183777 700.893860,419.183777 706.000732,419.183777 
	C701.678284,433.575928 697.344238,447.964630 693.049988,462.365204 
	C692.581787,463.935394 692.343201,465.574005 691.993408,467.585541 
	C673.633240,468.008881 655.277771,468.027588 636.456177,467.985962 
	C636.302429,466.861542 636.614685,465.797394 637.429810,464.318207 
	C652.470520,463.903168 667.008484,463.903168 681.767151,463.903168 
	C681.767151,441.836761 681.773376,420.735016 681.735962,399.633331 
	C681.734863,399.034424 681.269958,398.436340 681.021423,397.837860 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M674.980347,478.954773 
	C679.076782,478.954895 682.680054,478.954895 686.283386,478.954895 
	C686.271606,479.414001 686.259888,479.873108 686.248108,480.332214 
	C677.728821,480.332214 669.209473,480.332214 660.690186,480.332214 
	C660.674561,479.873047 660.658875,479.413849 660.643250,478.954681 
	C665.257874,478.954681 669.872498,478.954681 674.980347,478.954773 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M720.510498,468.578125 
	C723.449585,468.307800 726.703552,468.236206 730.380249,468.277405 
	C727.477173,468.519043 724.151245,468.647949 720.510498,468.578125 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M625.463074,468.547424 
	C627.125366,468.288025 629.065369,468.224701 631.404785,468.265320 
	C629.783081,468.494049 627.761902,468.618744 625.463074,468.547424 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M620.026611,467.967773 
	C619.958679,467.977722 619.862732,468.018188 619.913452,468.001038 
	C620.059998,467.943451 619.998718,467.998322 620.026611,467.967773 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M733.206116,468.497070 
	C733.128662,468.410919 733.500916,468.267242 733.686279,468.338104 
	C733.871582,468.408966 733.609741,468.620880 733.609741,468.620880 
	C733.609741,468.620880 733.283569,468.583221 733.206116,468.497070 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M622.067993,468.398315 
	C621.963745,468.301971 622.428467,468.186737 622.653625,468.264221 
	C622.878784,468.341705 622.556885,468.580872 622.556885,468.580872 
	C622.556885,468.580872 622.172302,468.494629 622.067993,468.398315 
z"/>
<path fill="#EDF8FD" opacity="1.000000" stroke="none" 
	d="
M85.119019,548.421509 
	C86.575630,548.044312 87.928192,548.014282 90.147598,547.993652 
	C101.001106,547.972717 110.987770,547.942444 120.974426,547.912170 
	C127.979080,548.202271 127.958534,548.202271 127.963676,555.262573 
	C127.997643,601.918701 128.027328,648.574890 128.113937,695.230957 
	C128.119461,698.204102 128.590820,701.176392 128.818130,704.566040 
	C122.350777,704.667480 115.901703,703.972778 109.472908,704.126404 
	C100.066933,704.351196 90.679825,705.280884 81.275383,705.703308 
	C78.188133,705.841980 75.072006,705.337463 71.579987,705.064575 
	C71.743805,687.254028 72.517555,669.509277 72.791199,651.756714 
	C73.101364,631.635376 72.970314,611.507080 73.017799,591.381836 
	C73.047623,578.740784 73.007805,566.099365 73.122543,553.459229 
	C73.138107,551.745239 73.873329,550.037842 74.592941,548.081543 
	C75.980270,547.897400 77.049995,547.959106 78.517990,548.010681 
	C80.019073,549.736206 81.445892,551.346802 82.171951,553.227905 
	C86.772461,565.146973 99.508347,572.722778 111.996651,570.624207 
	C115.486198,570.037781 119.176392,569.099365 118.903450,564.352722 
	C118.644562,559.850464 114.837631,559.461792 111.642090,559.066040 
	C108.036415,558.619568 104.335144,559.015930 100.693291,558.775513 
	C93.685112,558.312866 87.834274,555.872253 85.119019,548.421509 
z"/>
<path fill="#A78C7C" opacity="1.000000" stroke="none" 
	d="
M163.430374,540.043457 
	C154.336563,540.046753 145.650986,539.989441 136.502350,539.881775 
	C135.290253,534.705139 131.768784,532.731201 127.201500,533.111328 
	C122.351112,533.514954 120.695190,531.651062 119.679291,527.031799 
	C118.161278,520.129395 114.838692,513.706421 108.862915,509.599701 
	C105.413437,507.229095 101.031197,506.215790 96.300995,504.276825 
	C98.962334,503.520966 101.556305,502.328278 104.230629,502.107117 
	C113.598343,501.332428 122.741234,502.651031 131.619385,505.815643 
	C139.434204,508.601227 147.344162,511.133789 155.071518,514.139526 
	C156.690430,514.769287 158.849030,517.024475 158.792694,518.453064 
	C158.457870,526.945374 162.219696,533.403625 167.915680,539.464111 
	C166.581558,539.855103 165.210083,539.919006 163.430374,540.043457 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M760.958740,638.965820 
	C760.642761,658.196838 760.288086,677.427429 760.059021,696.659485 
	C760.029907,699.105347 760.657349,701.558899 760.979736,704.426331 
	C748.517029,704.909973 736.055420,705.029907 723.593750,705.032654 
	C683.369812,705.041443 643.145935,705.007141 602.363403,704.735535 
	C601.633484,704.269531 601.422852,704.108765 601.021423,703.676025 
	C597.768127,701.093506 595.360352,698.631714 595.523926,694.226501 
	C595.585754,692.562500 593.807678,690.830261 593.144775,688.885071 
	C597.777893,675.754639 602.622681,663.008118 606.366150,649.945984 
	C610.931946,634.014771 614.434998,617.797424 613.976013,600.562988 
	C612.986206,592.001038 612.354431,583.832642 610.839600,575.831482 
	C609.941223,571.086121 607.650085,566.604431 606.428467,562.002075 
	C609.488770,562.314270 612.118591,562.547180 614.720886,562.955566 
	C647.728760,568.135498 679.809570,576.560791 709.548462,592.131958 
	C729.673096,602.669250 748.100037,615.464905 758.497864,636.864319 
	C758.929932,637.753479 760.121216,638.273682 760.958740,638.965820 
z"/>
<path fill="#684347" opacity="1.000000" stroke="none" 
	d="
M469.498535,704.956177 
	C472.051544,700.001465 473.930359,695.000122 470.268097,689.207886 
	C474.449768,675.066589 478.884491,661.188232 483.394836,647.334595 
	C486.472076,637.882507 489.654968,628.464905 493.295410,618.586182 
	C501.400879,618.140442 509.001556,618.140442 516.988586,618.140442 
	C517.349609,622.734253 517.792725,626.674866 517.943970,630.626526 
	C518.343933,641.080994 518.502441,651.545532 518.971680,661.996399 
	C519.511475,674.018616 519.611511,674.014099 507.548157,674.012817 
	C507.381653,674.012817 507.215149,674.010742 507.048676,674.013123 
	C503.671692,674.061584 499.852203,673.018372 498.622345,677.950317 
	C498.478119,678.528748 496.694092,678.944214 495.645935,679.003052 
	C492.990204,679.152283 490.320709,679.054626 487.656708,679.057678 
	C480.142212,679.066345 477.449493,682.001953 477.477112,690.550293 
	C506.480011,690.550293 535.485229,690.550293 564.458191,690.550293 
	C565.377625,682.579651 562.517090,679.104736 555.251404,679.060730 
	C552.254456,679.042603 549.246521,679.199219 546.266113,678.975586 
	C545.155029,678.892273 543.386658,678.159912 543.156860,677.365356 
	C542.149963,673.883179 539.646667,673.911316 536.863403,673.989746 
	C533.536072,674.083496 530.193726,673.844727 526.876953,674.053467 
	C523.649658,674.256592 522.734985,672.749207 523.061279,669.879028 
	C523.379089,667.083130 523.834656,664.288452 523.923828,661.483459 
	C524.335815,648.531311 524.704712,635.576904 524.937622,622.620544 
	C524.992737,619.556519 525.864685,617.969788 529.214111,618.033447 
	C538.531067,618.210388 547.851196,618.221985 557.108154,618.659546 
	C557.405640,620.439819 557.551453,621.958435 558.157104,623.263733 
	C564.849792,637.688232 571.502808,652.133057 578.403320,666.458374 
	C582.126648,674.187988 586.306519,681.697571 590.061523,689.597351 
	C586.107727,695.198975 589.665100,699.965149 590.963684,704.899963 
	C554.776428,704.937378 518.589233,704.974854 482.401978,705.011963 
	C478.254883,705.016235 474.107758,705.018250 469.498535,704.956177 
M475.542603,697.789673 
	C475.573547,701.341797 476.763123,704.319580 480.809052,704.038086 
	C484.311005,703.794556 485.531189,700.805298 484.683014,697.833984 
	C484.183502,696.084045 482.118622,693.630737 480.703003,693.593872 
	C479.061920,693.551147 477.360779,695.811157 475.542603,697.789673 
M519.598938,693.977722 
	C519.434143,694.000061 519.264160,694.003601 519.105347,694.047485 
	C515.946350,694.921753 514.544312,697.260132 515.701904,700.069092 
	C516.369019,701.687805 518.770630,703.670532 520.265076,703.571960 
	C521.821106,703.469360 524.073730,701.279419 524.506042,699.609741 
	C525.243774,696.760620 523.596985,694.517639 519.598938,693.977722 
M561.467163,694.656311 
	C561.080505,696.923767 560.396484,699.200317 560.465027,701.453918 
	C560.489746,702.265991 562.282471,703.569946 563.342102,703.648071 
	C564.356079,703.722778 565.835449,702.744446 566.467529,701.799072 
	C568.820251,698.280518 566.543762,694.475220 561.467163,694.656311 
z"/>
<path fill="#CBBB9F" opacity="1.000000" stroke="none" 
	d="
M591.238525,705.201416 
	C589.665100,699.965149 586.107727,695.198975 590.380005,689.524048 
	C591.567749,689.149658 592.217957,689.139404 592.868225,689.129089 
	C593.807678,690.830261 595.585754,692.562500 595.523926,694.226501 
	C595.360352,698.631714 597.768127,701.093506 600.972412,703.901611 
	C601.075073,704.450562 601.017639,704.908813 601.017639,704.908813 
	C597.849548,705.106812 594.681396,705.304810 591.238525,705.201416 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M601.266663,704.949341 
	C601.017639,704.908813 601.075073,704.450562 601.124084,704.224976 
	C601.422852,704.108765 601.633484,704.269531 601.900146,704.657715 
	C601.835571,704.885803 601.675659,704.937805 601.266663,704.949341 
z"/>
<path fill="#59B6CF" opacity="1.000000" stroke="none" 
	d="
M342.039185,464.086395 
	C342.363220,467.687073 340.845642,469.235931 337.119934,469.080231 
	C333.318787,468.921417 329.498077,469.229584 325.365234,469.577759 
	C324.616913,469.851593 324.189240,469.881012 323.446228,469.441772 
	C323.077728,466.995972 323.024597,465.018860 322.971497,463.041748 
	C323.003601,459.652313 323.035706,456.262878 323.080139,451.953430 
	C323.052216,424.037720 323.011963,397.042023 322.971710,370.046326 
	C323.004059,366.986359 323.036407,363.926361 323.079895,359.952423 
	C323.082458,354.358582 323.073914,349.678741 323.065369,344.998871 
	C323.236786,344.745636 323.436462,344.517151 324.308258,344.196869 
	C344.283569,344.018646 363.615051,343.956940 382.946533,343.895203 
	C385.644012,343.963776 388.341522,344.032318 391.255157,344.424500 
	C389.992493,348.103729 388.513672,351.459351 386.568909,354.888733 
	C367.207184,354.962494 348.311340,354.962494 329.343018,354.962494 
	C329.343018,391.622009 329.343018,427.465881 329.343018,464.086395 
	C333.802368,464.086395 337.920776,464.086395 342.039185,464.086395 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M373.478699,478.958679 
	C381.388245,478.955841 388.851746,478.955841 396.315247,478.955841 
	C396.304718,479.455475 396.294159,479.955139 396.283630,480.454773 
	C387.755127,480.454773 379.226654,480.454773 370.698151,480.454773 
	C370.651642,480.171997 370.605103,479.889252 370.558563,479.606476 
	C371.383270,479.391510 372.207947,479.176514 373.478699,478.958679 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M322.703003,463.306824 
	C323.024597,465.018860 323.077728,466.995972 323.128052,469.393982 
	C322.931946,469.845734 322.738647,469.876556 322.259827,469.839203 
	C322.127686,467.704651 322.281128,465.638275 322.703003,463.306824 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M316.273987,469.908905 
	C316.025909,469.914124 316.046509,469.445679 316.116882,469.221985 
	C316.440094,469.070007 316.649048,469.208130 316.903778,469.580597 
	C316.993469,469.748535 316.522095,469.903687 316.273987,469.908905 
z"/>
<path fill="#58353B" opacity="1.000000" stroke="none" 
	d="
M760.965515,638.500732 
	C760.121216,638.273682 758.929932,637.753479 758.497864,636.864319 
	C748.100037,615.464905 729.673096,602.669250 709.548462,592.131958 
	C679.809570,576.560791 647.728760,568.135498 614.720886,562.955566 
	C612.118591,562.547180 609.488770,562.314270 606.436523,562.000122 
	C606.001343,562.000366 606.000793,562.013184 605.891113,561.794556 
	C605.582275,561.303711 605.323425,561.112244 604.702393,560.851196 
	C600.390076,556.424377 596.561768,551.956177 592.313416,547.931396 
	C588.880676,544.679260 584.941711,541.961548 581.227356,539.006714 
	C581.424744,536.565735 581.622131,534.124817 581.916748,531.281982 
	C634.011597,530.914001 686.009033,530.946838 738.006531,530.982910 
	C745.339478,530.988037 752.672363,531.008850 760.465454,531.055298 
	C760.941101,566.737366 760.956665,602.386536 760.965515,638.500732 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M665.460449,522.009766 
	C665.471069,516.499634 668.759338,515.270081 673.599548,515.949829 
	C675.716309,516.247070 677.908142,516.009766 680.530151,516.019836 
	C684.491150,516.343262 688.003296,517.029297 691.480347,516.882324 
	C695.318176,516.720276 696.527344,518.230469 695.946655,522.155029 
	C685.912231,522.390747 675.892090,522.223755 665.460449,522.009766 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M351.880707,535.692200 
	C343.912598,535.082275 335.944458,534.472351 327.528046,533.511414 
	C327.109009,532.535706 327.138245,531.911011 327.167480,531.286316 
	C346.133606,531.534363 365.099762,531.782410 384.533447,532.012695 
	C381.322113,533.117493 377.643250,534.239990 373.133240,535.355774 
	C365.494934,535.463440 358.687836,535.577820 351.880707,535.692200 
z"/>
<path fill="#F3EDD2" opacity="1.000000" stroke="none" 
	d="
M381.796631,517.313049 
	C386.822510,516.858032 391.656921,519.488586 396.383514,516.214355 
	C397.074158,515.735901 399.330658,517.517822 400.696716,518.750305 
	C400.353241,519.542725 400.175659,519.838684 399.998077,520.134583 
	C400.031403,520.611877 400.064758,521.089111 400.123596,521.793274 
	C391.425507,522.265808 382.701904,522.511475 373.522034,522.665833 
	C372.542999,519.355591 373.483826,517.544250 377.172150,517.942932 
	C378.589508,518.096191 380.062347,517.736206 381.796631,517.313049 
z"/>
<path fill="#59363C" opacity="1.000000" stroke="none" 
	d="
M407.372284,522.374756 
	C408.443207,520.938538 409.825439,519.768799 411.208618,518.206116 
	C415.041931,519.360901 418.874268,520.908630 422.957031,522.720825 
	C418.032837,522.870605 412.858215,522.755920 407.372284,522.374756 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M326.699127,531.167725 
	C327.138245,531.911011 327.109009,532.535706 327.067017,533.473999 
	C320.740021,533.460144 314.425781,533.132690 307.663635,532.770142 
	C308.398407,532.180176 309.565430,531.189148 310.766388,531.146057 
	C315.915741,530.961609 321.075073,531.056213 326.699127,531.167725 
z"/>
<path fill="#584144" opacity="1.000000" stroke="none" 
	d="
M365.991089,173.532135 
	C366.006042,184.356110 365.957275,194.715302 365.980255,205.538712 
	C366.051971,213.805588 366.051971,221.608261 366.051971,229.715790 
	C364.304688,229.911942 363.045563,230.168869 361.785095,230.175644 
	C354.621094,230.214157 347.442047,230.479950 340.296600,230.113373 
	C332.764252,229.726944 325.269989,228.196762 317.747986,228.107941 
	C307.700104,227.989288 297.639740,228.740372 287.588623,229.202271 
	C284.937195,229.324127 282.301605,229.988861 279.656067,230.006500 
	C266.665588,230.093231 253.674225,230.045868 240.267181,230.045868 
	C240.267181,200.637039 240.267181,171.252029 240.267181,142.238235 
	C246.037247,143.101288 251.597153,145.269318 257.636444,141.655151 
	C259.993591,140.244537 263.811798,141.275391 267.483643,141.361511 
	C268.002747,141.528824 267.996765,142.001740 267.692474,142.114075 
	C268.576294,143.196823 269.764404,144.167236 270.941101,145.399857 
	C270.920013,146.011566 270.910370,146.361053 270.485779,146.753448 
	C268.349152,147.528015 266.627380,148.259689 264.657715,148.737030 
	C262.915924,147.345154 261.422058,146.207611 259.928162,145.070068 
	C259.142242,146.279388 258.356323,147.488708 258.229828,147.683365 
	C260.513947,149.340775 261.826294,150.293015 263.078186,151.444534 
	C263.017731,151.643799 262.855499,152.027390 262.658630,152.179993 
	C262.592224,152.893372 262.722717,153.454132 263.325897,154.077087 
	C268.896210,153.755951 273.993866,153.372604 279.239563,152.888641 
	C279.257385,152.525879 279.127106,152.263733 278.998413,152.000793 
	C279.000000,152.000000 278.997589,152.003052 279.000061,151.636765 
	C278.996735,150.781998 278.990936,150.293503 279.375488,149.700989 
	C281.878479,149.553711 284.028992,149.722931 286.083862,149.356186 
	C286.839752,149.221283 287.369598,147.820221 288.029785,146.719025 
	C288.072144,146.070343 288.087250,145.699341 288.455627,145.257050 
	C289.524445,145.188431 290.239960,145.191071 290.964691,145.535522 
	C291.027649,146.330490 291.081390,146.783661 291.139526,147.518768 
	C291.429169,148.248352 291.714386,148.695999 292.197784,149.377106 
	C292.986084,149.670273 293.576202,149.729980 294.617310,149.753403 
	C297.511688,149.731796 299.955078,149.746490 302.452301,150.083344 
	C302.737427,151.015732 302.968719,151.625961 303.209839,152.642075 
	C303.320709,153.531845 303.429565,154.440750 303.521790,154.439072 
	C310.371063,154.313522 317.219818,154.135696 324.064789,153.864532 
	C324.399261,153.851273 324.699432,152.970398 325.739685,151.401352 
	C318.194336,151.401352 311.614685,151.401352 304.914734,150.993958 
	C304.717651,150.314026 304.640869,150.041489 304.905518,149.733185 
	C306.071899,148.882965 306.896851,148.068512 307.798767,146.911163 
	C307.931458,146.103394 307.987183,145.638519 308.476929,145.102203 
	C316.033356,144.675247 323.155701,144.319656 330.278076,143.964233 
	C335.893524,143.684006 341.509003,143.403961 347.447144,143.135437 
	C348.187012,142.455719 348.604248,141.764374 349.489014,141.103699 
	C355.252991,141.198273 360.549408,141.262207 365.845825,141.326126 
	C365.873016,151.906540 365.900208,162.486969 365.991089,173.532135 
M295.691925,218.998245 
	C296.132599,218.988724 296.573242,218.979202 297.005127,218.991440 
	C297.005127,218.991440 297.028320,218.991592 297.007324,219.728256 
	C297.704742,221.323639 298.402130,222.919037 298.621674,223.421265 
	C301.751495,222.348053 303.735413,221.666733 305.720032,220.987656 
	C307.150726,220.498108 308.582367,220.011444 310.685364,219.187729 
	C312.674164,219.033844 314.662994,218.879959 317.421387,219.082581 
	C318.179413,219.370239 319.007233,220.007584 319.681000,219.873093 
	C321.100433,219.589737 322.439087,218.901932 323.810913,218.380127 
	C322.699646,217.572906 321.589264,216.764481 320.476868,215.958847 
	C319.662964,215.369400 318.846497,214.783569 318.908997,214.101273 
	C320.923645,214.101273 322.938293,214.101273 324.952942,214.101273 
	C325.041168,213.650742 325.129364,213.200226 325.217560,212.749695 
	C324.593109,212.224609 323.978027,211.256760 323.342773,211.243362 
	C317.387024,211.117722 311.421539,211.026901 305.477692,211.314484 
	C304.763855,211.349014 304.161713,213.692474 302.899506,215.755737 
	C300.937103,215.938522 298.974670,216.121292 296.802368,215.344772 
	C297.582153,214.509705 298.361938,213.674622 299.898621,212.029022 
	C293.439392,212.029022 288.205322,211.988861 282.975494,212.119781 
	C282.628510,212.128479 282.314148,213.438477 281.929047,214.746964 
	C281.278839,215.474289 280.628632,216.201614 280.004456,216.986145 
	C280.004456,216.986145 279.941742,216.981934 279.523071,217.297791 
	C279.677368,217.858795 279.831635,218.419785 280.807587,219.156296 
	C282.196228,219.266388 283.584900,219.376465 285.011353,220.029404 
	C285.018524,220.392151 285.025696,220.754898 284.096436,221.212524 
	C268.609039,221.301437 268.609039,221.301437 266.380493,224.139557 
	C274.063782,224.139557 281.060455,224.176086 288.052704,224.017212 
	C288.359222,224.010254 288.625122,222.214188 288.931000,220.654739 
	C288.969147,220.259796 289.007263,219.864868 289.869232,219.310242 
	C291.270355,219.272751 292.671448,219.235245 294.273499,219.470108 
	C294.525940,219.317184 294.778381,219.164261 295.691925,218.998245 
M282.950928,154.305817 
	C288.437042,154.305817 293.923187,154.305817 299.409302,154.305817 
	C299.422211,153.649902 299.435120,152.993988 299.448029,152.338074 
	C298.305969,152.025482 297.163940,151.712891 295.799805,151.173538 
	C295.457916,151.054535 295.180664,151.136505 294.059662,151.557556 
	C290.931641,151.564362 287.788574,151.398163 284.683563,151.668869 
	C283.548126,151.767853 282.503174,152.904007 281.255066,153.937195 
	C281.509552,154.038498 281.764069,154.139786 282.950928,154.305817 
M279.982330,157.825684 
	C280.045929,158.469040 280.109528,159.112381 280.096161,160.332489 
	C280.055756,160.717804 280.015350,161.103134 279.050934,161.530914 
	C275.364349,161.530914 271.677765,161.530914 267.991180,161.530914 
	C267.866364,162.066513 267.741516,162.602112 267.616699,163.137711 
	C268.395630,163.661362 269.164490,164.620514 269.955139,164.638840 
	C275.598236,164.769592 281.250824,164.827255 286.886627,164.586121 
	C287.778534,164.547958 288.601044,162.886581 289.980194,161.592697 
	C296.686340,159.693649 291.196655,166.458923 294.316711,167.418610 
	C294.793549,165.990936 295.266968,164.573471 295.843658,162.846771 
	C297.310028,163.576889 298.404175,164.121658 299.498352,164.666443 
	C299.423553,164.194763 299.348785,163.723083 299.273987,163.251404 
	C301.601898,162.480698 303.920013,161.678513 306.261688,160.952209 
	C307.481903,160.573746 308.743622,160.328979 310.484344,159.920853 
	C310.812073,159.840256 311.139771,159.759659 312.214447,159.862671 
	C315.137695,160.171249 318.065186,160.707336 320.981659,160.653015 
	C321.884277,160.636200 322.756958,159.013687 323.643341,158.126328 
	C322.855377,157.439102 322.039215,156.136642 321.284332,156.171249 
	C318.034180,156.320175 314.802063,156.861526 311.020020,157.130493 
	C310.661224,157.029572 310.302399,156.928650 309.314209,156.327194 
	C305.223572,156.595413 301.132935,156.863632 297.126923,157.112137 
	C297.126923,157.112137 297.149963,157.195923 296.637634,157.433655 
	C296.270142,158.020111 295.902649,158.606567 295.526154,159.207413 
	C294.900848,158.333969 294.440002,157.690292 293.465851,156.971039 
	C293.296173,156.937439 293.126495,156.903839 292.320068,156.380142 
	C288.237427,156.646957 284.154755,156.913757 279.982330,157.825684 
M276.560944,209.800812 
	C276.012329,209.084305 275.546234,207.845673 274.900482,207.743591 
	C272.391785,207.346954 269.703522,206.778580 267.323730,207.325500 
	C265.687805,207.701447 264.450439,209.811676 263.010559,211.978806 
	C265.150299,214.593918 276.752380,215.145584 278.775482,212.679016 
	C279.025604,212.374100 278.853333,211.722763 278.952087,210.543869 
	C278.966431,210.313583 278.980804,210.083298 279.875397,209.702057 
	C282.607147,209.470917 285.338898,209.239792 288.070648,209.008667 
	C288.001038,208.242691 287.931396,207.476730 287.861786,206.710754 
	C284.535828,206.710754 281.205933,206.645660 277.891968,206.844711 
	C277.648895,206.859314 277.520538,208.782959 276.560944,209.800812 
M319.962463,194.140259 
	C324.231873,194.157455 328.509918,194.328064 332.764954,194.088974 
	C333.893890,194.025528 334.952087,192.702744 336.238495,191.600708 
	C336.238495,191.600708 336.205750,191.194473 336.741394,190.794739 
	C337.863281,189.203537 338.985138,187.612320 340.599518,185.916229 
	C340.736725,185.625107 340.873932,185.333969 341.896515,184.934952 
	C344.848572,184.301300 347.800629,183.667633 350.835815,182.516144 
	C350.548218,182.391327 350.260620,182.266510 349.049561,181.993408 
	C342.572571,181.980881 336.092926,181.870926 329.621002,182.045853 
	C328.460327,182.077225 327.331482,183.284851 326.146149,184.474487 
	C326.368195,184.943573 326.590210,185.412659 325.980042,185.998444 
	C321.724152,186.667343 317.445343,187.224625 313.229858,188.090225 
	C312.276459,188.285980 311.543243,189.553909 310.862671,191.059784 
	C311.714050,197.596756 316.163788,193.438995 319.962463,194.140259 
M300.458008,204.705444 
	C300.661072,205.122894 300.864136,205.540344 300.312195,206.457458 
	C297.581451,206.708817 294.850708,206.960175 290.877655,207.325882 
	C296.758942,211.173798 300.228882,210.258774 301.739227,205.797943 
	C304.505463,206.735458 307.271698,207.672974 310.178345,208.658066 
	C309.327972,205.795303 308.478210,202.934677 307.847107,199.414490 
	C309.083038,196.770706 307.704468,196.225800 305.400543,196.254272 
	C300.760803,196.311676 296.118561,196.231277 291.481079,196.352173 
	C290.572540,196.375870 289.681030,197.053070 288.781647,197.428879 
	C288.824341,197.905045 288.867004,198.381195 288.909698,198.857361 
	C290.853912,199.014862 292.841125,198.976669 294.728821,199.391388 
	C296.255615,199.726807 297.662567,200.607620 298.205200,201.365372 
	C294.466064,201.528915 290.726959,201.692459 286.987823,201.856018 
	C287.007416,202.534973 287.027008,203.213928 287.046600,203.892868 
	C291.265106,205.376846 295.646149,204.867493 300.458008,204.705444 
M307.491150,174.764648 
	C311.311523,174.763809 315.136505,174.866760 318.949371,174.696945 
	C320.049469,174.647949 321.114624,173.814255 322.195801,173.340302 
	C321.085999,172.725006 319.983765,171.592209 318.865173,171.575806 
	C309.399384,171.437012 299.930206,171.460846 290.463287,171.556946 
	C289.262207,171.569122 288.068268,172.279877 286.871002,172.666992 
	C286.938019,173.366440 287.005005,174.065903 287.072021,174.765350 
	C293.546112,174.765350 300.020203,174.765350 307.491150,174.764648 
M282.692902,191.236450 
	C280.511810,191.413467 278.330688,191.590485 276.149597,191.767502 
	C276.208160,192.418243 276.266724,193.068985 276.325287,193.719727 
	C282.959625,193.719727 289.593994,193.719727 296.228333,193.719727 
	C296.297455,193.163940 296.366547,192.608170 296.435669,192.052383 
	C292.387665,190.447266 287.887604,191.586227 282.692902,191.236450 
M295.636200,179.742355 
	C307.006714,179.771362 307.006714,179.771362 307.868683,177.567047 
	C301.616516,177.567047 295.307343,177.567047 288.998138,177.567047 
	C288.953766,178.085068 288.909424,178.603104 288.865051,179.121124 
	C290.808075,179.327530 292.751129,179.533951 295.636200,179.742355 
M301.160522,184.922501 
	C313.047913,184.903946 313.047913,184.903946 314.170013,181.913696 
	C309.552094,181.913696 305.130157,181.871704 300.710785,181.958817 
	C300.044617,181.971970 299.390350,182.587738 298.730560,182.924759 
	C299.256561,183.584091 299.782562,184.243423 301.160522,184.922501 
M304.565979,191.257629 
	C299.731659,191.276810 299.731659,191.276810 298.631500,194.386002 
	C300.408844,194.386002 301.991638,194.388184 303.574463,194.385361 
	C305.047363,194.382751 306.549835,194.545502 307.980774,194.297592 
	C308.702850,194.172501 309.295349,193.299271 309.946442,192.764328 
	C309.258759,192.255936 308.635986,191.557220 307.864655,191.294128 
	C307.133575,191.044769 306.246765,191.252045 304.565979,191.257629 
M268.556396,199.490463 
	C277.063751,200.341919 277.503967,200.223175 278.681213,196.138885 
	C275.607635,196.138885 272.695038,195.946259 269.841370,196.271225 
	C269.107025,196.354858 268.558258,198.067947 268.556396,199.490463 
M278.798035,201.583176 
	C277.556946,202.185440 276.315826,202.787704 275.074738,203.389984 
	C276.337006,203.829498 277.629730,204.702408 278.855103,204.616440 
	C281.252380,204.448196 283.612122,203.744797 285.987396,203.262909 
	C283.876678,202.696548 281.765930,202.130188 278.798035,201.583176 
M270.121185,176.252609 
	C269.274536,176.842758 268.384979,177.386902 267.638123,178.083969 
	C267.549316,178.166885 268.224274,179.533783 268.570892,179.545532 
	C271.979248,179.660828 275.393066,179.615158 278.805328,179.615158 
	C278.857483,178.840591 278.909607,178.066025 278.961761,177.291458 
	C276.284119,176.941635 273.606445,176.591827 270.121185,176.252609 
M278.797607,171.576920 
	C277.562317,172.190247 276.326996,172.803574 275.091705,173.416870 
	C276.512970,173.862610 277.957764,174.733780 279.350159,174.656876 
	C281.576904,174.533890 283.768951,173.781631 285.975647,173.295395 
	C283.868195,172.722382 281.760712,172.149368 278.797607,171.576920 
M278.955688,189.970718 
	C281.701813,189.970718 284.447937,189.970718 287.194061,189.970718 
	C287.205322,189.097656 287.216553,188.224594 287.227814,187.351532 
	C283.831909,187.351532 280.435974,187.351532 277.040070,187.351532 
	C277.390594,188.218613 277.741119,189.085693 278.955688,189.970718 
M321.328857,184.959900 
	C322.481018,184.482315 323.633179,184.004745 324.785339,183.527176 
	C324.641785,183.143646 324.498230,182.760132 324.354675,182.376602 
	C321.738403,182.376602 319.122162,182.376602 316.505890,182.376602 
	C316.413361,182.885452 316.320831,183.394287 316.228302,183.903137 
	C317.651428,184.255585 319.074554,184.608032 321.328857,184.959900 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M349.021454,141.073029 
	C348.604248,141.764374 348.187012,142.455719 347.143433,142.834427 
	C343.717346,142.347488 340.917908,142.026672 338.117920,142.021927 
	C314.744263,141.982269 291.370483,142.000778 267.996765,142.001740 
	C267.996765,142.001740 268.002747,141.528824 267.929138,141.304214 
	C293.546692,141.014481 319.237854,140.949356 345.783813,140.901001 
	C347.432892,140.969513 348.227173,141.021271 349.021454,141.073029 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M349.489014,141.103699 
	C348.227173,141.021271 347.432892,140.969513 346.240387,140.857193 
	C345.842163,140.796631 345.932800,140.409546 346.381226,140.202759 
	C348.732758,139.886871 351.559479,140.406097 350.715637,137.319931 
	C350.395020,136.147293 347.609161,135.648712 345.946930,134.842896 
	C345.946930,134.842896 345.932343,134.528946 345.925964,134.371857 
	C351.967316,134.083588 358.015076,133.952393 364.523438,133.905945 
	C364.984039,133.990692 365.027191,134.361084 364.615509,134.628387 
	C360.597260,134.660172 359.290314,136.059082 360.859741,139.709732 
	C362.528931,139.709732 364.155396,139.709732 365.781860,139.709732 
	C365.800964,139.978821 365.820038,140.247925 365.842438,140.921570 
	C360.549408,141.262207 355.252991,141.198273 349.489014,141.103699 
M357.920868,138.225876 
	C356.882202,137.177444 355.843567,136.128998 354.804932,135.080566 
	C354.257233,135.937195 353.709534,136.793839 353.161835,137.650467 
	C354.674103,138.094284 356.186401,138.538086 357.920868,138.225876 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M345.877258,135.272446 
	C347.609161,135.648712 350.395020,136.147293 350.715637,137.319931 
	C351.559479,140.406097 348.732758,139.886871 346.409363,140.005981 
	C345.928619,138.577988 345.868103,137.139984 345.877258,135.272446 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M387.034851,354.815002 
	C388.513672,351.459351 389.992493,348.103729 391.692963,344.515808 
	C393.666809,344.205048 395.419037,344.126587 398.051270,344.067017 
	C402.276093,344.034454 405.620819,343.983002 408.965576,343.931519 
	C409.728241,343.974731 410.490906,344.017975 411.632568,344.000946 
	C412.461670,344.024139 412.911835,344.107574 413.700745,344.260315 
	C414.191986,344.572174 414.397461,344.755249 414.852173,344.956055 
	C412.390961,354.762604 409.755219,364.497833 407.057251,374.215820 
	C406.537170,376.089294 405.773376,377.895111 404.720459,379.399261 
	C404.318939,371.155334 404.318939,363.244263 404.318939,354.815002 
	C397.972137,354.815002 392.503479,354.815002 387.034851,354.815002 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M322.689819,370.345337 
	C323.011963,397.042023 323.052216,424.037720 323.031952,451.493561 
	C322.654602,450.720734 322.063843,449.488312 322.061340,448.254700 
	C322.009796,423.028351 322.022644,397.801880 322.043610,372.575409 
	C322.044159,371.931641 322.281219,371.288055 322.689819,370.345337 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M382.638428,343.628235 
	C363.615051,343.956940 344.283569,344.018646 324.486267,344.054260 
	C324.580200,343.712860 325.140594,343.121033 325.699646,343.122345 
	C344.576630,343.167114 363.453461,343.268280 382.638428,343.628235 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M322.765991,345.289856 
	C323.073914,349.678741 323.082458,354.358582 323.031006,359.496094 
	C322.802856,355.162781 322.634735,350.371826 322.765991,345.289856 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M408.670807,343.661285 
	C405.620819,343.983002 402.276093,344.034454 398.483124,344.005127 
	C401.481964,343.746582 404.928986,343.568817 408.670807,343.661285 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M133.835938,427.829590 
	C125.090256,427.140381 117.473244,424.755585 111.734383,418.223297 
	C104.932526,410.481079 102.064110,401.532104 104.804482,391.473755 
	C107.774582,380.572235 114.830856,372.999237 125.902382,370.279236 
	C143.650406,365.918915 157.726593,375.733093 161.519516,391.939911 
	C165.693771,409.776245 153.877457,424.944611 137.147583,427.071320 
	C136.168854,427.195709 135.216476,427.527130 133.835938,427.829590 
M121.145599,388.357819 
	C129.504959,394.560272 132.648056,402.906952 131.347427,413.098907 
	C131.242996,413.917267 131.164398,414.804871 131.368210,415.583191 
	C131.814819,417.288757 132.450455,418.944885 133.008926,420.621185 
	C133.648636,419.025696 134.664047,417.471313 134.844055,415.825500 
	C135.149689,413.031097 134.819046,410.173370 134.965378,407.353180 
	C135.074295,405.253906 134.979324,402.882263 135.920471,401.143646 
	C137.767288,397.731903 136.914398,395.999542 133.544510,394.629883 
	C132.085251,394.036743 130.806931,392.847137 129.633438,391.731689 
	C126.620476,388.867767 123.758095,385.844513 120.719002,383.009857 
	C120.182991,382.509949 119.083305,382.614349 118.243935,382.439697 
	C118.221024,383.422577 117.873520,384.564209 118.257034,385.348267 
	C118.740952,386.337646 119.821236,387.035339 121.145599,388.357819 
z"/>
<path fill="#EDF8FD" opacity="1.000000" stroke="none" 
	d="
M166.532928,705.487183 
	C166.567276,704.010559 167.104553,702.754944 167.133209,701.487793 
	C167.426285,688.527283 167.691010,675.565491 167.859604,662.602722 
	C168.287827,629.677917 168.613480,596.751648 169.110336,563.827942 
	C169.187347,558.724854 169.950104,553.632080 170.713898,548.250671 
	C171.788284,547.976257 172.544510,547.985718 174.141968,548.001587 
	C189.307373,547.946899 203.631561,547.885803 217.955750,547.824707 
	C218.690140,549.276428 220.015152,550.707825 220.065811,552.182983 
	C220.481979,564.301636 220.841034,576.427734 220.878571,588.552673 
	C220.991913,625.156799 220.963425,661.761353 220.942062,698.365784 
	C220.940933,700.320312 220.497971,702.274597 220.101730,704.617676 
	C211.287476,704.998596 202.632156,704.990784 193.513977,704.977295 
	C188.356674,704.658936 183.662231,704.346313 178.507828,704.058350 
	C174.298523,704.622986 170.549149,705.162964 166.532928,705.487183 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M217.945770,547.680481 
	C203.631561,547.885803 189.307373,547.946899 174.520050,547.979614 
	C175.457809,547.648926 176.857727,547.089539 178.259705,547.084412 
	C191.171677,547.036926 204.084000,547.085266 217.453033,547.177002 
	C217.909836,547.248230 217.935791,547.536255 217.945770,547.680481 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M443.002563,167.987183 
	C442.783478,166.508255 442.614105,164.986023 442.690491,163.212067 
	C442.936188,162.960373 443.011353,163.017609 443.025360,163.446869 
	C443.075745,165.201950 443.112122,166.527786 443.148499,167.853622 
	C443.148499,167.853622 443.052307,167.943878 443.002563,167.987183 
z"/>
<path fill="#594547" opacity="1.000000" stroke="none" 
	d="
M551.508789,168.908890 
	C558.674988,168.922684 565.375061,168.974625 572.543701,168.998077 
	C573.153625,173.101669 573.414734,177.233688 573.416382,181.365814 
	C573.424805,202.292908 573.365906,223.220032 572.705444,244.574219 
	C549.419983,244.931595 526.759705,244.861923 504.099396,244.792236 
	C504.099396,219.737213 504.099396,194.682205 504.099396,168.947052 
	C519.951904,168.947052 535.497253,168.947052 551.508789,168.908890 
M541.229980,198.774033 
	C540.170471,198.715958 539.110901,198.657898 538.046997,197.915634 
	C538.380676,196.370392 538.714355,194.825150 539.928101,193.180862 
	C541.930847,193.180862 543.933594,193.180862 545.936340,193.180862 
	C545.940491,192.469604 545.944702,191.758362 545.948914,191.047104 
	C539.994019,191.047104 534.039124,191.047104 527.194153,190.954590 
	C522.163574,189.661240 519.234924,192.747467 515.673157,196.394684 
	C517.777344,196.394684 519.132263,196.394684 520.651367,196.394684 
	C520.901184,197.911148 521.110474,199.181747 521.319946,200.453339 
	C524.055176,200.596191 526.631958,200.730759 529.892456,200.940369 
	C530.579895,200.951721 531.267395,200.963058 532.640747,201.041168 
	C533.099426,201.024246 533.558105,201.007309 534.890747,200.995880 
	C537.211792,200.966934 539.532837,200.937988 542.605896,200.889618 
	C544.782410,200.900772 546.958862,200.911926 550.045105,200.960617 
	C553.933167,200.960617 557.821228,200.960617 561.709290,200.960617 
	C561.704163,200.271652 561.699097,199.582703 561.693970,198.893738 
	C557.451599,198.893738 553.209229,198.893738 548.413574,198.401077 
	C546.279358,198.578674 544.145203,198.756256 541.229980,198.774033 
M525.982056,233.027863 
	C525.992371,233.563370 525.997437,234.568039 526.013794,234.568237 
	C532.013000,234.635681 538.012939,234.634369 544.012878,234.634369 
	C544.023315,234.141190 544.033813,233.648010 544.044312,233.154831 
	C542.065247,233.002945 540.086182,232.851074 538.172058,232.111008 
	C537.848877,231.326065 537.661682,229.963470 537.180420,229.850189 
	C534.111633,229.127655 535.156677,231.179779 534.700623,232.730484 
	C534.449707,232.715179 534.198730,232.699890 533.893860,231.840332 
	C531.758789,229.103851 530.059753,228.878296 528.202271,232.725601 
	C527.916870,232.701843 527.631470,232.678070 527.692078,231.907211 
	C527.280151,231.199951 526.785828,229.846619 526.469238,229.886978 
	C523.789795,230.228653 519.749268,228.429977 519.838074,234.152466 
	C522.170654,233.624329 524.403870,233.118713 525.982056,233.027863 
M551.021729,217.066559 
	C551.829834,216.453537 552.637878,215.840500 553.445984,215.227478 
	C549.442566,215.199081 545.861389,216.431641 542.180847,216.930740 
	C535.098450,217.891129 532.930847,218.237106 532.213013,219.896103 
	C538.020081,219.896103 543.593567,219.896103 550.079590,219.937454 
	C555.384094,219.929169 560.688660,219.920883 565.993164,219.912598 
	C565.964294,219.175613 565.935364,218.438629 565.906433,217.701645 
	C560.838867,217.701645 555.771362,217.701645 551.021729,217.066559 
M539.039368,180.882843 
	C531.564087,180.290466 524.327515,181.130569 517.427795,183.991943 
	C517.498291,184.527557 517.568848,185.063187 517.639343,185.598801 
	C526.906982,184.515854 536.174683,183.432907 545.442322,182.349960 
	C545.461365,181.889648 545.480469,181.429352 545.499512,180.969040 
	C543.601929,180.840714 541.704346,180.712402 539.039368,180.882843 
M556.187927,210.050613 
	C547.483093,210.050613 538.778320,210.050613 530.073486,210.050613 
	C530.085571,210.616135 530.097595,211.181671 530.109680,211.747192 
	C539.697449,211.747192 549.285217,211.747192 558.872986,211.747192 
	C558.944519,211.455948 559.016052,211.164688 559.087585,210.873444 
	C558.431946,210.604141 557.776306,210.334839 556.187927,210.050613 
M516.747009,172.136078 
	C515.169739,172.320770 513.592468,172.505463 512.015198,172.690155 
	C512.064331,173.231720 512.113403,173.773270 512.162537,174.314835 
	C517.433044,175.001114 522.696533,175.240570 527.942993,174.399796 
	C527.951660,173.638214 527.960327,172.876633 527.968994,172.115051 
	C524.537537,172.115051 521.106018,172.115051 516.747009,172.136078 
M533.098633,206.124924 
	C529.299561,206.124924 525.500488,206.124924 521.701416,206.124924 
	C521.713013,206.868149 521.724609,207.611374 521.736206,208.354599 
	C526.219849,208.354599 530.703552,208.354599 535.187256,208.354599 
	C534.788635,207.615906 534.390076,206.877213 533.098633,206.124924 
M524.989441,219.000626 
	C526.801941,218.914474 528.614441,218.828339 530.426941,218.742188 
	C530.360291,218.237320 530.293640,217.732437 530.226990,217.227554 
	C527.219055,217.288513 523.999878,215.935364 521.327698,218.244339 
	C521.406921,218.717072 521.486206,219.189804 521.565430,219.662537 
	C522.442200,219.469269 523.318970,219.275986 524.989441,219.000626 
M534.800476,214.403793 
	C534.926086,214.870422 535.051697,215.337036 535.177368,215.803650 
	C535.545715,215.637863 535.914062,215.472061 536.282410,215.306259 
	C535.967224,214.981628 535.652100,214.656998 534.800476,214.403793 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M504.065826,245.087280 
	C526.759705,244.861923 549.419983,244.931595 572.549683,245.024628 
	C573.019104,245.047958 573.028381,245.496750 573.037842,245.720413 
	C550.339355,245.959290 527.631470,245.974503 504.453125,245.981934 
	C503.999207,245.776871 504.015747,245.579605 504.065826,245.087280 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M573.006653,167.473602 
	C571.315002,167.111542 569.715820,166.350327 568.116699,165.589096 
	C569.450439,164.738922 570.784180,163.888779 572.528564,163.017838 
	C572.992432,164.356186 573.045837,165.715302 573.006653,167.473602 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M553.236328,163.625107 
	C553.628723,163.193024 554.011108,163.012726 554.270447,163.122726 
	C555.802429,163.772659 558.445068,164.282120 558.616516,165.221619 
	C559.271729,168.812271 556.217651,167.652084 553.939697,167.874817 
	C553.435913,166.593445 553.302673,165.302231 553.236328,163.625107 
z"/>
<path fill="#EBF6FB" opacity="1.000000" stroke="none" 
	d="
M237.008301,525.690674 
	C237.005280,522.702637 237.005280,520.147400 237.005280,517.125977 
	C241.366623,518.202637 244.047913,520.395020 243.620239,523.971252 
	C243.262405,526.963623 241.959793,530.584106 237.223038,530.038818 
	C237.151611,528.717773 237.081467,527.420593 237.008301,525.690674 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M681.378296,258.100342 
	C680.837097,258.110443 680.674500,258.061615 680.152832,257.759552 
	C679.621399,257.265961 679.409973,257.067078 679.159546,256.909668 
	C679.149109,256.193451 679.138611,255.477249 679.603638,254.393082 
	C681.622253,254.052872 683.165405,254.080612 684.772705,254.485245 
	C684.831116,255.879776 684.825439,256.897400 684.819702,257.915039 
	C683.798767,257.957184 682.777893,257.999329 681.378296,258.100342 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M692.018799,254.099182 
	C692.020935,254.497559 692.023010,254.895935 692.047852,255.590881 
	C690.674622,256.566681 689.278625,257.245880 687.458130,257.539490 
	C687.040405,256.106598 687.047119,255.059280 687.465820,253.992111 
	C689.258118,254.014557 690.638428,254.056870 692.018799,254.099182 
z"/>
<path fill="#F0D5B6" opacity="1.000000" stroke="none" 
	d="
M687.053894,254.011978 
	C687.047119,255.059280 687.040405,256.106598 687.066528,257.544006 
	C686.592834,257.947021 686.086243,257.959900 685.199707,257.943909 
	C684.825439,256.897400 684.831116,255.879776 684.809875,254.238739 
	C684.782959,253.615341 684.747925,253.119080 684.747925,253.119080 
	C685.244324,253.073517 685.740723,253.027954 686.625122,253.253113 
	C687.013062,253.523819 687.053894,254.011978 687.053894,254.011978 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M366.048798,273.493591 
	C367.724152,272.620789 369.399506,271.747986 371.438904,270.847321 
	C383.030823,270.842651 394.258728,270.865814 406.398804,270.842407 
	C411.744080,271.134583 416.184875,271.822937 420.608429,271.725647 
	C426.429108,271.597565 432.236145,270.851654 438.369568,270.441010 
	C439.116425,270.601776 439.542786,270.692902 439.946808,271.257263 
	C440.007172,274.193939 440.089874,276.657349 440.141876,279.525482 
	C439.851562,281.727478 440.195282,284.036316 439.200134,285.209869 
	C437.416199,287.313660 435.007080,289.222778 432.470184,290.158569 
	C431.655090,290.459290 429.185944,287.669159 428.229126,285.887329 
	C426.512360,282.690277 425.054932,279.695740 420.598022,280.237244 
	C420.137054,280.293274 419.483582,278.764679 419.269775,277.940857 
	C420.413605,277.591858 421.207123,277.273315 422.175476,277.083923 
	C422.528656,277.518402 422.707062,277.823639 422.488068,277.448914 
	C422.718353,277.635376 422.331787,277.322388 421.768311,276.698303 
	C420.380005,275.655304 419.168579,274.923401 417.503052,274.109131 
	C413.028870,273.997162 409.008850,273.967560 404.707458,273.660156 
	C401.169983,273.426697 397.913879,273.471039 394.207092,273.558441 
	C393.161865,273.701660 392.567322,273.801880 391.674866,273.615784 
	C384.944305,273.458679 378.511627,273.587860 371.645721,273.702820 
	C369.491241,273.623627 367.770020,273.558594 366.048798,273.493591 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M438.049072,270.371399 
	C432.236145,270.851654 426.429108,271.597565 420.608429,271.725647 
	C416.184875,271.822937 411.744080,271.134583 406.893921,270.781769 
	C411.154388,270.407379 415.831879,270.046997 420.766327,269.348694 
	C422.078827,268.583099 423.780365,267.514557 424.090057,267.826782 
	C427.231873,270.993835 431.110748,269.800720 435.475220,269.887329 
	C436.811432,270.006897 437.430237,270.189148 438.049072,270.371399 
z"/>
<path fill="#F0D5B6" opacity="1.000000" stroke="none" 
	d="
M211.250427,518.836182 
	C211.026657,518.545898 211.017487,518.109375 211.017487,517.345703 
	C211.172760,517.575684 211.318893,518.132812 211.250427,518.836182 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M684.317505,253.096527 
	C684.747925,253.119080 684.782959,253.615341 684.745728,253.861847 
	C683.165405,254.080612 681.622253,254.052872 679.695557,254.046051 
	C679.310181,253.828064 679.308228,253.589127 679.413940,253.006714 
	C679.521667,252.663239 679.525452,252.688278 679.529297,252.665314 
	C680.984375,252.786224 682.435730,252.930099 684.317505,253.096527 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M679.176758,257.159302 
	C679.409973,257.067078 679.621399,257.265961 679.907104,257.692749 
	C679.644287,257.899597 679.368774,257.742859 679.176758,257.159302 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M666.000732,306.999390 
	C663.680847,305.969330 661.360168,304.939880 659.006104,303.538055 
	C661.241882,303.904388 663.511169,304.643097 665.891968,305.965393 
	C666.003540,306.549042 665.998962,307.000519 665.998962,307.000519 
	C665.998962,307.000519 666.000000,307.000000 666.000732,306.999390 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M674.511169,307.091919 
	C672.812500,307.306213 670.686157,307.462341 668.301514,307.354279 
	C670.056641,307.071289 672.070129,307.052521 674.511169,307.091919 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M666.302612,306.998077 
	C665.998962,307.000519 666.003540,306.549042 665.991516,306.324707 
	C666.299255,306.218811 666.619019,306.337280 667.074585,306.694458 
	C667.009033,306.954010 666.807617,306.974823 666.302612,306.998077 
z"/>
<path fill="#EDF9FE" opacity="1.000000" stroke="none" 
	d="
M646.185181,304.185211 
	C646.424927,304.174652 646.492432,304.350983 646.559937,304.527283 
	C646.377563,304.475555 646.195251,304.423798 646.185181,304.185211 
z"/>
<path fill="#F3EDD2" opacity="1.000000" stroke="none" 
	d="
M879.795532,193.698730 
	C878.602417,194.011398 877.214722,194.069382 874.992859,194.074860 
	C872.437683,194.095154 870.716614,194.167938 868.995544,194.240723 
	C818.648193,194.207001 768.300903,194.173279 717.265625,194.089935 
	C716.577698,194.040314 716.097900,194.054733 716.097900,194.054733 
	C715.429932,191.889282 714.762024,189.723846 714.082275,187.152374 
	C716.565002,186.828278 719.059326,186.980316 721.553833,186.981796 
	C771.713806,187.011505 821.873840,187.023911 872.496338,187.096222 
	C872.958801,187.152634 873.019348,187.648636 873.012329,188.301270 
	C872.171143,193.239349 874.823730,193.239349 877.793396,192.849594 
	C878.395935,193.047729 878.998413,193.245880 879.795532,193.698730 
z"/>
<path fill="#EDF9FE" opacity="1.000000" stroke="none" 
	d="
M661.032593,320.991943 
	C660.617859,321.867859 660.178894,322.743530 659.739929,323.619202 
	C659.294312,323.217896 658.848633,322.816620 658.403015,322.415283 
	C659.038574,321.935608 659.674133,321.455902 660.658691,320.959717 
	C661.007751,320.943237 661.008301,320.991730 661.032593,320.991943 
z"/>
<path fill="#594547" opacity="1.000000" stroke="none" 
	d="
M391.972748,273.902069 
	C392.567322,273.801880 393.161865,273.701660 394.100464,273.976074 
	C397.585083,277.034149 402.855408,276.827820 404.988800,273.937927 
	C409.008850,273.967560 413.028870,273.997162 417.505859,274.454285 
	C418.281647,275.911591 418.600555,276.941467 418.919434,277.971313 
	C419.483582,278.764679 420.137054,280.293274 420.598022,280.237244 
	C425.054932,279.695740 426.512360,282.690277 428.229126,285.887329 
	C429.185944,287.669159 431.655090,290.459290 432.470184,290.158569 
	C435.007080,289.222778 437.416199,287.313660 439.200134,285.209869 
	C440.195282,284.036316 439.851562,281.727478 440.306458,279.528015 
	C440.501709,279.125854 440.829376,279.158081 440.829376,279.158081 
	C440.865814,289.753998 440.902222,300.349945 440.918304,311.405029 
	C416.169495,311.926300 391.441040,311.990509 366.712555,312.033783 
	C366.252289,312.034607 365.791595,311.786621 364.780334,311.496948 
	C364.780334,300.655090 364.780334,289.752228 364.632935,278.399475 
	C364.517731,277.225891 364.549896,276.502167 364.560852,275.416138 
	C364.844025,274.674866 365.148438,274.295929 365.750824,273.705292 
	C367.770020,273.558594 369.491241,273.623627 371.660309,274.076447 
	C373.046387,274.961273 373.984589,275.458252 375.255219,275.936646 
	C375.808014,275.891479 376.028381,275.864929 376.694763,275.912903 
	C381.204895,276.014709 385.275452,276.172089 389.328033,275.969696 
	C390.241760,275.924072 391.092834,274.624420 391.972748,273.902069 
M383.908936,295.009308 
	C386.718811,294.819305 389.528656,294.629303 392.986389,295.155365 
	C393.517670,296.115051 393.987427,297.857483 394.590424,297.904877 
	C397.999695,298.172852 401.440948,298.034393 404.994476,298.034393 
	C404.810608,296.467834 404.697235,295.501678 404.575195,294.461761 
	C408.122772,294.208710 411.326263,293.980194 414.529755,293.751709 
	C414.502960,293.242340 414.476166,292.732971 414.449371,292.223602 
	C406.755676,292.223602 399.061951,292.223602 390.532440,292.127869 
	C388.026123,293.089661 385.519806,294.051453 382.160950,295.026489 
	C380.458832,295.013672 378.756714,295.000824 376.843872,294.173157 
	C376.768036,293.182983 376.867218,292.138428 376.580078,291.213867 
	C375.974182,289.263092 375.545959,286.111633 374.353210,285.753021 
	C372.494598,285.194214 368.991180,285.874725 368.123627,287.251648 
	C366.850830,289.271667 367.289062,292.369781 366.854156,295.912384 
	C366.874084,297.860565 367.034546,299.819855 366.881927,301.754425 
	C366.635101,304.883301 367.914856,305.967957 371.633209,305.561127 
	C375.071381,305.696655 378.509521,305.832184 382.771515,305.970551 
	C385.430511,305.458740 388.089539,304.946899 390.748566,304.435059 
	C390.647980,303.872650 390.547424,303.310242 390.446838,302.747803 
	C387.705048,303.141510 384.963226,303.535217 382.160645,303.186707 
	C381.696350,301.576630 381.232025,299.966553 381.133911,297.759277 
	C381.751801,296.834991 382.369690,295.910736 383.908936,295.009308 
M384.225708,309.490875 
	C390.453857,310.402649 396.626251,310.322662 402.761169,309.576355 
	C402.759857,308.769135 402.758514,307.961945 402.757202,307.154724 
	C397.422974,307.154724 392.087097,307.087097 386.756165,307.219940 
	C385.846283,307.242615 384.957794,308.122986 384.225708,309.490875 
M420.753448,299.784668 
	C419.828522,300.035797 418.903595,300.286926 417.978699,300.538055 
	C418.037903,300.779968 418.097137,301.021912 418.156372,301.263855 
	C423.355530,301.263855 428.554657,301.263855 433.753815,301.263855 
	C433.757721,300.769958 433.761597,300.276031 433.765472,299.782135 
	C429.745575,299.782135 425.725647,299.782135 420.753448,299.784668 
M392.603333,286.355286 
	C387.894897,285.722351 383.186462,285.089417 378.478027,284.456482 
	C378.425171,285.234497 378.372345,286.012512 378.319489,286.790527 
	C382.824829,286.790527 387.330139,286.790527 392.603333,286.355286 
M409.477661,279.427521 
	C411.879639,279.313904 414.281586,279.200287 416.683563,279.086700 
	C416.630066,278.532654 416.576538,277.978607 416.523010,277.424591 
	C411.731140,277.077423 406.939148,276.728363 402.202209,277.569305 
	C402.217773,278.188263 402.233337,278.807251 402.248871,279.426208 
	C404.343506,279.426208 406.438110,279.426208 409.477661,279.427521 
M390.138611,277.894501 
	C389.154083,277.894501 388.169586,277.894501 386.582520,277.894501 
	C390.639709,281.134766 398.149170,280.732483 399.466217,277.904755 
	C396.681824,277.904755 393.824341,277.904755 390.138611,277.894501 
M382.020782,277.888397 
	C379.842773,278.063812 377.664795,278.239258 375.486786,278.414673 
	C375.534607,278.956940 375.582428,279.499207 375.630249,280.041473 
	C378.233063,280.041473 380.848785,280.186188 383.431183,279.956482 
	C384.243866,279.884216 384.967163,278.807312 385.731384,278.190277 
	C384.766632,278.061127 383.801880,277.931976 382.020782,277.888397 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M716.053711,194.294708 
	C716.097900,194.054733 716.577698,194.040314 716.800171,194.130417 
	C716.894470,194.478531 716.705994,194.680099 716.270996,194.921021 
	C716.084778,195.016846 716.009460,194.534683 716.053711,194.294708 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M892.250427,334.523010 
	C891.878662,308.260406 891.806274,282.021881 891.760559,255.783310 
	C891.725281,235.520401 891.723328,215.257446 891.696411,194.526855 
	C892.127502,196.044342 892.950378,198.028885 892.953613,200.014740 
	C893.025208,244.409363 893.006775,288.804138 893.029663,333.681946 
	C892.889832,334.292328 892.725525,334.419708 892.250427,334.523010 
z"/>
<path fill="#F3EDD2" opacity="1.000000" stroke="none" 
	d="
M891.802490,193.887360 
	C889.453735,194.247269 887.162354,194.171844 884.440552,194.025818 
	C884.591064,193.586411 885.171875,193.217590 886.094971,192.734406 
	C887.989929,192.675537 889.542664,192.731033 891.478027,192.680176 
	C891.860352,192.866531 891.860107,193.159256 891.802490,193.887360 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M458.635254,167.876114 
	C458.175781,166.550812 458.114380,165.232880 458.080322,163.518311 
	C459.460907,163.068649 460.814148,163.015594 462.574615,162.970078 
	C463.435120,166.037064 463.228180,168.565125 458.635254,167.876114 
z"/>
<path fill="#EDF9FE" opacity="1.000000" stroke="none" 
	d="
M677.691956,293.283813 
	C676.408508,293.302521 675.508118,293.210785 674.607666,293.119080 
	C674.627808,292.720276 674.647949,292.321503 674.668091,291.922699 
	C675.926331,292.080994 677.184570,292.239258 678.442810,292.397522 
	C678.417664,292.526886 678.417603,292.668762 678.360901,292.782410 
	C678.289917,292.924866 678.172424,293.044128 677.691956,293.283813 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M365.811798,139.340775 
	C364.155396,139.709732 362.528931,139.709732 360.859741,139.709732 
	C359.290314,136.059082 360.597260,134.660172 364.614960,134.814819 
	C365.297974,136.146576 365.569855,137.559189 365.811798,139.340775 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M438.369568,270.441040 
	C437.430237,270.189148 436.811432,270.006897 435.962891,269.815399 
	C435.562561,268.587891 435.391937,267.369659 435.204041,265.784302 
	C436.763275,265.252808 438.339783,265.088409 440.664337,264.845978 
	C440.664337,266.743256 440.664337,268.248016 440.487366,270.208618 
	C440.310425,270.664398 439.969147,270.784027 439.969147,270.784027 
	C439.542786,270.692902 439.116425,270.601776 438.369568,270.441040 
z"/>
<path fill="#E0D1AE" opacity="1.000000" stroke="none" 
	d="
M687.465820,253.992111 
	C687.053894,254.011978 687.013062,253.523819 686.998718,253.279541 
	C688.517761,253.175507 690.051147,253.315735 691.801636,253.777573 
	C690.638428,254.056870 689.258118,254.014557 687.465820,253.992111 
z"/>
<path fill="#FDBA5B" opacity="1.000000" stroke="none" 
	d="
M561.226868,166.648712 
	C562.086182,165.202805 563.077637,164.135406 564.069031,163.067993 
	C564.649231,164.196640 565.229431,165.325287 565.809631,166.453934 
	C564.326050,166.645035 562.842529,166.836136 561.226868,166.648712 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M877.839233,192.445862 
	C874.823730,193.239349 872.171143,193.239349 873.047241,188.548645 
	C876.110413,187.693069 878.696472,187.778030 877.839233,192.445862 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M439.946808,271.257263 
	C439.969147,270.784027 440.310425,270.664398 440.480164,270.607422 
	C440.773834,273.111755 440.897766,275.673096 440.925537,278.696259 
	C440.829376,279.158081 440.501709,279.125854 440.337158,279.123291 
	C440.089874,276.657349 440.007172,274.193939 439.946808,271.257263 
z"/>
<path fill="#EBF6FB" opacity="1.000000" stroke="none" 
	d="
M372.027893,539.888794 
	C383.505554,539.713867 394.983307,539.542358 406.460876,539.362488 
	C412.079559,539.274475 417.599091,539.318176 419.903229,545.997925 
	C421.995209,552.062561 419.550629,557.086670 416.151337,561.758545 
	C415.266846,562.974121 413.529602,563.791809 412.018463,564.291992 
	C403.529968,567.101562 395.136902,570.441650 386.433624,572.301086 
	C374.423706,574.867004 362.388824,574.192505 351.031036,568.680542 
	C350.733673,568.536194 350.485504,568.223206 350.181976,568.168518 
	C340.893402,566.494812 338.477173,560.125671 337.891968,551.638550 
	C337.380493,544.220764 337.942841,542.562927 345.302368,540.900024 
	C346.598511,540.607178 347.925629,540.451355 349.989380,540.259155 
	C357.836151,540.153625 364.932007,540.021179 372.027893,539.888794 
M376.700409,559.215637 
	C379.321777,558.627319 382.439270,558.681213 382.694336,554.809753 
	C376.535706,553.137512 373.137115,554.430054 371.076294,559.723511 
	C372.908752,559.629272 374.426270,559.551331 376.700409,559.215637 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M372.018677,539.562744 
	C364.932007,540.021179 357.836151,540.153625 350.368439,540.161011 
	C351.529999,539.454346 353.063385,538.872620 355.106812,538.097412 
	C353.871033,537.317871 353.018585,536.780151 352.023407,535.967285 
	C358.687836,535.577820 365.494934,535.463440 372.710632,535.476196 
	C372.749329,536.814514 372.379395,538.025574 372.018677,539.562744 
z"/>
<path fill="#EC3561" opacity="1.000000" stroke="none" 
	d="
M469.913971,577.152283 
	C469.254181,571.631592 468.074982,566.083862 468.091858,560.539673 
	C468.140869,544.419250 467.919250,528.240784 469.192657,512.195312 
	C470.914246,490.502289 475.235229,469.205383 483.577057,448.934296 
	C487.727966,438.847382 493.707672,434.997925 504.747711,434.996521 
	C516.242493,434.995087 527.775391,435.572174 539.219666,434.811798 
	C547.961426,434.231049 556.723450,441.812775 559.427368,449.574860 
	C565.239380,466.259460 569.026062,483.393799 570.886597,500.885895 
	C572.444519,515.532593 573.056763,530.281860 573.995300,544.991577 
	C574.438660,551.941772 574.803772,558.903320 574.927429,565.864624 
	C574.982849,568.981079 574.357544,572.109558 574.039917,575.639771 
	C574.038635,576.046997 574.089172,576.039795 573.756592,576.067261 
	C572.958435,576.749695 572.492737,577.404663 572.013550,578.032593 
	C571.999939,578.005615 572.059082,578.018066 571.877380,578.079773 
	C571.458618,578.250793 571.263123,578.410828 570.652588,578.761230 
	C555.318787,578.768250 540.441589,578.635681 525.506958,578.141113 
	C526.494629,576.600586 527.436462,575.306824 528.602539,574.263672 
	C533.720764,569.685303 534.229431,562.321411 529.688477,557.430054 
	C525.174011,552.567261 517.363037,552.481140 512.814392,557.243958 
	C508.105042,562.175049 508.471313,569.335632 513.631836,574.040894 
	C514.936096,575.230042 516.128357,576.542114 517.241821,578.049438 
	C517.037170,578.474976 516.962769,578.648682 516.888306,578.822388 
	C502.147125,578.750122 487.405945,578.677856 472.166443,578.102234 
	C471.085114,577.417847 470.502106,577.236877 469.919098,577.055847 
	C469.919098,577.055847 469.940948,577.126831 469.913971,577.152283 
z"/>
<path fill="#A15F68" opacity="1.000000" stroke="none" 
	d="
M557.170044,618.298889 
	C547.851196,618.221985 538.531067,618.210388 529.214111,618.033447 
	C525.864685,617.969788 524.992737,619.556519 524.937622,622.620544 
	C524.704712,635.576904 524.335815,648.531311 523.923828,661.483459 
	C523.834656,664.288452 523.379089,667.083130 523.061279,669.879028 
	C522.734985,672.749207 523.649658,674.256592 526.876953,674.053467 
	C530.193726,673.844727 533.536072,674.083496 536.863403,673.989746 
	C539.646667,673.911316 542.149963,673.883179 543.156860,677.365356 
	C543.386658,678.159912 545.155029,678.892273 546.266113,678.975586 
	C549.246521,679.199219 552.254456,679.042603 555.251404,679.060730 
	C562.517090,679.104736 565.377625,682.579651 564.458191,690.550293 
	C535.485229,690.550293 506.480011,690.550293 477.477112,690.550293 
	C477.449493,682.001953 480.142212,679.066345 487.656708,679.057678 
	C490.320709,679.054626 492.990204,679.152283 495.645935,679.003052 
	C496.694092,678.944214 498.478119,678.528748 498.622345,677.950317 
	C499.852203,673.018372 503.671692,674.061584 507.048676,674.013123 
	C507.215149,674.010742 507.381653,674.012817 507.548157,674.012817 
	C519.611511,674.014099 519.511475,674.018616 518.971680,661.996399 
	C518.502441,651.545532 518.343933,641.080994 517.943970,630.626526 
	C517.792725,626.674866 517.349609,622.734253 516.988586,618.140442 
	C509.001556,618.140442 501.400879,618.140442 493.325867,618.233093 
	C490.232574,618.272156 487.536224,618.575439 485.023926,618.030334 
	C483.530548,617.706360 482.326965,616.046875 481.424866,614.522400 
	C488.013397,614.041870 494.170227,613.994568 500.326782,614.017761 
	C520.621765,614.094177 540.916626,614.196228 561.179321,614.657288 
	C559.821472,616.117004 558.495789,617.207947 557.170044,618.298889 
z"/>
<path fill="#EC3561" opacity="1.000000" stroke="none" 
	d="
M561.211487,614.288452 
	C540.916626,614.196228 520.621765,614.094177 500.326782,614.017761 
	C494.170227,613.994568 488.013397,614.041870 481.387054,614.124146 
	C479.115906,614.121338 477.145294,614.482300 475.560211,613.860535 
	C473.956940,613.231567 471.667542,611.735596 471.538452,610.434814 
	C471.072968,605.742676 471.143463,600.949341 471.586639,596.248474 
	C471.698395,595.062744 473.948120,594.078552 475.602173,593.502319 
	C477.094055,596.764343 473.085754,602.025269 479.911621,601.991455 
	C491.995331,601.931641 504.079102,601.888184 516.487061,601.969666 
	C520.141968,604.139404 523.339050,603.575134 526.967712,601.722412 
	C537.800720,601.890137 548.129883,601.958618 558.459229,601.987183 
	C566.867798,602.010498 567.010254,601.841858 567.349304,593.139832 
	C568.834106,594.728088 570.594482,596.246460 570.896606,598.014038 
	C571.421631,601.086182 570.912476,604.319214 571.079468,607.471985 
	C571.323486,612.078613 569.508728,614.422241 564.683472,614.038757 
	C563.539978,613.947876 562.369507,614.196167 561.211487,614.288452 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M516.162842,601.837830 
	C504.079102,601.888184 491.995331,601.931641 479.911621,601.991455 
	C473.085754,602.025269 477.094055,596.764343 475.986053,593.556885 
	C488.193481,593.069153 500.403809,593.027527 513.057251,593.497681 
	C514.387878,596.619019 515.275330,599.228394 516.162842,601.837830 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M516.487061,601.969666 
	C515.275330,599.228394 514.387878,596.619019 513.546204,593.638611 
	C514.762878,591.748230 515.933777,590.228821 517.639526,588.395630 
	C520.417908,588.066833 522.661621,588.051941 525.027100,588.340454 
	C526.374878,590.157104 527.600769,591.670410 528.822632,593.577026 
	C528.033691,596.515503 527.248840,599.060669 526.463989,601.605896 
	C523.339050,603.575134 520.141968,604.139404 516.487061,601.969666 
M520.740417,599.779663 
	C522.079407,599.004272 524.363647,598.399231 524.541199,597.414429 
	C524.824829,595.841064 524.175964,593.120911 523.058777,592.537476 
	C521.838013,591.900024 518.957703,592.561279 518.000977,593.681519 
	C515.891052,596.152222 517.518127,598.205078 520.740417,599.779663 
z"/>
<path fill="#D4C9A8" opacity="1.000000" stroke="none" 
	d="
M524.905273,588.037048 
	C522.661621,588.051941 520.417908,588.066833 517.757507,588.081116 
	C517.234070,585.307495 517.127441,582.534546 516.954590,579.291992 
	C516.962769,578.648682 517.037170,578.474976 517.552368,577.894348 
	C520.326416,577.995789 522.659607,578.504211 525.075928,579.457275 
	C525.074402,582.613586 524.989868,585.325317 524.905273,588.037048 
z"/>
<path fill="#F5556C" opacity="1.000000" stroke="none" 
	d="
M470.050110,577.346863 
	C470.502106,577.236877 471.085114,577.417847 471.826691,577.871948 
	C471.383881,577.975952 470.782471,577.806885 470.050110,577.346863 
z"/>
<path fill="#71D8EA" opacity="1.000000" stroke="none" 
	d="
M298.508209,297.258423 
	C295.160278,298.676208 294.852600,296.728882 294.849915,294.485168 
	C294.843933,289.495514 294.735870,284.500885 294.947235,279.520050 
	C294.995453,278.384186 296.170105,277.296112 296.826324,276.186066 
	C297.578827,277.284943 298.955444,278.370453 298.979248,279.484894 
	C299.103210,285.290710 298.882965,291.103882 298.508209,297.258423 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M199.980347,295.473663 
	C199.967834,289.730347 199.878738,284.423676 200.058182,279.126099 
	C200.091705,278.136719 201.202011,277.183838 201.815399,276.214142 
	C202.738205,276.994690 204.425842,277.742737 204.460602,278.561035 
	C204.698959,284.169434 204.982941,289.832214 204.420364,295.393311 
	C204.159378,297.973083 201.944519,299.545868 199.980347,295.473663 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M189.181854,296.926025 
	C187.629456,296.664703 185.286987,296.142456 185.250992,295.492432 
	C184.949097,290.043060 184.979767,284.567444 185.147171,279.106995 
	C185.177734,278.109894 186.285400,277.145752 186.895859,276.166412 
	C187.909866,277.207764 189.771088,278.228760 189.796722,279.293884 
	C189.935410,285.058533 189.619873,290.834076 189.181854,296.926025 
z"/>
<path fill="#74CEE5" opacity="1.000000" stroke="none" 
	d="
M171.541382,293.329407 
	C171.618896,289.992584 171.944687,286.963074 172.270477,283.933594 
	C172.590286,283.905701 172.910080,283.877808 173.229889,283.849915 
	C173.744995,286.499451 174.438797,289.136444 174.625824,291.808960 
	C174.663635,292.349426 172.784866,293.024017 171.541382,293.329407 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M530.386597,403.646454 
	C529.511780,403.475189 528.636963,403.303925 527.221558,402.962830 
	C526.151978,402.914062 525.623108,403.035126 525.094177,403.156128 
	C520.020142,403.302704 514.906738,403.121368 509.887634,403.724609 
	C507.085754,404.061340 505.953857,403.248352 505.210938,400.510193 
	C505.062714,399.663788 505.085358,399.133118 505.348755,397.966248 
	C504.358032,391.490692 503.126495,385.651276 501.894989,379.811890 
	C501.098145,375.994629 500.301331,372.177338 499.504517,368.360077 
	C499.822449,368.417938 500.140411,368.475800 500.458374,368.533691 
	C500.817932,366.383057 501.177490,364.232422 501.689880,361.167755 
	C503.208649,360.159912 505.872406,358.392212 509.135284,356.280792 
	C513.503540,355.265411 517.272644,354.593750 521.041809,353.922119 
	C526.242554,355.546906 531.443359,357.171692 537.089722,359.232117 
	C538.313477,360.748138 539.091614,361.828491 539.869751,362.908875 
	C539.924072,368.262390 539.978394,373.615906 539.971436,379.777161 
	C539.899414,381.057983 539.888672,381.531067 539.674683,382.319122 
	C538.073242,389.546631 537.701111,396.917358 530.824524,401.342072 
	C530.371704,401.633423 530.518616,402.856689 530.386597,403.646454 
z"/>
<path fill="#CBBB9F" opacity="1.000000" stroke="none" 
	d="
M530.645752,403.792389 
	C530.518616,402.856689 530.371704,401.633423 530.824524,401.342072 
	C537.701111,396.917358 538.073242,389.546631 539.943359,382.435974 
	C541.254517,382.698608 542.093750,383.159332 542.933044,383.620056 
	C544.370850,386.916840 544.278320,390.070343 541.844177,393.569489 
	C540.446411,395.116760 539.257080,396.118683 538.067749,397.120544 
	C537.630493,399.476135 537.193237,401.831696 536.820557,404.609924 
	C534.891724,404.667816 532.898315,404.303070 530.645752,403.792389 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M506.989136,345.208008 
	C514.347534,345.168579 521.705872,345.129120 529.652100,345.327332 
	C530.446228,345.785583 530.696045,345.931732 530.989380,346.003479 
	C531.047180,346.448853 531.104980,346.894196 530.872681,347.748047 
	C530.320129,348.307709 530.123108,348.519653 529.991516,348.792358 
	C522.304749,348.823120 514.617981,348.853882 506.500671,348.438538 
	C506.376465,347.064301 506.682800,346.136169 506.989136,345.208008 
z"/>
<path fill="#CBBB9F" opacity="1.000000" stroke="none" 
	d="
M501.595703,380.032288 
	C503.126495,385.651276 504.358032,391.490692 505.339722,397.567993 
	C502.986908,397.805878 500.883942,397.805878 497.832947,397.805878 
	C498.551117,395.381805 499.068970,393.633850 499.681946,391.564819 
	C494.062042,389.896729 498.365143,386.868561 498.995605,383.795288 
	C498.920532,383.410248 498.874786,383.446533 498.874817,383.446533 
	C499.682007,382.381927 500.489227,381.317291 501.595703,380.032288 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M505.304504,335.287292 
	C500.416840,335.311890 495.963440,335.311890 491.510040,335.311890 
	C491.198364,334.899353 490.886658,334.486816 490.574982,334.074280 
	C491.611725,333.150238 492.595886,331.509552 493.694489,331.428986 
	C497.948212,331.117065 502.238403,331.302155 507.568359,331.302155 
	C506.738373,333.098877 506.238586,334.180786 505.304504,335.287292 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M504.577576,311.190491 
	C505.454102,312.295776 505.871216,313.346069 506.471649,314.857971 
	C500.261749,314.857971 494.845825,314.857971 489.429871,314.857971 
	C489.109406,314.499786 488.788940,314.141632 488.468475,313.783447 
	C489.537567,312.898193 490.556335,311.333008 491.684784,311.249512 
	C495.809479,310.944305 499.970703,311.132904 504.577576,311.190491 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M517.266663,320.646057 
	C518.176270,319.424988 519.194702,317.998016 520.304626,317.922943 
	C524.417603,317.644684 528.560791,317.812134 533.747559,318.819000 
	C532.891541,319.768921 532.050110,321.518890 531.177063,321.534821 
	C526.594971,321.618500 522.004822,321.263367 517.266663,320.646057 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M540.343994,362.887634 
	C539.091614,361.828491 538.313477,360.748138 537.409058,359.411743 
	C541.565369,359.084778 545.849915,358.924652 550.128906,359.018494 
	C550.977051,359.037140 551.803772,360.030853 552.640381,360.574890 
	C551.831909,361.333557 551.073853,362.671082 550.205811,362.746704 
	C547.096741,363.017609 543.950439,362.861206 540.343994,362.887634 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M538.526978,397.177277 
	C539.257080,396.118683 540.446411,395.116760 541.937195,393.940491 
	C546.355896,393.736572 550.482544,393.539124 554.585266,393.768982 
	C556.011536,393.848907 557.378662,394.986389 558.772766,395.640869 
	C557.448059,396.193726 556.137024,397.180725 554.796326,397.222809 
	C549.531311,397.388153 544.256958,397.255798 538.526978,397.177277 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M512.396484,321.653809 
	C509.316620,321.669769 506.641663,321.885712 504.026978,321.582275 
	C502.815704,321.441742 501.721832,320.289429 500.574707,319.595795 
	C500.797913,319.006042 501.021088,318.416321 501.244293,317.826569 
	C505.003510,317.826569 508.765686,317.748718 512.519348,317.893372 
	C513.255249,317.921753 513.958008,318.811127 514.676025,319.303406 
	C514.059387,320.082703 513.442688,320.862030 512.396484,321.653809 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M493.915924,321.673523 
	C491.366119,321.059784 489.267822,320.447296 487.169525,319.834808 
	C489.186310,319.160156 491.199249,318.473389 493.224182,317.824097 
	C493.523346,317.728149 493.911530,317.719818 494.203888,317.824127 
	C495.809204,318.396759 497.397461,319.017120 498.991547,319.621094 
	C497.450165,320.305634 495.908813,320.990173 493.915924,321.673523 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M521.015198,353.494385 
	C517.272644,354.593750 513.503540,355.265411 509.331879,356.015625 
	C507.935120,355.184692 506.940857,354.275146 505.946594,353.365601 
	C506.255951,352.758331 506.565277,352.151093 506.874634,351.543854 
	C511.579285,352.051453 516.283936,352.559021 521.015198,353.494385 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M512.227478,311.126587 
	C514.484009,311.127197 516.362244,310.833221 518.074219,311.239594 
	C519.155457,311.496246 519.988342,312.799042 520.932678,313.632599 
	C520.706421,314.004059 520.480164,314.375549 520.253967,314.747009 
	C516.732300,314.747009 513.210632,314.747009 509.688965,314.747009 
	C509.360748,314.437286 509.032562,314.127594 508.704346,313.817871 
	C509.729187,312.921356 510.754028,312.024841 512.227478,311.126587 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M506.766174,325.045624 
	C508.388702,325.738739 509.563049,326.432190 510.737366,327.125671 
	C509.663391,327.754791 508.640442,328.783264 507.504639,328.928436 
	C505.260925,329.215179 502.954712,329.013031 500.722748,329.013031 
	C499.872192,325.051483 499.872192,325.051483 506.766174,325.045624 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M506.528046,345.190948 
	C506.682800,346.136169 506.376465,347.064301 506.056274,348.290894 
	C503.402588,348.713318 500.759216,348.956482 498.125488,348.877869 
	C497.462402,348.858093 496.830078,347.807831 496.183594,347.231079 
	C496.840576,346.500977 497.451172,345.200562 498.162781,345.142731 
	C500.779388,344.930023 503.429474,345.129517 506.528046,345.190948 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M516.144775,328.989075 
	C514.720703,328.255981 513.767212,327.524811 512.813782,326.793671 
	C513.774841,326.219513 514.679810,325.326294 515.710022,325.145081 
	C517.301208,324.865143 519.056519,324.771057 520.592834,325.171387 
	C521.750000,325.472839 522.673096,326.672638 523.700378,327.472534 
	C523.434021,327.978668 523.167725,328.484833 522.901428,328.990967 
	C520.806091,328.990967 518.710815,328.990967 516.144775,328.989075 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M504.566315,338.164429 
	C506.418182,340.390656 506.397766,341.897430 503.301849,341.979797 
	C501.668762,342.023285 500.033600,341.987488 498.430023,341.987488 
	C497.655304,338.017426 497.655304,338.017426 504.566315,338.164429 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M498.428467,352.385254 
	C499.711792,357.255646 496.189117,355.921448 494.138092,355.805511 
	C492.913544,355.736298 491.759827,354.413727 490.574280,353.654572 
	C490.817657,353.144012 491.061035,352.633423 491.304443,352.122864 
	C493.563202,352.122864 495.821991,352.122864 498.428467,352.385254 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M498.932220,382.983765 
	C498.874786,383.446533 498.920532,383.410248 498.923920,383.381958 
	C496.822571,383.449951 494.683350,383.784332 492.635590,383.487579 
	C492.070892,383.405731 491.106232,380.999420 491.485474,380.422638 
	C492.724182,378.538788 498.104309,380.152649 498.932220,382.983765 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M543.343384,383.613098 
	C542.093750,383.159332 541.254517,382.698608 540.146606,382.121033 
	C539.888672,381.531067 539.899414,381.057983 539.990417,380.237732 
	C542.025391,379.883820 544.014343,379.657288 545.921753,379.954224 
	C547.032349,380.127136 548.012268,381.138824 549.051025,381.773071 
	C548.099426,382.371735 547.205322,383.118103 546.176575,383.518280 
	C545.465149,383.795013 544.567871,383.593781 543.343384,383.613098 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M530.989380,345.725128 
	C530.696045,345.931732 530.446228,345.785583 530.117371,345.382935 
	C530.326294,345.282837 530.657898,345.364807 530.989380,345.725128 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M530.265991,348.836731 
	C530.123108,348.519653 530.320129,348.307709 530.787170,348.076660 
	C530.841370,348.291595 530.690918,348.586365 530.265991,348.836731 
z"/>
<path fill="#534949" opacity="1.000000" stroke="none" 
	d="
M386.568909,354.888733 
	C392.503479,354.815002 397.972137,354.815002 404.318939,354.815002 
	C404.318939,363.244263 404.318939,371.155334 404.404419,379.528564 
	C404.405243,400.757050 404.313660,421.523315 404.239899,442.289642 
	C404.215210,449.236023 404.236023,456.182556 404.236023,463.894775 
	C396.455078,463.894775 389.196350,463.894775 381.474915,463.964813 
	C368.327393,463.998108 355.642639,463.961395 342.498535,464.005554 
	C337.920776,464.086395 333.802368,464.086395 329.343018,464.086395 
	C329.343018,427.465881 329.343018,391.622009 329.343018,354.962494 
	C348.311340,354.962494 367.207184,354.962494 386.568909,354.888733 
M374.093170,421.023590 
	C368.163422,421.399719 362.233704,421.775818 356.303955,422.151917 
	C356.357147,422.671661 356.410370,423.191376 356.463562,423.711121 
	C362.658783,423.711121 368.854004,423.711121 375.958344,423.874207 
	C386.833710,424.026337 386.833710,424.026337 387.878754,421.059784 
	C383.505859,421.059784 379.260071,421.059784 374.093170,421.023590 
M354.471405,394.553619 
	C360.095612,394.588043 365.721100,394.690948 371.342529,394.582703 
	C372.182190,394.566559 373.002747,393.559235 373.832153,393.010468 
	C373.008759,392.453186 372.187897,391.419342 371.361572,391.414948 
	C365.420807,391.383423 359.478882,391.560822 352.933411,391.752289 
	C352.435089,392.266266 351.936798,392.780243 351.438507,393.294220 
	C352.133545,393.637238 352.828552,393.980255 354.471405,394.553619 
M370.570129,432.157440 
	C369.354218,432.844635 368.138306,433.531799 366.922394,434.218964 
	C368.162567,434.713806 369.395050,435.613037 370.644196,435.636719 
	C377.824951,435.773163 385.011932,435.794189 392.190857,435.615509 
	C393.467163,435.583771 394.715485,434.429871 395.976746,433.794189 
	C394.622986,433.248108 393.279694,432.262512 391.913696,432.230011 
	C385.091583,432.067780 378.263489,432.155701 370.570129,432.157440 
M373.736877,368.267151 
	C370.741669,368.268890 367.740631,368.170563 364.755432,368.344604 
	C364.032288,368.386749 363.361572,369.327881 362.666779,369.855652 
	C363.298492,370.442963 363.901489,371.496460 364.566864,371.537415 
	C367.550659,371.721161 370.566315,371.795380 373.542877,371.559906 
	C375.924713,371.371460 376.430511,370.121368 373.736877,368.267151 
M349.692841,414.857361 
	C348.753723,415.275482 347.814606,415.693604 346.875488,416.111694 
	C347.453796,416.728180 348.015930,417.859985 348.612946,417.878662 
	C352.936981,418.014038 357.270813,417.993805 361.593445,417.820435 
	C362.144440,417.798309 362.648468,416.605133 364.063202,414.854492 
	C358.805634,414.854492 354.729126,414.854492 349.692841,414.857361 
M363.159515,396.930115 
	C360.851410,396.935974 358.524200,396.776031 356.245758,397.038910 
	C355.463043,397.129211 354.802216,398.276062 354.085724,398.940247 
	C354.831177,399.607422 355.525635,400.766266 356.331635,400.849854 
	C358.778198,401.103577 361.277649,401.064301 363.734833,400.867828 
	C364.493805,400.807129 365.183258,399.877014 365.904541,399.344940 
	C365.284637,398.552612 364.664734,397.760315 363.159515,396.930115 
M357.925415,371.627075 
	C358.814972,370.935181 359.704529,370.243286 360.594086,369.551361 
	C359.798340,369.123566 359.027069,368.393616 358.202087,368.326874 
	C356.064758,368.153839 353.890625,368.139526 351.759613,368.349670 
	C351.040497,368.420593 350.406647,369.356171 349.733826,369.896545 
	C350.369965,370.470612 350.952240,371.446106 351.652832,371.540161 
	C353.441681,371.780365 355.283356,371.627594 357.925415,371.627075 
M388.142944,403.109375 
	C384.333618,403.818970 379.894653,401.696960 376.652618,405.305847 
	C380.892365,406.228851 384.997009,406.281891 389.097168,406.170319 
	C389.697021,406.154022 390.275513,405.353424 390.863892,404.915710 
	C390.258545,404.319336 389.653198,403.722961 388.142944,403.109375 
M348.370392,366.162323 
	C350.139984,366.162323 351.909546,366.162323 353.679138,366.162323 
	C351.138824,361.195496 346.961243,363.680573 343.560455,363.095947 
	C342.370697,362.891418 340.978973,363.861633 339.679474,364.295380 
	C339.814972,364.918030 339.950470,365.540649 340.085938,366.163300 
	C342.534821,366.163300 344.983673,366.163300 348.370392,366.162323 
M350.844543,435.707214 
	C352.922974,435.061371 355.001373,434.415558 357.079803,433.769714 
	C354.904480,433.232025 352.729767,432.691864 350.552643,432.161652 
	C350.396820,432.123688 350.195526,432.101959 350.062469,432.167816 
	C348.912720,432.736511 347.773804,433.327026 346.631622,433.911041 
	C347.755554,434.509735 348.879486,435.108429 350.844543,435.707214 
M351.936279,383.134308 
	C352.748749,382.603455 353.561218,382.072601 354.373688,381.541779 
	C353.680573,381.031158 353.009796,380.120117 352.290436,380.079956 
	C349.345093,379.915619 346.378845,379.917450 343.434875,380.096771 
	C342.775452,380.136963 342.174774,381.141235 341.547028,381.701599 
	C342.255402,382.177551 342.938141,383.010986 343.676849,383.063965 
	C346.126740,383.239563 348.596771,383.134216 351.936279,383.134308 
M379.504608,428.958496 
	C379.235229,428.306824 378.984161,427.097412 378.693665,427.087891 
	C374.841431,426.961487 370.983643,427.003510 367.127258,427.003510 
	C367.084747,427.507111 367.042267,428.010681 366.999756,428.514282 
	C370.568573,431.052704 374.785583,429.481079 379.504608,428.958496 
M355.772766,377.877747 
	C356.081573,376.824554 356.390350,375.771362 356.699158,374.718201 
	C354.298309,374.724762 351.894836,374.682770 349.500702,374.812927 
	C349.260864,374.825989 349.077820,375.883759 348.868408,376.456665 
	C350.571075,376.938049 352.270386,377.432159 353.979584,377.889130 
	C354.283997,377.970490 354.629669,377.897644 355.772766,377.877747 
M362.553284,377.970245 
	C363.049988,377.969788 363.596558,378.104523 364.033936,377.943207 
	C365.267548,377.488159 366.456390,376.911560 367.662872,376.382904 
	C366.434082,375.672485 365.258301,374.831207 363.955414,374.303802 
	C363.246033,374.016663 362.239807,374.047516 361.513641,374.321899 
	C360.596649,374.668365 359.828674,375.409210 358.996399,375.979980 
	C359.894867,376.642120 360.793335,377.304230 362.553284,377.970245 
M372.918365,416.439514 
	C370.117767,415.751312 367.317169,415.063110 364.516541,414.374908 
	C364.375336,415.105713 364.234100,415.836548 364.092865,416.567383 
	C366.549957,419.072754 369.639404,418.244873 372.918365,416.439514 
M356.123108,364.575806 
	C358.980133,365.267853 361.837189,365.959869 364.694214,366.651886 
	C364.838379,365.955933 364.982544,365.259949 365.126709,364.563995 
	C362.745911,361.631653 359.446777,362.998535 356.123108,364.575806 
M349.185699,444.751495 
	C349.648560,445.562897 350.043335,447.017426 350.585999,447.074890 
	C352.998840,447.330353 355.454041,447.185730 357.893890,447.185730 
	C356.146240,442.662109 352.683746,444.586121 349.185699,444.751495 
M364.543121,406.259338 
	C366.075073,405.781586 367.607056,405.303833 369.139008,404.826050 
	C367.537170,404.253296 365.940582,403.664856 364.328644,403.122009 
	C364.033173,403.022522 363.625580,403.001404 363.354889,403.127228 
	C362.216888,403.656281 361.111206,404.254791 359.993713,404.827911 
	C361.198914,405.304626 362.404114,405.781372 364.543121,406.259338 
z"/>
<path fill="#4D2F36" opacity="1.000000" stroke="none" 
	d="
M581.122009,539.411011 
	C584.941711,541.961548 588.880676,544.679260 592.313416,547.931396 
	C596.561768,551.956177 600.390076,556.424377 604.810242,561.071289 
	C605.416748,561.719482 605.676758,561.909973 606.000793,562.013184 
	C606.000793,562.013184 606.001343,562.000366 605.993286,562.002319 
	C607.650085,566.604431 609.941223,571.086121 610.839600,575.831482 
	C612.354431,583.832642 612.986206,592.001038 613.576416,600.609802 
	C606.587463,603.525574 601.308533,600.973511 596.339050,596.866699 
	C587.298706,589.395752 582.322510,579.152039 577.122192,569.047485 
	C577.267456,563.645752 577.412720,558.243958 577.658997,552.449219 
	C578.845581,547.975891 579.931091,543.895630 581.122009,539.411011 
z"/>
<path fill="#3E2329" opacity="1.000000" stroke="none" 
	d="
M577.034241,569.414185 
	C582.322510,579.152039 587.298706,589.395752 596.339050,596.866699 
	C601.308533,600.973511 606.587463,603.525574 613.562988,601.073730 
	C614.434998,617.797424 610.931946,634.014771 606.366150,649.945984 
	C602.622681,663.008118 597.777893,675.754639 593.144775,688.885071 
	C592.217957,689.139404 591.567749,689.149658 590.598938,689.233154 
	C586.306519,681.697571 582.126648,674.187988 578.403320,666.458374 
	C571.502808,652.133057 564.849792,637.688232 558.157104,623.263733 
	C557.551453,621.958435 557.405640,620.439819 557.108154,618.659546 
	C558.495789,617.207947 559.821472,616.117004 561.179321,614.657227 
	C562.369507,614.196167 563.539978,613.947876 564.683472,614.038757 
	C569.508728,614.422241 571.323486,612.078613 571.079468,607.471985 
	C570.912476,604.319214 571.421631,601.086182 570.896606,598.014038 
	C570.594482,596.246460 568.834106,594.728088 566.894043,593.028442 
	C553.647583,593.034180 541.237122,593.108948 528.826721,593.183716 
	C527.600769,591.670410 526.374878,590.157104 525.027100,588.340454 
	C524.989868,585.325317 525.074402,582.613586 525.232117,579.344727 
	C525.305237,578.787598 525.564392,578.503174 525.564392,578.503174 
	C540.441589,578.635681 555.318787,578.768250 570.861084,578.765015 
	C571.808655,578.517029 571.986328,578.313293 572.059082,578.018066 
	C572.059082,578.018066 571.999939,578.005615 572.331787,577.997437 
	C573.138794,577.339417 573.614014,576.689636 574.089233,576.039795 
	C574.089172,576.039795 574.038635,576.046997 574.056335,576.067505 
	C575.031433,573.985596 575.988831,571.883301 577.034241,569.414185 
z"/>
<path fill="#E5DAB8" opacity="1.000000" stroke="none" 
	d="
M400.227905,520.004211 
	C400.175659,519.838684 400.353241,519.542725 400.754639,519.112427 
	C400.804840,519.276672 400.631256,519.575256 400.227905,520.004211 
z"/>
<path fill="#CBBB9F" opacity="1.000000" stroke="none" 
	d="
M525.219055,403.347717 
	C525.623108,403.035126 526.151978,402.914062 526.776123,403.024750 
	C526.362183,403.350739 525.853027,403.445007 525.219055,403.347717 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M850.637878,290.378693 
	C849.933777,291.754517 849.061890,293.609375 848.155334,293.626526 
	C837.363281,293.830566 826.565186,293.820709 815.771667,293.663177 
	C814.782654,293.648743 813.814209,292.231384 812.836182,291.465515 
	C813.774841,290.835358 814.714294,289.657227 815.652161,289.658417 
	C827.252930,289.673798 838.853394,289.860992 850.637878,290.378693 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M807.956238,238.592499 
	C807.666748,240.960739 806.853699,242.282364 803.941895,242.232864 
	C792.512512,242.038589 781.076355,242.234467 769.647522,242.024567 
	C768.481506,242.003159 767.347595,240.231171 766.588318,238.770691 
	C780.637329,238.377426 794.296753,238.484970 807.956238,238.592499 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M772.971436,267.624878 
	C777.429382,267.626343 781.393738,267.626343 785.358032,267.626343 
	C785.665771,268.076477 785.973450,268.526611 786.281189,268.976746 
	C785.237549,269.929565 784.214111,271.681976 783.147034,271.709015 
	C774.361328,271.931854 765.565247,271.930939 756.779175,271.716858 
	C755.627258,271.688782 754.514099,270.070618 753.382996,269.188904 
	C753.659180,268.667053 753.935364,268.145233 754.211548,267.623413 
	C760.300293,267.623413 766.389099,267.623413 772.971436,267.624878 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M763.960693,322.004272 
	C763.610474,322.019806 763.260315,322.035339 762.648071,322.071533 
	C761.830750,319.921356 762.234314,318.579102 764.907043,318.591827 
	C776.716309,318.648102 788.526611,318.566681 800.333923,318.730255 
	C801.254639,318.743011 802.154480,320.258606 802.474426,321.502869 
	C789.243469,321.954742 776.602051,321.979492 763.960693,322.004272 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M801.221375,282.219727 
	C806.159668,282.218781 810.637817,282.073944 815.096069,282.308167 
	C816.366089,282.374878 817.578125,283.542786 818.816772,284.205719 
	C817.640930,284.939941 816.489502,286.257629 815.284973,286.308197 
	C809.830505,286.537201 804.355957,286.532837 798.900513,286.315247 
	C797.636658,286.264862 796.419434,285.046631 795.180725,284.365753 
	C796.376099,283.650299 797.529175,282.843658 798.786377,282.261749 
	C799.331787,282.009308 800.091431,282.219635 801.221375,282.219727 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M841.048218,254.892242 
	C840.342529,255.853775 839.641052,256.781128 838.927551,256.790436 
	C830.989746,256.894440 823.048828,256.920868 815.112671,256.766693 
	C814.226685,256.749451 813.364868,255.488724 812.491882,254.804672 
	C813.230469,254.157730 813.961121,252.959229 814.708923,252.948425 
	C822.976196,252.829041 831.246521,252.866776 839.514526,252.974197 
	C840.031494,252.980896 840.536316,253.924194 841.048218,254.892242 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M759.923096,206.124481 
	C753.141174,206.124039 746.845764,206.124039 740.550415,206.124039 
	C740.276611,205.612350 740.002808,205.100677 739.729004,204.588989 
	C740.852417,203.754013 741.955322,202.230255 743.102539,202.196091 
	C750.425964,201.977982 757.761963,201.990494 765.086548,202.191010 
	C766.227722,202.222244 767.332031,203.602737 768.453430,204.359299 
	C768.216187,204.947845 767.979004,205.536392 767.741760,206.124939 
	C765.297729,206.124939 762.853699,206.124939 759.923096,206.124481 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M808.071045,276.126465 
	C816.613098,275.465668 825.041809,275.203278 833.472107,275.126465 
	C834.217651,275.119690 834.974304,276.323853 835.725769,276.965637 
	C835.014160,277.654510 834.312439,278.930084 833.589294,278.942383 
	C825.606995,279.077820 817.620300,279.067078 809.638733,278.904480 
	C809.062866,278.892761 808.517517,277.386169 808.071045,276.126465 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M787.508057,209.025360 
	C794.455139,209.013794 800.956665,208.927200 807.451538,209.096405 
	C808.586609,209.125992 809.693726,210.231659 810.813721,210.840332 
	C809.657410,211.572510 808.520935,212.898438 807.341492,212.937820 
	C801.015991,213.149048 794.679077,213.087860 788.348022,212.991623 
	C787.350403,212.976456 786.362854,212.301804 785.370605,211.932068 
	C785.933838,210.967117 786.497070,210.002151 787.508057,209.025360 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M755.563293,289.338470 
	C760.997803,289.247223 766.001465,289.083191 770.985413,289.324829 
	C772.276611,289.387390 773.506165,290.720337 774.764038,291.469727 
	C773.579102,292.281464 772.431458,293.720276 771.202515,293.793396 
	C766.555603,294.070068 761.882202,293.924835 757.218933,293.896240 
	C753.437012,293.873047 752.821167,292.313293 755.563293,289.338470 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M755.982605,305.016144 
	C761.921936,304.689636 767.859253,304.247406 773.802429,304.147888 
	C774.820801,304.130829 775.863647,305.576019 776.895203,306.345734 
	C775.928223,307.183105 774.967529,308.732361 773.993225,308.740967 
	C768.194397,308.792297 762.392456,308.487427 756.265198,307.680389 
	C755.953430,306.377777 755.968018,305.696960 755.982605,305.016144 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M768.480469,224.209595 
	C769.382568,226.725342 768.782532,227.915085 766.192993,227.879929 
	C759.561096,227.789886 752.923401,227.962311 746.297546,227.743256 
	C745.219604,227.707611 744.190002,226.209427 743.138000,225.387253 
	C743.401794,224.903137 743.665588,224.419022 743.929382,223.934906 
	C751.989441,223.934906 760.049500,223.934906 768.480469,224.209595 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M789.662231,279.063019 
	C784.389771,279.056641 779.567078,279.199860 774.766113,278.941071 
	C773.570129,278.876648 772.444153,277.514465 771.286011,276.748779 
	C771.535950,276.182220 771.785950,275.615692 772.035889,275.049133 
	C778.453247,275.049133 784.872009,274.985840 791.286133,275.129791 
	C792.082397,275.147644 792.853943,276.266479 793.636902,276.875183 
	C792.464661,277.604797 791.292358,278.334412 789.662231,279.063019 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M794.184998,271.864807 
	C792.563477,271.855530 791.335388,272.073029 790.260864,271.761169 
	C789.515015,271.544678 788.388184,270.486908 788.480042,270.004608 
	C788.650085,269.111084 789.555542,267.695190 790.211487,267.663269 
	C794.684692,267.445648 799.176819,267.435669 803.651367,267.627136 
	C804.297668,267.654785 805.450623,269.210724 805.342346,269.897552 
	C805.224609,270.644379 803.949463,271.682556 803.107239,271.754578 
	C800.303467,271.994446 797.467529,271.857880 794.184998,271.864807 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M796.492615,293.749359 
	C795.116150,292.952667 794.179016,292.157135 793.241882,291.361603 
	C794.219421,290.764008 795.176941,289.692780 796.178040,289.650421 
	C800.626648,289.462250 805.087830,289.568817 809.632874,289.568817 
	C810.817871,292.244568 810.732910,293.846619 807.368347,293.772430 
	C803.891113,293.695709 800.410889,293.752258 796.492615,293.749359 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M772.943115,213.022324 
	C768.359802,213.022049 764.263611,213.022049 760.220642,213.022049 
	C758.765381,208.282913 761.907532,209.066360 764.200806,209.040421 
	C780.693054,208.853912 780.693176,208.863800 780.743713,213.022598 
	C778.306152,213.022598 775.868225,213.022598 772.943115,213.022324 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M747.011353,213.129471 
	C744.368530,213.104126 742.190857,213.225662 740.057312,212.973465 
	C739.325562,212.886948 738.704285,211.865417 738.032471,211.271088 
	C738.708008,210.510880 739.360535,209.117538 740.062866,209.091995 
	C745.040710,208.910736 750.031067,208.941132 755.010620,209.107773 
	C755.620728,209.128189 756.659546,210.364883 756.648132,211.023132 
	C756.636475,211.693878 755.627014,212.846176 754.961060,212.917694 
	C752.492859,213.182770 749.986084,213.088867 747.011353,213.129471 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M781.359558,256.807129 
	C779.276123,254.883270 778.647217,253.053238 782.029724,252.918411 
	C787.276306,252.709259 792.537476,252.863174 797.792419,252.863174 
	C798.062927,253.377808 798.333435,253.892441 798.603943,254.407074 
	C797.476624,255.225555 796.388550,256.677307 795.215149,256.749969 
	C790.767822,257.025360 786.292786,256.853973 781.359558,256.807129 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M786.726807,202.057434 
	C788.179016,202.832870 789.161011,203.608154 790.143005,204.383423 
	C789.146729,204.962463 788.172668,205.990707 787.150391,206.041199 
	C783.174194,206.237534 779.176758,206.242523 775.201233,206.041611 
	C774.198486,205.990936 773.247620,204.912476 772.272949,204.306335 
	C773.280518,203.557587 774.246094,202.241394 775.303284,202.163116 
	C778.937073,201.894073 782.602844,202.058228 786.726807,202.057434 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M753.885864,334.361023 
	C748.910217,334.677582 743.934570,334.994110 738.958862,335.310669 
	C738.803528,334.749664 738.648132,334.188690 738.492737,333.627686 
	C739.095947,332.776550 739.699158,331.925415 741.066467,331.001953 
	C745.583191,330.872314 749.335876,330.814972 753.371582,330.877808 
	C753.731689,332.118988 753.808777,333.239990 753.885864,334.361023 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M792.502014,304.256134 
	C795.930542,304.211609 798.916016,304.309357 801.890564,304.171204 
	C804.977539,304.027802 805.761780,305.308533 804.632629,308.240417 
	C800.232666,308.240417 795.798889,308.240417 790.497375,308.240417 
	C791.129761,306.637726 791.591980,305.466278 792.502014,304.256134 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M759.055542,221.156311 
	C758.626099,220.032486 758.196594,218.908661 757.448242,216.950348 
	C763.500366,216.950348 768.726562,216.950348 774.434204,217.426544 
	C773.890198,218.931747 772.939148,220.744888 771.826050,220.850494 
	C767.597656,221.251694 763.316772,221.100815 759.055542,221.156311 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M778.141846,217.065369 
	C782.765137,217.005615 787.391296,217.023407 792.010559,216.853897 
	C794.376038,216.767105 795.411316,217.623993 794.534058,220.474365 
	C789.945129,220.962173 785.848938,220.804840 781.777771,221.055069 
	C778.613647,221.249557 777.611328,219.984604 778.141846,217.065369 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M773.040405,249.410645 
	C771.252808,248.799408 769.963867,248.189529 768.674988,247.579651 
	C769.917236,246.923019 771.137756,245.753540 772.405640,245.699814 
	C777.512634,245.483322 782.638184,245.505463 787.747375,245.695221 
	C788.868408,245.736847 789.950439,246.827911 791.050476,247.435684 
	C789.999512,248.091400 788.971313,249.266083 787.893677,249.313385 
	C783.116577,249.522964 778.325317,249.408951 773.040405,249.410645 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M777.732544,217.049713 
	C777.611328,219.984604 778.613647,221.249557 781.777771,221.055069 
	C785.848938,220.804840 789.945129,220.962173 794.493774,220.905579 
	C792.339783,221.242966 789.717285,221.585678 787.107239,222.005356 
	C785.142029,222.321365 783.192688,222.736084 780.699341,223.488983 
	C777.690186,224.244202 774.034851,222.224213 773.757935,227.037537 
	C773.652588,225.418579 773.547241,223.799622 773.408508,221.667053 
	C769.112854,221.667053 764.399353,221.667053 759.370728,221.411682 
	C763.316772,221.100815 767.597656,221.251694 771.826050,220.850494 
	C772.939148,220.744888 773.890198,218.931747 774.890991,217.482971 
	C775.685364,217.053513 776.504272,217.043793 777.732544,217.049713 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M789.899109,289.897888 
	C790.336060,290.243439 790.489990,290.393188 790.482666,290.534607 
	C790.298096,294.116791 790.110901,294.105988 781.284973,293.805573 
	C778.566833,293.713043 777.045410,293.152618 778.353760,289.698151 
	C782.007202,289.698151 785.774048,289.698151 789.899109,289.897888 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M754.751404,286.204346 
	C753.337280,283.644958 753.778381,282.177429 756.700989,282.200989 
	C759.172913,282.220947 761.668274,282.016510 764.105469,282.309113 
	C765.038330,282.421112 765.838623,283.637268 766.699402,284.350281 
	C765.809814,285.073120 764.963379,286.343170 764.022705,286.417358 
	C761.080444,286.649475 758.102661,286.430145 754.751404,286.204346 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M786.463135,298.127106 
	C790.418518,297.462952 794.273560,297.138885 798.133484,297.063202 
	C798.693542,297.052216 799.558411,298.154785 799.756470,298.884705 
	C799.902771,299.424347 799.192688,300.776917 798.867676,300.775726 
	C794.826599,300.761139 790.784912,300.586700 786.750488,300.337006 
	C786.585449,300.326813 786.491516,299.169769 786.463135,298.127106 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M764.518494,264.131042 
	C760.949829,264.141113 757.826111,264.141113 754.492310,264.141113 
	C753.516968,261.745667 753.174255,259.961304 756.675598,260.034515 
	C759.145630,260.086243 761.623108,259.953430 764.085571,260.099609 
	C764.912537,260.148682 765.703613,260.803833 766.511047,261.181976 
	C765.995178,262.161652 765.479309,263.141296 764.518494,264.131042 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M761.760376,242.160934 
	C759.162354,242.164856 757.004333,242.348969 754.907471,242.071365 
	C753.911865,241.939560 753.032898,240.926788 752.101135,240.313080 
	C753.091431,239.590744 754.019470,238.380814 755.084656,238.244858 
	C757.505676,237.935822 760.006531,238.015320 762.448669,238.232498 
	C763.330261,238.310928 764.136658,239.234268 764.977417,239.772064 
	C764.060120,240.565262 763.142822,241.358459 761.760376,242.160934 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M753.847290,311.977478 
	C757.281860,311.879303 760.721741,311.643097 764.147522,311.774353 
	C765.071533,311.809723 765.952881,312.959991 766.853821,313.598511 
	C766.022034,314.323639 765.177429,315.680756 764.360718,315.664154 
	C760.881042,315.593475 757.409668,315.116425 753.899780,314.055664 
	C753.858643,312.874908 753.852966,312.426208 753.847290,311.977478 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M761.947327,230.902985 
	C763.868713,230.979172 765.320862,231.056305 767.501099,231.172119 
	C765.919067,237.603027 761.080383,234.121353 758.088806,234.860977 
	C755.763123,235.435944 753.178101,235.115829 754.743225,230.903915 
	C756.910767,230.903915 759.194458,230.903915 761.947327,230.902985 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M762.710388,296.928436 
	C764.324036,297.644806 765.484558,298.362366 766.645081,299.079956 
	C765.572021,299.720703 764.539612,300.813477 763.418091,300.914154 
	C760.500854,301.175964 757.544495,301.002167 754.544067,301.002167 
	C753.294373,298.271515 753.596008,296.781982 756.837952,296.923035 
	C758.641113,297.001495 760.450684,296.932312 762.710388,296.928436 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M782.357178,297.405945 
	C781.999817,298.786652 781.422607,300.701447 780.555298,300.843384 
	C777.960693,301.267975 775.232239,301.184784 772.599976,300.897339 
	C771.704712,300.799591 770.940125,299.504883 770.115845,298.757080 
	C770.921021,298.154510 771.703247,297.074280 772.535461,297.034332 
	C775.683105,296.883179 778.846863,297.069489 782.357178,297.405945 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M748.171631,274.940735 
	C750.599854,274.954163 752.600037,274.772247 754.523132,275.076843 
	C755.348083,275.207520 756.012817,276.349548 756.750305,277.032104 
	C755.999817,277.705383 755.308167,278.859375 754.487549,278.959869 
	C752.222778,279.237213 749.868652,279.318329 747.620483,278.991150 
	C746.329773,278.803345 745.176575,277.671021 743.961426,276.963898 
	C745.211731,276.290070 746.462036,275.616272 748.171631,274.940735 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M774.471497,286.781433 
	C772.956482,285.971619 771.856018,285.162445 770.755615,284.353271 
	C771.795593,283.597717 772.817017,282.813934 773.890137,282.108765 
	C774.123230,281.955566 774.568176,282.000000 774.869995,282.096283 
	C776.962219,282.763794 780.828979,283.451385 780.836060,284.165070 
	C780.881287,288.739532 777.005188,286.001587 774.471497,286.781433 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M851.215332,332.803528 
	C849.565979,332.939606 848.185608,332.995056 846.391907,333.003113 
	C843.679932,331.960388 841.381287,330.964996 839.079956,329.537354 
	C843.227600,329.242554 847.377808,329.379974 852.081543,329.831726 
	C852.623901,331.007538 852.612793,331.869019 852.601685,332.730469 
	C852.229187,332.727936 851.856750,332.725403 851.215332,332.803528 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M779.799316,304.583252 
	C782.282532,304.234161 784.503052,303.804291 786.549805,304.223145 
	C787.378113,304.392670 787.827393,306.414459 788.449219,307.593323 
	C785.928223,307.987915 783.406860,308.594452 780.886658,308.589447 
	C780.410828,308.588470 779.939880,306.154755 779.799316,304.583252 
z"/>
<path fill="#F5556C" opacity="1.000000" stroke="none" 
	d="
M755.580444,304.896210 
	C755.968018,305.696960 755.953430,306.377777 755.966553,307.395386 
	C754.672424,307.880249 753.350586,308.028351 751.221558,308.084534 
	C749.871521,308.031189 749.328674,308.069733 748.785889,308.108276 
	C747.813843,308.124634 746.841858,308.140991 745.240356,308.072998 
	C744.431030,307.991058 744.251221,307.993500 744.071411,307.995911 
	C741.994751,305.501923 743.465393,304.348694 745.826660,304.267456 
	C748.934387,304.160461 752.060242,304.582001 755.580444,304.896210 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M779.359375,315.476044 
	C777.159180,315.713409 775.244507,316.106598 773.557739,315.652649 
	C772.360779,315.330475 771.471436,313.864838 771.000122,312.158325 
	C773.805725,313.907227 779.646423,307.350494 779.359375,315.476044 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M805.877808,277.897156 
	C802.988220,278.573639 800.227417,278.976135 797.467041,278.972809 
	C796.689209,278.971863 795.912903,277.781250 795.135864,277.136292 
	C795.836121,276.422180 796.773804,274.974731 797.198364,275.112183 
	C800.098877,276.051239 804.297668,272.342072 805.877808,277.897156 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M738.138672,322.247314 
	C738.344849,320.724579 738.705078,318.493408 739.375183,318.396149 
	C741.356506,318.108429 743.460266,318.663849 745.516113,318.889465 
	C744.935059,320.226715 744.647949,322.376099 743.706360,322.716827 
	C742.174133,323.271271 740.213989,322.643158 738.138672,322.247314 
z"/>
<path fill="#58353B" opacity="1.000000" stroke="none" 
	d="
M807.762512,238.193909 
	C794.296753,238.484970 780.637329,238.377426 766.522217,238.385880 
	C767.008606,238.001297 767.947571,237.071777 768.893005,237.065109 
	C781.191650,236.978546 793.491333,237.012314 805.790466,237.066483 
	C806.384277,237.069107 806.976074,237.541626 807.762512,238.193909 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M759.126221,321.577759 
	C758.757812,322.070251 758.563232,322.155731 758.314819,322.348389 
	C755.353638,322.446686 752.463318,322.474579 749.198242,322.085449 
	C748.779602,321.323120 748.612793,321.053925 748.323120,320.860870 
	C749.836731,316.224365 753.593872,319.430786 756.226990,318.779419 
	C757.003906,318.587219 758.251160,320.296173 759.126221,321.577759 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M764.258789,322.302429 
	C776.602051,321.979492 789.243469,321.954742 802.339478,321.937164 
	C802.626770,322.419098 802.459412,322.893829 802.250122,323.619873 
	C792.126038,323.582001 782.043640,323.304962 771.962158,322.994873 
	C769.492065,322.918915 767.025208,322.734924 764.258789,322.302429 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M781.553101,234.556244 
	C778.894958,234.860580 776.564026,235.168213 774.347107,234.796371 
	C773.591492,234.669632 773.122559,232.834045 772.522644,231.779266 
	C775.194153,231.504852 777.869202,231.058273 780.533936,231.113159 
	C781.019226,231.123154 781.462341,233.180939 781.553101,234.556244 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M755.437317,246.331238 
	C755.000610,247.509903 754.305847,249.018723 753.410095,249.149384 
	C750.990967,249.502243 748.467102,249.446594 746.024963,249.182510 
	C745.005249,249.072266 744.087097,248.023911 743.122742,247.402100 
	C744.156982,246.850449 745.171509,245.876953 746.229126,245.827728 
	C749.172363,245.690765 752.133545,245.937607 755.437317,246.331238 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M745.450195,310.032959 
	C748.758057,310.223053 752.995056,308.857483 751.513977,314.812164 
	C749.202271,314.453857 747.164490,314.430206 745.349060,313.782928 
	C743.057068,312.965759 741.467224,311.599976 745.450195,310.032959 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M764.874817,275.040955 
	C766.542908,275.710419 767.754272,276.378906 768.965637,277.047424 
	C767.745850,277.712738 766.466370,279.012970 765.319275,278.905151 
	C763.222412,278.708099 759.026428,280.959534 760.029724,275.262756 
	C761.520935,275.187042 762.969482,275.113525 764.874817,275.040955 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M785.195679,264.154633 
	C783.897339,263.260071 783.040771,262.369720 782.184265,261.479370 
	C783.099792,260.977417 783.976562,260.370300 784.945374,260.012787 
	C785.531494,259.796509 786.353699,259.758118 786.906860,260.004913 
	C788.307007,260.629608 789.615051,261.460449 790.960022,262.208679 
	C789.684387,262.858490 788.430298,263.557587 787.120728,264.129578 
	C786.701904,264.312469 786.136047,264.158630 785.195679,264.154633 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M784.852417,233.834381 
	C785.573608,232.570145 786.337158,231.223572 787.309692,231.050354 
	C789.351074,230.686813 791.502258,230.940048 793.563843,230.940048 
	C794.239807,235.398087 792.547607,236.000351 784.852417,233.834381 
z"/>
<path fill="#A0A950" opacity="1.000000" stroke="none" 
	d="
M773.216675,259.977478 
	C774.817444,259.991028 776.012329,259.848602 777.126465,260.085510 
	C777.789795,260.226562 778.881897,261.077179 778.813721,261.411560 
	C778.622803,262.347839 777.920349,263.933807 777.434998,263.928253 
	C775.076904,263.901337 772.723877,263.437164 770.369019,263.127869 
	C771.171631,262.078949 771.974243,261.030029 773.216675,259.977478 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M741.078735,328.948761 
	C741.197083,328.014099 741.356995,326.258789 741.428040,326.262390 
	C745.254944,326.455505 749.074219,326.796661 752.893311,327.758972 
	C752.892273,328.395325 752.785400,328.831390 752.343872,328.901917 
	C748.294495,328.964539 744.686584,328.956635 741.078735,328.948761 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M807.740234,256.855713 
	C805.037415,256.099670 800.644958,258.948761 800.867981,252.865219 
	C803.408203,252.865219 805.544312,252.754913 807.658752,252.920944 
	C808.473633,252.984924 809.239136,253.676956 810.027161,254.082825 
	C809.415710,255.004333 808.804260,255.925873 807.740234,256.855713 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M826.535034,282.299072 
	C828.457520,286.679199 828.148499,286.884613 821.341125,285.984100 
	C819.908691,280.890594 823.790649,282.517822 826.535034,282.299072 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M784.858765,283.966675 
	C786.330688,283.106659 787.784851,282.308228 789.217529,282.345093 
	C790.078369,282.367218 790.905579,283.692139 791.747925,284.431580 
	C790.825317,285.088379 789.825378,286.367340 788.997314,286.264374 
	C787.553101,286.084747 786.214661,285.053986 784.858765,283.966675 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M803.524780,300.889923 
	C803.346313,299.534912 803.592346,297.164978 803.825989,297.166199 
	C805.832581,297.176605 807.836853,297.615662 809.841858,297.926666 
	C809.362915,298.931580 809.103943,300.534424 808.356506,300.809448 
	C807.043091,301.292664 805.430786,300.963318 803.524780,300.889923 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M772.083862,252.864563 
	C773.682922,252.860519 774.897827,252.645309 775.964661,252.949509 
	C776.669189,253.150391 777.603210,254.080856 777.627319,254.715332 
	C777.652954,255.391083 776.734802,256.689301 776.216003,256.695740 
	C774.168518,256.721283 772.116089,256.346375 770.065552,256.120056 
	C770.589294,255.038071 771.113098,253.956085 772.083862,252.864563 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M774.066895,227.299118 
	C774.034851,222.224213 777.690186,224.244202 780.601562,223.871887 
	C781.085693,224.073074 781.130615,224.273483 781.164429,225.079865 
	C781.181213,226.109283 781.209106,226.532700 781.236938,226.956116 
	C778.949890,227.157654 776.662903,227.359177 774.066895,227.299118 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M756.082642,252.873291 
	C757.987915,253.410599 759.445557,253.957504 760.903198,254.504425 
	C760.487244,255.259079 760.082886,256.650299 759.653320,256.658173 
	C757.801575,256.691925 755.942444,256.320160 754.086060,256.096039 
	C754.602356,255.024979 755.118713,253.953918 756.082642,252.873291 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M750.387451,231.438660 
	C750.157593,232.805649 749.776062,234.632141 749.013794,234.808014 
	C747.570801,235.140915 745.909241,234.526291 744.338501,234.305344 
	C744.787170,233.193344 744.973755,231.427338 745.744263,231.118637 
	C746.981018,230.623108 748.604065,231.091736 750.387451,231.438660 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M741.017578,329.258575 
	C744.686584,328.956635 748.294495,328.964539 752.403198,329.221741 
	C752.965515,329.899902 753.027039,330.328766 753.088501,330.757629 
	C749.335876,330.814972 745.583191,330.872314 741.364990,330.879578 
	C740.918335,330.409119 740.937378,329.988770 741.017578,329.258575 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M753.371582,330.877808 
	C753.027039,330.328766 752.965515,329.899902 752.844727,329.151215 
	C752.785400,328.831390 752.892273,328.395325 752.981018,328.189148 
	C753.298157,327.965088 753.526550,327.947205 754.097839,327.902985 
	C755.144775,328.184998 755.848877,328.493378 756.790405,328.970398 
	C756.962219,334.739502 756.962219,334.739502 754.018921,334.700195 
	C753.808777,333.239990 753.731689,332.118988 753.371582,330.877808 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M853.000183,332.831177 
	C852.612793,331.869019 852.623901,331.007538 852.500244,329.841797 
	C853.511108,329.999603 854.656677,330.461731 855.802307,330.923828 
	C855.001099,331.593201 854.199890,332.262543 853.000183,332.831177 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M869.275696,194.458298 
	C870.716614,194.167938 872.437683,194.095154 874.578491,194.123169 
	C873.184143,194.374619 871.369995,194.525253 869.275696,194.458298 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M835.980835,329.520508 
	C836.144226,330.017303 836.284485,330.544159 836.424805,331.070984 
	C836.168091,331.133392 835.911377,331.195831 835.654663,331.258240 
	C835.616638,330.836639 835.578613,330.414978 835.724976,329.690369 
	C835.909424,329.387360 835.957825,329.550568 835.980835,329.520508 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M781.410706,226.807983 
	C781.209106,226.532700 781.181213,226.109283 781.239990,225.378510 
	C781.412537,225.600739 781.498474,226.130295 781.410706,226.807983 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M753.643860,312.119507 
	C753.852966,312.426208 753.858643,312.874908 753.779907,313.649200 
	C753.610413,313.403687 753.525391,312.832581 753.643860,312.119507 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M748.995850,308.297546 
	C749.328674,308.069733 749.871521,308.031189 750.820984,308.052002 
	C750.553711,308.236572 749.879761,308.361725 748.995850,308.297546 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M748.222412,321.115540 
	C748.612793,321.053925 748.779602,321.323120 748.799683,321.911499 
	C748.557739,321.893127 748.339722,321.631683 748.222412,321.115540 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M744.153198,308.161743 
	C744.251221,307.993500 744.431030,307.991058 744.877014,308.039703 
	C744.840393,308.169708 744.537720,308.248657 744.153198,308.161743 
z"/>
<path fill="#F5556C" opacity="1.000000" stroke="none" 
	d="
M848.699829,349.934387 
	C850.056396,350.390930 851.006348,350.824768 851.956360,351.258606 
	C851.983337,351.759064 852.010315,352.259521 852.037292,352.759949 
	C850.043884,353.088593 848.056763,353.500458 846.049988,353.651855 
	C845.764771,353.673340 845.001648,351.930573 845.107239,351.849701 
	C846.088379,351.098145 847.211426,350.531769 848.699829,349.934387 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M120.972519,547.713013 
	C110.987770,547.942444 101.001106,547.972717 90.555923,547.964111 
	C93.635216,547.614197 97.169106,547.106079 100.711731,547.035278 
	C107.140854,546.906799 113.575180,547.038757 120.468521,547.089844 
	C120.929710,547.117615 120.970612,547.513855 120.972519,547.713013 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M443.548981,167.901688 
	C443.112122,166.527786 443.075745,165.201950 443.061157,163.477722 
	C443.409454,163.029205 443.742096,162.911346 444.061523,162.940063 
	C445.975861,163.112183 449.056885,161.794220 448.641083,165.322235 
	C448.517822,166.367874 445.591400,167.083115 443.548981,167.901688 
z"/>
<path fill="#584345" opacity="1.000000" stroke="none" 
	d="
M431.906250,220.598419 
	C431.858459,220.801697 431.528839,220.495178 431.528839,220.495178 
	C431.528839,220.495178 431.706421,220.111206 431.860535,220.046570 
	C432.014679,219.981949 431.954071,220.395142 431.906250,220.598419 
z"/>
<path fill="#584345" opacity="1.000000" stroke="none" 
	d="
M428.449585,218.437851 
	C428.511292,218.396652 428.387909,218.479050 428.449585,218.437851 
z"/>
<path fill="#514546" opacity="1.000000" stroke="none" 
	d="
M706.463379,419.110840 
	C700.893860,419.183777 695.787048,419.183777 690.381226,419.183777 
	C690.381226,402.894562 690.381226,387.339172 690.381226,370.872742 
	C699.959229,370.872742 709.517578,370.872742 719.542358,370.798157 
	C723.119751,370.870087 726.230652,371.016571 729.707581,371.180267 
	C729.707581,387.033142 729.707581,402.660553 729.707581,419.037872 
	C722.036133,419.037872 714.481079,419.037872 706.463379,419.110840 
M704.649658,408.971191 
	C709.112915,408.979645 713.583313,409.130432 718.034973,408.907867 
	C719.332214,408.842957 720.576172,407.712189 721.844543,407.069977 
	C720.503235,406.416382 719.204468,405.336365 717.811890,405.197693 
	C714.885498,404.906250 711.909851,405.109192 709.641113,405.109192 
	C708.558411,403.402679 707.928101,401.365540 707.096863,401.279907 
	C703.508240,400.910248 699.857849,401.046600 696.239624,401.212067 
	C695.894653,401.227875 695.157837,403.264435 695.378906,403.452972 
	C697.923218,405.622498 698.701904,410.569183 704.649658,408.971191 
M707.262390,387.943939 
	C709.976440,386.731476 708.804077,386.134308 706.916931,385.526581 
	C701.726807,383.855316 698.679871,387.506805 695.023010,389.653625 
	C695.080994,390.121460 695.138916,390.589294 695.196899,391.057129 
	C698.610046,391.057129 702.023193,391.057129 705.053223,391.057129 
	C705.599243,389.989532 706.104858,389.000916 707.262390,387.943939 
M710.762512,397.119537 
	C706.468018,397.257507 702.173462,397.395508 697.878967,397.533478 
	C697.922668,398.300049 697.966309,399.066620 698.009949,399.833191 
	C702.479126,399.833191 706.948608,399.846405 711.414429,399.724976 
	C711.492554,399.722870 711.526611,398.100311 710.762512,397.119537 
z"/>
<path fill="#534B4B" opacity="1.000000" stroke="none" 
	d="
M680.553955,397.890381 
	C681.269958,398.436340 681.734863,399.034424 681.735962,399.633331 
	C681.773376,420.735016 681.767151,441.836761 681.767151,463.903168 
	C667.008484,463.903168 652.470520,463.903168 637.469971,463.984436 
	C634.691589,463.924927 632.375732,463.784180 629.604980,463.615753 
	C629.604980,441.861511 629.604980,420.199799 629.604980,397.942932 
	C646.547729,397.942932 663.317139,397.942932 680.553955,397.890381 
M655.937683,427.245697 
	C657.601868,427.147827 659.266052,427.049988 660.930298,426.952148 
	C661.067810,426.542755 661.205322,426.133392 661.342896,425.724030 
	C660.910706,425.532227 660.479980,425.177155 660.046204,425.173279 
	C654.110657,425.119843 648.173950,425.079407 642.239929,425.176575 
	C641.835999,425.183136 641.450439,426.312744 640.668762,427.464386 
	C639.499023,428.103149 638.329224,428.741882 637.159424,429.380615 
	C637.528687,429.879211 637.897949,430.377838 638.267212,430.876465 
	C639.532837,429.684265 640.798462,428.492096 642.684570,427.225433 
	C643.098816,427.260590 643.513000,427.295746 643.964111,427.954254 
	C647.789734,428.917969 651.615295,429.881683 655.959229,430.975983 
	C655.463989,428.930359 655.271301,428.134583 655.937683,427.245697 
M646.806885,444.977173 
	C643.687134,444.977173 640.567383,444.977173 637.447632,444.977173 
	C640.238831,447.144043 643.215332,448.641724 646.358215,449.584564 
	C648.923279,450.354126 650.922913,449.406982 651.674011,446.157806 
	C652.109375,446.193024 652.544739,446.228271 653.018738,446.990417 
	C654.472046,449.072723 665.997253,450.438995 667.515625,448.608704 
	C667.966125,448.065613 667.866089,447.065796 668.764465,446.166290 
	C669.667603,445.894592 670.570679,445.622894 671.473816,445.351196 
	C671.391968,444.817566 671.310059,444.283966 671.228210,443.750336 
	C663.319946,444.154663 655.411682,444.558990 646.806885,444.977173 
M652.320129,417.500275 
	C653.727966,417.076508 655.135803,416.652740 656.543640,416.229004 
	C656.403992,415.574585 656.264282,414.920197 656.124634,414.265808 
	C650.186035,415.153809 644.247375,416.041840 638.308777,416.929871 
	C638.396790,417.675812 638.484802,418.421722 638.572876,419.167664 
	C643.008423,418.801178 647.443970,418.434692 652.320129,417.500275 
M639.048401,406.147888 
	C637.432556,406.571503 635.816650,406.995117 634.200806,407.418732 
	C634.271240,407.644196 634.341675,407.869629 634.412109,408.095093 
	C638.535889,408.095093 642.659607,408.095093 646.783386,408.095093 
	C646.808655,407.571930 646.833862,407.048798 646.859131,406.525635 
	C644.534851,406.397888 642.210510,406.270111 639.048401,406.147888 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M475.614166,697.430664 
	C477.360779,695.811157 479.061920,693.551147 480.703003,693.593872 
	C482.118622,693.630737 484.183502,696.084045 484.683014,697.833984 
	C485.531189,700.805298 484.311005,703.794556 480.809052,704.038086 
	C476.763123,704.319580 475.573547,701.341797 475.614166,697.430664 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M519.987610,693.978027 
	C523.596985,694.517639 525.243774,696.760620 524.506042,699.609741 
	C524.073730,701.279419 521.821106,703.469360 520.265076,703.571960 
	C518.770630,703.670532 516.369019,701.687805 515.701904,700.069092 
	C514.544312,697.260132 515.946350,694.921753 519.105347,694.047485 
	C519.264160,694.003601 519.434143,694.000061 519.987610,693.978027 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M561.790344,694.454468 
	C566.543762,694.475220 568.820251,698.280518 566.467529,701.799072 
	C565.835449,702.744446 564.356079,703.722778 563.342102,703.648071 
	C562.282471,703.569946 560.489746,702.265991 560.465027,701.453918 
	C560.396484,699.200317 561.080505,696.923767 561.790344,694.454468 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M605.891113,561.794556 
	C605.676758,561.909973 605.416748,561.719482 605.112793,561.221558 
	C605.323425,561.112244 605.582275,561.303711 605.891113,561.794556 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M267.692474,142.114075 
	C291.370483,142.000778 314.744263,141.982269 338.117920,142.021927 
	C340.917908,142.026672 343.717346,142.347488 346.820740,142.822815 
	C341.509003,143.403961 335.893524,143.684006 330.278076,143.964233 
	C323.155701,144.319656 316.033356,144.675247 308.013855,145.011108 
	C301.729675,145.058853 296.342560,145.126282 290.955475,145.193710 
	C290.239960,145.191071 289.524445,145.188431 287.993408,145.142807 
	C281.769440,145.112442 276.360992,145.125046 270.952515,145.137650 
	C269.764404,144.167236 268.576294,143.196823 267.692474,142.114075 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M306.992737,174.764999 
	C300.020203,174.765350 293.546112,174.765350 287.072021,174.765350 
	C287.005005,174.065903 286.938019,173.366440 286.871002,172.666992 
	C288.068268,172.279877 289.262207,171.569122 290.463287,171.556946 
	C299.930206,171.460846 309.399384,171.437012 318.865173,171.575806 
	C319.983765,171.592209 321.085999,172.725006 322.195801,173.340302 
	C321.114624,173.814255 320.049469,174.647949 318.949371,174.696945 
	C315.136505,174.866760 311.311523,174.763809 306.992737,174.764999 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M340.107025,186.021118 
	C338.985138,187.612320 337.863281,189.203537 335.996674,190.911880 
	C327.070862,190.795441 318.889771,190.561874 310.708679,190.328308 
	C311.543243,189.553909 312.276459,188.285980 313.229858,188.090225 
	C317.445343,187.224625 321.724152,186.667343 326.871765,185.974594 
	C331.877991,185.974197 335.992523,185.997665 340.107025,186.021118 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M283.162903,191.236053 
	C287.887604,191.586227 292.387665,190.447266 296.435669,192.052383 
	C296.366547,192.608170 296.297455,193.163940 296.228333,193.719727 
	C289.593994,193.719727 282.959625,193.719727 276.325287,193.719727 
	C276.266724,193.068985 276.208160,192.418243 276.149597,191.767502 
	C278.330688,191.590485 280.511810,191.413467 283.162903,191.236053 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M299.122681,201.246490 
	C297.662567,200.607620 296.255615,199.726807 294.728821,199.391388 
	C292.841125,198.976669 290.853912,199.014862 288.909698,198.857361 
	C288.867004,198.381195 288.824341,197.905045 288.781647,197.428879 
	C289.681030,197.053070 290.572540,196.375870 291.481079,196.352173 
	C296.118561,196.231277 300.760803,196.311676 305.400543,196.254272 
	C307.704468,196.225800 309.083038,196.770706 307.318970,199.754486 
	C304.418365,200.520325 302.045868,200.946182 299.541138,201.316925 
	C299.408844,201.261826 299.122681,201.246490 299.122681,201.246490 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M299.673401,201.372025 
	C302.045868,200.946182 304.418365,200.520325 307.209656,200.084259 
	C308.478210,202.934677 309.327972,205.795303 310.178345,208.658066 
	C307.271698,207.672974 304.505463,206.735458 301.371582,205.894958 
	C301.003937,205.991974 301.067200,205.957794 301.067200,205.957794 
	C300.864136,205.540344 300.661072,205.122894 300.261780,204.136017 
	C299.934845,202.835068 299.804138,202.103546 299.673401,201.372025 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M309.986572,160.023834 
	C308.743622,160.328979 307.481903,160.573746 306.261688,160.952209 
	C303.920013,161.678513 301.601898,162.480698 299.273987,163.251404 
	C299.348785,163.723083 299.423553,164.194763 299.498352,164.666443 
	C298.404175,164.121658 297.310028,163.576889 295.843658,162.846771 
	C295.266968,164.573471 294.793549,165.990936 294.316711,167.418610 
	C291.196655,166.458923 296.686340,159.693649 289.242554,161.670410 
	C285.661560,161.661560 282.818268,161.575012 279.974945,161.488449 
	C280.015350,161.103134 280.055756,160.717804 280.585754,160.063385 
	C284.482391,159.807587 287.908813,160.025299 291.284393,159.705872 
	C292.257843,159.613739 293.084961,157.975830 293.979187,157.046616 
	C294.440002,157.690292 294.900848,158.333969 295.526154,159.207413 
	C295.902649,158.606567 296.270142,158.020111 296.898071,157.708069 
	C298.211456,158.602570 299.224487,159.659470 300.325012,159.760208 
	C303.526764,160.053253 306.763519,159.963470 309.986572,160.023834 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M303.507782,214.965744 
	C304.161713,213.692474 304.763855,211.349014 305.477692,211.314484 
	C311.421539,211.026901 317.387024,211.117722 323.342773,211.243362 
	C323.978027,211.256760 324.593109,212.224609 325.217560,212.749695 
	C325.129364,213.200226 325.041168,213.650742 324.952942,214.101273 
	C322.938293,214.101273 320.923645,214.101273 318.044556,214.075012 
	C314.995453,214.393280 312.810822,214.737808 310.227600,215.047424 
	C307.721924,214.996933 305.614868,214.981339 303.507782,214.965744 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M288.909912,221.251511 
	C288.625122,222.214188 288.359222,224.010254 288.052704,224.017212 
	C281.060455,224.176086 274.063782,224.139557 266.380493,224.139557 
	C268.609039,221.301437 268.609039,221.301437 284.945984,221.247116 
	C286.833679,221.271637 287.871796,221.261581 288.909912,221.251511 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M305.035034,151.401352 
	C311.614685,151.401352 318.194336,151.401352 325.739685,151.401352 
	C324.699432,152.970398 324.399261,153.851273 324.064789,153.864532 
	C317.219818,154.135696 310.371063,154.313522 303.521790,154.439072 
	C303.429565,154.440750 303.320709,153.531845 303.459778,152.585205 
	C304.144958,151.882080 304.589996,151.641724 305.035034,151.401352 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M279.512939,161.509674 
	C282.818268,161.575012 285.661560,161.661560 288.980286,161.861893 
	C288.601044,162.886581 287.778534,164.547958 286.886627,164.586121 
	C281.250824,164.827255 275.598236,164.769592 269.955139,164.638840 
	C269.164490,164.620514 268.395630,163.661362 267.616699,163.137711 
	C267.741516,162.602112 267.866364,162.066513 267.991180,161.530914 
	C271.677765,161.530914 275.364349,161.530914 279.512939,161.509674 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M264.905640,148.991364 
	C266.627380,148.259689 268.349152,147.528015 270.948547,146.865448 
	C277.218353,146.955261 282.610443,146.975983 288.002563,146.996704 
	C287.369598,147.820221 286.839752,149.221283 286.083862,149.356186 
	C284.028992,149.722931 281.878479,149.553711 278.925934,149.593384 
	C273.692535,149.390320 269.299103,149.190842 264.905640,148.991364 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M303.203644,215.360748 
	C305.614868,214.981339 307.721924,214.996933 310.400726,215.390533 
	C312.865570,216.754379 314.758667,217.740234 316.651794,218.726074 
	C314.662994,218.879959 312.674164,219.033844 309.899658,219.234589 
	C305.085419,219.184830 301.056854,219.088211 297.028320,218.991592 
	C297.028320,218.991592 297.005127,218.991440 297.022766,218.553040 
	C297.023102,217.544800 297.005798,216.974991 296.998901,216.363983 
	C297.009277,216.322784 297.012268,216.304062 297.012268,216.304062 
	C298.974670,216.121292 300.937103,215.938522 303.203644,215.360748 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M295.165161,179.741364 
	C292.751129,179.533951 290.808075,179.327530 288.865051,179.121124 
	C288.909424,178.603104 288.953766,178.085068 288.998138,177.567047 
	C295.307343,177.567047 301.616516,177.567047 307.868683,177.567047 
	C307.006714,179.771362 307.006714,179.771362 295.165161,179.741364 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M350.752686,183.033981 
	C347.800629,183.667633 344.848572,184.301300 341.170593,184.682220 
	C335.692444,184.269455 330.940216,184.109421 326.187958,183.949402 
	C327.331482,183.284851 328.460327,182.077225 329.621002,182.045853 
	C336.092926,181.870926 342.572571,181.980881 349.588562,182.257889 
	C350.272003,182.771042 350.480377,182.941574 350.752686,183.033981 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M299.541138,201.316925 
	C299.804138,202.103546 299.934845,202.835068 300.056824,203.834106 
	C295.646149,204.867493 291.265106,205.376846 287.046600,203.892868 
	C287.027008,203.213928 287.007416,202.534973 286.987823,201.856018 
	C290.726959,201.692459 294.466064,201.528915 298.663940,201.305939 
	C299.122681,201.246490 299.408844,201.261826 299.541138,201.316925 
z"/>
<path fill="#C6B9A0" opacity="1.000000" stroke="none" 
	d="
M310.785675,190.694046 
	C318.889771,190.561874 327.070862,190.795441 335.728851,191.111755 
	C336.205750,191.194473 336.238495,191.600708 335.670044,191.783264 
	C331.029602,191.951187 326.949188,191.784744 322.890533,192.009995 
	C321.592224,192.082047 320.351471,193.191330 319.084381,193.826050 
	C316.163788,193.438995 311.714050,197.596756 310.785675,190.694046 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M278.876770,211.231949 
	C278.853333,211.722763 279.025604,212.374100 278.775482,212.679016 
	C276.752380,215.145584 265.150299,214.593918 263.485809,211.527924 
	C268.932953,211.128662 273.904877,211.180298 278.876770,211.231949 
z"/>
<path fill="#684347" opacity="1.000000" stroke="none" 
	d="
M264.657715,148.737030 
	C269.299103,149.190842 273.692535,149.390320 278.535583,149.697418 
	C278.990936,150.293503 278.996735,150.781998 278.600159,151.567963 
	C273.178070,151.658707 268.158356,151.451981 263.138611,151.245270 
	C261.826294,150.293015 260.513947,149.340775 258.229828,147.683365 
	C258.356323,147.488708 259.142242,146.279388 259.928162,145.070068 
	C261.422058,146.207611 262.915924,147.345154 264.657715,148.737030 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M278.914429,210.887909 
	C273.904877,211.180298 268.932953,211.128662 263.497986,211.111877 
	C264.450439,209.811676 265.687805,207.701447 267.323730,207.325500 
	C269.703522,206.778580 272.391785,207.346954 274.900482,207.743591 
	C275.546234,207.845673 276.012329,209.084305 277.225281,209.745529 
	C278.258118,209.744492 278.626678,209.798752 278.995209,209.852997 
	C278.980804,210.083298 278.966431,210.313583 278.914429,210.887909 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M291.999603,149.143631 
	C291.714386,148.695999 291.429169,148.248352 291.594177,147.458252 
	C297.270172,147.161880 302.496002,147.207962 307.721802,147.254059 
	C306.896851,148.068512 306.071899,148.882965 304.640137,149.687988 
	C303.488373,149.706100 302.943451,149.733627 302.398499,149.761169 
	C299.955078,149.746490 297.511688,149.731796 294.380066,149.586029 
	C293.127808,149.351166 292.563690,149.247406 291.999603,149.143631 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M300.734558,184.912628 
	C299.782562,184.243423 299.256561,183.584091 298.730560,182.924759 
	C299.390350,182.587738 300.044617,181.971970 300.710785,181.958817 
	C305.130157,181.871704 309.552094,181.913696 314.170013,181.913696 
	C313.047913,184.903946 313.047913,184.903946 300.734558,184.912628 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M317.036591,218.904327 
	C314.758667,217.740234 312.865570,216.754379 310.799316,215.425446 
	C312.810822,214.737808 314.995453,214.393280 317.605621,214.122437 
	C318.846497,214.783569 319.662964,215.369400 320.476868,215.958847 
	C321.589264,216.764481 322.699646,217.572906 323.810913,218.380127 
	C322.439087,218.901932 321.100433,219.589737 319.681000,219.873093 
	C319.007233,220.007584 318.179413,219.370239 317.036591,218.904327 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M311.563354,157.259979 
	C314.802063,156.861526 318.034180,156.320175 321.284332,156.171249 
	C322.039215,156.136642 322.855377,157.439102 323.643341,158.126328 
	C322.756958,159.013687 321.884277,160.636200 320.981659,160.653015 
	C318.065186,160.707336 315.137695,160.171249 311.891602,159.470978 
	C311.566956,158.472855 311.565155,157.866409 311.563354,157.259979 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M279.435303,209.777527 
	C278.626678,209.798752 278.258118,209.744492 277.614227,209.754639 
	C277.520538,208.782959 277.648895,206.859314 277.891968,206.844711 
	C281.205933,206.645660 284.535828,206.710754 287.861786,206.710754 
	C287.931396,207.476730 288.001038,208.242691 288.070648,209.008667 
	C285.338898,209.239792 282.607147,209.470917 279.435303,209.777527 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M304.997192,191.258057 
	C306.246765,191.252045 307.133575,191.044769 307.864655,191.294128 
	C308.635986,191.557220 309.258759,192.255936 309.946442,192.764313 
	C309.295349,193.299271 308.702850,194.172501 307.980774,194.297592 
	C306.549835,194.545502 305.047363,194.382751 303.574463,194.385361 
	C301.991638,194.388184 300.408844,194.386002 298.631500,194.386002 
	C299.731659,191.276810 299.731659,191.276810 304.997192,191.258057 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M268.240326,199.261475 
	C268.558258,198.067947 269.107025,196.354858 269.841370,196.271225 
	C272.695038,195.946259 275.607635,196.138885 278.681213,196.138885 
	C277.503967,200.223175 277.063751,200.341919 268.240326,199.261475 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M311.291687,157.195236 
	C311.565155,157.866409 311.566956,158.472855 311.518127,159.379166 
	C311.139771,159.759659 310.812073,159.840256 310.235474,159.972336 
	C306.763519,159.963470 303.526764,160.053253 300.325012,159.760208 
	C299.224487,159.659470 298.211456,158.602570 297.154236,157.589203 
	C297.149963,157.195923 297.126923,157.112137 297.544800,157.089859 
	C301.956329,156.987625 305.949982,156.907684 309.943604,156.827728 
	C310.302399,156.928650 310.661224,157.029572 311.291687,157.195236 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M279.226624,201.573486 
	C281.765930,202.130188 283.876678,202.696548 285.987396,203.262924 
	C283.612122,203.744797 281.252380,204.448196 278.855103,204.616440 
	C277.629730,204.702408 276.337006,203.829498 275.074738,203.389984 
	C276.315826,202.787704 277.556946,202.185440 279.226624,201.573486 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M270.524994,176.247314 
	C273.606445,176.591827 276.284119,176.941635 278.961761,177.291458 
	C278.909607,178.066025 278.857483,178.840591 278.805328,179.615158 
	C275.393066,179.615158 271.979248,179.660828 268.570892,179.545532 
	C268.224274,179.533783 267.549316,178.166885 267.638123,178.083969 
	C268.384979,177.386902 269.274536,176.842758 270.524994,176.247314 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M279.225433,171.576630 
	C281.760712,172.149368 283.868195,172.722382 285.975647,173.295395 
	C283.768951,173.781631 281.576904,174.533890 279.350159,174.656876 
	C277.957764,174.733780 276.512970,173.862610 275.091705,173.416870 
	C276.326996,172.803574 277.562317,172.190247 279.225433,171.576630 
z"/>
<path fill="#D44341" opacity="1.000000" stroke="none" 
	d="
M263.078186,151.444519 
	C268.158356,151.451981 273.178070,151.658707 278.597717,151.934235 
	C278.997589,152.003052 279.000000,152.000000 279.002136,152.249634 
	C279.004242,152.499252 279.091492,152.989273 279.091492,152.989258 
	C273.993866,153.372604 268.896210,153.755951 263.354828,153.746002 
	C262.892548,152.910919 262.874023,152.469162 262.855499,152.027390 
	C262.855499,152.027390 263.017731,151.643799 263.078186,151.444519 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M296.907318,215.824417 
	C297.012268,216.304062 297.009277,216.322784 296.992493,216.326508 
	C296.975739,216.330231 296.984863,216.254913 296.933167,215.859589 
	C292.926697,215.026657 288.971954,214.589066 284.642914,214.066528 
	C283.507294,214.035461 282.745972,214.089325 281.984619,214.143188 
	C282.314148,213.438477 282.628510,212.128479 282.975494,212.119781 
	C288.205322,211.988861 293.439392,212.029022 299.898621,212.029022 
	C298.361938,213.674622 297.582153,214.509705 296.907318,215.824417 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M293.722534,157.008820 
	C293.084961,157.975830 292.257843,159.613739 291.284393,159.705872 
	C287.908813,160.025299 284.482391,159.807587 280.624237,159.774994 
	C280.109528,159.112381 280.045929,158.469040 280.483948,157.466187 
	C284.975952,157.027878 288.966400,156.949051 292.956818,156.870239 
	C293.126495,156.903839 293.296173,156.937439 293.722534,157.008820 
z"/>
<path fill="#684347" opacity="1.000000" stroke="none" 
	d="
M297.017822,219.359924 
	C301.056854,219.088211 305.085419,219.184830 309.563782,219.402466 
	C308.582367,220.011444 307.150726,220.498108 305.720032,220.987656 
	C303.735413,221.666733 301.751495,222.348053 298.621674,223.421265 
	C298.402130,222.919037 297.704742,221.323639 297.017822,219.359924 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M281.416931,153.567001 
	C282.503174,152.904007 283.548126,151.767853 284.683563,151.668869 
	C287.788574,151.398163 290.931641,151.564362 294.779175,151.585876 
	C295.673096,151.542892 295.847504,151.471603 296.021881,151.400299 
	C297.163940,151.712891 298.305969,152.025482 299.448029,152.338074 
	C299.435120,152.993988 299.422211,153.649902 299.409302,154.305817 
	C293.923187,154.305817 288.437042,154.305817 282.387726,154.057266 
	C281.824524,153.808716 281.416931,153.567001 281.416931,153.567001 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M301.016968,205.958344 
	C300.228882,210.258774 296.758942,211.173798 290.877655,207.325882 
	C294.850708,206.960175 297.581451,206.708817 300.689697,206.207626 
	C301.067200,205.957794 301.003937,205.991974 301.016968,205.958344 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M288.029785,146.719025 
	C282.610443,146.975983 277.218353,146.955261 271.363464,146.822540 
	C270.910370,146.361053 270.920013,146.011566 270.941101,145.399857 
	C276.360992,145.125046 281.769440,145.112442 287.640137,145.214081 
	C288.087250,145.699341 288.072144,146.070343 288.029785,146.719025 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M307.798767,146.911163 
	C302.496002,147.207962 297.270172,147.161880 291.589722,147.176300 
	C291.081390,146.783661 291.027649,146.330490 290.964691,145.535522 
	C296.342560,145.126282 301.729675,145.058853 307.579834,145.082550 
	C307.987183,145.638519 307.931458,146.103394 307.798767,146.911163 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M319.523438,193.983154 
	C320.351471,193.191330 321.592224,192.082047 322.890533,192.009995 
	C326.949188,191.784744 331.029602,191.951187 335.572144,191.962006 
	C334.952087,192.702744 333.893890,194.025528 332.764954,194.088974 
	C328.509918,194.328064 324.231873,194.157455 319.523438,193.983154 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M278.523682,189.961731 
	C277.741119,189.085693 277.390594,188.218613 277.040070,187.351532 
	C280.435974,187.351532 283.831909,187.351532 287.227814,187.351532 
	C287.216553,188.224594 287.205322,189.097656 287.194061,189.970718 
	C284.447937,189.970718 281.701813,189.970718 278.523682,189.961731 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M326.167053,184.211945 
	C330.940216,184.109421 335.692444,184.269455 340.727905,184.736160 
	C340.873932,185.333969 340.736725,185.625107 340.353271,185.968674 
	C335.992523,185.997665 331.877991,185.974197 327.287872,185.916245 
	C326.590210,185.412659 326.368195,184.943573 326.167053,184.211945 
z"/>
<path fill="#E9C255" opacity="1.000000" stroke="none" 
	d="
M284.973541,219.486542 
	C283.584900,219.376465 282.196228,219.266388 280.399506,218.735535 
	C279.974854,217.870499 279.958282,217.426224 279.941711,216.981934 
	C279.941742,216.981934 280.004456,216.986145 280.418152,216.907654 
	C282.239380,216.665512 283.646912,216.501877 285.499420,216.444809 
	C288.732727,216.683014 291.521027,216.814667 294.279938,217.322632 
	C294.191193,218.198532 294.131866,218.698151 294.072571,219.197754 
	C292.671448,219.235245 291.270355,219.272751 289.059509,219.271057 
	C287.157684,219.316757 286.065613,219.401657 284.973541,219.486542 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M320.913269,184.960205 
	C319.074554,184.608032 317.651428,184.255585 316.228302,183.903137 
	C316.320831,183.394287 316.413361,182.885452 316.505890,182.376602 
	C319.122162,182.376602 321.738403,182.376602 324.354675,182.376602 
	C324.498230,182.760132 324.641785,183.143646 324.785339,183.527176 
	C323.633179,184.004745 322.481018,184.482315 320.913269,184.960205 
z"/>
<path fill="#674247" opacity="1.000000" stroke="none" 
	d="
M309.628906,156.577469 
	C305.949982,156.907684 301.956329,156.987625 297.502502,157.099731 
	C301.132935,156.863632 305.223572,156.595413 309.628906,156.577469 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M292.638428,156.625183 
	C288.966400,156.949051 284.975952,157.027878 280.528809,157.143646 
	C284.154755,156.913757 288.237427,156.646957 292.638428,156.625183 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M285.054443,216.338257 
	C283.646912,216.501877 282.239380,216.665512 280.405151,216.879044 
	C280.628632,216.201614 281.278839,215.474289 281.956848,214.445068 
	C282.745972,214.089325 283.507294,214.035461 284.627625,214.341370 
	C285.009216,215.246857 285.031830,215.792557 285.054443,216.338257 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M284.992432,219.757965 
	C286.065613,219.401657 287.157684,219.316757 288.647583,219.350891 
	C289.007263,219.864868 288.969147,220.259796 288.920471,220.953125 
	C287.871796,221.261581 286.833679,221.271637 285.414215,221.199677 
	C285.025696,220.754898 285.018524,220.392151 284.992432,219.757965 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M302.452301,150.083328 
	C302.943451,149.733627 303.488373,149.706100 304.298706,149.723755 
	C304.640869,150.041489 304.717651,150.314026 304.914734,150.993958 
	C304.589996,151.641724 304.144958,151.882080 303.449982,152.179321 
	C302.968719,151.625961 302.737427,151.015732 302.452301,150.083328 
z"/>
<path fill="#684347" opacity="1.000000" stroke="none" 
	d="
M296.984863,216.254913 
	C296.984863,216.254913 296.975739,216.330231 296.982117,216.367706 
	C297.005798,216.974991 297.023102,217.544800 297.027161,218.542160 
	C296.573242,218.979202 296.132599,218.988724 295.348877,218.676514 
	C295.001617,217.916916 294.997437,217.479050 295.515076,216.905151 
	C296.352875,216.597717 296.668854,216.426315 296.984863,216.254913 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M294.993256,217.041199 
	C294.997437,217.479050 295.001617,217.916916 295.018311,218.683044 
	C294.778381,219.164261 294.525940,219.317184 294.173035,219.333923 
	C294.131866,218.698151 294.191193,218.198532 294.452026,217.335602 
	C294.653534,216.972260 294.993256,217.041199 294.993256,217.041199 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M292.197784,149.377106 
	C292.563690,149.247406 293.127808,149.351166 293.929108,149.622314 
	C293.576202,149.729980 292.986084,149.670273 292.197784,149.377106 
z"/>
<path fill="#755355" opacity="1.000000" stroke="none" 
	d="
M279.732391,217.139862 
	C279.958282,217.426224 279.974854,217.870499 279.988678,218.647797 
	C279.831635,218.419785 279.677368,217.858795 279.732391,217.139862 
z"/>
<path fill="#684347" opacity="1.000000" stroke="none" 
	d="
M262.658630,152.179993 
	C262.874023,152.469162 262.892548,152.910919 262.882141,153.683792 
	C262.722717,153.454132 262.592224,152.893372 262.658630,152.179993 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M281.335999,153.752106 
	C281.416931,153.567001 281.824524,153.808716 281.921539,154.024902 
	C281.764069,154.139786 281.509552,154.038498 281.335999,153.752106 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M350.794250,182.775055 
	C350.480377,182.941574 350.272003,182.771042 350.050293,182.332031 
	C350.260620,182.266510 350.548218,182.391327 350.794250,182.775055 
z"/>
<path fill="#684347" opacity="1.000000" stroke="none" 
	d="
M279.239563,152.888641 
	C279.091492,152.989273 279.004242,152.499252 279.000549,152.250427 
	C279.127106,152.263733 279.257385,152.525879 279.239563,152.888641 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M295.910828,151.286926 
	C295.847504,151.471603 295.673096,151.542892 295.233337,151.516830 
	C295.180664,151.136505 295.457916,151.054535 295.910828,151.286926 
z"/>
<path fill="#FDBA5B" opacity="1.000000" stroke="none" 
	d="
M357.809753,138.603882 
	C356.186401,138.538086 354.674103,138.094284 353.161865,137.650482 
	C353.709534,136.793839 354.257233,135.937195 354.804932,135.080566 
	C355.843567,136.128998 356.882202,137.177444 357.809753,138.603882 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M120.894928,388.108337 
	C119.821236,387.035339 118.740952,386.337646 118.257034,385.348267 
	C117.873520,384.564209 118.221024,383.422577 118.243935,382.439697 
	C119.083305,382.614349 120.182991,382.509949 120.719002,383.009857 
	C123.758095,385.844513 126.620476,388.867767 129.633438,391.731689 
	C130.806931,392.847137 132.085251,394.036743 133.544510,394.629883 
	C136.914398,395.999542 137.767288,397.731903 135.920471,401.143646 
	C134.979324,402.882263 135.074295,405.253906 134.965378,407.353180 
	C134.819046,410.173370 135.149689,413.031097 134.844055,415.825500 
	C134.664047,417.471313 133.648636,419.025696 133.008911,420.621185 
	C132.450455,418.944885 131.814819,417.288757 131.368210,415.583191 
	C131.164398,414.804871 131.242996,413.917267 131.347427,413.098907 
	C132.648056,402.906952 129.504959,394.560272 120.894928,388.108337 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M539.048096,193.279907 
	C538.714355,194.825150 538.380676,196.370392 537.647400,198.354309 
	C536.170776,199.525452 535.093811,200.257919 534.016785,200.990387 
	C533.558105,201.007309 533.099426,201.024246 532.390991,200.637146 
	C531.465820,199.820251 530.790466,199.407364 530.114990,198.994476 
	C529.812927,199.618088 529.510803,200.241699 529.208740,200.865326 
	C526.631958,200.730759 524.055176,200.596191 521.319946,200.453339 
	C521.110474,199.181747 520.901184,197.911148 520.651367,196.394684 
	C519.132263,196.394684 517.777344,196.394684 515.673157,196.394684 
	C519.234924,192.747467 522.163574,189.661240 527.526367,191.428223 
	C531.588379,192.361221 535.318237,192.820572 539.048096,193.279907 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M539.423096,180.733459 
	C541.704346,180.712402 543.601929,180.840714 545.499512,180.969040 
	C545.480469,181.429352 545.461365,181.889648 545.442322,182.349960 
	C536.174683,183.432907 526.906982,184.515854 517.639343,185.598801 
	C517.568848,185.063187 517.498291,184.527557 517.427795,183.991943 
	C524.327515,181.130569 531.564087,180.290466 539.423096,180.733459 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M556.654297,210.058075 
	C557.776306,210.334839 558.431946,210.604141 559.087585,210.873444 
	C559.016052,211.164688 558.944519,211.455948 558.872986,211.747192 
	C549.285217,211.747192 539.697449,211.747192 530.109680,211.747192 
	C530.097595,211.181671 530.085571,210.616135 530.073486,210.050613 
	C538.778320,210.050613 547.483093,210.050613 556.654297,210.058075 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M549.167053,219.896103 
	C543.593567,219.896103 538.020081,219.896103 532.213013,219.896103 
	C532.930847,218.237106 535.098450,217.891129 542.180847,216.930740 
	C545.861389,216.431641 549.442566,215.199081 553.445984,215.227478 
	C552.637878,215.840500 551.829834,216.453537 550.607300,217.469269 
	C549.850891,218.546677 549.508972,219.221390 549.167053,219.896103 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M517.210815,172.125565 
	C521.106018,172.115051 524.537537,172.115051 527.968994,172.115051 
	C527.960327,172.876633 527.951660,173.638214 527.942993,174.399796 
	C522.696533,175.240570 517.433044,175.001114 512.162537,174.314835 
	C512.113403,173.773270 512.064331,173.231720 512.015198,172.690155 
	C513.592468,172.505463 515.169739,172.320770 517.210815,172.125565 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M527.346008,232.654297 
	C527.631470,232.678070 527.916870,232.701843 528.921021,232.810699 
	C531.075806,232.825378 532.511841,232.754990 533.947815,232.684586 
	C534.198730,232.699890 534.449707,232.715179 535.329712,232.800827 
	C536.674866,232.813858 537.390991,232.756531 538.107117,232.699188 
	C540.086182,232.851074 542.065247,233.002945 544.044312,233.154831 
	C544.033813,233.648010 544.023315,234.141190 544.012878,234.634369 
	C538.012939,234.634369 532.013000,234.635681 526.013794,234.568237 
	C525.997437,234.568039 525.992371,233.563370 526.378174,232.865311 
	C526.774231,232.702759 527.063965,232.709305 527.063965,232.709305 
	C527.063965,232.709305 527.346008,232.654297 527.346008,232.654297 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M533.545044,206.131714 
	C534.390076,206.877213 534.788635,207.615906 535.187256,208.354599 
	C530.703552,208.354599 526.219849,208.354599 521.736206,208.354599 
	C521.724609,207.611374 521.713013,206.868149 521.701416,206.124924 
	C525.500488,206.124924 529.299561,206.124924 533.545044,206.131714 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M549.623291,219.916779 
	C549.508972,219.221390 549.850891,218.546677 550.448364,217.786804 
	C555.771362,217.701645 560.838867,217.701645 565.906433,217.701645 
	C565.935364,218.438629 565.964294,219.175613 565.993164,219.912598 
	C560.688660,219.920883 555.384094,219.929169 549.623291,219.916779 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M539.488098,193.230377 
	C535.318237,192.820572 531.588379,192.361221 527.971375,191.474487 
	C534.039124,191.047104 539.994019,191.047104 545.948914,191.047104 
	C545.944702,191.758362 545.940491,192.469604 545.936340,193.180862 
	C543.933594,193.180862 541.930847,193.180862 539.488098,193.230377 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M527.519043,232.280762 
	C527.346008,232.654297 527.063965,232.709305 527.063965,232.709305 
	C527.063965,232.709305 526.774231,232.702759 526.705627,232.657928 
	C524.403870,233.118713 522.170654,233.624329 519.838074,234.152466 
	C519.749268,228.429977 523.789795,230.228653 526.469238,229.886978 
	C526.785828,229.846619 527.280151,231.199951 527.519043,232.280762 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M548.966919,198.893738 
	C553.209229,198.893738 557.451599,198.893738 561.693970,198.893738 
	C561.699097,199.582703 561.704163,200.271652 561.709290,200.960617 
	C557.821228,200.960617 553.933167,200.960617 549.510803,200.608704 
	C548.973267,199.802444 548.970093,199.348099 548.966919,198.893738 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M524.592590,219.041672 
	C523.318970,219.275986 522.442200,219.469269 521.565430,219.662537 
	C521.486206,219.189804 521.406921,218.717072 521.327698,218.244339 
	C523.999878,215.935364 527.219055,217.288513 530.226990,217.227554 
	C530.293640,217.732437 530.360291,218.237320 530.426941,218.742188 
	C528.614441,218.828339 526.801941,218.914474 524.592590,219.041672 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M548.690247,198.647400 
	C548.970093,199.348099 548.973267,199.802444 549.055908,200.589935 
	C546.958862,200.911926 544.782410,200.900772 542.292480,200.573547 
	C541.989746,199.816254 542.000366,199.375061 542.010986,198.933853 
	C544.145203,198.756256 546.279358,198.578674 548.690247,198.647400 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M541.620483,198.853943 
	C542.000366,199.375061 541.989746,199.816254 541.916504,200.583252 
	C539.532837,200.937988 537.211792,200.966934 534.453735,200.993134 
	C535.093811,200.257919 536.170776,199.525452 537.649597,198.696411 
	C539.110901,198.657898 540.170471,198.715958 541.620483,198.853943 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M533.920837,232.262451 
	C532.511841,232.754990 531.075806,232.825378 529.349976,232.787811 
	C530.059753,228.878296 531.758789,229.103851 533.920837,232.262451 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M538.139587,232.405106 
	C537.390991,232.756531 536.674866,232.813858 535.705933,232.775986 
	C535.156677,231.179779 534.111633,229.127655 537.180420,229.850189 
	C537.661682,229.963470 537.848877,231.326065 538.139587,232.405106 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M529.550537,200.902832 
	C529.510803,200.241699 529.812927,199.618088 530.114990,198.994476 
	C530.790466,199.407364 531.465820,199.820251 532.048035,200.603760 
	C531.267395,200.963058 530.579895,200.951721 529.550537,200.902832 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M535.068726,214.368073 
	C535.652100,214.656998 535.967224,214.981628 536.282410,215.306259 
	C535.914062,215.472061 535.545715,215.637863 535.177368,215.803650 
	C535.051697,215.337036 534.926086,214.870422 535.068726,214.368073 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M391.674866,273.615784 
	C391.092834,274.624420 390.241760,275.924072 389.328033,275.969696 
	C385.275452,276.172089 381.204895,276.014709 376.638367,275.626404 
	C375.974426,274.999664 375.812927,274.733948 375.651428,274.468262 
	C375.408569,274.963928 375.165710,275.459595 374.922821,275.955261 
	C373.984589,275.458252 373.046387,274.961273 372.093567,274.090637 
	C378.511627,273.587860 384.944305,273.458679 391.674866,273.615784 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M404.707458,273.660156 
	C402.855408,276.827820 397.585083,277.034149 394.551147,273.933044 
	C397.913879,273.471039 401.169983,273.426697 404.707458,273.660156 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M419.269775,277.940857 
	C418.600555,276.941467 418.281647,275.911591 417.959961,274.536621 
	C419.168579,274.923401 420.380005,275.655304 421.788116,276.690552 
	C421.984802,276.993835 422.000641,276.954742 422.000641,276.954742 
	C421.207123,277.273315 420.413605,277.591858 419.269775,277.940857 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M421.965027,277.001587 
	C422.331787,277.322388 422.718353,277.635376 422.488068,277.448914 
	C422.707062,277.823639 422.528656,277.518402 422.175476,277.083923 
	C422.000641,276.954742 421.984802,276.993835 421.965027,277.001587 
z"/>
<path fill="#E8F1F6" opacity="1.000000" stroke="none" 
	d="
M381.947693,305.967712 
	C378.509521,305.832184 375.071381,305.696655 371.296387,304.889587 
	C370.959534,300.568756 370.959534,296.919495 370.959534,292.088959 
	C368.893158,293.611938 367.945679,294.310242 366.998230,295.008545 
	C367.289062,292.369781 366.850830,289.271667 368.123627,287.251648 
	C368.991180,285.874725 372.494598,285.194214 374.353210,285.753021 
	C375.545959,286.111633 375.974182,289.263092 376.580078,291.213867 
	C376.867218,292.138428 376.768036,293.182983 376.871094,294.957764 
	C378.188110,296.613708 379.477905,297.485107 380.767731,298.356476 
	C381.232025,299.966553 381.696350,301.576630 382.040405,303.876831 
	C381.929352,305.033844 381.938538,305.500793 381.947693,305.967712 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M391.368256,292.223602 
	C399.061951,292.223602 406.755676,292.223602 414.449371,292.223602 
	C414.476166,292.732971 414.502960,293.242340 414.529755,293.751709 
	C411.326263,293.980194 408.122772,294.208710 404.575195,294.461761 
	C404.697235,295.501678 404.810608,296.467834 404.994476,298.034393 
	C401.440948,298.034393 397.999695,298.172852 394.590424,297.904877 
	C393.987427,297.857483 393.517670,296.115051 392.455719,294.609680 
	C391.739441,293.450562 391.553864,292.837067 391.368256,292.223602 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M384.142578,309.048981 
	C384.957794,308.122986 385.846283,307.242615 386.756165,307.219940 
	C392.087097,307.087097 397.422974,307.154724 402.757202,307.154724 
	C402.758514,307.961945 402.759857,308.769135 402.761169,309.576355 
	C396.626251,310.322662 390.453857,310.402649 384.142578,309.048981 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M366.926208,295.460449 
	C367.945679,294.310242 368.893158,293.611938 370.959534,292.088959 
	C370.959534,296.919495 370.959534,300.568756 370.930450,304.690582 
	C367.914856,305.967957 366.635101,304.883301 366.881927,301.754425 
	C367.034546,299.819855 366.874084,297.860565 366.926208,295.460449 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M421.229614,299.783386 
	C425.725647,299.782135 429.745575,299.782135 433.765472,299.782135 
	C433.761597,300.276031 433.757721,300.769958 433.753815,301.263855 
	C428.554657,301.263855 423.355530,301.263855 418.156372,301.263855 
	C418.097137,301.021912 418.037903,300.779968 417.978699,300.538055 
	C418.903595,300.286926 419.828522,300.035797 421.229614,299.783386 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M392.219421,286.572906 
	C387.330139,286.790527 382.824829,286.790527 378.319489,286.790527 
	C378.372345,286.012512 378.425171,285.234497 378.478027,284.456482 
	C383.186462,285.089417 387.894897,285.722351 392.219421,286.572906 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M409.005188,279.426880 
	C406.438110,279.426208 404.343506,279.426208 402.248871,279.426208 
	C402.233337,278.807251 402.217773,278.188263 402.202209,277.569305 
	C406.939148,276.728363 411.731140,277.077423 416.523010,277.424591 
	C416.576538,277.978607 416.630066,278.532654 416.683563,279.086700 
	C414.281586,279.200287 411.879639,279.313904 409.005188,279.426880 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M390.552734,277.899628 
	C393.824341,277.904755 396.681824,277.904755 399.466217,277.904755 
	C398.149170,280.732483 390.639709,281.134766 386.582520,277.894501 
	C388.169586,277.894501 389.154083,277.894501 390.552734,277.899628 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M382.428955,277.845642 
	C383.801880,277.931976 384.766632,278.061127 385.731384,278.190247 
	C384.967163,278.807312 384.243866,279.884216 383.431183,279.956482 
	C380.848785,280.186188 378.233063,280.041473 375.630249,280.041473 
	C375.582428,279.499207 375.534607,278.956940 375.486786,278.414673 
	C377.664795,278.239258 379.842773,278.063812 382.428955,277.845642 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M382.359619,305.969116 
	C381.938538,305.500793 381.929352,305.033844 382.070801,304.247925 
	C384.963226,303.535217 387.705048,303.141510 390.446838,302.747803 
	C390.547424,303.310242 390.647980,303.872650 390.748566,304.435059 
	C388.089539,304.946899 385.430511,305.458740 382.359619,305.969116 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M390.950348,292.175720 
	C391.553864,292.837067 391.739441,293.450562 392.131775,294.251678 
	C389.528656,294.629303 386.718811,294.819305 383.454590,295.004700 
	C383.000275,295.000122 383.013489,295.013214 383.013489,295.013245 
	C385.519806,294.051453 388.026123,293.089661 390.950348,292.175720 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M380.950806,298.057861 
	C379.477905,297.485107 378.188110,296.613708 376.976440,295.365173 
	C378.756714,295.000824 380.458832,295.013672 382.587219,295.019836 
	C383.013489,295.013214 383.000275,295.000122 382.993927,294.993286 
	C382.369690,295.910736 381.751801,296.834991 380.950806,298.057861 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M375.255219,275.936646 
	C375.165710,275.459595 375.408569,274.963928 375.651428,274.468262 
	C375.812927,274.733948 375.974426,274.999664 376.192322,275.551880 
	C376.028381,275.864929 375.808014,275.891479 375.255219,275.936646 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M376.322113,559.344482 
	C374.426270,559.551331 372.908752,559.629272 371.076294,559.723511 
	C373.137115,554.430054 376.535706,553.137512 382.694336,554.809753 
	C382.439270,558.681213 379.321777,558.627319 376.322113,559.344482 
z"/>
<path fill="#F5DDCC" opacity="1.000000" stroke="none" 
	d="
M525.506958,578.141113 
	C525.564392,578.503174 525.305237,578.787598 525.149048,578.900146 
	C522.659607,578.504211 520.326416,577.995789 517.682617,577.642578 
	C516.128357,576.542114 514.936096,575.230042 513.631836,574.040894 
	C508.471313,569.335632 508.105042,562.175049 512.814392,557.243958 
	C517.363037,552.481140 525.174011,552.567261 529.688477,557.430054 
	C534.229431,562.321411 533.720764,569.685303 528.602539,574.263672 
	C527.436462,575.306824 526.494629,576.600586 525.506958,578.141113 
M517.049500,559.442078 
	C514.212158,561.830505 513.140320,564.740173 514.695190,568.251343 
	C516.241882,571.744263 520.383911,573.357788 523.863159,571.960266 
	C527.275208,570.589844 529.131714,566.467163 527.933350,562.921387 
	C526.611450,559.010132 522.697144,557.530029 517.049500,559.442078 
z"/>
<path fill="#F5556C" opacity="1.000000" stroke="none" 
	d="
M573.756653,576.067261 
	C573.614014,576.689636 573.138794,577.339417 572.345337,578.024414 
	C572.492737,577.404663 572.958435,576.749695 573.756653,576.067261 
z"/>
<path fill="#F5556C" opacity="1.000000" stroke="none" 
	d="
M571.877380,578.079773 
	C571.986328,578.313293 571.808655,578.517029 571.317688,578.625427 
	C571.263123,578.410828 571.458618,578.250793 571.877380,578.079773 
z"/>
<path fill="#F75174" opacity="1.000000" stroke="none" 
	d="
M528.822632,593.577026 
	C541.237122,593.108948 553.647583,593.034180 566.513184,593.070801 
	C567.010254,601.841858 566.867798,602.010498 558.459229,601.987183 
	C548.129883,601.958618 537.800720,601.890137 526.967712,601.722412 
	C527.248840,599.060669 528.033691,596.515503 528.822632,593.577026 
z"/>
<path fill="#EC3561" opacity="1.000000" stroke="none" 
	d="
M520.372314,599.679688 
	C517.518127,598.205078 515.891052,596.152222 518.000977,593.681519 
	C518.957703,592.561279 521.838013,591.900024 523.058777,592.537476 
	C524.175964,593.120911 524.824829,595.841064 524.541199,597.414429 
	C524.363647,598.399231 522.079407,599.004272 520.372314,599.679688 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M371.003815,432.156494 
	C378.263489,432.155701 385.091583,432.067780 391.913696,432.230011 
	C393.279694,432.262512 394.622986,433.248108 395.976746,433.794189 
	C394.715485,434.429871 393.467163,435.583771 392.190857,435.615509 
	C385.011932,435.794189 377.824951,435.773163 370.644196,435.636719 
	C369.395050,435.613037 368.162567,434.713806 366.922394,434.218994 
	C368.138306,433.531799 369.354218,432.844635 371.003815,432.156494 
z"/>
<path fill="#FDEDDC" opacity="1.000000" stroke="none" 
	d="
M353.537354,391.671936 
	C359.478882,391.560822 365.420807,391.383423 371.361572,391.414948 
	C372.187897,391.419342 373.008759,392.453186 373.832153,393.010437 
	C373.002747,393.559235 372.182190,394.566559 371.342529,394.582703 
	C365.721100,394.690948 360.095612,394.588043 354.061646,393.997833 
	C353.613739,392.852020 353.575531,392.261963 353.537354,391.671936 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M374.137726,368.313232 
	C376.430511,370.121368 375.924713,371.371460 373.542877,371.559906 
	C370.566315,371.795380 367.550659,371.721161 364.566864,371.537415 
	C363.901489,371.496460 363.298492,370.442963 362.666748,369.855652 
	C363.361572,369.327881 364.032288,368.386749 364.755432,368.344604 
	C367.740631,368.170563 370.741669,368.268890 374.137726,368.313232 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M350.172729,414.855927 
	C354.729126,414.854492 358.805634,414.854492 364.063202,414.854492 
	C362.648468,416.605133 362.144440,417.798309 361.593445,417.820435 
	C357.270813,417.993805 352.936981,418.014038 348.612946,417.878662 
	C348.015930,417.859985 347.453796,416.728180 346.875488,416.111694 
	C347.814606,415.693604 348.753723,415.275482 350.172729,414.855927 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M363.602173,396.949036 
	C364.664734,397.760315 365.284637,398.552612 365.904541,399.344940 
	C365.183258,399.877014 364.493805,400.807129 363.734833,400.867828 
	C361.277649,401.064301 358.778198,401.103577 356.331635,400.849854 
	C355.525635,400.766266 354.831177,399.607422 354.085724,398.940247 
	C354.802216,398.276062 355.463043,397.129211 356.245758,397.038910 
	C358.524200,396.776031 360.851410,396.935974 363.602173,396.949036 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M375.049255,423.711121 
	C368.854004,423.711121 362.658783,423.711121 356.463562,423.711121 
	C356.410370,423.191376 356.357147,422.671661 356.303955,422.151917 
	C362.233704,421.775818 368.163422,421.399719 374.553406,421.373169 
	C375.025513,422.385529 375.037384,423.048309 375.049255,423.711121 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M357.514648,371.629578 
	C355.283356,371.627594 353.441681,371.780365 351.652832,371.540161 
	C350.952240,371.446106 350.369965,370.470612 349.733826,369.896545 
	C350.406647,369.356171 351.040497,368.420593 351.759613,368.349670 
	C353.890625,368.139526 356.064758,368.153839 358.202087,368.326874 
	C359.027069,368.393616 359.798340,369.123566 360.594086,369.551392 
	C359.704529,370.243286 358.814972,370.935181 357.514648,371.629578 
z"/>
<path fill="#EEECD3" opacity="1.000000" stroke="none" 
	d="
M388.595398,403.117981 
	C389.653198,403.722961 390.258545,404.319336 390.863892,404.915710 
	C390.275513,405.353424 389.697021,406.154022 389.097168,406.170319 
	C384.997009,406.281891 380.892365,406.228851 376.652618,405.305847 
	C379.894653,401.696960 384.333618,403.818970 388.595398,403.117981 
z"/>
<path fill="#F2EAD4" opacity="1.000000" stroke="none" 
	d="
M347.901489,366.162811 
	C344.983673,366.163300 342.534821,366.163300 340.085938,366.163300 
	C339.950470,365.540649 339.814972,364.918030 339.679474,364.295380 
	C340.978973,363.861633 342.370697,362.891418 343.560455,363.095947 
	C346.961243,363.680573 351.138824,361.195496 353.679138,366.162323 
	C351.909546,366.162323 350.139984,366.162323 347.901489,366.162811 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M350.423981,435.707153 
	C348.879486,435.108429 347.755554,434.509735 346.631622,433.911011 
	C347.773804,433.327026 348.912720,432.736511 350.062469,432.167816 
	C350.195526,432.101959 350.396820,432.123688 350.552643,432.161652 
	C352.729767,432.691864 354.904480,433.232025 357.079803,433.769714 
	C355.001373,434.415558 352.922974,435.061371 350.423981,435.707153 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M351.497681,383.135468 
	C348.596771,383.134216 346.126740,383.239563 343.676849,383.063965 
	C342.938141,383.010986 342.255402,382.177551 341.547058,381.701599 
	C342.174774,381.141235 342.775452,380.136963 343.434875,380.096771 
	C346.378845,379.917450 349.345093,379.915619 352.290436,380.079956 
	C353.009796,380.120117 353.680573,381.031158 354.373688,381.541779 
	C353.561218,382.072601 352.748749,382.603455 351.497681,383.135468 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M375.503784,423.792664 
	C375.037384,423.048309 375.025513,422.385529 375.013977,421.391235 
	C379.260071,421.059784 383.505859,421.059784 387.878754,421.059784 
	C386.833710,424.026337 386.833710,424.026337 375.503784,423.792664 
z"/>
<path fill="#ECE4D1" opacity="1.000000" stroke="none" 
	d="
M379.132141,429.203979 
	C374.785583,429.481079 370.568573,431.052704 366.999756,428.514282 
	C367.042267,428.010681 367.084747,427.507111 367.127258,427.003510 
	C370.983643,427.003510 374.841431,426.961487 378.693665,427.087891 
	C378.984161,427.097412 379.235229,428.306824 379.132141,429.203979 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M355.364502,377.886902 
	C354.629669,377.897644 354.283997,377.970490 353.979584,377.889130 
	C352.270386,377.432159 350.571075,376.938049 348.868408,376.456665 
	C349.077820,375.883759 349.260864,374.825989 349.500702,374.812927 
	C351.894836,374.682770 354.298309,374.724762 356.699158,374.718201 
	C356.390350,375.771362 356.081573,376.824554 355.364502,377.886902 
z"/>
<path fill="#C7C4BB" opacity="1.000000" stroke="none" 
	d="
M362.122559,377.968292 
	C360.793335,377.304230 359.894867,376.642120 358.996399,375.979980 
	C359.828674,375.409210 360.596649,374.668365 361.513641,374.321899 
	C362.239807,374.047516 363.246033,374.016663 363.955414,374.303802 
	C365.258301,374.831207 366.434082,375.672485 367.662872,376.382904 
	C366.456390,376.911560 365.267548,377.488159 364.033936,377.943207 
	C363.596558,378.104523 363.049988,377.969788 362.122559,377.968292 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M372.833893,416.874115 
	C369.639404,418.244873 366.549957,419.072754 364.092865,416.567383 
	C364.234100,415.836548 364.375336,415.105713 364.516541,414.374908 
	C367.317169,415.063110 370.117767,415.751312 372.833893,416.874115 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M356.205963,364.140137 
	C359.446777,362.998535 362.745911,361.631653 365.126709,364.563995 
	C364.982544,365.259949 364.838379,365.955933 364.694214,366.651886 
	C361.837189,365.959869 358.980133,365.267853 356.205963,364.140137 
z"/>
<path fill="#F1EEDE" opacity="1.000000" stroke="none" 
	d="
M349.545624,444.475281 
	C352.683746,444.586121 356.146240,442.662109 357.893890,447.185730 
	C355.454041,447.185730 352.998840,447.330353 350.585999,447.074890 
	C350.043335,447.017426 349.648560,445.562897 349.545624,444.475281 
z"/>
<path fill="#EEECD3" opacity="1.000000" stroke="none" 
	d="
M364.076233,406.258728 
	C362.404114,405.781372 361.198914,405.304626 359.993713,404.827881 
	C361.111206,404.254791 362.216888,403.656281 363.354889,403.127228 
	C363.625580,403.001404 364.033173,403.022522 364.328644,403.122009 
	C365.940582,403.664856 367.537170,404.253296 369.139008,404.826050 
	C367.607056,405.303833 366.075073,405.781586 364.076233,406.258728 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M353.235382,391.712097 
	C353.575531,392.261963 353.613739,392.852020 353.587769,393.882660 
	C352.828552,393.980255 352.133545,393.637238 351.438507,393.294220 
	C351.936798,392.780243 352.435089,392.266266 353.235382,391.712097 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M704.178955,408.977448 
	C698.701904,410.569183 697.923218,405.622498 695.378906,403.452972 
	C695.157837,403.264435 695.894653,401.227875 696.239624,401.212067 
	C699.857849,401.046600 703.508240,400.910248 707.096863,401.279907 
	C707.928101,401.365540 708.558411,403.402679 709.641113,405.109192 
	C711.909851,405.109192 714.885498,404.906250 717.811890,405.197693 
	C719.204468,405.336365 720.503235,406.416382 721.844543,407.069977 
	C720.576172,407.712189 719.332214,408.842957 718.034973,408.907867 
	C713.583313,409.130432 709.112915,408.979645 704.178955,408.977448 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M706.936401,387.978119 
	C706.104858,389.000916 705.599243,389.989532 705.053223,391.057129 
	C702.023193,391.057129 698.610046,391.057129 695.196899,391.057129 
	C695.138916,390.589294 695.080994,390.121460 695.023010,389.653625 
	C698.679871,387.506805 701.726807,383.855316 706.916931,385.526581 
	C708.804077,386.134308 709.976440,386.731476 706.936401,387.978119 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M711.171875,397.176697 
	C711.526611,398.100311 711.492554,399.722870 711.414429,399.724976 
	C706.948608,399.846405 702.479126,399.833191 698.009949,399.833191 
	C697.966309,399.066620 697.922668,398.300049 697.878967,397.533478 
	C702.173462,397.395508 706.468018,397.257507 711.171875,397.176697 
z"/>
<path fill="#81756D" opacity="1.000000" stroke="none" 
	d="
M652.099854,417.784241 
	C647.443970,418.434692 643.008423,418.801178 638.572876,419.167664 
	C638.484802,418.421722 638.396790,417.675812 638.308777,416.929871 
	C644.247375,416.041840 650.186035,415.153809 656.124634,414.265808 
	C656.264282,414.920197 656.403992,415.574585 656.543640,416.229004 
	C655.135803,416.652740 653.727966,417.076508 652.099854,417.784241 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M668.018372,446.275269 
	C667.866089,447.065796 667.966125,448.065613 667.515625,448.608704 
	C665.997253,450.438995 654.472046,449.072723 653.463501,446.556641 
	C658.611572,446.173706 663.315002,446.224487 668.018372,446.275269 
z"/>
<path fill="#DBD3C5" opacity="1.000000" stroke="none" 
	d="
M668.391418,446.220764 
	C663.315002,446.224487 658.611572,446.173706 653.444153,446.193176 
	C652.544739,446.228271 652.109375,446.193024 650.961609,446.137024 
	C649.333923,445.731903 648.418701,445.347626 647.503418,444.963318 
	C655.411682,444.558990 663.319946,444.154663 671.228210,443.750336 
	C671.310059,444.283966 671.391968,444.817566 671.473816,445.351196 
	C670.570679,445.622894 669.667603,445.894592 668.391418,446.220764 
z"/>
<path fill="#615355" opacity="1.000000" stroke="none" 
	d="
M647.155151,444.970245 
	C648.418701,445.347626 649.333923,445.731903 650.636963,446.187439 
	C650.922913,449.406982 648.923279,450.354126 646.358215,449.584564 
	C643.215332,448.641724 640.238831,447.144043 637.447632,444.977173 
	C640.567383,444.977173 643.687134,444.977173 647.155151,444.970245 
z"/>
<path fill="#E1DACA" opacity="1.000000" stroke="none" 
	d="
M641.056335,426.920105 
	C641.450439,426.312744 641.835999,425.183136 642.239929,425.176575 
	C648.173950,425.079407 654.110657,425.119843 660.046204,425.173279 
	C660.479980,425.177155 660.910706,425.532227 661.342896,425.724030 
	C661.205322,426.133392 661.067810,426.542755 660.930298,426.952148 
	C659.266052,427.049988 657.601868,427.147827 655.049805,427.204346 
	C650.750305,427.218933 647.338806,427.274902 643.927246,427.330872 
	C643.513000,427.295746 643.098816,427.260590 642.130127,427.147095 
	C641.402588,427.019226 641.229492,426.969666 641.056335,426.920105 
z"/>
<path fill="#B09C8C" opacity="1.000000" stroke="none" 
	d="
M639.467285,406.145111 
	C642.210510,406.270111 644.534851,406.397888 646.859131,406.525635 
	C646.833862,407.048798 646.808655,407.571930 646.783386,408.095093 
	C642.659607,408.095093 638.535889,408.095093 634.412109,408.095093 
	C634.341675,407.869629 634.271240,407.644196 634.200806,407.418732 
	C635.816650,406.995117 637.432556,406.571503 639.467285,406.145111 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M643.945679,427.642578 
	C647.338806,427.274902 650.750305,427.218933 654.620239,427.250885 
	C655.271301,428.134583 655.463989,428.930359 655.959229,430.975983 
	C651.615295,429.881683 647.789734,428.917969 643.945679,427.642578 
z"/>
<path fill="#736360" opacity="1.000000" stroke="none" 
	d="
M640.862549,427.192261 
	C641.229492,426.969666 641.402588,427.019226 641.819946,427.184326 
	C640.798462,428.492096 639.532837,429.684265 638.267212,430.876465 
	C637.897949,430.377838 637.528687,429.879211 637.159424,429.380615 
	C638.329224,428.741882 639.499023,428.103149 640.862549,427.192261 
z"/>
<path fill="#584144" opacity="1.000000" stroke="none" 
	d="
M295.515076,216.905151 
	C294.993256,217.041199 294.653534,216.972260 294.481445,216.959290 
	C291.521027,216.814667 288.732727,216.683014 285.499390,216.444809 
	C285.031830,215.792557 285.009216,215.246857 285.001892,214.426300 
	C288.971954,214.589066 292.926697,215.026657 296.933167,215.859589 
	C296.668854,216.426315 296.352875,216.597717 295.515076,216.905151 
z"/>
<path fill="#EC3561" opacity="1.000000" stroke="none" 
	d="
M517.383423,559.250305 
	C522.697144,557.530029 526.611450,559.010132 527.933350,562.921387 
	C529.131714,566.467163 527.275208,570.589844 523.863159,571.960266 
	C520.383911,573.357788 516.241882,571.744263 514.695190,568.251343 
	C513.140320,564.740173 514.212158,561.830505 517.383423,559.250305 
z"/>
</svg>
    );
  }
}
